
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fS9aS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $35f8ea0e57b63fc6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iDMge = parcelRequire("iDMge");
var $35f8ea0e57b63fc6$export$2e2bcd8739ae039 = (0, $iDMge.default);

});
parcelRegister("iDMge", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad305416969de9df$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $ad305416969de9df$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});


parcelRegister("bGx3v", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("lMeHP")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("lMeHP")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("lMeHP")).monitorForElements);

var $lMeHP = parcelRequire("lMeHP");

});
parcelRegister("lMeHP", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $274fd39eed06d81a$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $274fd39eed06d81a$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $274fd39eed06d81a$export$c746a5152d4ba26c);

var $4eDgu = parcelRequire("4eDgu");

var $eNpGE = parcelRequire("eNpGE");

var $1FL6N = parcelRequire("1FL6N");

var $kL2Iu = parcelRequire("kL2Iu");

var $bGF1c = parcelRequire("bGF1c");

var $6Z6g4 = parcelRequire("6Z6g4");

var $bbhqT = parcelRequire("bbhqT");

var $9Hsiy = parcelRequire("9Hsiy");

var $94xAz = parcelRequire("94xAz");



const $274fd39eed06d81a$var$draggableRegistry = new WeakMap();
function $274fd39eed06d81a$var$addToRegistry(args) {
    $274fd39eed06d81a$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $274fd39eed06d81a$var$draggableRegistry.delete(args.element);
    };
}
const $274fd39eed06d81a$var$honeyPotFix = (0, $1FL6N.makeHoneyPotFix)();
const $274fd39eed06d81a$var$adapter = (0, $kL2Iu.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $bGF1c.combine)($274fd39eed06d81a$var$honeyPotFix.bindEvents(), (0, $4eDgu.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $274fd39eed06d81a$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $94xAz.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $eNpGE.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $9Hsiy.isAndroid)() && !event.dataTransfer.types.includes((0, $c360c820836f002e$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $dd6912455344a253$export$4c44a460f123106))) event.dataTransfer.setData((0, $c360c820836f002e$export$fd3d00026297c0ad), (0, $9Hsiy.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $8f124db82e8162d9$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $274fd39eed06d81a$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $274fd39eed06d81a$var$honeyPotFix.getOnPostDispatch()
});
const $274fd39eed06d81a$export$e7140b68045b5036 = $274fd39eed06d81a$var$adapter.dropTarget;
const $274fd39eed06d81a$export$59a074bac4c54f54 = $274fd39eed06d81a$var$adapter.monitor;
function $274fd39eed06d81a$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $bGF1c.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $274fd39eed06d81a$var$adapter.registerUsage(), $274fd39eed06d81a$var$addToRegistry(args), (0, $bbhqT.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $6Z6g4.once)(cleanup);
}

});
parcelRegister("eNpGE", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $0bd961127f5c6385$export$81d0353f25f5dd);

var $5R8nS = parcelRequire("5R8nS");
function $0bd961127f5c6385$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $5R8nS.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("5R8nS", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $ed8999c5c68f0692$export$821bdcd739a2706b);

function $ed8999c5c68f0692$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $5cf283db7425d2da$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $5cf283db7425d2da$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("1FL6N", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $1ef078b9c6e19245$export$8ecad27c959e89e0);

var $4eDgu = parcelRequire("4eDgu");


const $1ef078b9c6e19245$var$honeyPotSize = 2;
const $1ef078b9c6e19245$var$halfHoneyPotSize = $1ef078b9c6e19245$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $1ef078b9c6e19245$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $1ef078b9c6e19245$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $1ef078b9c6e19245$var$halfHoneyPotSize,
        y: point.y - $1ef078b9c6e19245$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $1ef078b9c6e19245$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $1ef078b9c6e19245$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $1ef078b9c6e19245$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $1ef078b9c6e19245$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $1ef078b9c6e19245$var$getHoneyPotRectFor({ client: client }) {
    const point = $1ef078b9c6e19245$var$preventGoingForwardsOffScreen($1ef078b9c6e19245$var$preventGoingBackwardsOffScreen($1ef078b9c6e19245$var$pullBackByHalfHoneyPotSize($1ef078b9c6e19245$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $1ef078b9c6e19245$var$honeyPotSize,
        height: $1ef078b9c6e19245$var$honeyPotSize
    });
}
function $1ef078b9c6e19245$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $1ef078b9c6e19245$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $1ef078b9c6e19245$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $5cf283db7425d2da$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $1ef078b9c6e19245$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$1ef078b9c6e19245$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $2ec8d9a2d82c6656$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $4eDgu.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $1ef078b9c6e19245$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $1ef078b9c6e19245$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($1ef078b9c6e19245$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $4eDgu.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $1ef078b9c6e19245$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $4eDgu.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $1ef078b9c6e19245$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $2ec8d9a2d82c6656$export$7d0a15ee70427305 = 2147483647;


parcelRegister("kL2Iu", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $bd380b156d8e6dea$export$2aa3a33160990d96);

var $aMZuK = parcelRequire("aMZuK");

var $7AaOq = parcelRequire("7AaOq");

var $ewThI = parcelRequire("ewThI");

var $lpRx1 = parcelRequire("lpRx1");
function $bd380b156d8e6dea$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $lpRx1.makeMonitor)();
    const dropTargetAPI = (0, $ewThI.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $aMZuK.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $aMZuK.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $7AaOq.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("aMZuK", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $f3500dba41a35f9f$export$3efdceeb8ca25c51);

var $4eDgu = parcelRequire("4eDgu");

var $eNpGE = parcelRequire("eNpGE");

var $5R8nS = parcelRequire("5R8nS");

var $8loH9 = parcelRequire("8loH9");

var $bOMk0 = parcelRequire("bOMk0");

var $94xAz = parcelRequire("94xAz");

var $jm0YA = parcelRequire("jm0YA");
const $f3500dba41a35f9f$var$globalState = {
    isActive: false
};
function $f3500dba41a35f9f$var$canStart() {
    return !$f3500dba41a35f9f$var$globalState.isActive;
}
function $f3500dba41a35f9f$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $f3500dba41a35f9f$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $f3500dba41a35f9f$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$f3500dba41a35f9f$var$canStart()) return;
    const initial = $f3500dba41a35f9f$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $f3500dba41a35f9f$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $f3500dba41a35f9f$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $jm0YA.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $f3500dba41a35f9f$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $94xAz.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $5R8nS.isHoneyPotElement)(event.target) ? (0, $eNpGE.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $f3500dba41a35f9f$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $f3500dba41a35f9f$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $4eDgu.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $8loH9.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $94xAz.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $f3500dba41a35f9f$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $94xAz.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $bOMk0.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $f3500dba41a35f9f$var$getNativeSetDragImage(event)
    });
}
function $f3500dba41a35f9f$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $f3500dba41a35f9f$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $94xAz.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $f3500dba41a35f9f$export$3efdceeb8ca25c51 = {
    canStart: $f3500dba41a35f9f$var$canStart,
    start: $f3500dba41a35f9f$var$start
};

});
parcelRegister("8loH9", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $97f7775a76a39681$export$57d220c74e84a273);

var $3eRFA = parcelRequire("3eRFA");

var $72Sl2 = parcelRequire("72Sl2");

var $a6xZ7 = parcelRequire("a6xZ7");

var $5lX6q = parcelRequire("5lX6q");
function $97f7775a76a39681$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $72Sl2.isSafari)()) return (0, $a6xZ7.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $3eRFA.isFirefox)()) return (0, $5lX6q.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("3eRFA", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $288ff54b248c09c1$export$b7d78993b74f766d);

var $6Z6g4 = parcelRequire("6Z6g4");
const $288ff54b248c09c1$export$b7d78993b74f766d = (0, $6Z6g4.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("6Z6g4", function(module, exports) {
$parcel$export(module.exports, "once", () => $0b20b020bad824dd$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $0b20b020bad824dd$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("72Sl2", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $121e8e6824d6f182$export$95df08bae54cb4df);

var $6Z6g4 = parcelRequire("6Z6g4");
const $121e8e6824d6f182$export$95df08bae54cb4df = (0, $6Z6g4.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("a6xZ7", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $fe067a409d635012$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $fe067a409d635012$export$f21837c338005454);

var $4eDgu = parcelRequire("4eDgu");

var $72Sl2 = parcelRequire("72Sl2");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $fe067a409d635012$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $fe067a409d635012$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $72Sl2.isSafari)()) return false;
    return dragEnter.hasOwnProperty($fe067a409d635012$var$symbols.isEnteringWindow);
}
function $fe067a409d635012$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $72Sl2.isSafari)()) return false;
    return dragLeave.hasOwnProperty($fe067a409d635012$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $72Sl2.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$fe067a409d635012$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$fe067a409d635012$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("5lX6q", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $4b57bc8a1a8aa801$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $4b57bc8a1a8aa801$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $4b57bc8a1a8aa801$export$e46810fef53b5b0e(eventTarget) {
    return $4b57bc8a1a8aa801$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("bOMk0", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $e36026db3017001f$export$ac5e5b0daf997b2);
function $e36026db3017001f$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("94xAz", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $707250af3e660119$export$7c112ceec8941e67);
function $707250af3e660119$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("jm0YA", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $6737eea2553ffebf$export$9f13ecc44e83d682);

var $bRPNB = parcelRequire("bRPNB");
const $6737eea2553ffebf$var$scheduleOnDrag = (0, $bRPNB.default)((fn)=>fn());
const $6737eea2553ffebf$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $6737eea2553ffebf$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $6737eea2553ffebf$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $6737eea2553ffebf$var$dragStart.flush();
            $6737eea2553ffebf$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $6737eea2553ffebf$var$scheduleOnDrag(()=>{
                $6737eea2553ffebf$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $6737eea2553ffebf$var$dragStart.flush();
            $6737eea2553ffebf$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("bRPNB", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a3cd329086d9065$export$2e2bcd8739ae039);
var $8a3cd329086d9065$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8a3cd329086d9065$export$2e2bcd8739ae039 = $8a3cd329086d9065$var$rafSchd;

});



parcelRegister("7AaOq", function(module, exports) {
$parcel$export(module.exports, "register", () => $bfd9e06491f71b4d$export$6503ec6e8aabbaf);
const $bfd9e06491f71b4d$var$ledger = new Map();
function $bfd9e06491f71b4d$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $bfd9e06491f71b4d$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $bfd9e06491f71b4d$var$ledger.set(typeKey, initial);
    return initial;
}
function $bfd9e06491f71b4d$export$6503ec6e8aabbaf(args) {
    const entry = $bfd9e06491f71b4d$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $bfd9e06491f71b4d$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("ewThI", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $82e371ccc057fc49$export$47d10e7bd9c81890);

var $bGF1c = parcelRequire("bGF1c");

var $6Z6g4 = parcelRequire("6Z6g4");

var $bbhqT = parcelRequire("bbhqT");
function $82e371ccc057fc49$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $82e371ccc057fc49$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $bGF1c.combine)((0, $bbhqT.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $6Z6g4.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $82e371ccc057fc49$var$copyReverse(current);
        const actualCaptureOrdered = $82e371ccc057fc49$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $82e371ccc057fc49$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("bGF1c", function(module, exports) {
$parcel$export(module.exports, "combine", () => $e66d0584ba97c850$export$1be1fc439b849fdf);
function $e66d0584ba97c850$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("bbhqT", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $d091c0cf3d6ce588$export$5dcb5c23b6ba980a);
function $d091c0cf3d6ce588$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("lpRx1", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $b0598f29b07116e1$export$5dd4ed888d5b12ca);

var $6Z6g4 = parcelRequire("6Z6g4");
function $b0598f29b07116e1$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $6Z6g4.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("9Hsiy", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $b32f3ca0fa9cdc04$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $b32f3ca0fa9cdc04$export$aceb3ed8b7f7bd2c);

var $6Z6g4 = parcelRequire("6Z6g4");
const $b32f3ca0fa9cdc04$export$a11b0059900ceec8 = (0, $6Z6g4.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $b32f3ca0fa9cdc04$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $c360c820836f002e$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $dd6912455344a253$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $8f124db82e8162d9$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("dROq6", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("bGF1c")).combine);

var $bGF1c = parcelRequire("bGF1c");

});

parcelRegister("ahm5r", function(module, exports) {
$parcel$export(module.exports, "defaultMemoize", () => $77bc9fe89b8fd54e$export$281bff7f05488aa2, (v) => $77bc9fe89b8fd54e$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $77bc9fe89b8fd54e$export$5943f4447f6ef248, (v) => $77bc9fe89b8fd54e$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $77bc9fe89b8fd54e$export$75979cfcd91bf38f, (v) => $77bc9fe89b8fd54e$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $77bc9fe89b8fd54e$export$595d22ed68ca2841, (v) => $77bc9fe89b8fd54e$export$595d22ed68ca2841 = v);
var $77bc9fe89b8fd54e$export$1e511d4a378977f5;
var $77bc9fe89b8fd54e$export$281bff7f05488aa2;
var $77bc9fe89b8fd54e$export$5943f4447f6ef248;
var $77bc9fe89b8fd54e$export$75979cfcd91bf38f;
var $77bc9fe89b8fd54e$export$595d22ed68ca2841;
'use strict';
$77bc9fe89b8fd54e$export$1e511d4a378977f5 = true;
$77bc9fe89b8fd54e$export$281bff7f05488aa2 = $77bc9fe89b8fd54e$var$defaultMemoize;
$77bc9fe89b8fd54e$export$5943f4447f6ef248 = $77bc9fe89b8fd54e$var$createSelectorCreator;
$77bc9fe89b8fd54e$export$75979cfcd91bf38f = $77bc9fe89b8fd54e$var$createStructuredSelector;
function $77bc9fe89b8fd54e$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $77bc9fe89b8fd54e$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $77bc9fe89b8fd54e$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $77bc9fe89b8fd54e$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$77bc9fe89b8fd54e$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $77bc9fe89b8fd54e$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $77bc9fe89b8fd54e$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $77bc9fe89b8fd54e$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $77bc9fe89b8fd54e$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $77bc9fe89b8fd54e$var$createSelector = $77bc9fe89b8fd54e$export$595d22ed68ca2841 = $77bc9fe89b8fd54e$var$createSelectorCreator($77bc9fe89b8fd54e$var$defaultMemoize);
function $77bc9fe89b8fd54e$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $77bc9fe89b8fd54e$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("ehjs8", function(module, exports) {
$parcel$export(module.exports, "useUFOTransitionCompleter", () => $e0324a8b3bd2f489$export$369f0ded13ce6c50);
$parcel$export(module.exports, "default", () => $e0324a8b3bd2f489$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $fiPhB = parcelRequire("fiPhB");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $kTRgU = parcelRequire("kTRgU");

var $hlf0k = parcelRequire("hlf0k");
function $e0324a8b3bd2f489$var$traceUFOTransition(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $jcIvM.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $2QO3b.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $2QO3b.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $kTRgU.default).current = ufoName;
        const rate = (0, $jcIvM.getInteractionRate)(ufoName, 'transition');
        if ((0, $2oAAJ.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $aXKmr.v4)();
            (0, $hlf0k.setInteractionActiveTrace)(newId);
            (0, $kVpZx.DefaultInteractionID).current = newId;
            (0, $2QO3b.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $fiPhB.getActiveTrace)());
        }
    }
}
function $e0324a8b3bd2f489$export$369f0ded13ce6c50() {
    const interactionId = (0, $eJOHy.useContext)((0, $kVpZx.default));
    const capturedInteractionId = interactionId.current;
    (0, $eJOHy.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $2QO3b.tryComplete)(capturedInteractionId);
                });
            });
            (0, $2QO3b.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $e0324a8b3bd2f489$export$2e2bcd8739ae039 = $e0324a8b3bd2f489$var$traceUFOTransition;

});
parcelRegister("kTRgU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d83fdedb7008f28$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $2d83fdedb7008f28$var$UFORouteName = {
    current: null
};
var $2d83fdedb7008f28$export$2e2bcd8739ae039 = $2d83fdedb7008f28$var$UFORouteName;

});

parcelRegister("hlf0k", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $f8d6d6ea08fb2f24$export$f2e521e495a88544);

var $fiPhB = parcelRequire("fiPhB");

var $60IA9 = parcelRequire("60IA9");
function $f8d6d6ea08fb2f24$export$f2e521e495a88544(newId) {
    (0, $fiPhB.setActiveTrace)(newId.replace(/-/g, ''), (0, $60IA9.generateSpanId)(), 'transition');
}

});
parcelRegister("60IA9", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $5bbbf214b1843fa6$export$295213bc4d0c54ad);
function $5bbbf214b1843fa6$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("ioEQd", function(module, exports) {
$parcel$export(module.exports, "GlobalPageLoadExperience", () => $38d63ebf6b3fc25b$export$bf7c1e56255f1467);

var $giU3c = parcelRequire("giU3c");

var $fTXZI = parcelRequire("fTXZI");

var $2lxLk = parcelRequire("2lxLk");

var $eYCyY = parcelRequire("eYCyY");
class $38d63ebf6b3fc25b$var$UFOGlobalPageLoadExperience extends (0, $fTXZI.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $fTXZI.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, $2lxLk.ExperienceTypes).Load, this.performanceType = (0, $2lxLk.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const $38d63ebf6b3fc25b$export$bf7c1e56255f1467 = new $38d63ebf6b3fc25b$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $giU3c.untilAll)([
        {
            category: (0, $eYCyY.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("giU3c", function(module, exports) {
$parcel$export(module.exports, "untilAll", () => $94735965704fd40e$export$44695628831598be);

var $20DN1 = parcelRequire("20DN1");

var $jnh7D = parcelRequire("jnh7D");
const $94735965704fd40e$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $94735965704fd40e$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $94735965704fd40e$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($94735965704fd40e$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($94735965704fd40e$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $jnh7D.UFOExperienceState).ABORTED || data.state === (0, $jnh7D.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $20DN1.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $jnh7D.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});
parcelRegister("jnh7D", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $b2ac2a271b6df9a8$export$81b70111112841a0);
const $b2ac2a271b6df9a8$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});


parcelRegister("fTXZI", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $e479da249a1768e7$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $e479da249a1768e7$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");


var $dSWrv = parcelRequire("dSWrv");

var $9mSCV = parcelRequire("9mSCV");

var $20DN1 = parcelRequire("20DN1");

var $kHJa7 = parcelRequire("kHJa7");

var $h1AcD = parcelRequire("h1AcD");

var $2uGRn = parcelRequire("2uGRn");

var $jnh7D = parcelRequire("jnh7D");

var $7d1lL = parcelRequire("7d1lL");

var $2lxLk = parcelRequire("2lxLk");
const $e479da249a1768e7$var$getPageVisibleState = ()=>{
    return !(0, $dSWrv.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $h1AcD.PageVisibleState).VISIBLE : (0, $h1AcD.PageVisibleState).HIDDEN;
};
const $e479da249a1768e7$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2uGRn.roundPerfNow)();
};
class $e479da249a1768e7$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $jnh7D.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $h1AcD.PageVisibleState).MIXED;
            (0, $kHJa7.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $e479da249a1768e7$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $2lxLk.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $20DN1.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $7d1lL.canTransition)(this.state, newState)) {
            (0, $20DN1.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $jnh7D.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $e479da249a1768e7$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $e479da249a1768e7$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $9mSCV.getGlobalEventStream)().push((0, $9mSCV.unsubscribeEvent)((0, $h1AcD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $20DN1.ufolog)('this.parent', this.parent);
                (0, $9mSCV.getGlobalEventStream)().push((0, $9mSCV.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $20DN1.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $20DN1.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $jnh7D.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $e479da249a1768e7$var$getPageVisibleState();
            (0, $kHJa7.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $20DN1.ufolog)('subscribed', this.id);
                (0, $9mSCV.getGlobalEventStream)().push((0, $9mSCV.subscribeEvent)((0, $h1AcD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $h1AcD.FMP_MARK) && name !== (0, $h1AcD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $20DN1.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $e479da249a1768e7$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $jnh7D.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $h1AcD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $h1AcD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $20DN1.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $kHJa7.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $jnh7D.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $jnh7D.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $jnh7D.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $20DN1.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $34234590f9b2f613$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $34234590f9b2f613$export$2295b861f318254a = '0.1.5';

parcelRegister("2uGRn", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $43e53b9bba0a96b4$export$5f490af6b2b115cf);
const $43e53b9bba0a96b4$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("7d1lL", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $25a5a8e8c51ed208$export$178881f329fdb81f);

var $jnh7D = parcelRequire("jnh7D");
const $25a5a8e8c51ed208$var$UFOStateAvailableTransitions = {
    [(0, $jnh7D.UFOExperienceState).NOT_STARTED.id]: [
        (0, $jnh7D.UFOExperienceState).STARTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).STARTED.id]: [
        (0, $jnh7D.UFOExperienceState).IN_PROGRESS.id,
        (0, $jnh7D.UFOExperienceState).BLOCKED.id,
        (0, $jnh7D.UFOExperienceState).SUCCEEDED.id,
        (0, $jnh7D.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jnh7D.UFOExperienceState).FAILED.id,
        (0, $jnh7D.UFOExperienceState).ABORTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $jnh7D.UFOExperienceState).BLOCKED.id,
        (0, $jnh7D.UFOExperienceState).SUCCEEDED.id,
        (0, $jnh7D.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jnh7D.UFOExperienceState).FAILED.id,
        (0, $jnh7D.UFOExperienceState).ABORTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).BLOCKED.id]: [
        (0, $jnh7D.UFOExperienceState).RECOVERED.id,
        (0, $jnh7D.UFOExperienceState).ABORTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).RECOVERED.id]: [
        (0, $jnh7D.UFOExperienceState).STARTED.id,
        (0, $jnh7D.UFOExperienceState).SUCCEEDED.id,
        (0, $jnh7D.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jnh7D.UFOExperienceState).FAILED.id,
        (0, $jnh7D.UFOExperienceState).ABORTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).SUCCEEDED.id]: [
        (0, $jnh7D.UFOExperienceState).STARTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $jnh7D.UFOExperienceState).SUCCEEDED.id,
        (0, $jnh7D.UFOExperienceState).FAILED.id,
        (0, $jnh7D.UFOExperienceState).ABORTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).FAILED.id]: [
        (0, $jnh7D.UFOExperienceState).STARTED.id
    ],
    [(0, $jnh7D.UFOExperienceState).ABORTED.id]: [
        (0, $jnh7D.UFOExperienceState).STARTED.id
    ]
};
const $25a5a8e8c51ed208$export$178881f329fdb81f = (state1, state2)=>{
    return $25a5a8e8c51ed208$var$UFOStateAvailableTransitions[state1.id] && $25a5a8e8c51ed208$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});


parcelRegister("eYCyY", function(module, exports) {
$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $c1fb94b6365b1ff3$export$17d97452062ccf73);
const $c1fb94b6365b1ff3$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("7mF43", function(module, exports) {

var $1rzja = parcelRequire("1rzja");

var $auNny = parcelRequire("auNny");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $55ca7107246c2abd$var$camelCase = $auNny(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $1rzja(word) : word);
});
module.exports = $55ca7107246c2abd$var$camelCase;

});
parcelRegister("1rzja", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");

var $jK0pg = parcelRequire("jK0pg");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $10d3b38905757c28$var$capitalize(string) {
    return $jK0pg($cz1WF(string).toLowerCase());
}
module.exports = $10d3b38905757c28$var$capitalize;

});
parcelRegister("jK0pg", function(module, exports) {

var $c0WDi = parcelRequire("c0WDi");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $e5f2a0e6551bc108$var$upperFirst = $c0WDi('toUpperCase');
module.exports = $e5f2a0e6551bc108$var$upperFirst;

});
parcelRegister("c0WDi", function(module, exports) {

var $j4Djm = parcelRequire("j4Djm");

var $beeZR = parcelRequire("beeZR");

var $gsm7J = parcelRequire("gsm7J");

var $cz1WF = parcelRequire("cz1WF");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $8bf2f764055b2c95$var$createCaseFirst(methodName) {
    return function(string) {
        string = $cz1WF(string);
        var strSymbols = $beeZR(string) ? $gsm7J(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $j4Djm(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $8bf2f764055b2c95$var$createCaseFirst;

});
parcelRegister("j4Djm", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $de2ce2712045b876$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $1FqKq(array, start, end);
}
module.exports = $de2ce2712045b876$var$castSlice;

});
parcelRegister("1FqKq", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $136e5e577b5a0efb$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $136e5e577b5a0efb$var$baseSlice;

});


parcelRegister("beeZR", function(module, exports) {
/** Used to compose unicode character classes. */ var $82cca28b825da4c2$var$rsAstralRange = '\\ud800-\\udfff', $82cca28b825da4c2$var$rsComboMarksRange = '\\u0300-\\u036f', $82cca28b825da4c2$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $82cca28b825da4c2$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $82cca28b825da4c2$var$rsComboRange = $82cca28b825da4c2$var$rsComboMarksRange + $82cca28b825da4c2$var$reComboHalfMarksRange + $82cca28b825da4c2$var$rsComboSymbolsRange, $82cca28b825da4c2$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $82cca28b825da4c2$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $82cca28b825da4c2$var$reHasUnicode = RegExp('[' + $82cca28b825da4c2$var$rsZWJ + $82cca28b825da4c2$var$rsAstralRange + $82cca28b825da4c2$var$rsComboRange + $82cca28b825da4c2$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $82cca28b825da4c2$var$hasUnicode(string) {
    return $82cca28b825da4c2$var$reHasUnicode.test(string);
}
module.exports = $82cca28b825da4c2$var$hasUnicode;

});

parcelRegister("gsm7J", function(module, exports) {

var $goUhd = parcelRequire("goUhd");

var $beeZR = parcelRequire("beeZR");

var $1w59V = parcelRequire("1w59V");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $bfb06c2da7212147$var$stringToArray(string) {
    return $beeZR(string) ? $1w59V(string) : $goUhd(string);
}
module.exports = $bfb06c2da7212147$var$stringToArray;

});
parcelRegister("goUhd", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $bf0a8a9d1377e36d$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $bf0a8a9d1377e36d$var$asciiToArray;

});

parcelRegister("1w59V", function(module, exports) {
/** Used to compose unicode character classes. */ var $11acc813663f26dc$var$rsAstralRange = '\\ud800-\\udfff', $11acc813663f26dc$var$rsComboMarksRange = '\\u0300-\\u036f', $11acc813663f26dc$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $11acc813663f26dc$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $11acc813663f26dc$var$rsComboRange = $11acc813663f26dc$var$rsComboMarksRange + $11acc813663f26dc$var$reComboHalfMarksRange + $11acc813663f26dc$var$rsComboSymbolsRange, $11acc813663f26dc$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $11acc813663f26dc$var$rsAstral = '[' + $11acc813663f26dc$var$rsAstralRange + ']', $11acc813663f26dc$var$rsCombo = '[' + $11acc813663f26dc$var$rsComboRange + ']', $11acc813663f26dc$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $11acc813663f26dc$var$rsModifier = '(?:' + $11acc813663f26dc$var$rsCombo + '|' + $11acc813663f26dc$var$rsFitz + ')', $11acc813663f26dc$var$rsNonAstral = '[^' + $11acc813663f26dc$var$rsAstralRange + ']', $11acc813663f26dc$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $11acc813663f26dc$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $11acc813663f26dc$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $11acc813663f26dc$var$reOptMod = $11acc813663f26dc$var$rsModifier + '?', $11acc813663f26dc$var$rsOptVar = '[' + $11acc813663f26dc$var$rsVarRange + ']?', $11acc813663f26dc$var$rsOptJoin = '(?:' + $11acc813663f26dc$var$rsZWJ + '(?:' + [
    $11acc813663f26dc$var$rsNonAstral,
    $11acc813663f26dc$var$rsRegional,
    $11acc813663f26dc$var$rsSurrPair
].join('|') + ')' + $11acc813663f26dc$var$rsOptVar + $11acc813663f26dc$var$reOptMod + ')*', $11acc813663f26dc$var$rsSeq = $11acc813663f26dc$var$rsOptVar + $11acc813663f26dc$var$reOptMod + $11acc813663f26dc$var$rsOptJoin, $11acc813663f26dc$var$rsSymbol = '(?:' + [
    $11acc813663f26dc$var$rsNonAstral + $11acc813663f26dc$var$rsCombo + '?',
    $11acc813663f26dc$var$rsCombo,
    $11acc813663f26dc$var$rsRegional,
    $11acc813663f26dc$var$rsSurrPair,
    $11acc813663f26dc$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $11acc813663f26dc$var$reUnicode = RegExp($11acc813663f26dc$var$rsFitz + '(?=' + $11acc813663f26dc$var$rsFitz + ')|' + $11acc813663f26dc$var$rsSymbol + $11acc813663f26dc$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $11acc813663f26dc$var$unicodeToArray(string) {
    return string.match($11acc813663f26dc$var$reUnicode) || [];
}
module.exports = $11acc813663f26dc$var$unicodeToArray;

});





parcelRegister("auNny", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $jZ5x9 = parcelRequire("jZ5x9");

var $e4QpN = parcelRequire("e4QpN");
/** Used to compose unicode capture groups. */ var $7a43025a04797511$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $7a43025a04797511$var$reApos = RegExp($7a43025a04797511$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $7a43025a04797511$var$createCompounder(callback) {
    return function(string) {
        return $2x6Yt($e4QpN($jZ5x9(string).replace($7a43025a04797511$var$reApos, '')), callback, '');
    };
}
module.exports = $7a43025a04797511$var$createCompounder;

});
parcelRegister("2x6Yt", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1d8412cc6c5da549$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $1d8412cc6c5da549$var$arrayReduce;

});

parcelRegister("jZ5x9", function(module, exports) {

var $ezX5z = parcelRequire("ezX5z");

var $cz1WF = parcelRequire("cz1WF");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $e8c801ad4e9925cd$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $e8c801ad4e9925cd$var$rsComboMarksRange = '\\u0300-\\u036f', $e8c801ad4e9925cd$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $e8c801ad4e9925cd$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $e8c801ad4e9925cd$var$rsComboRange = $e8c801ad4e9925cd$var$rsComboMarksRange + $e8c801ad4e9925cd$var$reComboHalfMarksRange + $e8c801ad4e9925cd$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $e8c801ad4e9925cd$var$rsCombo = '[' + $e8c801ad4e9925cd$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $e8c801ad4e9925cd$var$reComboMark = RegExp($e8c801ad4e9925cd$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $e8c801ad4e9925cd$var$deburr(string) {
    string = $cz1WF(string);
    return string && string.replace($e8c801ad4e9925cd$var$reLatin, $ezX5z).replace($e8c801ad4e9925cd$var$reComboMark, '');
}
module.exports = $e8c801ad4e9925cd$var$deburr;

});
parcelRegister("ezX5z", function(module, exports) {

var $loEwo = parcelRequire("loEwo");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $a9d22b6967b987ff$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $a9d22b6967b987ff$var$deburrLetter = $loEwo($a9d22b6967b987ff$var$deburredLetters);
module.exports = $a9d22b6967b987ff$var$deburrLetter;

});
parcelRegister("loEwo", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $f93b459096362628$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $f93b459096362628$var$basePropertyOf;

});



parcelRegister("e4QpN", function(module, exports) {

var $ai2bm = parcelRequire("ai2bm");

var $lh9An = parcelRequire("lh9An");

var $cz1WF = parcelRequire("cz1WF");

var $293dC = parcelRequire("293dC");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $a3fa18f82c5d7d8f$var$words(string, pattern, guard) {
    string = $cz1WF(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $lh9An(string) ? $293dC(string) : $ai2bm(string);
    return string.match(pattern) || [];
}
module.exports = $a3fa18f82c5d7d8f$var$words;

});
parcelRegister("ai2bm", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $77dd4728fdec592c$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $77dd4728fdec592c$var$asciiWords(string) {
    return string.match($77dd4728fdec592c$var$reAsciiWord) || [];
}
module.exports = $77dd4728fdec592c$var$asciiWords;

});

parcelRegister("lh9An", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $f7d29f08d99f314e$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $f7d29f08d99f314e$var$hasUnicodeWord(string) {
    return $f7d29f08d99f314e$var$reHasUnicodeWord.test(string);
}
module.exports = $f7d29f08d99f314e$var$hasUnicodeWord;

});

parcelRegister("293dC", function(module, exports) {
/** Used to compose unicode character classes. */ var $18feeb2c79bdcb6e$var$rsAstralRange = '\\ud800-\\udfff', $18feeb2c79bdcb6e$var$rsComboMarksRange = '\\u0300-\\u036f', $18feeb2c79bdcb6e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $18feeb2c79bdcb6e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $18feeb2c79bdcb6e$var$rsComboRange = $18feeb2c79bdcb6e$var$rsComboMarksRange + $18feeb2c79bdcb6e$var$reComboHalfMarksRange + $18feeb2c79bdcb6e$var$rsComboSymbolsRange, $18feeb2c79bdcb6e$var$rsDingbatRange = '\\u2700-\\u27bf', $18feeb2c79bdcb6e$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $18feeb2c79bdcb6e$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $18feeb2c79bdcb6e$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $18feeb2c79bdcb6e$var$rsPunctuationRange = '\\u2000-\\u206f', $18feeb2c79bdcb6e$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $18feeb2c79bdcb6e$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $18feeb2c79bdcb6e$var$rsVarRange = '\\ufe0e\\ufe0f', $18feeb2c79bdcb6e$var$rsBreakRange = $18feeb2c79bdcb6e$var$rsMathOpRange + $18feeb2c79bdcb6e$var$rsNonCharRange + $18feeb2c79bdcb6e$var$rsPunctuationRange + $18feeb2c79bdcb6e$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $18feeb2c79bdcb6e$var$rsApos = "['\u2019]", $18feeb2c79bdcb6e$var$rsBreak = '[' + $18feeb2c79bdcb6e$var$rsBreakRange + ']', $18feeb2c79bdcb6e$var$rsCombo = '[' + $18feeb2c79bdcb6e$var$rsComboRange + ']', $18feeb2c79bdcb6e$var$rsDigits = '\\d+', $18feeb2c79bdcb6e$var$rsDingbat = '[' + $18feeb2c79bdcb6e$var$rsDingbatRange + ']', $18feeb2c79bdcb6e$var$rsLower = '[' + $18feeb2c79bdcb6e$var$rsLowerRange + ']', $18feeb2c79bdcb6e$var$rsMisc = '[^' + $18feeb2c79bdcb6e$var$rsAstralRange + $18feeb2c79bdcb6e$var$rsBreakRange + $18feeb2c79bdcb6e$var$rsDigits + $18feeb2c79bdcb6e$var$rsDingbatRange + $18feeb2c79bdcb6e$var$rsLowerRange + $18feeb2c79bdcb6e$var$rsUpperRange + ']', $18feeb2c79bdcb6e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $18feeb2c79bdcb6e$var$rsModifier = '(?:' + $18feeb2c79bdcb6e$var$rsCombo + '|' + $18feeb2c79bdcb6e$var$rsFitz + ')', $18feeb2c79bdcb6e$var$rsNonAstral = '[^' + $18feeb2c79bdcb6e$var$rsAstralRange + ']', $18feeb2c79bdcb6e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $18feeb2c79bdcb6e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $18feeb2c79bdcb6e$var$rsUpper = '[' + $18feeb2c79bdcb6e$var$rsUpperRange + ']', $18feeb2c79bdcb6e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $18feeb2c79bdcb6e$var$rsMiscLower = '(?:' + $18feeb2c79bdcb6e$var$rsLower + '|' + $18feeb2c79bdcb6e$var$rsMisc + ')', $18feeb2c79bdcb6e$var$rsMiscUpper = '(?:' + $18feeb2c79bdcb6e$var$rsUpper + '|' + $18feeb2c79bdcb6e$var$rsMisc + ')', $18feeb2c79bdcb6e$var$rsOptContrLower = '(?:' + $18feeb2c79bdcb6e$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $18feeb2c79bdcb6e$var$rsOptContrUpper = '(?:' + $18feeb2c79bdcb6e$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $18feeb2c79bdcb6e$var$reOptMod = $18feeb2c79bdcb6e$var$rsModifier + '?', $18feeb2c79bdcb6e$var$rsOptVar = '[' + $18feeb2c79bdcb6e$var$rsVarRange + ']?', $18feeb2c79bdcb6e$var$rsOptJoin = '(?:' + $18feeb2c79bdcb6e$var$rsZWJ + '(?:' + [
    $18feeb2c79bdcb6e$var$rsNonAstral,
    $18feeb2c79bdcb6e$var$rsRegional,
    $18feeb2c79bdcb6e$var$rsSurrPair
].join('|') + ')' + $18feeb2c79bdcb6e$var$rsOptVar + $18feeb2c79bdcb6e$var$reOptMod + ')*', $18feeb2c79bdcb6e$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $18feeb2c79bdcb6e$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $18feeb2c79bdcb6e$var$rsSeq = $18feeb2c79bdcb6e$var$rsOptVar + $18feeb2c79bdcb6e$var$reOptMod + $18feeb2c79bdcb6e$var$rsOptJoin, $18feeb2c79bdcb6e$var$rsEmoji = '(?:' + [
    $18feeb2c79bdcb6e$var$rsDingbat,
    $18feeb2c79bdcb6e$var$rsRegional,
    $18feeb2c79bdcb6e$var$rsSurrPair
].join('|') + ')' + $18feeb2c79bdcb6e$var$rsSeq;
/** Used to match complex or compound words. */ var $18feeb2c79bdcb6e$var$reUnicodeWord = RegExp([
    $18feeb2c79bdcb6e$var$rsUpper + '?' + $18feeb2c79bdcb6e$var$rsLower + '+' + $18feeb2c79bdcb6e$var$rsOptContrLower + '(?=' + [
        $18feeb2c79bdcb6e$var$rsBreak,
        $18feeb2c79bdcb6e$var$rsUpper,
        '$'
    ].join('|') + ')',
    $18feeb2c79bdcb6e$var$rsMiscUpper + '+' + $18feeb2c79bdcb6e$var$rsOptContrUpper + '(?=' + [
        $18feeb2c79bdcb6e$var$rsBreak,
        $18feeb2c79bdcb6e$var$rsUpper + $18feeb2c79bdcb6e$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $18feeb2c79bdcb6e$var$rsUpper + '?' + $18feeb2c79bdcb6e$var$rsMiscLower + '+' + $18feeb2c79bdcb6e$var$rsOptContrLower,
    $18feeb2c79bdcb6e$var$rsUpper + '+' + $18feeb2c79bdcb6e$var$rsOptContrUpper,
    $18feeb2c79bdcb6e$var$rsOrdUpper,
    $18feeb2c79bdcb6e$var$rsOrdLower,
    $18feeb2c79bdcb6e$var$rsDigits,
    $18feeb2c79bdcb6e$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $18feeb2c79bdcb6e$var$unicodeWords(string) {
    return string.match($18feeb2c79bdcb6e$var$reUnicodeWord) || [];
}
module.exports = $18feeb2c79bdcb6e$var$unicodeWords;

});




parcelRegister("6NDp7", function(module, exports) {

var $auNny = parcelRequire("auNny");

var $jK0pg = parcelRequire("jK0pg");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $4f35e28334026a71$var$startCase = $auNny(function(result, word, index) {
    return result + (index ? ' ' : '') + $jK0pg(word);
});
module.exports = $4f35e28334026a71$var$startCase;

});

parcelRegister("hqYEY", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $39e33f1e9d6d276b$export$b0c5c2fac8144e54);

var $4EA5D = parcelRequire("4EA5D");

var $kAheH = parcelRequire("kAheH");
const $39e33f1e9d6d276b$export$b0c5c2fac8144e54 = {
    pageLoad: $kAheH.pageLoad,
    pageSegmentLoad: $kAheH.pageSegmentLoad,
    interaction: $kAheH.interaction,
    custom: $kAheH.custom,
    concurrent: $4EA5D.concurrent
};

});
parcelRegister("4EA5D", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $6c5957d7aa0ac79b$export$370df09ecc3de059);

var $cXQfL = parcelRequire("cXQfL");

var $kAheH = parcelRequire("kAheH");
const $6c5957d7aa0ac79b$var$concurrentMetrics = {};
const $6c5957d7aa0ac79b$var$getKey = (config, type)=>`${type}--${config.key}`;
const $6c5957d7aa0ac79b$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $6c5957d7aa0ac79b$var$ensurePath = (config, type)=>{
    const key = $6c5957d7aa0ac79b$var$getKey(config, type);
    if (!(key in $6c5957d7aa0ac79b$var$concurrentMetrics)) $6c5957d7aa0ac79b$var$concurrentMetrics[key] = {};
};
const $6c5957d7aa0ac79b$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $6c5957d7aa0ac79b$var$getKey(config, type);
    if (concurrentKey in $6c5957d7aa0ac79b$var$concurrentMetrics && $6c5957d7aa0ac79b$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $6c5957d7aa0ac79b$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $6c5957d7aa0ac79b$var$concurrentMetrics)) $6c5957d7aa0ac79b$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $6c5957d7aa0ac79b$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $6c5957d7aa0ac79b$var$validateConfig(config);
    $6c5957d7aa0ac79b$var$ensurePath(config, type);
    const metricFromCache = $6c5957d7aa0ac79b$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $cXQfL.BMEventsType).INLINE_RESULT ? (0, $kAheH.interaction) : (0, $kAheH.custom);
    const metric = metricFactory(config);
    $6c5957d7aa0ac79b$var$concurrentMetrics[$6c5957d7aa0ac79b$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $6c5957d7aa0ac79b$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$6c5957d7aa0ac79b$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$6c5957d7aa0ac79b$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $cXQfL.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$6c5957d7aa0ac79b$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $cXQfL.BMEventsType).CUSTOM)
};

});
parcelRegister("kAheH", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $79e1776f2b5ebf92$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $79e1776f2b5ebf92$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $79e1776f2b5ebf92$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $79e1776f2b5ebf92$export$4c00f665f0d4b443);

var $8OWCA = parcelRequire("8OWCA");

var $l5apP = parcelRequire("l5apP");

var $780Mt = parcelRequire("780Mt");

var $cXQfL = parcelRequire("cXQfL");
const $79e1776f2b5ebf92$export$791d520f7e8058a5 = (config)=>{
    return new (0, $l5apP.PageLoadMetric)({
        ...config,
        type: (0, $cXQfL.BMEventsType).PAGE_LOAD
    });
};
const $79e1776f2b5ebf92$export$94114666844d5f66 = (config)=>{
    return new (0, $780Mt.PageSegmentLoadMetric)({
        ...config,
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $79e1776f2b5ebf92$export$92473e6020ad89b4 = (config)=>{
    return new (0, $8OWCA.Metric)({
        ...config,
        type: (0, $cXQfL.BMEventsType).INLINE_RESULT
    });
};
const $79e1776f2b5ebf92$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $8OWCA.Metric)({
        ...config,
        type: (0, $cXQfL.BMEventsType).CUSTOM
    });
};

});
parcelRegister("8OWCA", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $103cf4e1861f2275$export$efdd3e096bc27746);

var $7iYeO = parcelRequire("7iYeO");

var $1bqgN = parcelRequire("1bqgN");

var $4nAvL = parcelRequire("4nAvL");
class $103cf4e1861f2275$export$efdd3e096bc27746 extends (0, $4nAvL.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $7iYeO.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $1bqgN.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("l5apP", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $22a1e3fedd9cf1fe$export$3c51073271a9eac3);

var $3yxn4 = parcelRequire("3yxn4");

var $aYXC1 = parcelRequire("aYXC1");

var $7iYeO = parcelRequire("7iYeO");

var $1bqgN = parcelRequire("1bqgN");

var $cXQfL = parcelRequire("cXQfL");

var $coO5R = parcelRequire("coO5R");

var $gIaDh = parcelRequire("gIaDh");

var $cPmtP = parcelRequire("cPmtP");
class $22a1e3fedd9cf1fe$export$3c51073271a9eac3 extends (0, $coO5R.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $gIaDh.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $gIaDh.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $gIaDh.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $coO5R.BasePageLoadMetric).FMP]) {
                const mark = (0, $3yxn4.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $gIaDh.pageLoadMetaMetric).markFMP(mark);
            } else (0, $gIaDh.pageLoadMetaMetric).markFMP(this.marks[(0, $coO5R.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $7iYeO.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $1bqgN.submitter).queue(data);
        (0, $aYXC1.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $gIaDh.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $gIaDh.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $gIaDh.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $1bqgN.submitter).config.configChunk;
        if (!configChunk?.[(0, $cXQfL.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $cPmtP.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $1bqgN.submitter).queue(webVitalMetric.getData());
        (0, $aYXC1.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("cPmtP", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $8957110f8dc958c8$export$dc0d85d4d6503cd7);

var $cXQfL = parcelRequire("cXQfL");

var $4nAvL = parcelRequire("4nAvL");
class $8957110f8dc958c8$export$dc0d85d4d6503cd7 extends (0, $4nAvL.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $cXQfL.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4nAvL.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("780Mt", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $50380b5bbc3c40d2$export$24c8bfcd77494cc1);

var $3yxn4 = parcelRequire("3yxn4");

var $cXQfL = parcelRequire("cXQfL");

var $4nAvL = parcelRequire("4nAvL");

var $8OWCA = parcelRequire("8OWCA");

var $gIaDh = parcelRequire("gIaDh");
class $50380b5bbc3c40d2$export$24c8bfcd77494cc1 extends (0, $8OWCA.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $gIaDh.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $50380b5bbc3c40d2$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($50380b5bbc3c40d2$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $gIaDh.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$50380b5bbc3c40d2$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $3yxn4.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $cXQfL.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4nAvL.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4nAvL.MetricState).STARTED) (0, $gIaDh.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("fsdQg", function(module, exports) {
module.exports = $b40435496fea6640$var$defaultsPlugin;
function $b40435496fea6640$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("48TwY", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $9ae3593ba8ccf1af$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $9ae3593ba8ccf1af$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $9ae3593ba8ccf1af$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("kMruL")).WebStorageType);

var $9SIye = parcelRequire("9SIye");
var $cnsbg = parcelRequire("cnsbg");

var $60vYG = parcelRequire("60vYG");

var $6T1aH = parcelRequire("6T1aH");

var $9lTmU = parcelRequire("9lTmU");

var $kMruL = parcelRequire("kMruL");

var $hDiko = parcelRequire("hDiko");
var $4OAg2 = parcelRequire("4OAg2");
var $31mod = parcelRequire("31mod");
class $9ae3593ba8ccf1af$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $9lTmU.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $60vYG.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $9SIye.getBscGlobalState)().webStorageEnabled) return true;
        (0, $60vYG.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $60vYG.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $hDiko.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $60vYG.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $9SIye.getBscGlobalState)().product;
        const itemSetStatus = await (0, $4OAg2.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $60vYG.Logger).debug(`${itemSetStatus === (0, $6T1aH.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $60vYG.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $31mod.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $60vYG.Logger).debug(`${itemSetStatus === (0, $6T1aH.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $60vYG.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $cnsbg.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $9ae3593ba8ccf1af$export$c8cc3ffd3f2c1d2f = new $9ae3593ba8ccf1af$export$8e4a3cf07a10930b(window?.localStorage, (0, $kMruL.WebStorageType).LocalStorage);
const $9ae3593ba8ccf1af$export$edbae459bdf957a5 = new $9ae3593ba8ccf1af$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $kMruL.WebStorageType).SessionStorage);
const $9ae3593ba8ccf1af$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $kMruL.WebStorageType).LocalStorage]: $9ae3593ba8ccf1af$export$c8cc3ffd3f2c1d2f,
        [(0, $kMruL.WebStorageType).SessionStorage]: $9ae3593ba8ccf1af$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("9SIye", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $43d404a92474e748$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $43d404a92474e748$export$882c4530c58781d8);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $6T1aH = parcelRequire("6T1aH");

var $l4GgM = parcelRequire("l4GgM");

var $60vYG = parcelRequire("60vYG");
let $43d404a92474e748$var$analyticsEnabledGlobalState;
let $43d404a92474e748$var$productGlobalState;
let $43d404a92474e748$var$perimeterGlobalState;
let $43d404a92474e748$var$webStorageControlsEnabledGlobalState;
let $43d404a92474e748$var$localConsentModeGlobalState;
let $43d404a92474e748$var$packageDebugModeEnabledGlobalState;
let $43d404a92474e748$var$allowUncategorizedCookiesInOverridesGlobalState;
let $43d404a92474e748$var$hasInitialized = false;
let $43d404a92474e748$var$cookiesCacheLoader;
let $43d404a92474e748$var$localStorageCacheLoader;
let $43d404a92474e748$var$sessionStorageCacheLoader;
let $43d404a92474e748$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $6T1aH.CategoryStorageType).Cookies:
            return await $43d404a92474e748$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $6T1aH.CategoryStorageType).LocalStorage:
            return await $43d404a92474e748$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $6T1aH.CategoryStorageType).SessionStorage:
            return await $43d404a92474e748$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $43d404a92474e748$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $43d404a92474e748$var$analyticsEnabledGlobalState ?? true,
        product: $43d404a92474e748$var$productGlobalState,
        perimeter: $43d404a92474e748$var$perimeterGlobalState,
        webStorageEnabled: $43d404a92474e748$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $43d404a92474e748$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $43d404a92474e748$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $43d404a92474e748$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $43d404a92474e748$var$cookiesCacheLoader,
        localStorageCacheLoader: $43d404a92474e748$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $43d404a92474e748$var$sessionStorageCacheLoader,
        loadCache: $43d404a92474e748$var$loadCache,
        hasInitialized: $43d404a92474e748$var$hasInitialized
    };
};
const $43d404a92474e748$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $60vYG.Logger).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$43d404a92474e748$var$productGlobalState || $43d404a92474e748$var$productGlobalState == null || $43d404a92474e748$var$productGlobalState === 'all') && product) $43d404a92474e748$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $43d404a92474e748$var$webStorageControlsEnabledGlobalState === undefined) $43d404a92474e748$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $eGOwo.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $43d404a92474e748$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $43d404a92474e748$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($43d404a92474e748$var$hasInitialized) return;
    if (!(0, $eGOwo.fg)('fedramp-cookies-controls')) $43d404a92474e748$var$localConsentModeGlobalState = localConsentMode;
    else // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    $43d404a92474e748$var$localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
    $43d404a92474e748$var$analyticsEnabledGlobalState = analyticsEnabled;
    $43d404a92474e748$var$perimeterGlobalState = perimeter;
    $43d404a92474e748$var$cookiesCacheLoader = new (0, $l4GgM.CacheLoader)((0, $6T1aH.CategoryStorageType).Cookies, perimeter);
    $43d404a92474e748$var$localStorageCacheLoader = new (0, $l4GgM.CacheLoader)((0, $6T1aH.CategoryStorageType).LocalStorage, perimeter);
    $43d404a92474e748$var$sessionStorageCacheLoader = new (0, $l4GgM.CacheLoader)((0, $6T1aH.CategoryStorageType).SessionStorage, perimeter);
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_debug_mode')) $43d404a92474e748$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get('atl-bsc-debug-mode'));
    $43d404a92474e748$var$hasInitialized = true;
};
const $43d404a92474e748$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $43d404a92474e748$var$loadCache = overrideLoadCache;
    if (overrideProduct) $43d404a92474e748$var$productGlobalState = overrideProduct;
};
const $43d404a92474e748$export$ac7c2edd09656c05 = ()=>{
    $43d404a92474e748$var$analyticsEnabledGlobalState = undefined;
    $43d404a92474e748$var$productGlobalState = undefined;
    $43d404a92474e748$var$webStorageControlsEnabledGlobalState = undefined;
    $43d404a92474e748$var$localConsentModeGlobalState = undefined;
    $43d404a92474e748$var$packageDebugModeEnabledGlobalState = undefined;
    $43d404a92474e748$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $43d404a92474e748$var$cookiesCacheLoader = undefined;
    $43d404a92474e748$var$localStorageCacheLoader = undefined;
    $43d404a92474e748$var$sessionStorageCacheLoader = undefined;
    $43d404a92474e748$var$hasInitialized = false;
};

});
parcelRegister("6T1aH", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $699d49366537a1d7$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $699d49366537a1d7$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $699d49366537a1d7$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $699d49366537a1d7$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $699d49366537a1d7$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $699d49366537a1d7$export$96e9906d6d93a972);
var $699d49366537a1d7$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $699d49366537a1d7$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $699d49366537a1d7$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $699d49366537a1d7$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $699d49366537a1d7$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $699d49366537a1d7$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $699d49366537a1d7$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $699d49366537a1d7$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("l4GgM", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $d84e08a41958ae2e$export$e479342c697b82a9);

var $eGOwo = parcelRequire("eGOwo");

var $6T1aH = parcelRequire("6T1aH");

var $60vYG = parcelRequire("60vYG");

var $4IEwo = parcelRequire("4IEwo");
class $d84e08a41958ae2e$export$e479342c697b82a9 {
    constructor(storageType, perimeter = 'commercial'){
        if (!(0, $eGOwo.fg)('fedramp-cookies-controls')) switch(storageType){
            case (0, $6T1aH.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $4IEwo.COOKIE_CACHE_URL_COMMERCIAL_PROD);
                break;
            case (0, $6T1aH.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $4IEwo.LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD);
                break;
            case (0, $6T1aH.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $4IEwo.SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD);
                break;
            default:
                this.cacheUrl = (0, $4IEwo.LEGACY_COOKIE_CACHE_URL_PROD);
        }
        else {
            // If a new perimeter type is added, but not supported by us yet, default to commercial URLs
            const cacheUrlLookup = (0, $4IEwo.CATEGORY_CACHE_URL_PERIMETER_LOOKUP)[perimeter] || (0, $4IEwo.COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP);
            this.cacheUrl = cacheUrlLookup[storageType];
        }
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $60vYG.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("60vYG", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $c9beafc98f4373dc$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $9SIye = parcelRequire("9SIye");
const $c9beafc98f4373dc$var$LOG_PREFIX = '[browser-storage-controls]';
class $c9beafc98f4373dc$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$c9beafc98f4373dc$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$c9beafc98f4373dc$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $lgusX.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$c9beafc98f4373dc$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
	 * Logger for additional debugging of the package. Debug logs are only sent when the
	 * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
	 */ static debug(message, metadata) {
        if ((0, $9SIye.getBscGlobalState)().packageDebugMode && (0, $eGOwo.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$c9beafc98f4373dc$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("lgusX", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $6231a7ac0d6748f9$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $6231a7ac0d6748f9$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $6231a7ac0d6748f9$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $6231a7ac0d6748f9$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $6231a7ac0d6748f9$export$1ba525b8a711eaac);

var $6g1o6 = parcelRequire("6g1o6");
var $78ewy = parcelRequire("78ewy");

var $9SIye = parcelRequire("9SIye");

var $60vYG = parcelRequire("60vYG");

var $5xP1I = parcelRequire("5xP1I");

var $63Yei = parcelRequire("63Yei");
const $6231a7ac0d6748f9$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $78ewy.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $78ewy.envType).DEV;
    return (0, $78ewy.envType).PROD;
};
const $6231a7ac0d6748f9$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $6231a7ac0d6748f9$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $6231a7ac0d6748f9$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $6231a7ac0d6748f9$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $6231a7ac0d6748f9$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $6231a7ac0d6748f9$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $6231a7ac0d6748f9$export$fce3dd735e04d566();
    return {
        packageName: $5xP1I.packageName,
        packageVersion: $5xP1I.packageVersion,
        domain: domain,
        product: (0, $9SIye.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $6231a7ac0d6748f9$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $9SIye.getBscGlobalState)().analyticsEnabled) instance = new (0, $6g1o6.default)({
                env: $6231a7ac0d6748f9$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $60vYG.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $9SIye.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $6231a7ac0d6748f9$export$5bfe55348e7aebc1(properties) {
    (0, $63Yei.withAnalyticsEventSampling)(properties.action, ()=>$6231a7ac0d6748f9$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $6231a7ac0d6748f9$var$decorateEventAttributes(properties.attributes)
        }));
}
function $6231a7ac0d6748f9$export$1aecf263098db667(properties) {
    $6231a7ac0d6748f9$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $6231a7ac0d6748f9$var$decorateEventAttributes(properties.attributes)
    });
}
function $6231a7ac0d6748f9$export$22a3b1671f38a193(properties) {
    $6231a7ac0d6748f9$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $6231a7ac0d6748f9$var$decorateEventAttributes(properties.attributes)
    });
}
function $6231a7ac0d6748f9$export$1ba525b8a711eaac(properties) {
    $6231a7ac0d6748f9$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $6231a7ac0d6748f9$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("5xP1I", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $88e9fd0e571b2a4a$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $88e9fd0e571b2a4a$export$91546b032799aa40);
const $88e9fd0e571b2a4a$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $88e9fd0e571b2a4a$export$91546b032799aa40 = "0.0.0-use.local" ?? '';

});

parcelRegister("63Yei", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $0060e7b4f5a50409$export$67b6e87f323cb6ad);

var $6T1aH = parcelRequire("6T1aH");

var $9SIye = parcelRequire("9SIye");

var $2Q7IK = parcelRequire("2Q7IK");

var $cnsbg = parcelRequire("cnsbg");
const $0060e7b4f5a50409$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $0060e7b4f5a50409$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $0060e7b4f5a50409$var$loadSamplingConfig() {
    if ((0, $2Q7IK.cache).cachedSamplingConfig) return (0, $2Q7IK.cache).cachedSamplingConfig;
    if ((0, $cnsbg.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $9SIye.getBscGlobalState)();
    const controlsData = await loadCache((0, $6T1aH.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $2Q7IK.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $0060e7b4f5a50409$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($0060e7b4f5a50409$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $0060e7b4f5a50409$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $0060e7b4f5a50409$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $0060e7b4f5a50409$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $0060e7b4f5a50409$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $0060e7b4f5a50409$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $0060e7b4f5a50409$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $0060e7b4f5a50409$export$b286f5e8716d11ad(analyticsEventKey);
    $0060e7b4f5a50409$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("2Q7IK", function(module, exports) {
$parcel$export(module.exports, "cache", () => $54e6bed9e27de240$export$69a3209f1a06c04d);

var $cM9c7 = parcelRequire("cM9c7");
const $54e6bed9e27de240$export$69a3209f1a06c04d = new (0, $cM9c7.CachedSamplingConfig)();

});
parcelRegister("cM9c7", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $a69adc5ef9633013$export$b886edaf6623554a);
class $a69adc5ef9633013$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("cnsbg", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $37eae782491d6ab8$export$48d7c418edadb60c);

var $6g1o6 = parcelRequire("6g1o6");

var $eGOwo = parcelRequire("eGOwo");
const $37eae782491d6ab8$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $eGOwo.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $6g1o6.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});




parcelRegister("4IEwo", function(module, exports) {
$parcel$export(module.exports, "LEGACY_COOKIE_CACHE_URL_PROD", () => $7d3d1933e93f099c$export$194c34963e6f0bc6);
$parcel$export(module.exports, "COOKIE_CACHE_URL_COMMERCIAL_PROD", () => $7d3d1933e93f099c$export$b44048c6704cb5cb);
$parcel$export(module.exports, "LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD", () => $7d3d1933e93f099c$export$c55beaf8e17d7be2);
$parcel$export(module.exports, "SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD", () => $7d3d1933e93f099c$export$e1db91db5e7e324f);
$parcel$export(module.exports, "COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP", () => $7d3d1933e93f099c$export$218c59d0d43946aa);
$parcel$export(module.exports, "CATEGORY_CACHE_URL_PERIMETER_LOOKUP", () => $7d3d1933e93f099c$export$df45fb0af5b720ce);

var $6T1aH = parcelRequire("6T1aH");
const $7d3d1933e93f099c$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $7d3d1933e93f099c$export$b44048c6704cb5cb = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $7d3d1933e93f099c$export$c55beaf8e17d7be2 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $7d3d1933e93f099c$export$e1db91db5e7e324f = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
const $7d3d1933e93f099c$export$abf8d23e319d4d71 = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_COOKIE.json';
const $7d3d1933e93f099c$export$de367b95fcc6730f = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_LOCAL_STORAGE.json';
const $7d3d1933e93f099c$export$d5e6ad74bf291eaf = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_SESSION_STORAGE.json';
const $7d3d1933e93f099c$export$218c59d0d43946aa = {
    [(0, $6T1aH.CategoryStorageType).Cookies]: $7d3d1933e93f099c$export$b44048c6704cb5cb,
    [(0, $6T1aH.CategoryStorageType).LocalStorage]: $7d3d1933e93f099c$export$c55beaf8e17d7be2,
    [(0, $6T1aH.CategoryStorageType).SessionStorage]: $7d3d1933e93f099c$export$e1db91db5e7e324f
};
const $7d3d1933e93f099c$export$df45fb0af5b720ce = {
    commercial: $7d3d1933e93f099c$export$218c59d0d43946aa,
    'fedramp-moderate': {
        [(0, $6T1aH.CategoryStorageType).Cookies]: $7d3d1933e93f099c$export$abf8d23e319d4d71,
        [(0, $6T1aH.CategoryStorageType).LocalStorage]: $7d3d1933e93f099c$export$de367b95fcc6730f,
        [(0, $6T1aH.CategoryStorageType).SessionStorage]: $7d3d1933e93f099c$export$d5e6ad74bf291eaf
    }
};

});



parcelRegister("9lTmU", function(module, exports) {
$parcel$export(module.exports, "BSCIndexedDB", () => $74cf185c6cc9d4ba$export$36328b3bcbe4623a);

var $cnsbg = parcelRequire("cnsbg");

var $60vYG = parcelRequire("60vYG");
class $74cf185c6cc9d4ba$export$fde2a4e0e57f47e {
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $60vYG.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $60vYG.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $60vYG.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $60vYG.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $60vYG.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $cnsbg.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $60vYG.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $60vYG.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $74cf185c6cc9d4ba$export$36328b3bcbe4623a = new $74cf185c6cc9d4ba$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("kMruL", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $b4aba77fd2dde240$export$259e3a861f28589b);
var $b4aba77fd2dde240$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("hDiko", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $f2baebf3c5c11399$export$e612bb1301d659de);

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");
const $f2baebf3c5c11399$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("4OAg2", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $9a09d7243e83978b$export$5ee8760f703d9d62);

var $lgusX = parcelRequire("lgusX");

var $15Ffx = parcelRequire("15Ffx");

var $60vYG = parcelRequire("60vYG");

var $9lTmU = parcelRequire("9lTmU");

var $6T1aH = parcelRequire("6T1aH");

var $kMruL = parcelRequire("kMruL");
const $9a09d7243e83978b$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $15Ffx.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $kMruL.WebStorageType).LocalStorage ? (0, $6T1aH.CategoryStorageType).LocalStorage : (0, $6T1aH.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $9lTmU.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $6T1aH.Status).SUCCESS;
        } else return (0, $6T1aH.Status).BLOCKED;
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $6T1aH.Status).BLOCKED;
    }
};

});
parcelRegister("15Ffx", function(module, exports) {
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $98bf34875a45eddb$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $9UP3e = parcelRequire("9UP3e");

var $6T1aH = parcelRequire("6T1aH");

var $9SIye = parcelRequire("9SIye");
const $98bf34875a45eddb$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $98bf34875a45eddb$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $98bf34875a45eddb$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $98bf34875a45eddb$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $98bf34875a45eddb$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $6T1aH.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $6T1aH.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $6T1aH.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $6T1aH.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $6T1aH.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $98bf34875a45eddb$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $9SIye.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $98bf34875a45eddb$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $98bf34875a45eddb$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $98bf34875a45eddb$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $6T1aH.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $9UP3e.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};

});
parcelRegister("9UP3e", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $5e3eb0b6229ca77c$export$1de6a888ae076ff8);

var $9SIye = parcelRequire("9SIye");
var $cnsbg = parcelRequire("cnsbg");

var $2hz3A = parcelRequire("2hz3A");

var $cE8Xm = parcelRequire("cE8Xm");

var $2p0jb = parcelRequire("2p0jb");

var $eCCyA = parcelRequire("eCCyA");
async function $5e3eb0b6229ca77c$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $9SIye.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $2p0jb.getCookie)((0, $2hz3A.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $eCCyA.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $cE8Xm.getConsentToken)();
            if ((0, $cnsbg.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $eCCyA.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $eCCyA.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("2hz3A", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $d67e96e0466dbe3b$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $d67e96e0466dbe3b$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $d67e96e0466dbe3b$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $d67e96e0466dbe3b$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $d67e96e0466dbe3b$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $d67e96e0466dbe3b$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $d67e96e0466dbe3b$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $d67e96e0466dbe3b$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $d67e96e0466dbe3b$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $d67e96e0466dbe3b$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $d67e96e0466dbe3b$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $d67e96e0466dbe3b$export$31deaeaebce525bb);

var $6T1aH = parcelRequire("6T1aH");
const $d67e96e0466dbe3b$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $d67e96e0466dbe3b$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $d67e96e0466dbe3b$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $d67e96e0466dbe3b$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $d67e96e0466dbe3b$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $d67e96e0466dbe3b$export$37073d560ecebada = 'atl-testing-consents';
const $d67e96e0466dbe3b$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $d67e96e0466dbe3b$export$b28b5d760fe14a21 = {
    [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $6T1aH.PreferenceCategory).Functional]: true,
    [(0, $6T1aH.PreferenceCategory).Marketing]: true,
    [(0, $6T1aH.PreferenceCategory).Analytics]: true,
    [(0, $6T1aH.PreferenceCategory).Unknown]: true
};
const $d67e96e0466dbe3b$export$4a12f9e99971760a = {
    [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $6T1aH.PreferenceCategory).Functional]: false,
    [(0, $6T1aH.PreferenceCategory).Marketing]: false,
    [(0, $6T1aH.PreferenceCategory).Analytics]: false,
    [(0, $6T1aH.PreferenceCategory).Unknown]: false
};
const $d67e96e0466dbe3b$export$f0fd1d13ec1d48f2 = {
    ...$d67e96e0466dbe3b$export$4a12f9e99971760a,
    [(0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $d67e96e0466dbe3b$export$f95182b7aa141c57 = '001';
const $d67e96e0466dbe3b$export$1f25427b34f9c405 = '002';
const $d67e96e0466dbe3b$export$31deaeaebce525bb = '003';

});

parcelRegister("cE8Xm", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $9d8ed08c3b8c2bf5$export$f1b8f2ca713fca08);

var $2hz3A = parcelRequire("2hz3A");

var $2p0jb = parcelRequire("2p0jb");

var $581Jb = parcelRequire("581Jb");

var $7nXZH = parcelRequire("7nXZH");

var $dXpgI = parcelRequire("dXpgI");
const $9d8ed08c3b8c2bf5$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $dXpgI.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $581Jb.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $2p0jb.getCookie)((0, $2hz3A.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $7nXZH.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $7nXZH.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $7nXZH.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("2p0jb", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $1b72a6fd957568fa$export$4be65e66cfa2648a);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");
function $1b72a6fd957568fa$export$4be65e66cfa2648a(key) {
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get();
    try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get();
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("581Jb", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $440e04da5386f149$export$b5282052fc15e1ae);

var $2hz3A = parcelRequire("2hz3A");

var $2p0jb = parcelRequire("2p0jb");
const $440e04da5386f149$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $2p0jb.getCookie)((0, $2hz3A.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("7nXZH", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $a238c35a91f6c432$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $a238c35a91f6c432$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $a238c35a91f6c432$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $a238c35a91f6c432$export$b3365240280cb3c3);

var $7Nsid = parcelRequire("7Nsid");
var $60vYG = parcelRequire("60vYG");

var $2hz3A = parcelRequire("2hz3A");

var $hvH66 = parcelRequire("hvH66");

var $5Qndl = parcelRequire("5Qndl");
const $a238c35a91f6c432$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $5Qndl.setStrictlyNecessaryCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $60vYG.Logger).debug(`Set Consent Token ${(0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $a238c35a91f6c432$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $5Qndl.setStrictlyNecessaryCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $60vYG.Logger).debug(`set fallback consent token: ${(0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $a238c35a91f6c432$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $hvH66.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $7Nsid.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $5Qndl.setStrictlyNecessaryCookie)((0, $2hz3A.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $60vYG.Logger).debug(`set shouldShowBannerCookie: ${(0, $2hz3A.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $a238c35a91f6c432$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $a238c35a91f6c432$export$8e560d0760f733a2(consentToken);
    $a238c35a91f6c432$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("7Nsid", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $92f99f9ffdbfd375$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $92f99f9ffdbfd375$export$27647458f3cf29d2);
const $92f99f9ffdbfd375$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $92f99f9ffdbfd375$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("hvH66", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $32b4eab45d78822e$export$bfdb9f82a9194c1e);

var $5H4WP = parcelRequire("5H4WP");

var $59rsN = parcelRequire("59rsN");

var $cnsbg = parcelRequire("cnsbg");

var $7Nsid = parcelRequire("7Nsid");

var $2hz3A = parcelRequire("2hz3A");

var $eLZEM = parcelRequire("eLZEM");

var $2p0jb = parcelRequire("2p0jb");

var $eCCyA = parcelRequire("eCCyA");
const $32b4eab45d78822e$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $eCCyA.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $32b4eab45d78822e$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $32b4eab45d78822e$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $7Nsid.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $eLZEM.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $32b4eab45d78822e$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $eLZEM.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $32b4eab45d78822e$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $eLZEM.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $32b4eab45d78822e$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $32b4eab45d78822e$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $7Nsid.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $eLZEM.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $32b4eab45d78822e$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $eLZEM.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $32b4eab45d78822e$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $eLZEM.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $32b4eab45d78822e$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).__SSR_INITIALIZE_COOKIES__ === 'function' && (0, $59rsN.default).getExperimentValue('confluence_ssr_use_fallback_token', 'isEnabled', false);
    const fallbackConsentToken = (0, $cnsbg.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $32b4eab45d78822e$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $7Nsid.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $32b4eab45d78822e$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $32b4eab45d78822e$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("eLZEM", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $72fafca97a3913e6$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $72fafca97a3913e6$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $72fafca97a3913e6$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $72fafca97a3913e6$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $72fafca97a3913e6$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $72fafca97a3913e6$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $72fafca97a3913e6$export$a79c0ea3d7c2444a);

var $7Nsid = parcelRequire("7Nsid");

var $2hz3A = parcelRequire("2hz3A");

var $2p0jb = parcelRequire("2p0jb");

var $6T1aH = parcelRequire("6T1aH");

var $5AlXQ = parcelRequire("5AlXQ");
const $72fafca97a3913e6$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $2hz3A.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $72fafca97a3913e6$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $2hz3A.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $72fafca97a3913e6$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($72fafca97a3913e6$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $72fafca97a3913e6$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $72fafca97a3913e6$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $72fafca97a3913e6$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $72fafca97a3913e6$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $7Nsid.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $72fafca97a3913e6$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $2hz3A.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $2hz3A.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $6T1aH.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $7Nsid.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $7Nsid.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $7Nsid.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $72fafca97a3913e6$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $2hz3A.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $7Nsid.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $5AlXQ.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $7Nsid.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $5AlXQ.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $7Nsid.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $5AlXQ.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $7Nsid.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $5AlXQ.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $72fafca97a3913e6$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $2p0jb.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $72fafca97a3913e6$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $72fafca97a3913e6$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $72fafca97a3913e6$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $72fafca97a3913e6$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $6T1aH.PreferenceCategory).StrictlyNecessary,
        (0, $6T1aH.PreferenceCategory).Functional,
        (0, $6T1aH.PreferenceCategory).Analytics,
        (0, $6T1aH.PreferenceCategory).Marketing,
        (0, $6T1aH.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: (0, $5AlXQ.ConsentHubKey).StrictlyNecessary,
        [(0, $6T1aH.PreferenceCategory).Functional]: (0, $5AlXQ.ConsentHubKey).Functional,
        [(0, $6T1aH.PreferenceCategory).Analytics]: (0, $5AlXQ.ConsentHubKey).Analytics,
        [(0, $6T1aH.PreferenceCategory).Marketing]: (0, $5AlXQ.ConsentHubKey).Marketing,
        [(0, $6T1aH.PreferenceCategory).Unknown]: (0, $5AlXQ.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $72fafca97a3913e6$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $72fafca97a3913e6$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $72fafca97a3913e6$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $72fafca97a3913e6$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $72fafca97a3913e6$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("5AlXQ", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $5dbf5fad5004484f$export$31140359b1e505cf);
var $5dbf5fad5004484f$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("eCCyA", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $070b92fe100e8eda$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $070b92fe100e8eda$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $070b92fe100e8eda$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $070b92fe100e8eda$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $070b92fe100e8eda$export$7962405c3ca274b1);

var $9SIye = parcelRequire("9SIye");

var $7Nsid = parcelRequire("7Nsid");

var $2hz3A = parcelRequire("2hz3A");

var $eLZEM = parcelRequire("eLZEM");

var $6T1aH = parcelRequire("6T1aH");
const $070b92fe100e8eda$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $2hz3A.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $2hz3A.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $2hz3A.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $2hz3A.V001_SCHEMA_KEY),
        (0, $2hz3A.V002_SCHEMA_KEY),
        (0, $2hz3A.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $070b92fe100e8eda$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $2hz3A.V001_SCHEMA_KEY);
    return [
        version,
        (0, $7Nsid.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $7Nsid.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $7Nsid.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $7Nsid.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $070b92fe100e8eda$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $6T1aH.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $6T1aH.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $6T1aH.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $6T1aH.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $070b92fe100e8eda$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $2hz3A.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $6T1aH.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $6T1aH.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $6T1aH.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $6T1aH.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Functional]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Analytics]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Marketing]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Unknown]),
        (0, $7Nsid.getBitValueFromBool)(isDefaultConsentBit),
        (0, $7Nsid.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $7Nsid.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $070b92fe100e8eda$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $eLZEM.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$070b92fe100e8eda$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $070b92fe100e8eda$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $2hz3A.V003_SCHEMA_KEY);
    return [
        version,
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Functional]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Analytics]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Marketing]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.PreferenceCategory).Unknown]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $7Nsid.getBitValueFromBool)(userPreferences[(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $070b92fe100e8eda$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $6T1aH.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $6T1aH.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $6T1aH.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $6T1aH.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $6T1aH.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $070b92fe100e8eda$var$V002SpecificBitKeys = [
    (0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $6T1aH.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $6T1aH.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $6T1aH.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $6T1aH.ConsentPreferenceV2).ConsentedUnderFADP
];
const $070b92fe100e8eda$var$V003SpecificBitKeys = [
    (0, $6T1aH.ContextualConsentProperty).ConsentsAreDefault,
    (0, $6T1aH.ContextualConsentProperty).UserIsAuthenticated,
    (0, $6T1aH.ContextualConsentProperty).ConsentDataUnavailable
];
function $070b92fe100e8eda$export$3199823fec979bd1(userPreferences) {
    if ((0, $9SIye.getBscGlobalState)().localConsentMode) return $070b92fe100e8eda$var$packPrefsVersion001(userPreferences);
    const isV002 = $070b92fe100e8eda$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $070b92fe100e8eda$var$packPrefsVersion002(userPreferences);
    const isV003 = $070b92fe100e8eda$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $070b92fe100e8eda$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $070b92fe100e8eda$var$packPrefsVersion001(userPreferences);
}
function $070b92fe100e8eda$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $9SIye.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $2hz3A.V001_SCHEMA_KEY)) return $070b92fe100e8eda$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $070b92fe100e8eda$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $070b92fe100e8eda$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $070b92fe100e8eda$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $070b92fe100e8eda$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $070b92fe100e8eda$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $070b92fe100e8eda$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $6T1aH.PrefetchedPreferenceState).INTERNAL) {
        if ($070b92fe100e8eda$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $070b92fe100e8eda$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $eLZEM.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $070b92fe100e8eda$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $6T1aH.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("5Qndl", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $1ea2bf17eefdf984$export$93509ff9a62ee022);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");
const $1ea2bf17eefdf984$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("dXpgI", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $4547d11cb1ad3373$export$c515de1cc9cebc71);

var $eGOwo = parcelRequire("eGOwo");

var $2hz3A = parcelRequire("2hz3A");

var $a3JoR = parcelRequire("a3JoR");

var $eCCyA = parcelRequire("eCCyA");
const $4547d11cb1ad3373$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $a3JoR.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $eCCyA.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $eGOwo.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $2hz3A.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("a3JoR", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $b679eeeed7465547$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $b679eeeed7465547$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $b679eeeed7465547$export$f8422650c3dec8b2);

var $60vYG = parcelRequire("60vYG");

var $eLZEM = parcelRequire("eLZEM");
const $b679eeeed7465547$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $b679eeeed7465547$var$POST_CONSENTS_URL = `${$b679eeeed7465547$var$BASE_CONSENTS_URL}/user`;
const $b679eeeed7465547$var$GET_CONSENTS_URL = `${$b679eeeed7465547$var$POST_CONSENTS_URL}/consents/cookies`;
const $b679eeeed7465547$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $eLZEM.serializeConsents)(consentData);
        const consentTimestamp = (0, $eLZEM.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $eLZEM.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $b679eeeed7465547$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$b679eeeed7465547$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $b679eeeed7465547$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $b679eeeed7465547$export$bd9f5bcbf9cd947c();
    }
};
const $b679eeeed7465547$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $eLZEM.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $b679eeeed7465547$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$b679eeeed7465547$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $b679eeeed7465547$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $eLZEM.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});






parcelRegister("31mod", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $e9ecbb3cc4421022$export$f1b0c189562aa9fd);

var $eGOwo = parcelRequire("eGOwo");

var $lgusX = parcelRequire("lgusX");

var $60vYG = parcelRequire("60vYG");

var $6T1aH = parcelRequire("6T1aH");

var $9lTmU = parcelRequire("9lTmU");
const $e9ecbb3cc4421022$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $9lTmU.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // code to address HOT-122970
            if ((0, $eGOwo.fg)('platform_set_necessary_storage_item_error_hotfix')) (0, $60vYG.Logger).errorWithOperationalEvent({
                action: 'indexDbSetRecordError',
                attributes: eventAttributes,
                message: `Index DB setRecord function failed with message: ${e.message || ''}`
            });
            else // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $6T1aH.Status).SUCCESS;
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $6T1aH.Status).FAILED;
    }
};

});


parcelRegister("252Bx", function(module, exports) {
var $183e119a8732cefa$var$namespace = 'expire_mixin';
module.exports = $183e119a8732cefa$var$expirePlugin;
function $183e119a8732cefa$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $183e119a8732cefa$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($183e119a8732cefa$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($183e119a8732cefa$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($183e119a8732cefa$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("02LWr", function(module, exports) {

var $9h7YF = parcelRequire("9h7YF");
var $00856038be26568a$var$slice = $9h7YF.slice;
var $00856038be26568a$var$pluck = $9h7YF.pluck;
var $00856038be26568a$var$each = $9h7YF.each;
var $00856038be26568a$var$bind = $9h7YF.bind;
var $00856038be26568a$var$create = $9h7YF.create;
var $00856038be26568a$var$isList = $9h7YF.isList;
var $00856038be26568a$var$isFunction = $9h7YF.isFunction;
var $00856038be26568a$var$isObject = $9h7YF.isObject;
module.exports = {
    createStore: $00856038be26568a$var$createStore
};
var $00856038be26568a$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $00856038be26568a$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $00856038be26568a$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $00856038be26568a$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $00856038be26568a$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$00856038be26568a$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$00856038be26568a$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $00856038be26568a$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $00856038be26568a$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($00856038be26568a$var$isList(plugin)) {
                $00856038be26568a$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $00856038be26568a$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$00856038be26568a$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$00856038be26568a$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $00856038be26568a$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$00856038be26568a$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $00856038be26568a$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $00856038be26568a$var$create(_privateStoreProps, $00856038be26568a$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $00856038be26568a$var$each(store, function(prop, propName) {
        if ($00856038be26568a$var$isFunction(prop)) store.raw[propName] = $00856038be26568a$var$bind(store, prop);
    });
    $00856038be26568a$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $00856038be26568a$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("9h7YF", function(module, exports) {
var $6c0be3c6f5d2607d$var$assign = $6c0be3c6f5d2607d$var$make_assign();
var $6c0be3c6f5d2607d$var$create = $6c0be3c6f5d2607d$var$make_create();
var $6c0be3c6f5d2607d$var$trim = $6c0be3c6f5d2607d$var$make_trim();
var $6c0be3c6f5d2607d$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $6c0be3c6f5d2607d$var$assign,
    create: $6c0be3c6f5d2607d$var$create,
    trim: $6c0be3c6f5d2607d$var$trim,
    bind: $6c0be3c6f5d2607d$var$bind,
    slice: $6c0be3c6f5d2607d$var$slice,
    each: $6c0be3c6f5d2607d$var$each,
    map: $6c0be3c6f5d2607d$var$map,
    pluck: $6c0be3c6f5d2607d$var$pluck,
    isList: $6c0be3c6f5d2607d$var$isList,
    isFunction: $6c0be3c6f5d2607d$var$isFunction,
    isObject: $6c0be3c6f5d2607d$var$isObject,
    Global: $6c0be3c6f5d2607d$var$Global
};
function $6c0be3c6f5d2607d$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$6c0be3c6f5d2607d$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $6c0be3c6f5d2607d$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $6c0be3c6f5d2607d$var$slice(arguments, 1);
        return $6c0be3c6f5d2607d$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $6c0be3c6f5d2607d$var$slice(arguments, 1);
            F.prototype = obj;
            return $6c0be3c6f5d2607d$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $6c0be3c6f5d2607d$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $6c0be3c6f5d2607d$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $6c0be3c6f5d2607d$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $6c0be3c6f5d2607d$var$each(obj, fn) {
    $6c0be3c6f5d2607d$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $6c0be3c6f5d2607d$var$map(obj, fn) {
    var res = $6c0be3c6f5d2607d$var$isList(obj) ? [] : {};
    $6c0be3c6f5d2607d$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $6c0be3c6f5d2607d$var$pluck(obj, fn) {
    if ($6c0be3c6f5d2607d$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $6c0be3c6f5d2607d$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $6c0be3c6f5d2607d$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $6c0be3c6f5d2607d$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("jdVjN", function(module, exports) {

var $9h7YF = parcelRequire("9h7YF");
var $dfebb16e43b138de$var$Global = $9h7YF.Global;
module.exports = {
    name: 'localStorage',
    read: $dfebb16e43b138de$var$read,
    write: $dfebb16e43b138de$var$write,
    each: $dfebb16e43b138de$var$each,
    remove: $dfebb16e43b138de$var$remove,
    clearAll: $dfebb16e43b138de$var$clearAll
};
function $dfebb16e43b138de$var$localStorage() {
    return $dfebb16e43b138de$var$Global.localStorage;
}
function $dfebb16e43b138de$var$read(key) {
    return $dfebb16e43b138de$var$localStorage().getItem(key);
}
function $dfebb16e43b138de$var$write(key, data) {
    return $dfebb16e43b138de$var$localStorage().setItem(key, data);
}
function $dfebb16e43b138de$var$each(fn) {
    for(var i = $dfebb16e43b138de$var$localStorage().length - 1; i >= 0; i--){
        var key = $dfebb16e43b138de$var$localStorage().key(i);
        fn($dfebb16e43b138de$var$read(key), key);
    }
}
function $dfebb16e43b138de$var$remove(key) {
    return $dfebb16e43b138de$var$localStorage().removeItem(key);
}
function $dfebb16e43b138de$var$clearAll() {
    return $dfebb16e43b138de$var$localStorage().clear();
}

});

parcelRegister("jZWi5", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $e8f0ee2b2bc109ec$var$read,
    write: $e8f0ee2b2bc109ec$var$write,
    each: $e8f0ee2b2bc109ec$var$each,
    remove: $e8f0ee2b2bc109ec$var$remove,
    clearAll: $e8f0ee2b2bc109ec$var$clearAll
};
var $e8f0ee2b2bc109ec$var$memoryStorage = {};
function $e8f0ee2b2bc109ec$var$read(key) {
    return $e8f0ee2b2bc109ec$var$memoryStorage[key];
}
function $e8f0ee2b2bc109ec$var$write(key, data) {
    $e8f0ee2b2bc109ec$var$memoryStorage[key] = data;
}
function $e8f0ee2b2bc109ec$var$each(callback) {
    for(var key in $e8f0ee2b2bc109ec$var$memoryStorage)if ($e8f0ee2b2bc109ec$var$memoryStorage.hasOwnProperty(key)) callback($e8f0ee2b2bc109ec$var$memoryStorage[key], key);
}
function $e8f0ee2b2bc109ec$var$remove(key) {
    delete $e8f0ee2b2bc109ec$var$memoryStorage[key];
}
function $e8f0ee2b2bc109ec$var$clearAll(key) {
    $e8f0ee2b2bc109ec$var$memoryStorage = {};
}

});

parcelRegister("f39LL", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $ce4a21a7c2198dde$export$c00d22927c60484a);

var $fTXZI = parcelRequire("fTXZI");
class $ce4a21a7c2198dde$export$c00d22927c60484a extends (0, $fTXZI.UFOAbstractExperience) {
}

});

parcelRegister("75Jcs", function(module, exports) {

var $eZ5uk = parcelRequire("eZ5uk");

var $4c94y = parcelRequire("4c94y");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $529c0fcb56335505$var$baseForOwn(object, iteratee) {
    return object && $eZ5uk(object, iteratee, $4c94y);
}
module.exports = $529c0fcb56335505$var$baseForOwn;

});

parcelRegister("iWqim", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ "use strict";
var $dca20a6b4b51e13d$var$i = module.exports;
// we only care about objects or arrays for now
function $dca20a6b4b51e13d$var$weCareAbout(val) {
    return null !== val && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $dca20a6b4b51e13d$var$isObjectLike(val));
}
function $dca20a6b4b51e13d$var$isObjectLike(val) {
    return typeof val === "object" && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
}
function $dca20a6b4b51e13d$var$arrayClone(arr) {
    var index = 0, length = arr.length, result = Array(length);
    for(; index < length; index += 1)result[index] = arr[index];
    return result;
}
function $dca20a6b4b51e13d$var$objClone(obj) {
    var index = 0, keys = Object.keys(obj), length = keys.length, key, result = {};
    for(; index < length; index += 1){
        key = keys[index];
        result[key] = obj[key];
    }
    return result;
}
function $dca20a6b4b51e13d$var$clone(coll) {
    if (Array.isArray(coll)) return $dca20a6b4b51e13d$var$arrayClone(coll);
    else return $dca20a6b4b51e13d$var$objClone(coll);
}
function $dca20a6b4b51e13d$var$freezeIfNeeded(coll) {
    $dca20a6b4b51e13d$var$weCareAbout(coll) && Object.isFrozen(coll);
    return coll;
}
function $dca20a6b4b51e13d$var$_freeze(coll) {
    return coll;
}
function $dca20a6b4b51e13d$var$baseFreeze(coll, prevNodes) {
    if (prevNodes.some(function(node) {
        return node === coll;
    })) throw new Error("object has a reference cycle");
    Object.freeze(coll);
    prevNodes.push(coll);
    Object.keys(coll).forEach(function(key) {
        var prop = coll[key];
        if ($dca20a6b4b51e13d$var$weCareAbout(prop)) $dca20a6b4b51e13d$var$baseFreeze(prop, prevNodes);
    });
    prevNodes.pop();
    return coll;
}
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = function freeze(coll) {
    return coll;
};
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if ($dca20a6b4b51e13d$var$weCareAbout(coll) && Object.isFrozen(coll)) {
        var newColl = $dca20a6b4b51e13d$var$clone(coll);
        Object.keys(newColl).forEach(function(key) {
            newColl[key] = thaw(newColl[key]);
        });
        return newColl;
    }
    return coll;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $dca20a6b4b51e13d$var$_freeze(coll);
    var newObj = $dca20a6b4b51e13d$var$clone(coll);
    newObj[key] = $dca20a6b4b51e13d$var$freezeIfNeeded(value);
    return $dca20a6b4b51e13d$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    var newObj = $dca20a6b4b51e13d$var$clone(coll);
    delete newObj[key];
    return $dca20a6b4b51e13d$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    var key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $dca20a6b4b51e13d$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $dca20a6b4b51e13d$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $dca20a6b4b51e13d$var$baseGet(coll, path) {
    return (path || []).reduce(function(curr, key) {
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $dca20a6b4b51e13d$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    var existingVal = $dca20a6b4b51e13d$var$baseGet(coll, path);
    return $dca20a6b4b51e13d$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    "push",
    "unshift",
    "pop",
    "shift",
    "reverse",
    "sort"
].forEach(function(methodName) {
    module.exports[methodName] = function(arr, val) {
        var newArr = $dca20a6b4b51e13d$var$arrayClone(arr);
        newArr[methodName]($dca20a6b4b51e13d$var$freezeIfNeeded(val));
        return $dca20a6b4b51e13d$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr /*, args*/ ) {
    var newArr = $dca20a6b4b51e13d$var$arrayClone(arr), args = $dca20a6b4b51e13d$var$rest(arguments).map($dca20a6b4b51e13d$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $dca20a6b4b51e13d$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    var newArr = arr.slice(arg1, arg2);
    return $dca20a6b4b51e13d$var$_freeze(newArr);
};
[
    "map",
    "filter"
].forEach(function(methodName) {
    module.exports[methodName] = function(fn, arr) {
        var newArr = arr[methodName](fn);
        return $dca20a6b4b51e13d$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
module.exports.extend = module.exports.assign = function assign() {
    var newObj = $dca20a6b4b51e13d$var$rest(arguments).reduce($dca20a6b4b51e13d$var$singleAssign, arguments[0]);
    return $dca20a6b4b51e13d$var$_freeze(newObj);
};
function $dca20a6b4b51e13d$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce(function(obj, key) {
        return $dca20a6b4b51e13d$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $dca20a6b4b51e13d$var$merge;
function $dca20a6b4b51e13d$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce(function(obj, key) {
        var sourceVal = source[key];
        var targetVal = obj[key];
        var resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($dca20a6b4b51e13d$var$weCareAbout(sourceVal) && $dca20a6b4b51e13d$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (Object.isFrozen(resolvedSourceVal) && Object.isFrozen(targetVal), resolvedSourceVal === targetVal) return obj;
            if (Array.isArray(sourceVal)) return $dca20a6b4b51e13d$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $dca20a6b4b51e13d$var$assocIfDifferent(obj, key, $dca20a6b4b51e13d$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $dca20a6b4b51e13d$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $dca20a6b4b51e13d$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $dca20a6b4b51e13d$var$i.assoc(target, key, value);
}
function $dca20a6b4b51e13d$var$_slice(array, start) {
    var begin = start || 0;
    var len = array.length;
    len -= begin;
    len = len < 0 ? 0 : len;
    var result = new Array(len);
    for(var i = 0; i < len; i += 1)result[i] = array[i + begin];
    return result;
}
function $dca20a6b4b51e13d$var$rest(args) {
    return $dca20a6b4b51e13d$var$_slice(args, 1);
}
var $dca20a6b4b51e13d$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $dca20a6b4b51e13d$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach(function(methodName) {
    $dca20a6b4b51e13d$var$chainProto[methodName] = function() {
        var args = $dca20a6b4b51e13d$var$_slice(arguments);
        args.unshift(this.val);
        this.val = module.exports[methodName].apply(null, args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    var wrapped = Object.create($dca20a6b4b51e13d$var$chainProto);
    wrapped.val = val;
    return wrapped;
};
// for testing
module.exports._weCareAbout = $dca20a6b4b51e13d$var$weCareAbout;
module.exports._slice = $dca20a6b4b51e13d$var$_slice;

});

parcelRegister("40f0Z", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerContext", () => $96aea35daaac70ef$export$a7b0697657ed8bd0);

var $eJOHy = parcelRequire("eJOHy");
const $96aea35daaac70ef$export$a7b0697657ed8bd0 = (0, $eJOHy.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("5ST2i", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $11cec074832365db$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $eGOwo = parcelRequire("eGOwo");

var $ePvyd = parcelRequire("ePvyd");

var $icl1h = parcelRequire("icl1h");

var $jjfy5 = parcelRequire("jjfy5");

var $jHI6h = parcelRequire("jHI6h");

var $7q7TE = parcelRequire("7q7TE");

var $estLL = parcelRequire("estLL");

var $hCAmU = parcelRequire("hCAmU");

var $8ZO5s = parcelRequire("8ZO5s");

var $cFuVS = parcelRequire("cFuVS");
const $11cec074832365db$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $11cec074832365db$var$moduleID = 'relay-fetch';
const $11cec074832365db$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    function augmentResponse(response) {
        (0, $jHI6h.addTraceId)(queryName, (0, $cFuVS.getTraceIdFromExtensions)(response));
        (0, $ePvyd.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$11cec074832365db$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
                const body = (0, $icl1h.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                // Apply setOptions if provided
                if (dependencies?.setOptions && !(0, $eGOwo.fg)('createrelayenvironment_-_setoptions_to_getheaders')) options = dependencies.setOptions({
                    endpoint: endpoint,
                    options: options,
                    request: request,
                    variables: variables
                });
                // Apply getHeaders if provided to update headers
                if (dependencies?.getHeaders && (0, $eGOwo.fg)('createrelayenvironment_-_setoptions_to_getheaders')) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                const fetchOverNetwork = (0, $hCAmU.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $hCAmU.processMultipartPromise)(()=>(0, $8ZO5s.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $8ZO5s.shouldRetry),
                        retryAttempts: (0, $8ZO5s.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $11cec074832365db$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $jjfy5.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $jjfy5.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $jjfy5.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (response)=>{
                        if (dependencies?.isServer && $11cec074832365db$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $estLL.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $eGOwo.fg)('platform_relay_use_new_non_nullability')) response = $11cec074832365db$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null) dependencies?.queryResponseCache?.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $11cec074832365db$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($11cec074832365db$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $7q7TE.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $7q7TE.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};
function $11cec074832365db$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}

});
parcelRegister("ePvyd", function(module, exports) {
$parcel$export(module.exports, "startCapturingExtensions", () => $1b5f22c89bc1abbb$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $1b5f22c89bc1abbb$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $1b5f22c89bc1abbb$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $1b5f22c89bc1abbb$export$7c6ea4184129ef74);
const $1b5f22c89bc1abbb$var$OperationExtensionsMap = {};
const $1b5f22c89bc1abbb$export$8656ba3981c6f6c1 = (operationName)=>{
    $1b5f22c89bc1abbb$var$OperationExtensionsMap[operationName] = $1b5f22c89bc1abbb$var$OperationExtensionsMap[operationName] || [];
};
const $1b5f22c89bc1abbb$export$f16fa6040161f056 = (operationName)=>{
    $1b5f22c89bc1abbb$var$OperationExtensionsMap[operationName] = undefined;
};
const $1b5f22c89bc1abbb$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $1b5f22c89bc1abbb$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $1b5f22c89bc1abbb$export$7c6ea4184129ef74 = (operationName)=>$1b5f22c89bc1abbb$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("icl1h", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $2566551361e1e075$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $2566551361e1e075$export$55bce18df99af758);

var $igDjg = parcelRequire("igDjg");
const $2566551361e1e075$var$branchSlug = typeof $igDjg !== 'undefined' && $igDjg.env ? undefined : undefined;
const $2566551361e1e075$export$8f8c52ac77845a86 = `/gateway/api/graphql${$2566551361e1e075$var$branchSlug ? `/${$2566551361e1e075$var$branchSlug}/graphql` : ''}`;
const $2566551361e1e075$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $2566551361e1e075$export$8f8c52ac77845a86;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $2566551361e1e075$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("jjfy5", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $735303485d39c240$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $735303485d39c240$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $735303485d39c240$export$607b80f5bc6e396d = new Map();
const $735303485d39c240$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("jHI6h", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIds", () => $0b60fb9ef7d13de4$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $0b60fb9ef7d13de4$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $0b60fb9ef7d13de4$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $0b60fb9ef7d13de4$export$5113e470f5c95670);
const $0b60fb9ef7d13de4$var$OperationTraceIdMap = {};
const $0b60fb9ef7d13de4$export$a2bcb2fac360646c = (operationName)=>{
    $0b60fb9ef7d13de4$var$OperationTraceIdMap[operationName] = $0b60fb9ef7d13de4$var$OperationTraceIdMap[operationName] || [];
};
const $0b60fb9ef7d13de4$export$559128bdc4352001 = (operationName)=>{
    $0b60fb9ef7d13de4$var$OperationTraceIdMap[operationName] = undefined;
};
const $0b60fb9ef7d13de4$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $0b60fb9ef7d13de4$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $0b60fb9ef7d13de4$export$5113e470f5c95670 = (operationName)=>$0b60fb9ef7d13de4$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("7q7TE", function(module, exports) {
$parcel$export(module.exports, "CLIENT_DISPATCHER_MODULE", () => $b80bf66cdfb7e586$export$eb5d9c90d65c7fea);
$parcel$export(module.exports, "getClientDispatcher", () => $b80bf66cdfb7e586$export$5bb012cf9b3a5452);

var $KEoyW = parcelRequire("KEoyW");
const $b80bf66cdfb7e586$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $b80bf66cdfb7e586$var$dispatcher;
const $b80bf66cdfb7e586$export$5bb012cf9b3a5452 = ()=>{
    if (!$b80bf66cdfb7e586$var$dispatcher) {
        $b80bf66cdfb7e586$var$dispatcher = new (0, $KEoyW.ClientDispatcher)();
        // Handle the server hangup scenarios
        $b80bf66cdfb7e586$var$dispatcher.register($b80bf66cdfb7e586$export$eb5d9c90d65c7fea, $b80bf66cdfb7e586$var$dispatcher._abort.bind($b80bf66cdfb7e586$var$dispatcher));
    }
    return $b80bf66cdfb7e586$var$dispatcher;
};

});
parcelRegister("KEoyW", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $ef5c63555363a596$export$3f5ba18eb97af725);
class $ef5c63555363a596$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("estLL", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $5958657ba031fb2d$export$bd50bc4cd3c601ee);
const $5958657ba031fb2d$var$events = [];
const $5958657ba031fb2d$export$bd50bc4cd3c601ee = (event)=>{
    $5958657ba031fb2d$var$events.push(event);
};
const $5958657ba031fb2d$export$3c7145db84d4587c = ()=>{
    return $5958657ba031fb2d$var$events.splice(0, $5958657ba031fb2d$var$events.length);
};

});

parcelRegister("hCAmU", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $5832ad506eecd73b$export$f76505a7f2969e4e);
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $5832ad506eecd73b$export$33c9c992c7855d86);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $1O6Yz = parcelRequire("1O6Yz");

var $37Ewn = parcelRequire("37Ewn");

var $eGOwo = parcelRequire("eGOwo");

var $aMkcV = parcelRequire("aMkcV");
const $5832ad506eecd73b$var$NO_CONTENT = 204;
function $5832ad506eecd73b$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $5832ad506eecd73b$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch (error) {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $5832ad506eecd73b$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $5832ad506eecd73b$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $5832ad506eecd73b$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $5832ad506eecd73b$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $5832ad506eecd73b$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $5832ad506eecd73b$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        observer.error(error);
    }
}
function $5832ad506eecd73b$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $5832ad506eecd73b$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>{
        observer.error(new Error(`Error while parsing text response (Content-Type: ${response?.headers?.get('content-type')}): ${error instanceof Error ? error.message : String(error)}`));
    });
}
function $5832ad506eecd73b$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $37Ewn.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $5832ad506eecd73b$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $5832ad506eecd73b$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $5832ad506eecd73b$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $5832ad506eecd73b$var$handleMultipartResponse(response, observer);
            else $5832ad506eecd73b$var$handleTextResponse(response, observer);
        }).catch((error)=>observer.error(error));
    });
}
const $5832ad506eecd73b$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $5832ad506eecd73b$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $5832ad506eecd73b$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $5832ad506eecd73b$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $5832ad506eecd73b$export$5ad31d96a9271d42({ url: url, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const serializedVariables = JSON.stringify(variables);
    const queryLength = url.length + serializedVariables.length;
    const headersSize = $5832ad506eecd73b$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $5832ad506eecd73b$var$MAX_QUERY_LENGTH && headersSize <= $5832ad506eecd73b$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $5832ad506eecd73b$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $5832ad506eecd73b$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $aMkcV.RelayExperimentalApis).join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(options, {
        ...(0, $eGOwo.fg)('add_credential_option_for_all_agg_requests') ? {
            credentials: 'same-origin'
        } : {},
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    const { isGetRequest: isGetRequest, reason: reason } = $5832ad506eecd73b$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        const params = new URLSearchParams();
        params.append('variables', JSON.stringify(variables));
        url += `${url.includes('?') ? '&' : '?'}${params.toString()}`;
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("aMkcV", function(module, exports) {
$parcel$export(module.exports, "RelayExperimentalApis", () => $bf1768f77f7564c2$export$ebe3a775ce3053a5);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $bf1768f77f7564c2$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});


parcelRegister("8ZO5s", function(module, exports) {
$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $1fac778b1add3e83$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $1fac778b1add3e83$export$f859c88bfac2cf2c);
$parcel$export(module.exports, "shouldRetry", () => $1fac778b1add3e83$export$7bfea3c3d460ecd8);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $1fac778b1add3e83$export$9dec0f42cc67f6ab);
const $1fac778b1add3e83$export$81189edc9b923717 = 1;
const $1fac778b1add3e83$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $1fac778b1add3e83$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $1fac778b1add3e83$export$81189edc9b923717 ? $1fac778b1add3e83$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $1fac778b1add3e83$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $1fac778b1add3e83$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $1fac778b1add3e83$export$81189edc9b923717;
    return 0;
};

});

parcelRegister("cFuVS", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $16a9f56d3e737da1$export$eefb7f54c3b07211);
const $16a9f56d3e737da1$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};

});


parcelRegister("dFg4o", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $9f2b91d71d6daff4$var$batchActions;
module.exports.enableBatching = $9f2b91d71d6daff4$var$enableBatching;
module.exports.batchDispatchMiddleware = $9f2b91d71d6daff4$var$batchDispatchMiddleware;
var $9f2b91d71d6daff4$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $9f2b91d71d6daff4$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f2b91d71d6daff4$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $9f2b91d71d6daff4$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $9f2b91d71d6daff4$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("f8FDM", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("a6gy0", function(module, exports) {

var $a9KaZ = parcelRequire("a9KaZ");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $75a74ce991c3d333$var$partition = $a9KaZ(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $75a74ce991c3d333$var$partition;

});
parcelRegister("a9KaZ", function(module, exports) {

var $Z7W6I = parcelRequire("Z7W6I");

var $a2F5Q = parcelRequire("a2F5Q");

var $1lM9j = parcelRequire("1lM9j");

var $4sprp = parcelRequire("4sprp");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $764e90438ca205ad$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $4sprp(collection) ? $Z7W6I : $a2F5Q, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $1lM9j(iteratee, 2), accumulator);
    };
}
module.exports = $764e90438ca205ad$var$createAggregator;

});
parcelRegister("Z7W6I", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $0b7bda961ebbdfb2$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $0b7bda961ebbdfb2$var$arrayAggregator;

});

parcelRegister("a2F5Q", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $74f9f792525267c6$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $c3u3c(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $74f9f792525267c6$var$baseAggregator;

});
parcelRegister("c3u3c", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");

var $ih8ry = parcelRequire("ih8ry");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8c6d1345c175190b$var$baseEach = $ih8ry($75Jcs);
module.exports = $8c6d1345c175190b$var$baseEach;

});
parcelRegister("ih8ry", function(module, exports) {

var $7H30b = parcelRequire("7H30b");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d4e05d3150724472$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$7H30b(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $d4e05d3150724472$var$createBaseEach;

});





parcelRegister("8RHPx", function(module, exports) {
$parcel$export(module.exports, "getATLContextDomain", () => $c118166fa3731312$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $c118166fa3731312$export$45d6512913ef41b4);


var $4mreB = parcelRequire("4mreB");

var $bt6Zk = parcelRequire("bt6Zk");
function $c118166fa3731312$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $c118166fa3731312$var$isValidDomainKey(domainKey) {
    if (!(0, $bt6Zk.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $c118166fa3731312$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$c118166fa3731312$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $bt6Zk.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $c118166fa3731312$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $4mreB.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $c9cb1b3997607889$export$f005e2e9f707cb5f][0, $c9cb1b3997607889$export$42dd0cdd351a4a9] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $4mreB.domainMap)[perimeter]?.[env] ?? (0, $4mreB.domainMap)[0, $c9cb1b3997607889$export$f005e2e9f707cb5f][0, $c9cb1b3997607889$export$42dd0cdd351a4a9];
    const subdomain = (0, $4mreB.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $c118166fa3731312$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$c118166fa3731312$export$b5ce351acdc48c2a(domain)}`;
}
function $c118166fa3731312$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $c9cb1b3997607889$export$42dd0cdd351a4a9),
        (0, $c9cb1b3997607889$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $c9cb1b3997607889$export$a739cd5aac835909),
        (0, $c9cb1b3997607889$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $c9cb1b3997607889$export$a739cd5aac835909),
        (0, $c9cb1b3997607889$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $c9cb1b3997607889$export$a739cd5aac835909),
        (0, $c9cb1b3997607889$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $c9cb1b3997607889$export$42dd0cdd351a4a9),
        (0, $c9cb1b3997607889$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $c9cb1b3997607889$export$a739cd5aac835909),
        (0, $c9cb1b3997607889$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $c9cb1b3997607889$export$a739cd5aac835909),
        (0, $c9cb1b3997607889$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $c9cb1b3997607889$export$42dd0cdd351a4a9),
        (0, $c9cb1b3997607889$export$f005e2e9f707cb5f)
    ];
}

});
const $c9cb1b3997607889$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $c9cb1b3997607889$export$f005e2e9f707cb5f = 'commercial';
const $c9cb1b3997607889$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $c9cb1b3997607889$export$a739cd5aac835909 = 'stg';
const $c9cb1b3997607889$export$42dd0cdd351a4a9 = 'prod';
const $c9cb1b3997607889$export$404582bc18fe4d9e = 'dev';

parcelRegister("4mreB", function(module, exports) {
$parcel$export(module.exports, "domainMap", () => $f1102d4f6aa18cb5$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $f1102d4f6aa18cb5$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $f1102d4f6aa18cb5$export$4723232b625f823e);

const $f1102d4f6aa18cb5$export$6836b090dbaa813a = {
    [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
        [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $c9cb1b3997607889$export$bd6b5a7802d76127)]: {
        [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $c9cb1b3997607889$export$ce553301d55c2fd8)]: {
        [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};
const $f1102d4f6aa18cb5$export$c6ab20d0ac4d06b2 = {};
const $f1102d4f6aa18cb5$export$4723232b625f823e = {
    analytics: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $c9cb1b3997607889$export$ce553301d55c2fd8)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $c9cb1b3997607889$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $c9cb1b3997607889$export$ce553301d55c2fd8)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $c9cb1b3997607889$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $c9cb1b3997607889$export$f005e2e9f707cb5f)]: {
            [(0, $c9cb1b3997607889$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("bt6Zk", function(module, exports) {
$parcel$export(module.exports, "AllowedDomains", () => $2164138a0530e735$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $2164138a0530e735$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});


parcelRegister("8lcvP", function(module, exports) {
$parcel$export(module.exports, "getInstance", () => $68861382d5b9d025$export$8bedcca5bbd73999);

var $8RHPx = parcelRequire("8RHPx");

var $g2AB5 = parcelRequire("g2AB5");

var $axvja = parcelRequire("axvja");

var $aRseO = parcelRequire("aRseO");
const $68861382d5b9d025$var$redirect = ()=>{
    const identity = (0, $8RHPx.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $68861382d5b9d025$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $68861382d5b9d025$var$HeartbeatService = ()=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            const response = await (0, $aRseO.postHeartbeat)((0, $g2AB5.DEFAULT_HEARTBEAT_ENDPOINT), $68861382d5b9d025$var$redirect);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            // Silent degradation - heartbeat service should not interfere with application
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($68861382d5b9d025$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $68861382d5b9d025$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, (0, $g2AB5.INTERVAL_TIME));
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $axvja.default)({
            idleTimeoutMs: (0, $g2AB5.DEFAULT_IDLE_TIME),
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $68861382d5b9d025$var$instance = null;
const $68861382d5b9d025$export$8bedcca5bbd73999 = ()=>{
    if (!$68861382d5b9d025$var$instance) {
        $68861382d5b9d025$var$instance = $68861382d5b9d025$var$HeartbeatService();
        $68861382d5b9d025$var$instance.init();
    }
    return $68861382d5b9d025$var$instance;
};

});
parcelRegister("g2AB5", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_HEARTBEAT_ENDPOINT", () => $c4492f3766ffebfd$export$4496080a0271e85d);
$parcel$export(module.exports, "DEFAULT_IDLE_TIME", () => $c4492f3766ffebfd$export$af2ff676951003fe);
$parcel$export(module.exports, "INTERVAL_TIME", () => $c4492f3766ffebfd$export$f2b2f5ef0b498d26);
const $c4492f3766ffebfd$export$4496080a0271e85d = '/gateway/api/session/heartbeat';
const $c4492f3766ffebfd$export$af2ff676951003fe = 60000; // 60 seconds
const $c4492f3766ffebfd$export$f2b2f5ef0b498d26 = 10000; // 10 seconds

});

parcelRegister("axvja", function(module, exports) {
$parcel$export(module.exports, "default", () => $2938ba2c39a746f7$export$2e2bcd8739ae039);

var $6DCNy = parcelRequire("6DCNy");
const $2938ba2c39a746f7$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $2938ba2c39a746f7$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $2938ba2c39a746f7$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $2938ba2c39a746f7$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $2938ba2c39a746f7$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $2938ba2c39a746f7$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $2938ba2c39a746f7$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("6DCNy", function(module, exports) {

var $3s8bj = parcelRequire("3s8bj");

var $546O5 = parcelRequire("546O5");
/** Error message constants. */ var $4d547b1cf5aafaa2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $4d547b1cf5aafaa2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($4d547b1cf5aafaa2$var$FUNC_ERROR_TEXT);
    if ($546O5(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $3s8bj(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $4d547b1cf5aafaa2$var$throttle;

});


parcelRegister("aRseO", function(module, exports) {
$parcel$export(module.exports, "postHeartbeat", () => $e25017d3ddc1ed9b$export$931f43089f67754c);
const $e25017d3ddc1ed9b$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $e25017d3ddc1ed9b$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $e25017d3ddc1ed9b$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $e25017d3ddc1ed9b$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $e25017d3ddc1ed9b$var$timeout(backoff);
        return await $e25017d3ddc1ed9b$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $e25017d3ddc1ed9b$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $e25017d3ddc1ed9b$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        $e25017d3ddc1ed9b$var$RETRY_HTTP_CODES.includes(errorResponse.status);
    }
};

});


parcelRegister("2yxzK", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $6e522bc381468cbc$export$ec068583843480e7);

var $37Ewn = parcelRequire("37Ewn");

var $jGdmT = parcelRequire("jGdmT");
var $kSWdw = parcelRequire("kSWdw");
const $6e522bc381468cbc$export$ec068583843480e7 = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $37Ewn.Observable).create((sink)=>{
        const client = (0, $jGdmT.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const replayConfig = cacheConfig?.metadata?.replay || undefined;
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id,
                ...replayConfig && {
                    replay: replayConfig
                }
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $kSWdw.getSinkError)(sinkError);
                sink.error(errorInfo);
            }
        });
    });

});
parcelRegister("jGdmT", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $206f2025fe3e3ad4$export$6bb76d6eba7e258c);

var $aP5Ku = parcelRequire("aP5Ku");

var $aMkcV = parcelRequire("aMkcV");


var $al6Hz = parcelRequire("al6Hz");
let $206f2025fe3e3ad4$var$client;
const $206f2025fe3e3ad4$export$6bb76d6eba7e258c = ()=>{
    if ((0, $al6Hz.isSSR)()) return null;
    if (!$206f2025fe3e3ad4$var$client) $206f2025fe3e3ad4$var$client = (0, $aP5Ku.createClient)({
        url: (0, $al6Hz.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $835bac38e390d0b2$export$8b012b965402e06a),
        retryAttempts: (0, $835bac38e390d0b2$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $aMkcV.RelayExperimentalApis).join(',')
        }
    });
    return $206f2025fe3e3ad4$var$client;
};
const $206f2025fe3e3ad4$export$2f0afd443356d36f = ()=>{
    $206f2025fe3e3ad4$var$client = null;
};

});
parcelRegister("aP5Ku", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $7e13206484ee9913$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $jqv0c = parcelRequire("jqv0c");

var $c85tZ = parcelRequire("c85tZ");
var $7e13206484ee9913$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $7e13206484ee9913$var$__await ? (this.v = v, this) : new $7e13206484ee9913$var$__await(v);
};
var $7e13206484ee9913$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7e13206484ee9913$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $7e13206484ee9913$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $7e13206484ee9913$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$7e13206484ee9913$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $jqv0c.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $jqv0c.stringifyMessage)({
                                    type: (0, $jqv0c.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($7e13206484ee9913$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $jqv0c.stringifyMessage)(payload ? {
                            type: (0, $jqv0c.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $jqv0c.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $jqv0c.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $jqv0c.CloseCode).InternalClientError, (0, $c85tZ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $jqv0c.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $jqv0c.stringifyMessage)(message.payload ? {
                                    type: (0, $jqv0c.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $jqv0c.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $jqv0c.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $jqv0c.CloseCode).BadResponse, (0, $c85tZ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($7e13206484ee9913$var$isLikeCloseEvent(errOrCloseEvent) && ($7e13206484ee9913$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $jqv0c.CloseCode).InternalServerError,
            (0, $jqv0c.CloseCode).InternalClientError,
            (0, $jqv0c.CloseCode).BadRequest,
            (0, $jqv0c.CloseCode).BadResponse,
            (0, $jqv0c.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $jqv0c.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $jqv0c.CloseCode).SubscriberAlreadyExists,
            (0, $jqv0c.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($7e13206484ee9913$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $jqv0c.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $jqv0c.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $jqv0c.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $jqv0c.stringifyMessage)({
                        id: id,
                        type: (0, $jqv0c.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $jqv0c.stringifyMessage)({
                            id: id,
                            type: (0, $jqv0c.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $7e13206484ee9913$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $7e13206484ee9913$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $7e13206484ee9913$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $7e13206484ee9913$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $7e13206484ee9913$var$isLikeCloseEvent(val) {
    return (0, $c85tZ.isObject)(val) && 'code' in val && 'reason' in val;
}
function $7e13206484ee9913$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $7e13206484ee9913$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("jqv0c", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $e2487e7170aafd3f$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $e2487e7170aafd3f$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $e2487e7170aafd3f$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $e2487e7170aafd3f$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $e2487e7170aafd3f$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $c85tZ = parcelRequire("c85tZ");
const $e2487e7170aafd3f$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $e2487e7170aafd3f$export$ec743af8bb66f3be = 'graphql-ws';
var $e2487e7170aafd3f$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($e2487e7170aafd3f$export$777128f41f6616ec || ($e2487e7170aafd3f$export$777128f41f6616ec = {}));
var $e2487e7170aafd3f$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($e2487e7170aafd3f$export$80edbf15fa61a4db || ($e2487e7170aafd3f$export$80edbf15fa61a4db = {}));
function $e2487e7170aafd3f$export$c17861b159b1b673(val) {
    if (!(0, $c85tZ.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $c85tZ.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $c85tZ.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.ConnectionInit:
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.ConnectionAck:
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.Ping:
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $c85tZ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $c85tZ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $c85tZ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $c85tZ.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $c85tZ.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $c85tZ.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $c85tZ.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $c85tZ.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $c85tZ.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $c85tZ.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $c85tZ.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $c85tZ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $c85tZ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $c85tZ.extendedTypeof)(val.payload)}`);
            break;
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $c85tZ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $c85tZ.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $e2487e7170aafd3f$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $c85tZ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $e2487e7170aafd3f$export$9e0e49e75fa7d548(val) {
    try {
        $e2487e7170aafd3f$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $e2487e7170aafd3f$export$f2f615077a189f21(data, reviver) {
    return $e2487e7170aafd3f$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $e2487e7170aafd3f$export$77896e5b47bfd50b(msg, replacer) {
    $e2487e7170aafd3f$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("c85tZ", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $8d4a7c254635267c$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $8d4a7c254635267c$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $8d4a7c254635267c$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $8d4a7c254635267c$export$2937fa0c8dddae54);
/** @private */ function $8d4a7c254635267c$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $8d4a7c254635267c$export$a6cdc56e425d0d0a(val) {
    return $8d4a7c254635267c$export$573326049e1b1c6b(val) === 'object';
}
function $8d4a7c254635267c$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $8d4a7c254635267c$export$92bd080471bc30f1(val) {
    return $8d4a7c254635267c$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $8d4a7c254635267c$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $8d4a7c254635267c$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



const $835bac38e390d0b2$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $835bac38e390d0b2$export$bf6cd96e19b2987f = 100;
const $835bac38e390d0b2$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("al6Hz", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $3199c58c7e752710$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $3199c58c7e752710$export$29a72e89601dfc59);
const $3199c58c7e752710$export$48d7c418edadb60c = ()=>globalThis.false ?? false;
const $3199c58c7e752710$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("kSWdw", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $c140c46db54023c6$export$ece4736473c28965);
const $c140c46db54023c6$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});


parcelRegister("lmvVe", function(module, exports) {
$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $fafeef0d5b1aa214$export$6c790f07f4ef6a59);
$parcel$export(module.exports, "getSharedRelayEnvironmentConfig", () => $fafeef0d5b1aa214$export$e6902a9ee4e7639e);

var $37Ewn = parcelRequire("37Ewn");

var $cwmiZ = parcelRequire("cwmiZ");

var $8GOss = parcelRequire("8GOss");

var $2dRGk = parcelRequire("2dRGk");

var $eGOwo = parcelRequire("eGOwo");

var $kqd31 = parcelRequire("kqd31");

var $k9HBs = parcelRequire("k9HBs");

var $cyu5B = parcelRequire("cyu5B");

var $bAuRU = parcelRequire("bAuRU");
const $fafeef0d5b1aa214$var$createStore = (source, options)=>{
    (0, $37Ewn.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($cwmiZ)))(source, options);
};
function $fafeef0d5b1aa214$export$6c790f07f4ef6a59({ log: log, requiredFieldLogger: requiredFieldLogger, network: network, networkOptions: networkOptions, getDataID: getDataID, recordSource: recordSource }) {
    return {
        configName: 'Atlassian Graphql Gateway',
        network: network || $fafeef0d5b1aa214$var$getEnvironmentNetwork(networkOptions),
        store: $fafeef0d5b1aa214$var$createStore(recordSource || new (0, $37Ewn.RecordSource)(), {
            log: log ?? undefined,
            getDataID: getDataID ?? (0, $kqd31.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: getDataID ?? (0, $kqd31.default),
        scheduler: (0, $bAuRU.default),
        missingFieldHandlers: (0, $k9HBs.default)
    };
}
function $fafeef0d5b1aa214$export$e6902a9ee4e7639e({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, recordSource: recordSource }) {
    return {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $fafeef0d5b1aa214$var$getEnvironmentNetwork(networkOptions),
        store: $fafeef0d5b1aa214$var$createStore(recordSource || new (0, $37Ewn.RecordSource)(), {
            log: log ?? undefined,
            getDataID: getDataID ?? (0, $kqd31.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: getDataID ?? (0, $kqd31.default),
        scheduler: (0, $bAuRU.default),
        missingFieldHandlers: (0, $k9HBs.default),
        handlerProvider: (0, $eGOwo.fg)('platform_relay_config_deleteedge_handler') ? $fafeef0d5b1aa214$var$HandlerProvider : undefined
    };
}
function $fafeef0d5b1aa214$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $fafeef0d5b1aa214$var$DeleteEdgeHandler;
        default:
            return (0, $37Ewn.DefaultHandlerProvider)(handle);
    }
}
const $fafeef0d5b1aa214$var$getEnvironmentNetwork = (environmentOptions)=>{
    if (environmentOptions) return (0, $cyu5B.createNetwork)(environmentOptions);
    return 0, $cyu5B.network;
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $fafeef0d5b1aa214$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $fafeef0d5b1aa214$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $8GOss.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $2dRGk.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $fafeef0d5b1aa214$var$deleteNode(connection, id);
            }
        });
    }
};

});
parcelRegister("cwmiZ", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $91d9c69073ce2d57$var$_interopRequireDefault = $7Wmh0.default;

var $91d9c69073ce2d57$var$_createForOfIteratorHelper2 = $91d9c69073ce2d57$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $91d9c69073ce2d57$var$_defineProperty2 = $91d9c69073ce2d57$var$_interopRequireDefault((parcelRequire("ky4V8")));

var $2BDDE = parcelRequire("2BDDE");
var $91d9c69073ce2d57$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $2BDDE.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $91d9c69073ce2d57$var$assertInternalActorIdentifier = $2BDDE.assertInternalActorIdentifier;
parcelRequire("hElRV");

var $1fgZt = parcelRequire("1fgZt");

var $6mJYj = parcelRequire("6mJYj");

var $kA5Gq = parcelRequire("kA5Gq");

var $fagih = parcelRequire("fagih");

var $9bopL = parcelRequire("9bopL");

var $ldcaJ = parcelRequire("ldcaJ");

var $bg1wj = parcelRequire("bg1wj");

var $dc1NV = parcelRequire("dc1NV");

var $f91UN = parcelRequire("f91UN");

var $f91UN = parcelRequire("f91UN");
var $91d9c69073ce2d57$var$ROOT_ID = $f91UN.ROOT_ID, $91d9c69073ce2d57$var$ROOT_TYPE = $f91UN.ROOT_TYPE;

var $gHzdK = parcelRequire("gHzdK");
var $91d9c69073ce2d57$var$LiveResolverCache = $gHzdK.LiveResolverCache, $91d9c69073ce2d57$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $gHzdK.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $91d9c69073ce2d57$var$getUpdatedDataIDs = $gHzdK.getUpdatedDataIDs;

var $423Vm = parcelRequire("423Vm");
var $91d9c69073ce2d57$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $91d9c69073ce2d57$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $91d9c69073ce2d57$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $91d9c69073ce2d57$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1fgZt;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $kA5Gq;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $91d9c69073ce2d57$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $dc1NV(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $91d9c69073ce2d57$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $91d9c69073ce2d57$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $91d9c69073ce2d57$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $6mJYj.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $91d9c69073ce2d57$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $91d9c69073ce2d57$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $ldcaJ.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $91d9c69073ce2d57$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $fagih.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $91d9c69073ce2d57$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $423Vm(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $9bopL.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $423Vm(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $9bopL.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $91d9c69073ce2d57$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $bg1wj.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $fagih.getValue(record, $91d9c69073ce2d57$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $91d9c69073ce2d57$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $91d9c69073ce2d57$var$initializeRecordSource(target) {
    if (!target.has($91d9c69073ce2d57$var$ROOT_ID)) {
        var rootRecord = $fagih.create($91d9c69073ce2d57$var$ROOT_ID, $91d9c69073ce2d57$var$ROOT_TYPE);
        target.set($91d9c69073ce2d57$var$ROOT_ID, rootRecord);
    }
}
function $91d9c69073ce2d57$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $fagih.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $fagih.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $fagih.setValue(nextRecord, $f91UN.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $fagih.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $91d9c69073ce2d57$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $91d9c69073ce2d57$var$LiveResolverStore;

});
parcelRegister("gHzdK", function(module, exports) {
'use strict';

var $7Wmh0 = parcelRequire("7Wmh0");
var $c28bfb9c4a476c5e$var$_interopRequireDefault = $7Wmh0.default;

var $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2 = $c28bfb9c4a476c5e$var$_interopRequireDefault((parcelRequire("9CLQ8")));

var $l9X9G = parcelRequire("l9X9G");

var $54ow8 = parcelRequire("54ow8");
var $c28bfb9c4a476c5e$var$RELAY_LIVE_RESOLVER = $54ow8.RELAY_LIVE_RESOLVER;

var $llkIA = parcelRequire("llkIA");

var $2UUcW = parcelRequire("2UUcW");

var $axs8G = parcelRequire("axs8G");
var $c28bfb9c4a476c5e$var$generateClientID = $axs8G.generateClientID, $c28bfb9c4a476c5e$var$generateClientObjectClientID = $axs8G.generateClientObjectClientID;

var $fagih = parcelRequire("fagih");

var $g432U = parcelRequire("g432U");
var $c28bfb9c4a476c5e$var$createNormalizationSelector = $g432U.createNormalizationSelector;

var $7eJdF = parcelRequire("7eJdF");

var $3cbTo = parcelRequire("3cbTo");
var $c28bfb9c4a476c5e$var$normalize = $3cbTo.normalize;

var $f91UN = parcelRequire("f91UN");
var $c28bfb9c4a476c5e$var$RELAY_RESOLVER_ERROR_KEY = $f91UN.RELAY_RESOLVER_ERROR_KEY, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_INVALIDATION_KEY = $f91UN.RELAY_RESOLVER_INVALIDATION_KEY, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $f91UN.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_SNAPSHOT_KEY = $f91UN.RELAY_RESOLVER_SNAPSHOT_KEY, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_VALUE_KEY = $f91UN.RELAY_RESOLVER_VALUE_KEY, $c28bfb9c4a476c5e$var$getStorageKey = $f91UN.getStorageKey;

var $bhYu6 = parcelRequire("bhYu6");

var $dwouM = parcelRequire("dwouM");

var $jyY6u = parcelRequire("jyY6u");
var $c28bfb9c4a476c5e$var$isSuspenseSentinel = $jyY6u.isSuspenseSentinel;

var $423Vm = parcelRequire("423Vm");
parcelRequire("dH6ue");
var $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $c28bfb9c4a476c5e$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $c28bfb9c4a476c5e$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $c28bfb9c4a476c5e$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $c28bfb9c4a476c5e$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $c28bfb9c4a476c5e$var$expectRecord(recordSource, recordID);
        var storageKey = $c28bfb9c4a476c5e$var$getStorageKey(field, variables);
        var linkedID = $fagih.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $c28bfb9c4a476c5e$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $c28bfb9c4a476c5e$var$generateClientID(recordID, storageKey);
            linkedRecord = $fagih.create(linkedID, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $fagih.setValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $fagih.setValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $c28bfb9c4a476c5e$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $423Vm(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $c28bfb9c4a476c5e$var$expectRecord(recordSource, recordID);
            var nextRecord = $fagih.clone(currentRecord);
            $fagih.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $c28bfb9c4a476c5e$var$getStorageKey(field.fragment, variables);
                var resolverID = $c28bfb9c4a476c5e$var$generateClientID(recordID, fragmentStorageKey);
                $c28bfb9c4a476c5e$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $c28bfb9c4a476c5e$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $c28bfb9c4a476c5e$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $c28bfb9c4a476c5e$var$RELAY_LIVE_RESOLVER && $fagih.getValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $c28bfb9c4a476c5e$var$generateClientID(recordID, storageKey);
            linkedRecord = $fagih.clone(linkedRecord);
            var _liveState = $fagih.getValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$dwouM(_liveState)) $423Vm(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $fagih.setValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $fagih.getValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $fagih.getValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($c28bfb9c4a476c5e$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $c28bfb9c4a476c5e$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $423Vm(false);
        var liveState = $fagih.getValue(liveStateRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $fagih.setValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $fagih.setValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $fagih.setValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$fagih.hasValue(currentRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $fagih.clone(currentRecord);
            $fagih.setValue(nextRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $7eJdF.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $7eJdF.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $423Vm(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $fagih.setValue(resolverRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$c28bfb9c4a476c5e$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $bhYu6(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $423Vm(false);
                resolverValue = [];
                var nextSource = $7eJdF.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $423Vm(false);
                    var typename = $c28bfb9c4a476c5e$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $c28bfb9c4a476c5e$var$generateClientObjectClientID(typename, $fagih.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $c28bfb9c4a476c5e$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $c28bfb9c4a476c5e$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $423Vm(false);
                var _typename = $c28bfb9c4a476c5e$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $c28bfb9c4a476c5e$var$generateClientObjectClientID(_typename, $fagih.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $c28bfb9c4a476c5e$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $fagih.setValue(resolverRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $2UUcW(resolverValue);
            $fagih.setValue(resolverRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $2UUcW(value);
            $fagih.setValue(resolverRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $fagih.getValue(resolverRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $c28bfb9c4a476c5e$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$fagih.getValue(record, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $fagih.getValue(record, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $l9X9G(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($llkIA.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $fagih.clone(record);
            $fagih.setValue(nextRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($fagih.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $7eJdF.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $fagih.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $c28bfb9c4a476c5e$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $c28bfb9c4a476c5e$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $fagih.create(outputTypeDataID, typename);
                $fagih.setValue(_record, $c28bfb9c4a476c5e$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $423Vm(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $c28bfb9c4a476c5e$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $fagih.create(key, typeName);
            $fagih.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $c28bfb9c4a476c5e$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $c28bfb9c4a476c5e$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $c28bfb9c4a476c5e$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $c28bfb9c4a476c5e$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $c28bfb9c4a476c5e$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $fagih.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $c28bfb9c4a476c5e$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $c28bfb9c4a476c5e$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $fagih.getFields(record).forEach(function(field) {
        if ($fagih.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $fagih.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($fagih.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $fagih.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $c28bfb9c4a476c5e$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $fagih.clone(record);
    $fagih.setValue(nextRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $c28bfb9c4a476c5e$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $c28bfb9c4a476c5e$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $c28bfb9c4a476c5e$var$isResolverRecord(_record2)) $c28bfb9c4a476c5e$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $c28bfb9c4a476c5e$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $c28bfb9c4a476c5e$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $c28bfb9c4a476c5e$var$isResolverRecord(record)) $c28bfb9c4a476c5e$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $c28bfb9c4a476c5e$var$isResolverRecord(record) {
    return $fagih.getType(record) === $c28bfb9c4a476c5e$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $c28bfb9c4a476c5e$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $fagih.getValue(linkedRecord, $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $c28bfb9c4a476c5e$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $423Vm(false);
    return record;
}
function $c28bfb9c4a476c5e$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $c28bfb9c4a476c5e$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $423Vm(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $c28bfb9c4a476c5e$var$LiveResolverCache,
    getUpdatedDataIDs: $c28bfb9c4a476c5e$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $c28bfb9c4a476c5e$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("dwouM", function(module, exports) {
'use strict';
function $9d8143c8a5e9f47d$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $9d8143c8a5e9f47d$var$isLiveStateValue;

});



parcelRegister("2dRGk", function(module, exports) {
$parcel$export(module.exports, "default", () => $19e66fbd26552256$export$2e2bcd8739ae039);
var $19e66fbd26552256$var$isProduction = true;
function $19e66fbd26552256$var$warning(condition, message) {
    if (!$19e66fbd26552256$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $19e66fbd26552256$export$2e2bcd8739ae039 = $19e66fbd26552256$var$warning;

});

parcelRegister("kqd31", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3fadf5a57c0750e$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $7Tnm1 = parcelRequire("7Tnm1");
const $b3fadf5a57c0750e$var$idTypeMap = new Map();
function $b3fadf5a57c0750e$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $eGOwo.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($b3fadf5a57c0750e$var$idTypeMap.has(idString)) {
            const entry = $b3fadf5a57c0750e$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $7Tnm1.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $b3fadf5a57c0750e$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("7Tnm1", function(module, exports) {
$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $3b421e767f3af263$export$b8c037155fd57aaf);
const $3b421e767f3af263$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $3b421e767f3af263$var$isProduction = ()=>true;
const $3b421e767f3af263$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $3b421e767f3af263$var$INTERVAL_MS = 1000;
let $3b421e767f3af263$var$requestQueue = [];
let $3b421e767f3af263$var$isProcessingQueue = false;
const $3b421e767f3af263$var$processQueue = ()=>{
    if ($3b421e767f3af263$var$isProcessingQueue) return;
    $3b421e767f3af263$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($3b421e767f3af263$var$requestQueue.length === 0) {
            $3b421e767f3af263$var$isProcessingQueue = false;
            return;
        }
        const batch = $3b421e767f3af263$var$requestQueue.splice(0, $3b421e767f3af263$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$3b421e767f3af263$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $3b421e767f3af263$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $3b421e767f3af263$var$sendToServerBatched = (body, endpoint)=>{
    $3b421e767f3af263$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $3b421e767f3af263$var$processQueue();
};
const $3b421e767f3af263$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$3b421e767f3af263$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $3b421e767f3af263$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $3b421e767f3af263$var$sendData = (level, location, message, event = {})=>{
    const data = $3b421e767f3af263$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($3b421e767f3af263$var$isProduction()) return $3b421e767f3af263$var$sendToServerBatched(body, endpoint);
    return $3b421e767f3af263$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $3b421e767f3af263$export$b8c037155fd57aaf = (location, message, event)=>{
    $3b421e767f3af263$var$sendData('warn', location, message, event);
};

});


parcelRegister("k9HBs", function(module, exports) {
$parcel$export(module.exports, "default", () => $32ff55e88b875578$export$2e2bcd8739ae039);

var $4NoAT = parcelRequire("4NoAT");

var $kqd31 = parcelRequire("kqd31");
const $32ff55e88b875578$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $32ff55e88b875578$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $32ff55e88b875578$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $4NoAT.JiraFilterAri).parse(id).filterId;
            if ($32ff55e88b875578$var$isCustomFilter(filterId)) return (0, $kqd31.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($32ff55e88b875578$var$isSystemFilter(filterId)) return (0, $kqd31.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $32ff55e88b875578$var$MissingFieldHandlers = [
    $32ff55e88b875578$export$77232ec02db7a24a
];
var $32ff55e88b875578$export$2e2bcd8739ae039 = $32ff55e88b875578$var$MissingFieldHandlers;

});
parcelRegister("4NoAT", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $37ded0e0b4ad6b47$export$3cfb6cc809e835bd);

var $ixiZF = parcelRequire("ixiZF");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/filter/manifest.ts
var $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $ixiZF.JiraFilterAriResourceOwner),
    resourceType: (0, $ixiZF.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $37ded0e0b4ad6b47$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $37ded0e0b4ad6b47$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("ixiZF", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $d7ea0ad02897a4a2$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $d7ea0ad02897a4a2$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $d7ea0ad02897a4a2$export$e6199848f52f1119 = "jira", $d7ea0ad02897a4a2$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("3TJ9u", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $2d698865546fd7f6$export$579ee78b1dcf0a11);

var $gtr2v = parcelRequire("gtr2v");
// src/core/registered-ari.ts
var $2d698865546fd7f6$export$579ee78b1dcf0a11 = class extends (0, $gtr2v.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $gtr2v.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("gtr2v", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $bfe45443554a9b98$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $bfe45443554a9b98$export$44a7af7122933d6b);

var $cSeYX = parcelRequire("cSeYX");
// src/core/ari.ts
var $bfe45443554a9b98$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $cSeYX.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $bfe45443554a9b98$export$44a7af7122933d6b = class _AnyAri extends $bfe45443554a9b98$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $cSeYX.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $cSeYX.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("cSeYX", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $95f62654b240c83e$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $95f62654b240c83e$export$ab4b293d0121b8ee);

var $emp5t = parcelRequire("emp5t");

var $1Q76h = parcelRequire("1Q76h");
// src/core/rules/cloud-id.ts
function $95f62654b240c83e$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $1Q76h.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $95f62654b240c83e$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $1Q76h.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $95f62654b240c83e$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $95f62654b240c83e$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $95f62654b240c83e$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $1Q76h.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $95f62654b240c83e$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $1Q76h.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $95f62654b240c83e$var$NUMBER_OF_ARI_SEGMENTS = 5, $95f62654b240c83e$export$4c3a8cde7a55740b = class extends (0, $emp5t.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $95f62654b240c83e$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $emp5t.validateAriQualifier)(qualifier), (0, $emp5t.validatePlatformQualifier)(platformQualifier), $95f62654b240c83e$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $95f62654b240c83e$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $95f62654b240c83e$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $95f62654b240c83e$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $1Q76h.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $1Q76h.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $95f62654b240c83e$var$NUMBER_OF_ATI_SEGMENTS = 4, $95f62654b240c83e$var$AtiParser = class extends (0, $emp5t.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $95f62654b240c83e$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $emp5t.validateAtiQualifier)(qualifier), (0, $emp5t.validatePlatformQualifier)(platformQualifier), $95f62654b240c83e$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $95f62654b240c83e$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $emp5t.validateAtiQualifier)(qualifier), (0, $emp5t.validatePlatformQualifier)(platformQualifier), $95f62654b240c83e$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $95f62654b240c83e$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $95f62654b240c83e$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $95f62654b240c83e$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("emp5t", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $a7469493a2140e11$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $a7469493a2140e11$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $a7469493a2140e11$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $a7469493a2140e11$export$3d09a5c28ff3e040);

var $1Q76h = parcelRequire("1Q76h");
// src/core/rules/platform-qualifier.ts
function $a7469493a2140e11$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $1Q76h.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $a7469493a2140e11$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $1Q76h.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $a7469493a2140e11$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $1Q76h.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $a7469493a2140e11$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $1Q76h.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $a7469493a2140e11$var$NUMBER_OF_BASE_SEGMENTS = 5, $a7469493a2140e11$var$SEGMENT_SEPARATOR = ":", $a7469493a2140e11$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($a7469493a2140e11$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $1Q76h.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $a7469493a2140e11$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($a7469493a2140e11$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($a7469493a2140e11$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("1Q76h", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $157027c30f0eca1d$export$2191b9da168c6cf0);
// src/errors.ts
var $157027c30f0eca1d$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("cyu5B", function(module, exports) {
$parcel$export(module.exports, "fetchFn", () => $6e05055a522845c0$export$10f0d162cb6dae7c);
$parcel$export(module.exports, "network", () => $6e05055a522845c0$export$21fcfd9d5c6ebbd4);
$parcel$export(module.exports, "createNetwork", () => $6e05055a522845c0$export$2c3efcea68fbf7c6);

var $37Ewn = parcelRequire("37Ewn");

var $icl1h = parcelRequire("icl1h");

var $aMkcV = parcelRequire("aMkcV");

var $5ST2i = parcelRequire("5ST2i");

var $2yxzK = parcelRequire("2yxzK");
const $6e05055a522845c0$export$10f0d162cb6dae7c = async (request, variables, cacheConfig)=>{
    const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
    const body = (0, $icl1h.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $aMkcV.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
};
const $6e05055a522845c0$export$21fcfd9d5c6ebbd4 = (0, $37Ewn.Network).create($6e05055a522845c0$export$10f0d162cb6dae7c);
function $6e05055a522845c0$export$2c3efcea68fbf7c6(networkDependencies) {
    return (0, $37Ewn.Network).create((request, variables, cacheConfig)=>(0, $5ST2i.fetch)(request, variables, cacheConfig, networkDependencies), (0, $2yxzK.subscribe));
}

});

parcelRegister("bAuRU", function(module, exports) {
$parcel$export(module.exports, "default", () => $887d247bf612e24c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$887d247bf612e24c$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $aQK2r.version) === 'undefined' || (0, $aQK2r.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});


parcelRegister("5TDxB", function(module, exports) {
$parcel$export(module.exports, "createRelayEnvironment", () => $907bdc4554df7d1c$export$7afaa9c867644497);

var $37Ewn = parcelRequire("37Ewn");

var $lmvVe = parcelRequire("lmvVe");
function $907bdc4554df7d1c$export$7afaa9c867644497(environmentOptions) {
    const options = (0, $lmvVe.getSharedRelayEnvironmentConfig)(environmentOptions);
    return new (0, $37Ewn.Environment)(options);
}

});

parcelRegister("bgcdo", function(module, exports) {
$parcel$export(module.exports, "choreographerFactory", () => $a6f0319396ed144e$export$55d2aeb17c4cfbe);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7Q9YQ = parcelRequire("7Q9YQ");

var $4r2ee = parcelRequire("4r2ee");

var $7ozAR = parcelRequire("7ozAR");
var $hWoLQ = parcelRequire("hWoLQ");
var $4sDHa = parcelRequire("4sDHa");
var $URWD4 = parcelRequire("URWD4");
var $lbJgg = parcelRequire("lbJgg");
var $9cBd7 = parcelRequire("9cBd7");
var $fA2Iy = parcelRequire("fA2Iy");
var $ae67M = parcelRequire("ae67M");
var $9ljg8 = parcelRequire("9ljg8");
var $iHdtK = parcelRequire("iHdtK");
var $kpwyD = parcelRequire("kpwyD");
function $a6f0319396ed144e$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $4r2ee.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    // Capture plugin-wide TTL from options
    const pluginTtl = choreographerOptions.messageTtl;
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param callbacks An object containing start and stop callbacks.
	 * @param messageTtl Optional TTL for messages started via the returned startMessage function. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use plugin-wide TTL or global default (5 minutes). Message-level TTL takes priority over plugin-wide TTL.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $7Q9YQ.MessageEventType).START]: startCallback, [(0, $7Q9YQ.MessageEventType).STOP]: stopCallback } = {}, messageTtl)=>{
        const isMessageStarted = (0, $eJOHy.useRef)(false);
        const startRef = (0, $eJOHy.useRef)(startCallback);
        const stopRef = (0, $eJOHy.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $eJOHy.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        // Use message-level TTL if provided, otherwise fall back to plugin-wide TTL
        const startMessage = (0, $eJOHy.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            // Message-level TTL takes priority over plugin-wide TTL, if provided
            return plugin.startMessage(messageId, {}, messageTtl !== undefined ? messageTtl : pluginTtl);
        }, [
            messageId,
            startMessageCallback,
            messageTtl
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $eJOHy.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $eJOHy.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $7Q9YQ.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $eJOHy.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $eJOHy.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $eJOHy.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $7Q9YQ.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $7Q9YQ.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $eJOHy.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props, toggleableProp)=>{
        if ((0, $eGOwo.fg)('post-office_move_shouldbechoreographed')) return plugin.shouldBeChoreographed(props, choreographerOptions, toggleableProp);
        return (0, $9ljg8.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl })=>{
        const [shouldRender, setShouldRender] = (0, $eJOHy.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        }, messageTtl);
        (0, $eJOHy.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage,
            messageTtl
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition,
                messageTtl: messageTtl
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition" | "messageTtl"> is the same as T
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition" | "messageTtl"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $eJOHy.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            }, messageTtl);
            (0, $eJOHy.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue,
                messageTtl
            ]);
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $7ozAR.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $hWoLQ.Banner));
    const Flag = wrapWithFactoryFunctions((0, $4sDHa.Flag));
    const Modal = wrapWithFactoryFunctions((0, $lbJgg.Modal));
    const Popper = wrapWithFactoryFunctions((0, $fA2Iy.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $iHdtK.Spotlight));
    const SpotlightCard = wrapWithFactoryFunctions((0, $kpwyD.SpotlightCard));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $URWD4.InlineDialog));
    // Similar to Popup, PopoverContent uses a union type and so must be wrapped manually.
    const PopoverContent = function() {
        function WrappedPopoverContent(props) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9cBd7.PopoverContent), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopoverContent.displayName = `ChoreographerFactory(${(0, $9cBd7.PopoverContent).displayName})`;
        return WrappedPopoverContent;
    }();
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ae67M.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $ae67M.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard,
        PopoverContent: PopoverContent
    };
}

});
parcelRegister("4r2ee", function(module, exports) {
$parcel$export(module.exports, "ProductChoreographerPlugin", () => $6b9096419fe93874$export$44bee9c9373d59fb);

var $khSli = parcelRequire("khSli");
class $6b9096419fe93874$export$44bee9c9373d59fb extends (0, $khSli.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("7ozAR", function(module, exports) {
$parcel$export(module.exports, "AutoDismissFlag", () => $28338f243edaf4f2$export$9879a8e0db317538);

var $1jLQ3 = parcelRequire("1jLQ3");

var $9ljg8 = parcelRequire("9ljg8");
const $28338f243edaf4f2$export$9879a8e0db317538 = (0, $9ljg8.wrapComponentForChoreographer)((0, $1jLQ3.default));

});

parcelRegister("hWoLQ", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $6a729bebe7cfdc47$export$3b4e64e77073e307);

var $7mS2i = parcelRequire("7mS2i");

var $9ljg8 = parcelRequire("9ljg8");
const $6a729bebe7cfdc47$export$3b4e64e77073e307 = (0, $9ljg8.wrapComponentForChoreographer)((0, $7mS2i.default));

});

parcelRegister("4sDHa", function(module, exports) {
$parcel$export(module.exports, "Flag", () => $d8e0758eef658f71$export$48ea269755562084);

var $h0TP6 = parcelRequire("h0TP6");

var $9ljg8 = parcelRequire("9ljg8");
const $d8e0758eef658f71$export$48ea269755562084 = (0, $9ljg8.wrapComponentForChoreographer)((0, $h0TP6.default));

});

parcelRegister("URWD4", function(module, exports) {
$parcel$export(module.exports, "InlineDialog", () => $d9a597fbb7465d54$export$c7313f750e9cbc9d);

var $cwZBT = parcelRequire("cwZBT");

var $9ljg8 = parcelRequire("9ljg8");
const $d9a597fbb7465d54$export$c7313f750e9cbc9d = (0, $9ljg8.wrapToggleableComponentForChoreographer)((0, $cwZBT.default), 'isOpen');

});

parcelRegister("lbJgg", function(module, exports) {
$parcel$export(module.exports, "Modal", () => $b31a48c20584c1fd$export$2b77a92f1a5ad772);

var $gHHv2 = parcelRequire("gHHv2");

var $9ljg8 = parcelRequire("9ljg8");
const $b31a48c20584c1fd$export$2b77a92f1a5ad772 = (0, $9ljg8.wrapComponentForChoreographer)((0, $gHHv2.default));

});

parcelRegister("9cBd7", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $b315b7af65341f0c$export$d7e1f420b25549ff);

var $5Fxkp = parcelRequire("5Fxkp");

var $9ljg8 = parcelRequire("9ljg8");
const $b315b7af65341f0c$export$d7e1f420b25549ff = (0, $9ljg8.wrapToggleableComponentForChoreographer)((0, $5Fxkp.PopoverContent), 'isVisible');

});

parcelRegister("fA2Iy", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $558a20814f6ce656$export$badac9ada3a0bdf9);

var $8qmYl = parcelRequire("8qmYl");

var $9ljg8 = parcelRequire("9ljg8");
const $558a20814f6ce656$export$badac9ada3a0bdf9 = (0, $9ljg8.wrapComponentForChoreographer)((0, $8qmYl.Popper));

});

parcelRegister("ae67M", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $db3fff3fdb98948e$export$129a32eedafa97c5);

var $kJsb4 = parcelRequire("kJsb4");

var $9ljg8 = parcelRequire("9ljg8");
const $db3fff3fdb98948e$export$129a32eedafa97c5 = (0, $9ljg8.wrapToggleableComponentForChoreographer)((0, $kJsb4.Popup), 'isOpen');

});

parcelRegister("iHdtK", function(module, exports) {
$parcel$export(module.exports, "Spotlight", () => $26d5b0bd7302fa05$export$1033c28b5e1c2deb);

var $bdRit = parcelRequire("bdRit");

var $9ljg8 = parcelRequire("9ljg8");
const $26d5b0bd7302fa05$export$1033c28b5e1c2deb = (0, $9ljg8.wrapComponentForChoreographer)((0, $bdRit.default));

});

parcelRegister("kpwyD", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $7654dd825459bee1$export$14710e13fc01d383);

var $3l2IB = parcelRequire("3l2IB");

var $9ljg8 = parcelRequire("9ljg8");
const $7654dd825459bee1$export$14710e13fc01d383 = (0, $9ljg8.wrapComponentForChoreographer)((0, $3l2IB.default));

});


parcelRegister("1Q3jn", function(module, exports) {
$parcel$export(module.exports, "default", () => $156d37663eb902b7$export$2e2bcd8739ae039);

var $Ycxhg = parcelRequire("Ycxhg");

var $156d37663eb902b7$export$2e2bcd8739ae039 = (0, $Ycxhg.default);

});
parcelRegister("Ycxhg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b4f540bf905ab40$export$2e2bcd8739ae039);

var $2unhp = parcelRequire("2unhp");

var $fpB9r = parcelRequire("fpB9r");

var $eJOHy = parcelRequire("eJOHy");

var $jyUt8 = parcelRequire("jyUt8");

var $jD68e = parcelRequire("jD68e");
var $0b4f540bf905ab40$var$FocusLockCombination = /*#__PURE__*/ $eJOHy.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $eJOHy.createElement((0, $jyUt8.default), (0, $fpB9r.default)({
        sideCar: (0, $jD68e.default),
        ref: ref
    }, props));
});
var $0b4f540bf905ab40$var$_ref = (0, $jyUt8.default).propTypes || {}, $0b4f540bf905ab40$var$sideCar = $0b4f540bf905ab40$var$_ref.sideCar, $0b4f540bf905ab40$var$propTypes = (0, $2unhp.default)($0b4f540bf905ab40$var$_ref, [
    "sideCar"
]);
$0b4f540bf905ab40$var$FocusLockCombination.propTypes = {};
var $0b4f540bf905ab40$export$2e2bcd8739ae039 = $0b4f540bf905ab40$var$FocusLockCombination;

});
parcelRegister("jyUt8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3dcfedd669d600c$export$2e2bcd8739ae039);

var $fpB9r = parcelRequire("fpB9r");

var $eJOHy = parcelRequire("eJOHy");


var $56zCW = parcelRequire("56zCW");

var $lBwnZ = parcelRequire("lBwnZ");

var $9YQmh = parcelRequire("9YQmh");

var $2f0bX = parcelRequire("2f0bX");

var $btpar = parcelRequire("btpar");
var $e3dcfedd669d600c$var$emptyArray = [];
var $e3dcfedd669d600c$var$FocusLock = /*#__PURE__*/ $eJOHy.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $eJOHy.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $eJOHy.useRef();
    var isActive = $eJOHy.useRef(false);
    var originalFocusedElement = $eJOHy.useRef(null);
    var _React$useState2 = $eJOHy.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e3dcfedd669d600c$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $eJOHy.useState({}), id = _React$useState3[0];
    var onActivation = $eJOHy.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $eJOHy.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $eJOHy.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $eJOHy.useCallback(function(event) {
        if (isActive.current) (0, $2f0bX.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $2f0bX.mediumBlur).useMedium;
    var setObserveNode = $eJOHy.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $fpB9r.default)((_extends2 = {}, _extends2[$56zCW.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$56zCW.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $lBwnZ.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $eJOHy.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $eJOHy.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $9YQmh.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $eJOHy.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $9YQmh.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $eJOHy.createElement(SideCar, {
        id: id,
        sideCar: (0, $2f0bX.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $eJOHy.createElement(Container, (0, $fpB9r.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $eJOHy.createElement((0, $btpar.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $eJOHy.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $9YQmh.hiddenGuard)
    }));
});
$e3dcfedd669d600c$var$FocusLock.propTypes = {};
var $e3dcfedd669d600c$export$2e2bcd8739ae039 = $e3dcfedd669d600c$var$FocusLock;

});
parcelRegister("56zCW", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $3b792613fa14303c$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $3b792613fa14303c$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $3b792613fa14303c$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $3b792613fa14303c$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $3b792613fa14303c$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $3b792613fa14303c$export$4f9a06cb7441a087 = 'data-focus-lock';
var $3b792613fa14303c$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $3b792613fa14303c$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $3b792613fa14303c$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $3b792613fa14303c$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("lBwnZ", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $fba62cd8954b1911$export$74665b213cb5c4cf);

var $eJOHy = parcelRequire("eJOHy");

var $6rhqu = parcelRequire("6rhqu");

var $86T4q = parcelRequire("86T4q");
var $fba62cd8954b1911$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;
var $fba62cd8954b1911$var$currentValues = new WeakMap();
function $fba62cd8954b1911$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $86T4q.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $6rhqu.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $fba62cd8954b1911$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $fba62cd8954b1911$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $6rhqu.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $6rhqu.assignRef)(ref, current_1);
            });
        }
        $fba62cd8954b1911$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("6rhqu", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $4b02c833a3c1dea4$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $4b02c833a3c1dea4$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("86T4q", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $5e799a14b6f386f7$export$25bec8c6f54ee79a);

var $eJOHy = parcelRequire("eJOHy");
function $5e799a14b6f386f7$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $eJOHy.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("9YQmh", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $744254ea8ecb2eca$export$b8c7b07253306600);

var $eJOHy = parcelRequire("eJOHy");

var $744254ea8ecb2eca$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $744254ea8ecb2eca$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $744254ea8ecb2eca$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $eJOHy.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $744254ea8ecb2eca$export$b8c7b07253306600
    }));
};
$744254ea8ecb2eca$var$InFocusGuard.propTypes = {};
var $744254ea8ecb2eca$export$2e2bcd8739ae039 = $744254ea8ecb2eca$var$InFocusGuard;

});

parcelRegister("2f0bX", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $1a1d2194c81f4c25$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $1a1d2194c81f4c25$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $1a1d2194c81f4c25$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $1a1d2194c81f4c25$export$892cbf28e5518020);

var $7SuBe = parcelRequire("7SuBe");
var $1a1d2194c81f4c25$export$5733e022b1d538cb = (0, $7SuBe.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $1a1d2194c81f4c25$export$b3e9a9312f73723c = (0, $7SuBe.createMedium)();
var $1a1d2194c81f4c25$export$3a1d52767cbc07b8 = (0, $7SuBe.createMedium)();
var $1a1d2194c81f4c25$export$892cbf28e5518020 = (0, $7SuBe.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("7SuBe", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $5bc54ff938209996$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $5bc54ff938209996$export$e13ec7dd7a14088d);

var $dnskZ = parcelRequire("dnskZ");
function $5bc54ff938209996$var$ItoI(a) {
    return a;
}
function $5bc54ff938209996$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $5bc54ff938209996$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $5bc54ff938209996$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $5bc54ff938209996$var$ItoI;
    return $5bc54ff938209996$var$innerCreateMedium(defaults, middleware);
}
function $5bc54ff938209996$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $5bc54ff938209996$var$innerCreateMedium(null);
    medium.options = (0, $dnskZ.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("btpar", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $85a5ece175b45122$export$f5272e9b1168239c);

var $eJOHy = parcelRequire("eJOHy");
var $85a5ece175b45122$export$f5272e9b1168239c = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);

});


parcelRegister("jD68e", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4a66a7752ead3df$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $5XU67 = parcelRequire("5XU67");

var $27yJ1 = parcelRequire("27yJ1");
var $aAyr4 = parcelRequire("aAyr4");
var $bNNFQ = parcelRequire("bNNFQ");
var $kCJ0M = parcelRequire("kCJ0M");
var $gW5Tv = parcelRequire("gW5Tv");parcelRequire("2eBgq");
var $RcH2z = parcelRequire("RcH2z");

var $efB5P = parcelRequire("efB5P");

var $2f0bX = parcelRequire("2f0bX");
var $e4a66a7752ead3df$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $e4a66a7752ead3df$var$isFreeFocus = function isFreeFocus() {
    return $e4a66a7752ead3df$var$focusOnBody() || (0, $gW5Tv.focusIsHidden)();
};
var $e4a66a7752ead3df$var$lastActiveTrap = null;
var $e4a66a7752ead3df$var$lastActiveFocus = null;
var $e4a66a7752ead3df$var$lastPortaledElement = null;
var $e4a66a7752ead3df$var$focusWasOutsideWindow = false;
var $e4a66a7752ead3df$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $e4a66a7752ead3df$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($e4a66a7752ead3df$var$lastActiveTrap.whiteList || $e4a66a7752ead3df$var$defaultWhitelist)(activeElement);
};
var $e4a66a7752ead3df$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $e4a66a7752ead3df$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $e4a66a7752ead3df$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $e4a66a7752ead3df$var$lastPortaledElement && $e4a66a7752ead3df$var$lastPortaledElement.portaledElement === element;
};
function $e4a66a7752ead3df$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $e4a66a7752ead3df$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($e4a66a7752ead3df$var$focusWasOutsideWindow);
    return $e4a66a7752ead3df$var$focusWasOutsideWindow === 'meanwhile';
};
var $e4a66a7752ead3df$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $e4a66a7752ead3df$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $e4a66a7752ead3df$var$checkInHost(activeElement, area, area);
    });
};
var $e4a66a7752ead3df$var$activateTrap = function activateTrap() {
    var result = false;
    if ($e4a66a7752ead3df$var$lastActiveTrap) {
        var _lastActiveTrap = $e4a66a7752ead3df$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $e4a66a7752ead3df$var$lastPortaledElement && $e4a66a7752ead3df$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $efB5P.extractRef)).filter(Boolean));
            if (!activeElement || $e4a66a7752ead3df$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $e4a66a7752ead3df$var$focusWasOutside(crossFrame) || !$e4a66a7752ead3df$var$isFreeFocus() || !$e4a66a7752ead3df$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $kCJ0M.focusInside)(workingArea) || activeElement && $e4a66a7752ead3df$var$withinHost(activeElement, workingArea) || $e4a66a7752ead3df$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$e4a66a7752ead3df$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $RcH2z.moveFocusInside)(workingArea, $e4a66a7752ead3df$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $e4a66a7752ead3df$var$lastPortaledElement = {};
                        }
                    }
                    $e4a66a7752ead3df$var$focusWasOutsideWindow = false;
                    $e4a66a7752ead3df$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $aAyr4.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $e4a66a7752ead3df$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $e4a66a7752ead3df$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $e4a66a7752ead3df$var$onTrap = function onTrap(event) {
    if ($e4a66a7752ead3df$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $e4a66a7752ead3df$var$onBlur = function onBlur() {
    return (0, $efB5P.deferAction)($e4a66a7752ead3df$var$activateTrap);
};
var $e4a66a7752ead3df$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $e4a66a7752ead3df$var$recordPortal(currentNode, source);
};
var $e4a66a7752ead3df$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $e4a66a7752ead3df$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        onBlur: $e4a66a7752ead3df$var$onBlur,
        onFocus: $e4a66a7752ead3df$var$onFocus
    }, children);
};
$e4a66a7752ead3df$var$FocusTrap.propTypes = {};
var $e4a66a7752ead3df$var$onWindowBlur = function onWindowBlur() {
    $e4a66a7752ead3df$var$focusWasOutsideWindow = 'just';
    (0, $efB5P.deferAction)(function() {
        $e4a66a7752ead3df$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $e4a66a7752ead3df$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $e4a66a7752ead3df$var$onTrap);
    document.addEventListener('focusout', $e4a66a7752ead3df$var$onBlur);
    window.addEventListener('blur', $e4a66a7752ead3df$var$onWindowBlur);
};
var $e4a66a7752ead3df$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $e4a66a7752ead3df$var$onTrap);
    document.removeEventListener('focusout', $e4a66a7752ead3df$var$onBlur);
    window.removeEventListener('blur', $e4a66a7752ead3df$var$onWindowBlur);
};
function $e4a66a7752ead3df$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $e4a66a7752ead3df$var$focusLockAPI = {
    moveFocusInside: (0, $RcH2z.moveFocusInside),
    focusInside: (0, $kCJ0M.focusInside),
    focusNextElement: (0, $bNNFQ.focusNextElement),
    focusPrevElement: (0, $bNNFQ.focusPrevElement),
    focusFirstElement: (0, $bNNFQ.focusFirstElement),
    focusLastElement: (0, $bNNFQ.focusLastElement),
    captureFocusRestore: (0, $27yJ1.captureFocusRestore)
};
function $e4a66a7752ead3df$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$e4a66a7752ead3df$var$lastActiveTrap) $e4a66a7752ead3df$var$attachHandler();
    var lastTrap = $e4a66a7752ead3df$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $e4a66a7752ead3df$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $e4a66a7752ead3df$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($e4a66a7752ead3df$var$focusLockAPI);
        $e4a66a7752ead3df$var$activateTrap(true);
        (0, $efB5P.deferAction)($e4a66a7752ead3df$var$activateTrap);
    } else {
        $e4a66a7752ead3df$var$detachHandler();
        $e4a66a7752ead3df$var$lastActiveFocus = null;
    }
}
(0, $2f0bX.mediumFocus).assignSyncMedium($e4a66a7752ead3df$var$onFocus);
(0, $2f0bX.mediumBlur).assignMedium($e4a66a7752ead3df$var$onBlur);
(0, $2f0bX.mediumEffect).assignMedium(function(cb) {
    return cb($e4a66a7752ead3df$var$focusLockAPI);
});
var $e4a66a7752ead3df$export$2e2bcd8739ae039 = (0, $5XU67.default)($e4a66a7752ead3df$var$reducePropsToState, $e4a66a7752ead3df$var$handleStateChangeOnClient)($e4a66a7752ead3df$var$FocusWatcher);

});
parcelRegister("5XU67", function(module, exports) {
$parcel$export(module.exports, "default", () => $457dfa4719c7e222$export$2e2bcd8739ae039);

var $b8SSx = parcelRequire("b8SSx");

var $7M3Wu = parcelRequire("7M3Wu");

var $eJOHy = parcelRequire("eJOHy");
function $457dfa4719c7e222$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $b8SSx.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $eJOHy.PureComponent));
        (0, $7M3Wu.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $457dfa4719c7e222$export$2e2bcd8739ae039 = $457dfa4719c7e222$var$withSideEffect;

});
parcelRegister("7M3Wu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a9012fdc0c1f365$export$2e2bcd8739ae039);

var $j5ays = parcelRequire("j5ays");
function $5a9012fdc0c1f365$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $j5ays.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("j5ays", function(module, exports) {
$parcel$export(module.exports, "default", () => $0395c8f75e31fb87$export$2e2bcd8739ae039);

var $bqoox = parcelRequire("bqoox");

var $4kkki = parcelRequire("4kkki");
function $0395c8f75e31fb87$export$2e2bcd8739ae039(t) {
    var i = (0, $4kkki.default)(t, "string");
    return "symbol" == (0, $bqoox.default)(i) ? i : i + "";
}

});
parcelRegister("bqoox", function(module, exports) {
$parcel$export(module.exports, "default", () => $85150bb457a66b8e$export$2e2bcd8739ae039);
function $85150bb457a66b8e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $85150bb457a66b8e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $85150bb457a66b8e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4kkki", function(module, exports) {
$parcel$export(module.exports, "default", () => $3268cc17a8a041c5$export$2e2bcd8739ae039);

var $bqoox = parcelRequire("bqoox");
function $3268cc17a8a041c5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $bqoox.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bqoox.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("27yJ1", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $18b72bef2cd4c3f1$export$d357db6e554ff59a);

var $lBK8l = parcelRequire("lBK8l");
function $18b72bef2cd4c3f1$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $18b72bef2cd4c3f1$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $18b72bef2cd4c3f1$var$weakRef(currentElement),
            parent: $18b72bef2cd4c3f1$var$weakRef(currentElement.parentElement),
            left: $18b72bef2cd4c3f1$var$weakRef(currentElement.previousElementSibling),
            right: $18b72bef2cd4c3f1$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $18b72bef2cd4c3f1$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $18b72bef2cd4c3f1$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $lBK8l.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $18b72bef2cd4c3f1$export$d357db6e554ff59a = function(targetElement) {
    var location = $18b72bef2cd4c3f1$export$5061a7725be48ff9(targetElement);
    return function() {
        return $18b72bef2cd4c3f1$var$restoreFocusTo(location);
    };
};

});
parcelRegister("lBK8l", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $fbb0d6d403c71bec$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $fbb0d6d403c71bec$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $fbb0d6d403c71bec$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $fbb0d6d403c71bec$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $fbb0d6d403c71bec$export$2344b14b097df817);

var $by6G3 = parcelRequire("by6G3");

var $dy1S5 = parcelRequire("dy1S5");

var $bG9xb = parcelRequire("bG9xb");

var $3NlZt = parcelRequire("3NlZt");
var $fbb0d6d403c71bec$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $by6G3.toArray)(nodes).filter(function(node) {
        return (0, $dy1S5.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $dy1S5.notHiddenInput)(node);
    });
};
var $fbb0d6d403c71bec$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $by6G3.toArray)(nodes).filter(function(node) {
        return (0, $dy1S5.isAutoFocusAllowedCached)(cache, node);
    });
};
var $fbb0d6d403c71bec$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $bG9xb.orderByTabIndex)($fbb0d6d403c71bec$export$6266a5cd5915dc33((0, $3NlZt.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $fbb0d6d403c71bec$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $bG9xb.orderByTabIndex)($fbb0d6d403c71bec$export$6266a5cd5915dc33((0, $3NlZt.getFocusables)(topNodes), visibilityCache), false);
};
var $fbb0d6d403c71bec$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $fbb0d6d403c71bec$export$6266a5cd5915dc33((0, $3NlZt.getParentAutofocusables)(topNode), visibilityCache);
};
var $fbb0d6d403c71bec$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $fbb0d6d403c71bec$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $by6G3.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $fbb0d6d403c71bec$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $fbb0d6d403c71bec$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("by6G3", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $86880ca19ec86157$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $86880ca19ec86157$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $86880ca19ec86157$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $86880ca19ec86157$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $86880ca19ec86157$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $86880ca19ec86157$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("dy1S5", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $9dcfe6f809a6d277$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $9dcfe6f809a6d277$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $9dcfe6f809a6d277$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $9dcfe6f809a6d277$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $9dcfe6f809a6d277$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $9dcfe6f809a6d277$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $9dcfe6f809a6d277$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $9dcfe6f809a6d277$export$4e62c701997796c1);

var $56zCW = parcelRequire("56zCW");
var $9dcfe6f809a6d277$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $9dcfe6f809a6d277$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $9dcfe6f809a6d277$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $9dcfe6f809a6d277$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $9dcfe6f809a6d277$var$isVisibleUncached = function(node, checkParent) {
    return !node || $9dcfe6f809a6d277$var$isTopNode(node) || !$9dcfe6f809a6d277$var$isElementHidden(node) && !$9dcfe6f809a6d277$var$isInert(node) && checkParent($9dcfe6f809a6d277$var$getParentNode(node));
};
var $9dcfe6f809a6d277$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $9dcfe6f809a6d277$var$isVisibleUncached(node, $9dcfe6f809a6d277$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $9dcfe6f809a6d277$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$9dcfe6f809a6d277$var$isTopNode(node) ? $9dcfe6f809a6d277$export$b8550e27de209d85(node) ? checkParent($9dcfe6f809a6d277$var$getParentNode(node)) : false : true;
};
var $9dcfe6f809a6d277$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $9dcfe6f809a6d277$var$isAutoFocusAllowedUncached(node, $9dcfe6f809a6d277$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $9dcfe6f809a6d277$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $9dcfe6f809a6d277$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $9dcfe6f809a6d277$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $9dcfe6f809a6d277$export$9d74f6fbc6f469d0 = function(node) {
    return $9dcfe6f809a6d277$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $9dcfe6f809a6d277$export$8197b0ea56b3b055 = function(node) {
    return !(($9dcfe6f809a6d277$export$88a6ceeed5737ba3(node) || $9dcfe6f809a6d277$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $9dcfe6f809a6d277$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $56zCW.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $9dcfe6f809a6d277$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $9dcfe6f809a6d277$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $9dcfe6f809a6d277$export$602e5a0d338d7750 = function(node) {
    return !$9dcfe6f809a6d277$export$d94b8b58ec2f30eb(node);
};
var $9dcfe6f809a6d277$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("bG9xb", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $880b03398ccef246$export$cb40ee071f0d5226);

var $by6G3 = parcelRequire("by6G3");
var $880b03398ccef246$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $880b03398ccef246$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $880b03398ccef246$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $by6G3.toArray)(nodes).map(function(node, index) {
        var tabIndex = $880b03398ccef246$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($880b03398ccef246$export$350ee6c095d98996);
};

});

parcelRegister("3NlZt", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $2c370190983b2013$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $2c370190983b2013$export$853fa94d922e78b9);

var $56zCW = parcelRequire("56zCW");

var $by6G3 = parcelRequire("by6G3");

var $iU7vr = parcelRequire("iU7vr");
var $2c370190983b2013$var$queryTabbables = (0, $iU7vr.tabbables).join(',');
var $2c370190983b2013$var$queryGuardTabbables = "".concat($2c370190983b2013$var$queryTabbables, ", [data-focus-guard]");
var $2c370190983b2013$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $by6G3.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $2c370190983b2013$var$queryGuardTabbables : $2c370190983b2013$var$queryTabbables) ? [
            child
        ] : [], $2c370190983b2013$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $2c370190983b2013$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $2c370190983b2013$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $2c370190983b2013$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $2c370190983b2013$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $2c370190983b2013$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $by6G3.toArray)(parent.parentNode.querySelectorAll($2c370190983b2013$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $2c370190983b2013$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $56zCW.FOCUS_AUTO), "]"));
    return (0, $by6G3.toArray)(parentFocus).map(function(node) {
        return $2c370190983b2013$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("iU7vr", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $dc33477e61b7509d$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $dc33477e61b7509d$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("aAyr4", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $7b57fa658c2709df$export$f89ac71e91767111);

var $9RBXz = parcelRequire("9RBXz");

var $dy1S5 = parcelRequire("dy1S5");

var $6DqTH = parcelRequire("6DqTH");

var $bG9xb = parcelRequire("bG9xb");

var $3NlZt = parcelRequire("3NlZt");
var $7b57fa658c2709df$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $9RBXz.getAllAffectedNodes)(topNode).filter((0, $dy1S5.isNotAGuard));
    var commonParent = (0, $6DqTH.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $bG9xb.orderByTabIndex)((0, $3NlZt.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $3NlZt.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $dy1S5.isGuard)(node)
        };
    });
};

});
parcelRegister("9RBXz", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $72e6824ec51f7792$export$7e87c4720b9b279b);

var $56zCW = parcelRequire("56zCW");

var $by6G3 = parcelRequire("by6G3");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $72e6824ec51f7792$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $72e6824ec51f7792$var$getTopParent = function(node) {
    return node.parentNode ? $72e6824ec51f7792$var$getTopParent(node.parentNode) : node;
};
var $72e6824ec51f7792$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $by6G3.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $56zCW.FOCUS_GROUP));
        acc.push.apply(acc, group ? $72e6824ec51f7792$var$filterNested((0, $by6G3.toArray)($72e6824ec51f7792$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $56zCW.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $56zCW.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("6DqTH", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $4d4b3fd802aeb041$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $4d4b3fd802aeb041$export$8f99714c70a37db1);

var $lBK8l = parcelRequire("lBK8l");

var $by6G3 = parcelRequire("by6G3");
var $4d4b3fd802aeb041$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $4d4b3fd802aeb041$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $4d4b3fd802aeb041$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $4d4b3fd802aeb041$var$getParents(nodeA);
    var parentsB = $4d4b3fd802aeb041$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $4d4b3fd802aeb041$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $by6G3.asArray)(baseActiveElement);
    var leftEntries = (0, $by6G3.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $4d4b3fd802aeb041$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $4d4b3fd802aeb041$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $lBK8l.contains)(common, topCommon)) topCommon = common;
                else topCommon = $4d4b3fd802aeb041$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $4d4b3fd802aeb041$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $lBK8l.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("bNNFQ", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $897acd7e770fd497$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $897acd7e770fd497$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $897acd7e770fd497$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $897acd7e770fd497$export$6a79073ddabfd6c3);

var $2yQBm = parcelRequire("2yQBm");

var $lBK8l = parcelRequire("lBK8l");

var $by6G3 = parcelRequire("by6G3");
var $897acd7e770fd497$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $by6G3.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $lBK8l.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $lBK8l.getTabbableNodes)(shards, new Map()) : (0, $lBK8l.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $897acd7e770fd497$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $lBK8l.getTabbableNodes)((0, $by6G3.asArray)(shards), new Map()) : (0, $lBK8l.getFocusableNodes)((0, $by6G3.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $897acd7e770fd497$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $897acd7e770fd497$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $897acd7e770fd497$var$defaultOptions(options);
    var solution = $897acd7e770fd497$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $2yQBm.focusOn)(target.node, newOptions.focusOptions);
};
var $897acd7e770fd497$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $897acd7e770fd497$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $897acd7e770fd497$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $897acd7e770fd497$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $897acd7e770fd497$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $897acd7e770fd497$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $2yQBm.focusOn)(node.node, options.focusOptions);
};
var $897acd7e770fd497$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $897acd7e770fd497$var$pickBoundary(scope, options, 'first');
};
var $897acd7e770fd497$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $897acd7e770fd497$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("2yQBm", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $1dd78f4e241117e9$export$c12b3da842c43a8);
var $1dd78f4e241117e9$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("kCJ0M", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $f03a459cc484bf84$export$20115f8da7baa6fa);

var $lBK8l = parcelRequire("lBK8l");

var $9RBXz = parcelRequire("9RBXz");

var $by6G3 = parcelRequire("by6G3");

var $jEaTp = parcelRequire("jEaTp");
var $f03a459cc484bf84$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $f03a459cc484bf84$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $by6G3.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $f03a459cc484bf84$var$focusInFrame(node, activeElement);
    }));
};
var $f03a459cc484bf84$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $jEaTp.getActiveElement)((0, $by6G3.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $9RBXz.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $lBK8l.contains)(node, activeElement) || $f03a459cc484bf84$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("jEaTp", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $e4da33cbe06b449e$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $4so5Q = parcelRequire("4so5Q");
var $e4da33cbe06b449e$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $e4da33cbe06b449e$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $4so5Q.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $e4da33cbe06b449e$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("4so5Q", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $33ec77651a7a8b04$export$78d20aae35adef88);
var $33ec77651a7a8b04$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("gW5Tv", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $c546a29e231658a6$export$be6b21806d3fd485);

var $56zCW = parcelRequire("56zCW");

var $lBK8l = parcelRequire("lBK8l");

var $by6G3 = parcelRequire("by6G3");

var $jEaTp = parcelRequire("jEaTp");
var $c546a29e231658a6$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $jEaTp.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $by6G3.toArray)(inDocument.querySelectorAll("[".concat((0, $56zCW.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $lBK8l.contains)(node, activeElement);
    });
};

});

parcelRegister("2eBgq", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("RcH2z")).moveFocusInside);

var $56zCW = parcelRequire("56zCW");

var $kCJ0M = parcelRequire("kCJ0M");

var $gW5Tv = parcelRequire("gW5Tv");


var $aAyr4 = parcelRequire("aAyr4");

var $RcH2z = parcelRequire("RcH2z");

var $27yJ1 = parcelRequire("27yJ1");

var $bNNFQ = parcelRequire("bNNFQ");

var $lBK8l = parcelRequire("lBK8l");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $1a09cb6599c09d73$export$1a988e7317c65621 = $56zCW;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $1a09cb6599c09d73$var$deprecated_default_moveFocusInside = (0, $RcH2z.moveFocusInside);
var $1a09cb6599c09d73$export$2e2bcd8739ae039 //
 = $1a09cb6599c09d73$var$deprecated_default_moveFocusInside;

});
parcelRegister("RcH2z", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $09fecbf518e4ff83$export$cd599851e879a025);

var $2yQBm = parcelRequire("2yQBm");

var $jZgsU = parcelRequire("jZgsU");
var $09fecbf518e4ff83$var$guardCount = 0;
var $09fecbf518e4ff83$var$lockDisabled = false;
var $09fecbf518e4ff83$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $jZgsU.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($09fecbf518e4ff83$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($09fecbf518e4ff83$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $09fecbf518e4ff83$var$lockDisabled = true;
            setTimeout(function() {
                $09fecbf518e4ff83$var$lockDisabled = false;
            }, 1);
            return;
        }
        $09fecbf518e4ff83$var$guardCount++;
        (0, $2yQBm.focusOn)(focusable.node, options.focusOptions);
        $09fecbf518e4ff83$var$guardCount--;
    }
};

});
parcelRegister("jZgsU", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $e8d07c78c92dcf69$export$305758c744b57f6f);

var $hcRuF = parcelRequire("hcRuF");

var $lBK8l = parcelRequire("lBK8l");

var $9RBXz = parcelRequire("9RBXz");

var $by6G3 = parcelRequire("by6G3");

var $6bmna = parcelRequire("6bmna");

var $jEaTp = parcelRequire("jEaTp");

var $dy1S5 = parcelRequire("dy1S5");

var $6DqTH = parcelRequire("6DqTH");
var $e8d07c78c92dcf69$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $dy1S5.isDefined));
};
var $e8d07c78c92dcf69$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $jEaTp.getActiveElement)((0, $by6G3.asArray)(topNode).length > 0 ? document : (0, $by6G3.getFirst)(topNode).ownerDocument);
    var entries = (0, $9RBXz.getAllAffectedNodes)(topNode).filter((0, $dy1S5.isNotAGuard));
    var commonParent = (0, $6DqTH.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $lBK8l.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $dy1S5.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $lBK8l.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $e8d07c78c92dcf69$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $hcRuF.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $hcRuF.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $6bmna.pickAutofocus)(anyFocusable, innerTabbable, (0, $6DqTH.allParentAutofocusables)(entries, visibilityCache)) || (0, $6bmna.pickAutofocus)(anyFocusable, innerFocusables, (0, $6DqTH.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("hcRuF", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $c86d0d5e44fbd575$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $c86d0d5e44fbd575$export$65842178e9bb4205);

var $14rFr = parcelRequire("14rFr");

var $jMXEf = parcelRequire("jMXEf");

var $dy1S5 = parcelRequire("dy1S5");
var $c86d0d5e44fbd575$export$85710b12cf912438 = 'NEW_FOCUS';
var $c86d0d5e44fbd575$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $dy1S5.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $c86d0d5e44fbd575$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $c86d0d5e44fbd575$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $14rFr.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $jMXEf.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $jMXEf.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("14rFr", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $0c7ba05791ba1da8$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $0c7ba05791ba1da8$export$4a5a72a7124e45f9);

var $dy1S5 = parcelRequire("dy1S5");
var $0c7ba05791ba1da8$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $dy1S5.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $0c7ba05791ba1da8$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $dy1S5.isRadioElement)(node) && node.name) return $0c7ba05791ba1da8$var$findSelectedRadio(node, nodes);
    return node;
};
var $0c7ba05791ba1da8$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($0c7ba05791ba1da8$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("jMXEf", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $e680c4e0d8715706$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $e680c4e0d8715706$export$e06728ee87c96122);

var $14rFr = parcelRequire("14rFr");
var $e680c4e0d8715706$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $14rFr.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $e680c4e0d8715706$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $14rFr.correctNode)(node, nodes));
};

});


parcelRegister("6bmna", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $48051fec020a9a4e$export$cfb742983e257555);

var $lBK8l = parcelRequire("lBK8l");

var $jMXEf = parcelRequire("jMXEf");

var $dy1S5 = parcelRequire("dy1S5");
var $48051fec020a9a4e$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $dy1S5.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $48051fec020a9a4e$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $lBK8l.filterAutoFocusable)(nodes.filter($48051fec020a9a4e$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $jMXEf.pickFirstFocus)(autoFocusable);
    return (0, $jMXEf.pickFirstFocus)((0, $lBK8l.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("efB5P", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $a5ff3d4c5ac40b44$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $a5ff3d4c5ac40b44$export$c613fed06e332533);
function $a5ff3d4c5ac40b44$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $a5ff3d4c5ac40b44$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $a5ff3d4c5ac40b44$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("lSFAJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fedee7550c8b07ab$export$2e2bcd8739ae039);

var $jyUt8 = parcelRequire("jyUt8");






var $fedee7550c8b07ab$export$2e2bcd8739ae039 = (0, $jyUt8.default);

});

parcelRegister("ecYd5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jrOc5 = parcelRequire("jrOc5");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $a580e427323b2ac9$var$_interopRequireDefault($jrOc5).default;
    }
});

var $lmjji = parcelRequire("lmjji");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $lmjji.TouchScrollable;
    }
});
function $a580e427323b2ac9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("jrOc5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e2877965377eb9f8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $e2877965377eb9f8$var$_react2 = $e2877965377eb9f8$var$_interopRequireDefault($eJOHy);

var $2PAgW = parcelRequire("2PAgW");

var $lmjji = parcelRequire("lmjji");

var $c72SE = parcelRequire("c72SE");
var $e2877965377eb9f8$var$_withLockSheet2 = $e2877965377eb9f8$var$_interopRequireDefault($c72SE);

var $2O2jP = parcelRequire("2O2jP");
var $e2877965377eb9f8$var$_withTouchListeners2 = $e2877965377eb9f8$var$_interopRequireDefault($2O2jP);

var $hrSYD = parcelRequire("hrSYD");
function $e2877965377eb9f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e2877965377eb9f8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e2877965377eb9f8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e2877965377eb9f8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e2877965377eb9f8$var$ScrollLock = function(_PureComponent) {
    $e2877965377eb9f8$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $e2877965377eb9f8$var$_classCallCheck(this, ScrollLock);
        return $e2877965377eb9f8$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $e2877965377eb9f8$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$2PAgW.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $e2877965377eb9f8$var$_react2.default.createElement($lmjji.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($eJOHy.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $e2877965377eb9f8$var$compose = (0, $hrSYD.pipe)($e2877965377eb9f8$var$_withTouchListeners2.default, $e2877965377eb9f8$var$_withLockSheet2.default);
var $e2877965377eb9f8$var$SheetLock = $e2877965377eb9f8$var$compose($e2877965377eb9f8$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $e2877965377eb9f8$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $e2877965377eb9f8$var$_react2.default.createElement($e2877965377eb9f8$var$SheetLock, props) : props.children;
};
$e2877965377eb9f8$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $e2877965377eb9f8$var$LockToggle;

});
parcelRegister("2PAgW", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("lmjji", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $040344ac10efaae4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $040344ac10efaae4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");

var $2PAgW = parcelRequire("2PAgW");

var $hrSYD = parcelRequire("hrSYD");
function $040344ac10efaae4$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $040344ac10efaae4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $040344ac10efaae4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $040344ac10efaae4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $040344ac10efaae4$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $040344ac10efaae4$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $040344ac10efaae4$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $040344ac10efaae4$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $040344ac10efaae4$var$_possibleConstructorReturn(_this, _ret);
    }
    $040344ac10efaae4$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$2PAgW.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $hrSYD.preventInertiaScroll, $hrSYD.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $hrSYD.allowTouchMove, $hrSYD.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$2PAgW.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $hrSYD.preventInertiaScroll, $hrSYD.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $hrSYD.allowTouchMove, $hrSYD.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $040344ac10efaae4$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $eJOHy.cloneElement)(children, $040344ac10efaae4$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($eJOHy.PureComponent);

});
parcelRegister("hrSYD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $cb3f9a969be80f47$var$preventTouchMove;
module.exports.allowTouchMove = $cb3f9a969be80f47$var$allowTouchMove;
module.exports.preventInertiaScroll = $cb3f9a969be80f47$var$preventInertiaScroll;
module.exports.isTouchDevice = $cb3f9a969be80f47$var$isTouchDevice;
module.exports.camelToKebab = $cb3f9a969be80f47$var$camelToKebab;
module.exports.parse = $cb3f9a969be80f47$var$parse;
module.exports.getPadding = $cb3f9a969be80f47$var$getPadding;
module.exports.getWindowHeight = $cb3f9a969be80f47$var$getWindowHeight;
module.exports.getDocumentHeight = $cb3f9a969be80f47$var$getDocumentHeight;
module.exports.makeStyleTag = $cb3f9a969be80f47$var$makeStyleTag;
module.exports.injectStyles = $cb3f9a969be80f47$var$injectStyles;
module.exports.insertStyleTag = $cb3f9a969be80f47$var$insertStyleTag;

var $2PAgW = parcelRequire("2PAgW");
var $cb3f9a969be80f47$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $cb3f9a969be80f47$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $cb3f9a969be80f47$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $cb3f9a969be80f47$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $cb3f9a969be80f47$var$isTouchDevice() {
    if (!$2PAgW.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $cb3f9a969be80f47$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $cb3f9a969be80f47$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $cb3f9a969be80f47$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $cb3f9a969be80f47$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($cb3f9a969be80f47$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $cb3f9a969be80f47$var$getPadding() {
    if (!$2PAgW.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $cb3f9a969be80f47$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($2PAgW.canUseDOM) return window.innerHeight * multiplier;
}
function $cb3f9a969be80f47$var$getDocumentHeight() {
    if ($2PAgW.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $cb3f9a969be80f47$var$makeStyleTag() {
    if (!$2PAgW.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $cb3f9a969be80f47$var$injectStyles(tag, css) {
    if (!$2PAgW.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $cb3f9a969be80f47$var$insertStyleTag(tag) {
    if (!$2PAgW.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("c72SE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8d185f82044616ff$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $8d185f82044616ff$var$withLockSheet;

var $eJOHy = parcelRequire("eJOHy");
var $8d185f82044616ff$var$_react2 = $8d185f82044616ff$var$_interopRequireDefault($eJOHy);

var $hrSYD = parcelRequire("hrSYD");
function $8d185f82044616ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d185f82044616ff$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8d185f82044616ff$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8d185f82044616ff$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8d185f82044616ff$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $8d185f82044616ff$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $8d185f82044616ff$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8d185f82044616ff$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $hrSYD.makeStyleTag)();
                if (!sheet) return;
                (0, $hrSYD.injectStyles)(sheet, styles);
                (0, $hrSYD.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $hrSYD.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $hrSYD.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $8d185f82044616ff$var$_possibleConstructorReturn(_this, _ret);
        }
        $8d185f82044616ff$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $8d185f82044616ff$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($eJOHy.PureComponent);
}

});

parcelRegister("2O2jP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $20b20cbb5ee2b9e9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $20b20cbb5ee2b9e9$var$withTouchListeners;

var $eJOHy = parcelRequire("eJOHy");
var $20b20cbb5ee2b9e9$var$_react2 = $20b20cbb5ee2b9e9$var$_interopRequireDefault($eJOHy);

var $2PAgW = parcelRequire("2PAgW");

var $hrSYD = parcelRequire("hrSYD");
function $20b20cbb5ee2b9e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $20b20cbb5ee2b9e9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20b20cbb5ee2b9e9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $20b20cbb5ee2b9e9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $20b20cbb5ee2b9e9$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $20b20cbb5ee2b9e9$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $20b20cbb5ee2b9e9$var$_classCallCheck(this, TouchProvider);
            return $20b20cbb5ee2b9e9$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $20b20cbb5ee2b9e9$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$2PAgW.canUseDOM || !(0, $hrSYD.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $hrSYD.preventTouchMove, $hrSYD.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$2PAgW.canUseDOM || !(0, $hrSYD.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $hrSYD.preventTouchMove, $hrSYD.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $20b20cbb5ee2b9e9$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($eJOHy.PureComponent);
}

});



parcelRegister("6CugT", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("5mZ6c")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("5mZ6c")).dropTargetForExternal);

var $5mZ6c = parcelRequire("5mZ6c");

});
parcelRegister("5mZ6c", function(module, exports) {
$parcel$export(module.exports, "dropTargetForExternal", () => $2057ad6a9ea0fe11$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $2057ad6a9ea0fe11$export$bb1740f3194979c1);

var $4eDgu = parcelRequire("4eDgu");

var $kL2Iu = parcelRequire("kL2Iu");

var $9Hsiy = parcelRequire("9Hsiy");

var $mvADE = parcelRequire("mvADE");

var $bOMk0 = parcelRequire("bOMk0");


function $2057ad6a9ea0fe11$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $8f124db82e8162d9$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $c360c820836f002e$export$fd3d00026297c0ad) && value === (0, $9Hsiy.androidFallbackText)) return false;
    return true;
}
function $2057ad6a9ea0fe11$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$2057ad6a9ea0fe11$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $2057ad6a9ea0fe11$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $2057ad6a9ea0fe11$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $2057ad6a9ea0fe11$var$didDragStartLocally = false;
const $2057ad6a9ea0fe11$var$adapter = (0, $kL2Iu.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $4eDgu.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($2057ad6a9ea0fe11$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $mvADE.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $2057ad6a9ea0fe11$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $2057ad6a9ea0fe11$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$2057ad6a9ea0fe11$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $2057ad6a9ea0fe11$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $2057ad6a9ea0fe11$var$adapter.dropTarget(args);
}
function $2057ad6a9ea0fe11$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $2057ad6a9ea0fe11$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $2057ad6a9ea0fe11$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $2057ad6a9ea0fe11$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $4eDgu.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $bOMk0.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $4eDgu.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $2057ad6a9ea0fe11$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("mvADE", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $c9e9655eaf6fc6e0$export$d1c6f249e893cdf4);

var $3eRFA = parcelRequire("3eRFA");

var $72Sl2 = parcelRequire("72Sl2");

var $a6xZ7 = parcelRequire("a6xZ7");

var $5lX6q = parcelRequire("5lX6q");
function $c9e9655eaf6fc6e0$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $72Sl2.isSafari)()) return (0, $a6xZ7.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $3eRFA.isFirefox)()) return (0, $5lX6q.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("hTKn6", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("4sgOE")).monitorForTextSelection);

var $4sgOE = parcelRequire("4sgOE");

});
parcelRegister("4sgOE", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $a3f60a8d2b7e9c34$export$2e178e3647f5e6e9);

var $4eDgu = parcelRequire("4eDgu");

var $1FL6N = parcelRequire("1FL6N");

var $kL2Iu = parcelRequire("kL2Iu");

var $bGF1c = parcelRequire("bGF1c");

var $72Sl2 = parcelRequire("72Sl2");



function $a3f60a8d2b7e9c34$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $72Sl2.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $c360c820836f002e$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $a3f60a8d2b7e9c34$var$honeyPotFix = (0, $1FL6N.makeHoneyPotFix)();
const $a3f60a8d2b7e9c34$var$adapter = (0, $kL2Iu.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $bGF1c.combine)($a3f60a8d2b7e9c34$var$honeyPotFix.bindEvents(), (0, $4eDgu.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $8f124db82e8162d9$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $c360c820836f002e$export$fd3d00026297c0ad))) return;
                const target = $a3f60a8d2b7e9c34$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $c360c820836f002e$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $7d9e8655e1a79159$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $a3f60a8d2b7e9c34$var$honeyPotFix.getOnPostDispatch()
});
function $a3f60a8d2b7e9c34$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $a3f60a8d2b7e9c34$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $a3f60a8d2b7e9c34$var$adapter.registerUsage();
})();
function $a3f60a8d2b7e9c34$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $a3f60a8d2b7e9c34$var$adapter.monitor(args);
}

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $7d9e8655e1a79159$export$338a9f6c7a1f02b0 = 'text/html';



parcelRegister("5gCP6", function(module, exports) {

var $ilGjL = parcelRequire("ilGjL");
var $3d5c8fdb3323d17d$var$listeningFocusTrap = null;
function $3d5c8fdb3323d17d$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $3d5c8fdb3323d17d$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($3d5c8fdb3323d17d$var$listeningFocusTrap) $3d5c8fdb3323d17d$var$listeningFocusTrap.pause();
        $3d5c8fdb3323d17d$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $3d5c8fdb3323d17d$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $3d5c8fdb3323d17d$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $3d5c8fdb3323d17d$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $3d5c8fdb3323d17d$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $3d5c8fdb3323d17d$var$tryFocus(lastTabbableNode);
            return $3d5c8fdb3323d17d$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $3d5c8fdb3323d17d$var$tryFocus(firstTabbableNode);
        $3d5c8fdb3323d17d$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $ilGjL(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $3d5c8fdb3323d17d$var$tryFocus(lastTabbableNode);
        $3d5c8fdb3323d17d$var$tryFocus(firstTabbableNode);
    }
}
function $3d5c8fdb3323d17d$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $3d5c8fdb3323d17d$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $3d5c8fdb3323d17d$var$focusTrap;

});
parcelRegister("ilGjL", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $d5bb0397551260bb$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $d5bb0397551260bb$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("a7rgl", function(module, exports) {
$parcel$export(module.exports, "default", () => $75dfb4a1a1d0322a$export$2e2bcd8739ae039);

var $hZpoK = parcelRequire("hZpoK");
function $75dfb4a1a1d0322a$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $75dfb4a1a1d0322a$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $75dfb4a1a1d0322a$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($75dfb4a1a1d0322a$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $75dfb4a1a1d0322a$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($75dfb4a1a1d0322a$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $hZpoK.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $75dfb4a1a1d0322a$var$getOptions(options);
    return $75dfb4a1a1d0322a$var$defaultBehavior((0, $hZpoK.default)(target, computeOptions), computeOptions.behavior);
}
var $75dfb4a1a1d0322a$export$2e2bcd8739ae039 = $75dfb4a1a1d0322a$var$scrollIntoView;

});
parcelRegister("hZpoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d18bd5bbcfde8dc6$export$2e2bcd8739ae039);
function $d18bd5bbcfde8dc6$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $d18bd5bbcfde8dc6$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $d18bd5bbcfde8dc6$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $d18bd5bbcfde8dc6$var$isHiddenByFrame(el) {
    var frame = $d18bd5bbcfde8dc6$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $d18bd5bbcfde8dc6$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $d18bd5bbcfde8dc6$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $d18bd5bbcfde8dc6$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $d18bd5bbcfde8dc6$var$isHiddenByFrame(el);
    }
    return false;
}
function $d18bd5bbcfde8dc6$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $d18bd5bbcfde8dc6$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$d18bd5bbcfde8dc6$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($d18bd5bbcfde8dc6$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $d18bd5bbcfde8dc6$var$isScrollable(cursor) && !$d18bd5bbcfde8dc6$var$isScrollable(document.documentElement)) continue;
        if ($d18bd5bbcfde8dc6$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $d18bd5bbcfde8dc6$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $d18bd5bbcfde8dc6$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $d18bd5bbcfde8dc6$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $d18bd5bbcfde8dc6$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("gLsQb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hUEVu = parcelRequire("hUEVu");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $c347684d98640ade$var$_interopRequireDefault($hUEVu).default;
    }
});
function $c347684d98640ade$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hUEVu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d0a769beb4242d5a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
function $d0a769beb4242d5a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0a769beb4242d5a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d0a769beb4242d5a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d0a769beb4242d5a$var$NodeResolver = function(_Component) {
    $d0a769beb4242d5a$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $d0a769beb4242d5a$var$_classCallCheck(this, NodeResolver);
        return $d0a769beb4242d5a$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $d0a769beb4242d5a$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $aQK2r.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($eJOHy.Component);
module.exports.default = $d0a769beb4242d5a$var$NodeResolver;

});


parcelRegister("aeXRO", function(module, exports) {
$parcel$export(module.exports, "PendoChoreographerPlugin", () => $38df704194453b0a$export$3390a677f4025523);

var $7Q9YQ = parcelRequire("7Q9YQ");

var $khSli = parcelRequire("khSli");
class $38df704194453b0a$export$3390a677f4025523 extends (0, $khSli.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $7Q9YQ.ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("awdRS", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a87a6755cdae5ac$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $7a87a6755cdae5ac$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("6FOAB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a461cd813106257$export$2e2bcd8739ae039);

var $H2Ezi = parcelRequire("H2Ezi");

var $eFZhA = parcelRequire("eFZhA");
var $9a461cd813106257$export$2e2bcd8739ae039 = (0, $H2Ezi.default);

});
parcelRegister("H2Ezi", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b3e6a81f75986f6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jbhXM = parcelRequire("jbhXM");

var $aXKmr = parcelRequire("aXKmr");

var $eGOwo = parcelRequire("eGOwo");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $fiPhB = parcelRequire("fiPhB");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $kTRgU = parcelRequire("kTRgU");

var $3nRU2 = parcelRequire("3nRU2");

var $5QYU2 = parcelRequire("5QYU2");

var $5aa7F = parcelRequire("5aa7F");
let $9b3e6a81f75986f6$var$tryCompleteHandle;
let $9b3e6a81f75986f6$var$hasMarkedFirstSegmentLoad = false;
function $9b3e6a81f75986f6$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' }) {
    const parentContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const segmentIdMap = (0, $eJOHy.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $eJOHy.useMemo)(()=>{
        if (mode === 'single') return (0, $3nRU2.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $3nRU2.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $eJOHy.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $eJOHy.useContext)((0, $kVpZx.default));
    if (interactionId.current != null && !$9b3e6a81f75986f6$var$hasMarkedFirstSegmentLoad) {
        (0, $2QO3b.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $9b3e6a81f75986f6$var$hasMarkedFirstSegmentLoad = true;
    }
    const interactionContext = (0, $eJOHy.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($9b3e6a81f75986f6$var$tryCompleteHandle) cancelAnimationFrame?.($9b3e6a81f75986f6$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $9b3e6a81f75986f6$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $9b3e6a81f75986f6$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $2QO3b.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $2QO3b.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name, experimental = false) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $2QO3b.addHold)(interactionId.current, labelStack, name, experimental);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $2QO3b.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $2QO3b.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental (name = 'unknown') {
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $jcIvM.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $jcIvM.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $2QO3b.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $2QO3b.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $jcIvM.getInteractionRate)(name, 'press');
                if ((0, $2oAAJ.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $aXKmr.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $fiPhB.setInteractionActiveTrace)(newId, 'press');
                    (0, $2QO3b.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $kTRgU.default).current, (0, $fiPhB.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $2QO3b.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $2QO3b.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $2QO3b.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $2QO3b.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $2QO3b.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $2QO3b.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $2QO3b.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $2QO3b.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $5QYU2.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $eJOHy.useRef)(false);
    const onRender = (0, $eJOHy.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $jcIvM.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $2QO3b.addSegment)(labelStack);
        return ()=>{
            (0, $2QO3b.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $eJOHy.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    const ufoSegment = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aoMz.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
    if ((0, $eGOwo.fg)('platform_ufo_ssr_render_profiler')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5aa7F.default), {
        labelStack: labelStack,
        onRender: interactionContext.onRender,
        children: ufoSegment
    });
    return ufoSegment;
}
$9b3e6a81f75986f6$export$2e2bcd8739ae039.displayName = 'UFOSegment';

});
parcelRegister("3nRU2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec0e3f3eecf8a8f0$export$2e2bcd8739ae039);
function $ec0e3f3eecf8a8f0$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $ec0e3f3eecf8a8f0$export$2e2bcd8739ae039 = $ec0e3f3eecf8a8f0$var$generateId;

});

parcelRegister("5QYU2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e000c93bd8f4e6c$export$2e2bcd8739ae039);
function $9e000c93bd8f4e6c$var$scheduleOnPaint(callback) {
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $9e000c93bd8f4e6c$export$2e2bcd8739ae039 = $9e000c93bd8f4e6c$var$scheduleOnPaint;

});

parcelRegister("5aa7F", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e4d5d5f38c482a9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2QO3b = parcelRequire("2QO3b");

var $igDjg = parcelRequire("igDjg");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $1e4d5d5f38c482a9$var$startTimes = new Map();
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $1e4d5d5f38c482a9$var$lastActiveInteraction;
function $1e4d5d5f38c482a9$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $2QO3b.getActiveInteraction)()?.id;
    if (!!$1e4d5d5f38c482a9$var$lastActiveInteraction && $1e4d5d5f38c482a9$var$lastActiveInteraction !== activeInteractionId) $1e4d5d5f38c482a9$var$startTimes.clear();
    $1e4d5d5f38c482a9$var$lastActiveInteraction = activeInteractionId;
}
const $1e4d5d5f38c482a9$var$onStartRender = (id)=>{
    if (!$1e4d5d5f38c482a9$var$startTimes.has(id)) $1e4d5d5f38c482a9$var$startTimes.set(id, []);
    $1e4d5d5f38c482a9$var$startTimes.get(id)?.push(performance.now());
};
const $1e4d5d5f38c482a9$var$isInSSR = Boolean(globalThis?.false) || typeof $igDjg !== 'undefined' && Boolean($igDjg?.env?.REACT_SSR || false);
const $1e4d5d5f38c482a9$var$ProfilerMarker = ({ onRender: onRender })=>{
    if ($1e4d5d5f38c482a9$var$isInSSR) onRender?.();
    return null;
};
const $1e4d5d5f38c482a9$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $eJOHy.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    $1e4d5d5f38c482a9$var$checkActiveInteractionAndResetStartMarksIfSet();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($1e4d5d5f38c482a9$var$ProfilerMarker, {
                onRender: ()=>$1e4d5d5f38c482a9$var$onStartRender(reactProfilerId)
            }),
            children,
            /*#__PURE__*/ (0, $gt9Am.jsx)($1e4d5d5f38c482a9$var$ProfilerMarker, {
                onRender: ()=>{
                    const startTimesForId = $1e4d5d5f38c482a9$var$startTimes.get(reactProfilerId);
                    if (startTimesForId?.length) {
                        const endTime = performance.now();
                        const firstStartTime = startTimesForId[0];
                        const lastStartTime = startTimesForId[startTimesForId.length - 1];
                        const baseDuration = endTime - lastStartTime;
                        const actualDuration = endTime - firstStartTime;
                        onRender('mount', actualDuration, baseDuration, firstStartTime, endTime);
                    }
                }
            })
        ]
    });
};
const $1e4d5d5f38c482a9$var$SsrRenderProfiler = (props)=>{
    if ($1e4d5d5f38c482a9$var$isInSSR) return /*#__PURE__*/ (0, $gt9Am.jsx)($1e4d5d5f38c482a9$export$b8bd105b650b1c1e, {
        ...props
    });
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($1e4d5d5f38c482a9$var$ProfilerMarker, {}),
            props.children
        ]
    });
};
var $1e4d5d5f38c482a9$export$2e2bcd8739ae039 = $1e4d5d5f38c482a9$var$SsrRenderProfiler;

});


parcelRegister("eFZhA", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $7d36c90a31f75e17$export$5f6fe75c46d0124e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $huC5X = parcelRequire("huC5X");

var $H2Ezi = parcelRequire("H2Ezi");
function $7d36c90a31f75e17$export$5f6fe75c46d0124e(props) {
    const { children: children, ...otherProps } = props;
    return (0, $eGOwo.fg)('platform_ufo_enable_ttai_with_3p') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $H2Ezi.default), {
        type: "third-party",
        ...otherProps,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $H2Ezi.default), {
        type: "third-party",
        ...otherProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $huC5X.default), {
            ignore: (0, $eGOwo.fg)('platform_ufo_exclude_3p_elements_from_ttai'),
            reason: "third-party-element",
            children: children
        })
    });
}
$7d36c90a31f75e17$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';

});
parcelRegister("huC5X", function(module, exports) {
$parcel$export(module.exports, "default", () => $621690e83910abdb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");
function $621690e83910abdb$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const ignoredInteractionContext = (0, $eJOHy.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d0Gew.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
}
$621690e83910abdb$export$2e2bcd8739ae039.displayName = 'UFOIgnoreHolds';

});



parcelRegister("9vPaT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f42383ccf1b66ed$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");
var $5f42383ccf1b66ed$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $eJOHy.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $4J0ad.default)()(EngagementEventsWrapper);
};

});

parcelRegister("5nYbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b539259494434258$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");
var $b539259494434258$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $eJOHy.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).func
            };
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $eJOHy.useState)(null);
        const unsubscribeRef = (0, $eJOHy.useRef)(null);
        const removeConfigRef = (0, $eJOHy.useRef)(null);
        const canSubscribe = (0, $eJOHy.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $eJOHy.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $eJOHy.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $eJOHy.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $eJOHy.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $eJOHy.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $eJOHy.useRef)(engagementId);
        const previousMessageType = (0, $eJOHy.useRef)(messageType);
        const previousOnMessageDisposition = (0, $eJOHy.useRef)(onMessageDisposition);
        (0, $eJOHy.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, $gt9Am.jsx)(InnerComponent, {
            ...props,
            ...message
        }, messageKey);
    };
    return StoreWrapper;
};

});

parcelRegister("9BCGk", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $d137f564b71ef7ac$export$e7d79186651244da);
const $d137f564b71ef7ac$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("bK1H5", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cee64a71e8f8e89$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $2cee64a71e8f8e89$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("3JwXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $828d4fb674597716$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $1cnyy = parcelRequire("1cnyy");

var $051KK = parcelRequire("051KK");
function $828d4fb674597716$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $051KK.useSafeIntl)();
    const messages = (0, $1cnyy.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the context and pass them downstream
	 * This prevents the missing messages error
	 */ const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("1cnyy", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $edae14a83bfd210b$export$4d17e2d9c5348842);

var $eJOHy = parcelRequire("eJOHy");

var $jQpoN = parcelRequire("jQpoN");
const $edae14a83bfd210b$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $eJOHy.useState)((0, $jQpoN.DEFAULT_LOCALE_STATE));
    (0, $eJOHy.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("jQpoN", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $e67dce8644c421ff$export$79618bef82c02d4c);
const $e67dce8644c421ff$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("051KK", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $817a342116060735$export$f752ac21ea3960a5);

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $99KvW = parcelRequire("99KvW");
var $6YFG2 = parcelRequire("6YFG2");

var $jQpoN = parcelRequire("jQpoN");
// Prevents memory leaks
const $817a342116060735$var$cache = (0, $99KvW.createIntlCache)();
const $817a342116060735$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $6YFG2.Context));
    if (!context) return (0, $4nehu.createIntl)((0, $jQpoN.DEFAULT_LOCALE_STATE), $817a342116060735$var$cache);
    return context;
};

});


parcelRegister("fveN7", function(module, exports) {
$parcel$export(module.exports, "RovoPostMessagePubsubListener", () => $f849a73f74894fe0$export$e5e1a9c59c299631);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $f849a73f74894fe0$export$5340cc94dd0ecbea);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $leNtV = parcelRequire("leNtV");
const $f849a73f74894fe0$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $f849a73f74894fe0$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $f849a73f74894fe0$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $f849a73f74894fe0$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $f849a73f74894fe0$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($f849a73f74894fe0$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $f849a73f74894fe0$var$allowedOrigins.includes(hostname));
};
const $f849a73f74894fe0$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $leNtV.usePublish)('ai-mate');
    (0, $eJOHy.useEffect)(()=>{
        const handlerUnbind = (0, $4eDgu.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$f849a73f74894fe0$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $f849a73f74894fe0$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $f849a73f74894fe0$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $f849a73f74894fe0$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $f849a73f74894fe0$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $eJOHy.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const handlerUnbind = (0, $4eDgu.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$f849a73f74894fe0$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $f849a73f74894fe0$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $eJOHy.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $f849a73f74894fe0$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $f849a73f74894fe0$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("leNtV", function(module, exports) {
$parcel$export(module.exports, "useSubscribe", () => $13ad13a679308fb8$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $13ad13a679308fb8$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $13ad13a679308fb8$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $13ad13a679308fb8$export$60959659b2c22881);

var $eJOHy = parcelRequire("eJOHy");
const $13ad13a679308fb8$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $13ad13a679308fb8$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$13ad13a679308fb8$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $13ad13a679308fb8$var$pubSub = $13ad13a679308fb8$var$createPubSub();
const $13ad13a679308fb8$var$usePubSub = ()=>{
    return $13ad13a679308fb8$var$pubSub;
};
const $13ad13a679308fb8$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $13ad13a679308fb8$var$usePubSub();
    const callbackRef = (0, $eJOHy.useRef)(callback);
    callbackRef.current = callback;
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $13ad13a679308fb8$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $13ad13a679308fb8$var$usePubSub();
    const callbackRef = (0, $eJOHy.useRef)(callback);
    callbackRef.current = callback;
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $13ad13a679308fb8$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $13ad13a679308fb8$var$usePubSub();
    (0, $eJOHy.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $13ad13a679308fb8$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $13ad13a679308fb8$var$usePubSub();
    const publishFn = (0, $eJOHy.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $13ad13a679308fb8$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $13ad13a679308fb8$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $13ad13a679308fb8$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("8MX4m", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $03478fbf5ae3cfaf$export$cf6fa0bbcc94b912);
function $03478fbf5ae3cfaf$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("jkRyu", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $b4dc2b90292cfb47$export$4fe5fba5bb1d3c09);

var $2upMo = parcelRequire("2upMo");
function $b4dc2b90292cfb47$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2upMo.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("2upMo", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $962c591490d426bc$export$148e45a6d4b4d65);

var $cKxo0 = parcelRequire("cKxo0");

var $bxZJf = parcelRequire("bxZJf");

var $gx2o2 = parcelRequire("gx2o2");
function $962c591490d426bc$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $bxZJf.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $bxZJf.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $cKxo0.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $bxZJf.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $gx2o2.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("cKxo0", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $77e66522e6771cd6$export$567fc7097e064344);
let $77e66522e6771cd6$var$id = 100000;
function $77e66522e6771cd6$export$567fc7097e064344() {
    $77e66522e6771cd6$var$id += 1;
    return $77e66522e6771cd6$var$id.toString();
}

});

parcelRegister("bxZJf", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $7544964689515cb9$export$10dc3edfc20c8ff);
function $7544964689515cb9$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $7544964689515cb9$export$10dc3edfc20c8ff = $7544964689515cb9$var$createEventEmitter();

});

parcelRegister("gx2o2", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $aa154332eacdbfb4$export$3b514faac3ba993c);
function $aa154332eacdbfb4$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("goBB5", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAri", () => $befc0d413a701cce$export$d4d0794234e3fd53);

var $1JOdS = parcelRequire("1JOdS");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/workspace/manifest.ts
var $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1JOdS.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $1JOdS.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $befc0d413a701cce$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("1JOdS", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $1440f3a3433d3385$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $1440f3a3433d3385$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $1440f3a3433d3385$export$e52ccdf6abac8896 = "jira", $1440f3a3433d3385$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("3ZJvm", function(module, exports) {

var $euhRr = parcelRequire("euhRr");

var $lylkU = parcelRequire("lylkU");

var $1lM9j = parcelRequire("1lM9j");

var $l76qh = parcelRequire("l76qh");
/** Error message constants. */ var $2e8a5ded634097b9$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */ function $2e8a5ded634097b9$var$cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = $1lM9j;
    pairs = !length ? [] : $lylkU(pairs, function(pair) {
        if (typeof pair[1] != 'function') throw new TypeError($2e8a5ded634097b9$var$FUNC_ERROR_TEXT);
        return [
            toIteratee(pair[0]),
            pair[1]
        ];
    });
    return $l76qh(function(args) {
        var index = -1;
        while(++index < length){
            var pair = pairs[index];
            if ($euhRr(pair[0], this, args)) return $euhRr(pair[1], this, args);
        }
    });
}
module.exports = $2e8a5ded634097b9$var$cond;

});

parcelRegister("26U8a", function(module, exports) {
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */ function $1897aeb17d57dd34$var$stubTrue() {
    return true;
}
module.exports = $1897aeb17d57dd34$var$stubTrue;

});

parcelRegister("gbpNq", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $d02853f55ed70c5e$export$e83743682263315a);

var $8MX4m = parcelRequire("8MX4m");

var $jkRyu = parcelRequire("jkRyu");

var $dsHGc = parcelRequire("dsHGc");
const $d02853f55ed70c5e$var$cache = (0, $8MX4m.createCache)(new Map());
function $d02853f55ed70c5e$export$e83743682263315a(loader, opts) {
    return $d02853f55ed70c5e$var$cache.get(opts.moduleId, ()=>(0, $jkRyu.PreloadableJSResource)(()=>(0, $dsHGc.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});

parcelRegister("3Bzqe", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $97b53aef864376d5$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/ban-types */ function $97b53aef864376d5$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("e2Zbt", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $a3a0b67bacbfb8d0$export$c9058316764c140e);

var $6rhqu = parcelRequire("6rhqu");

var $a8lE5 = parcelRequire("a8lE5");
function $a3a0b67bacbfb8d0$export$c9058316764c140e(refs) {
    return (0, $a8lE5.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $6rhqu.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("a8lE5", function(module, exports) {
$parcel$export(module.exports, "createCallbackRef", () => $760b71194a42a36a$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $760b71194a42a36a$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("bskNA", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $70cfc1b43fb083bc$export$7c9538f5f3c365e9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $6UHe9 = parcelRequire("6UHe9");
const $70cfc1b43fb083bc$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $eJOHy.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $eJOHy.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $70cfc1b43fb083bc$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eJOHy.useRef)(1);
    const [modals, setModals] = (0, $eJOHy.useState)([]);
    const modalContext = (0, $eJOHy.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6UHe9.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $gt9Am.jsx)($70cfc1b43fb083bc$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}

});
parcelRegister("6UHe9", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $734ae1558d96f1fa$export$ab57792b9b6974a6);

var $eJOHy = parcelRequire("eJOHy");
const $734ae1558d96f1fa$export$ab57792b9b6974a6 = (0, $eJOHy.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("asoyU", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $0d38f1ebfe85cfd9$export$fb10b32cfe19f1e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $j4oe4 = parcelRequire("j4oe4");

var $lBwnZ = parcelRequire("lBwnZ");

var $2bMVP = parcelRequire("2bMVP");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $78OnL = parcelRequire("78OnL");

var $iUOpD = parcelRequire("iUOpD");

var $6UHe9 = parcelRequire("6UHe9");

var $dy5PQ = parcelRequire("dy5PQ");

var $lBsyH = parcelRequire("lBsyH");

var $4Gyvo = parcelRequire("4Gyvo");
const $0d38f1ebfe85cfd9$var$emptyEntryPointParams = {};
const $0d38f1ebfe85cfd9$var$emptyEntryPointProps = {};
function $0d38f1ebfe85cfd9$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = false }) {
    (0, $gRw8I.di)((0, $j4oe4.loadEntryPoint));
    const { openModal: openModal } = (0, $eJOHy.useContext)((0, $6UHe9.ModalContext));
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $iUOpD.useEntryPointConfig)();
    const metricName = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $0d38f1ebfe85cfd9$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                        children: title ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {}),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {}),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kseeK.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $gt9Am.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $gt9Am.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $0d38f1ebfe85cfd9$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $dy5PQ.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $lBwnZ.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("iUOpD", function(module, exports) {
$parcel$export(module.exports, "initEntryPointConfig", () => $2b5fa908729816ff$export$93a6801f9db838c4);
$parcel$export(module.exports, "useEntryPointConfig", () => $2b5fa908729816ff$export$dfa96f26176fa91f);

var $jaNQz = parcelRequire("jaNQz");

var $6FOAB = parcelRequire("6FOAB");
const $2b5fa908729816ff$var$DefaultUFOSegmentComponent = (0, $6FOAB.default);
const $2b5fa908729816ff$var$entryPointConfig = {
    PlaceholderComponent: (0, $jaNQz.default),
    UFOSegmentComponent: $2b5fa908729816ff$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $2b5fa908729816ff$export$93a6801f9db838c4(overrides) {
    Object.assign($2b5fa908729816ff$var$entryPointConfig, overrides);
    return $2b5fa908729816ff$var$entryPointConfig;
}
function $2b5fa908729816ff$export$dfa96f26176fa91f() {
    return $2b5fa908729816ff$var$entryPointConfig;
}

});
parcelRegister("jaNQz", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaf49ce7e1eaf856$export$2e2bcd8739ae039);

var $edMIO = parcelRequire("edMIO");
var $eaf49ce7e1eaf856$export$2e2bcd8739ae039 = (0, $edMIO.default);

});
parcelRegister("edMIO", function(module, exports) {
$parcel$export(module.exports, "default", () => $66d20be0bbbc247a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $jmcOt = parcelRequire("jmcOt");
var $drQtS = parcelRequire("drQtS");
function $66d20be0bbbc247a$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $eJOHy.useContext)((0, $drQtS.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jmcOt.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("dLR8J", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6dff8898aedc952$export$2e2bcd8739ae039);

var $eULmj = parcelRequire("eULmj");
var $a6dff8898aedc952$export$2e2bcd8739ae039 = (0, $eULmj.default);

});
parcelRegister("eULmj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8ae051fb04a3e37$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");
const $b8ae051fb04a3e37$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $eJOHy.useEffect) : (0, $eJOHy.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $b8ae051fb04a3e37$var$useInteractionIdValue() {
    const interactionId = (0, $eJOHy.useContext)((0, $kVpZx.default));
    const [currentId, setCurrentId] = (0, $eJOHy.useState)(interactionId?.current || null);
    $b8ae051fb04a3e37$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $kVpZx.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $b8ae051fb04a3e37$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    const currentInteractionId = $b8ae051fb04a3e37$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $eJOHy.useContext)((0, $7aoMz.default));
    $b8ae051fb04a3e37$var$useLayoutEffectSAFE(()=>{
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("jmcOt", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $4d6436fbedc2efd6$export$256c542058532d6f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $4d6436fbedc2efd6$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $4d6436fbedc2efd6$var$LazySuspenseContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $4d6436fbedc2efd6$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($4d6436fbedc2efd6$var$LazySuspenseContext);
    (0, $eJOHy.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$4d6436fbedc2efd6$var$DynamicFallback.displayName = 'DynamicFallback';
const $4d6436fbedc2efd6$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $eJOHy.useState)(null);
    const mountedRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4d6436fbedc2efd6$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4d6436fbedc2efd6$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $4d6436fbedc2efd6$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$4d6436fbedc2efd6$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("drQtS", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $4ef16544002b531e$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");
const $4ef16544002b531e$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});




parcelRegister("dy5PQ", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $2dbf562a1626ca84$export$1ff47f24e06a5d2d);
/* eslint-disable react-hooks/rules-of-hooks */ 
var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $i2FiL = parcelRequire("i2FiL");
const $2dbf562a1626ca84$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $2dbf562a1626ca84$var$TIME_TO_INTENT = 200;
function $2dbf562a1626ca84$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    if ((0, $eGOwo.fg)('entry-points_new_usepressablepreloadref')) return (0, $i2FiL.usePressablePreloadRefNew)({
        load: load,
        onLoad: onLoad,
        onBeforeLoad: onBeforeLoad,
        loadOnFocus: loadOnFocus,
        preloadOnFocus: preloadOnFocus
    });
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $2dbf562a1626ca84$var$PRELOAD_MAX_AGE);
            }, $2dbf562a1626ca84$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        if (loadOnFocus) el.addEventListener('focusin', clickListener);
        else if (preloadOnFocus) {
            el.addEventListener('focusin', preloadReference);
            el.addEventListener('focusout', cancelPreload);
        }
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
            if (loadOnFocus) el.removeEventListener('focusin', clickListener);
            else if (preloadOnFocus) {
                el.removeEventListener('focusin', preloadReference);
                el.removeEventListener('focusout', cancelPreload);
            }
        };
    }, [
        load,
        onBeforeLoad,
        onLoad,
        loadOnFocus,
        preloadOnFocus
    ]);
    return ref;
}

});
parcelRegister("i2FiL", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRefNew", () => $ebbaa1c03d309d21$export$a463e6d6528557a7);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
const $ebbaa1c03d309d21$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $ebbaa1c03d309d21$var$TIME_TO_INTENT = 200;
function $ebbaa1c03d309d21$export$a463e6d6528557a7({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $eJOHy.useRef)(null);
    const eventListeners = (0, $eJOHy.useRef)([]);
    const { clickListener: clickListener, mouseDownListener: mouseDownListener, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $eJOHy.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $ebbaa1c03d309d21$var$PRELOAD_MAX_AGE);
            }, $ebbaa1c03d309d21$var$TIME_TO_INTENT);
        };
        return {
            cancelPreload: cancelPreload,
            clickListener: clickListener,
            mouseDownListener: mouseDownListener,
            preloadReference: preloadReference
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $eJOHy.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $eJOHy.useCallback)((element, type, callback)=>{
        const unbind = (0, $4eDgu.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $eJOHy.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});


parcelRegister("lBsyH", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $1e53e8e4ec2fe176$export$5d4dc37edd8a3adb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $j4oe4 = parcelRequire("j4oe4");

var $eGOwo = parcelRequire("eGOwo");

var $2lP8b = parcelRequire("2lP8b");

var $hGtke = parcelRequire("hGtke");

var $iUOpD = parcelRequire("iUOpD");
const $1e53e8e4ec2fe176$var$noop = ()=>{};
function $1e53e8e4ec2fe176$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $iUOpD.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const reportErrorUFO = (0, $eGOwo.fg)('entry_point_container_ufo_report_error') ? (0, $2lP8b.useUFOReportError)() : $1e53e8e4ec2fe176$var$noop;
    const onError = (0, $eJOHy.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hGtke.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        if ((0, $eGOwo.fg)('entry_point_container_ufo_report_error')) reportErrorUFO({
            name: id,
            errorMessage: error.message,
            errorStack: error.stack,
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $eJOHy.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j4oe4.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $1e53e8e4ec2fe176$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $iUOpD.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($1e53e8e4ec2fe176$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}

});
parcelRegister("axOsj", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eJOHy")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("2lP8b", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $f5d3dcba2e192f7d$export$75d40f522062f923);

var $7aoMz = parcelRequire("7aoMz");

var $2QO3b = parcelRequire("2QO3b");
function $f5d3dcba2e192f7d$export$75d40f522062f923() {
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $2QO3b.getActiveInteraction)();
        if (interaction?.id) (0, $2QO3b.addError)(interaction.id, error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $2QO3b.addErrorToAll)(error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});


parcelRegister("4Gyvo", function(module, exports) {
$parcel$export(module.exports, "RelayEnvironmentProvider", () => $fa1adb4db0a01e42$export$43b1f3e917d65526);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $fa1adb4db0a01e42$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $fa1adb4db0a01e42$export$e237a628f59c9f4e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bqauo = parcelRequire("bqauo");
function $fa1adb4db0a01e42$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j4oe4.RelayEnvironmentProvider), {
        environment: (0, $bqauo.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
const $fa1adb4db0a01e42$export$43b1f3e917d65526 = $fa1adb4db0a01e42$export$6c22afad970ad5ac;
const $fa1adb4db0a01e42$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $eJOHy.useContext)((0, $j4oe4.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($fa1adb4db0a01e42$export$6c22afad970ad5ac, {
        children: children
    });
};
function $fa1adb4db0a01e42$export$e237a628f59c9f4e() {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("bqauo", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $1f5ed46492cb5531$export$df54517d175e6d6b);

var $37Ewn = parcelRequire("37Ewn");

var $eGOwo = parcelRequire("eGOwo");

var $lmvVe = parcelRequire("lmvVe");

var $fZTxF = parcelRequire("fZTxF");

var $5ST2i = parcelRequire("5ST2i");

var $cyu5B = parcelRequire("cyu5B");

var $96h4t = parcelRequire("96h4t");

var $2yxzK = parcelRequire("2yxzK");
const $1f5ed46492cb5531$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $1f5ed46492cb5531$export$df54517d175e6d6b = new (0, $37Ewn.Environment)((0, $lmvVe.getDefaultRelayEnvironmentConfig)({
    network: (0, $37Ewn.Network).create((request, variables, cacheConfig)=>{
        // use new fetch if the feature flag is enabled
        if ((0, $eGOwo.fg)('platform_environment_for_atlassian_studio') || (0, $eGOwo.fg)('relay_store_for_platform_packages_in_confluence')) return (0, $5ST2i.fetch)(request, variables, cacheConfig, {
            getLoggingAndMetricsHelper: $1f5ed46492cb5531$var$getLoggingAndMetricsHelper,
            withErrorHandling: (source)=>source,
            validateResponse: (request, response)=>{
                const errors = 'errors' in response ? response.errors : undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    (0, $fZTxF.captureErrors)(errors, {
                        operationName: request.name,
                        requestId: requestId
                    });
                    if ((0, $fZTxF.isUnauthenticated)(errors)) return false;
                }
                return true;
            },
            onInvalidResponse: ()=>{},
            queryResponseCache: new (0, $96h4t.SSRQueryResponseCache)({
                cacheName: 'relay-cache/v2/AGG',
                size: Infinity,
                ttl: Infinity
            }),
            isServer: globalThis.false
        });
        // fallback to currnt fetch
        return (0, $cyu5B.fetchFn)(request, variables, cacheConfig);
    }, (0, $2yxzK.subscribe))
}));

});
parcelRegister("fZTxF", function(module, exports) {
$parcel$export(module.exports, "captureErrors", () => $8de2fef92e4dcc92$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $8de2fef92e4dcc92$export$1724ecfee73c4768);

var $aXKmr = parcelRequire("aXKmr");
const $8de2fef92e4dcc92$var$errorCollector = new Map();
const $8de2fef92e4dcc92$export$da396ad2a542b095 = 120000; // 2min
const $8de2fef92e4dcc92$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $8de2fef92e4dcc92$var$errorCollector.delete(key);
    }, $8de2fef92e4dcc92$export$da396ad2a542b095);
};
const $8de2fef92e4dcc92$export$c211170518c6d0f6 = (key = (0, $aXKmr.v4)())=>{
    $8de2fef92e4dcc92$var$errorCollector.set(key, []);
    $8de2fef92e4dcc92$var$scheduleCleanup(key);
    return key;
};
const $8de2fef92e4dcc92$export$e0491a0d974dadfa = (key)=>{
    const errors = $8de2fef92e4dcc92$var$errorCollector.get(key);
    $8de2fef92e4dcc92$var$errorCollector.delete(key);
    return errors || [];
};
const $8de2fef92e4dcc92$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $8de2fef92e4dcc92$var$errorCollector.forEach((value, key)=>{
        $8de2fef92e4dcc92$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $8de2fef92e4dcc92$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("96h4t", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $218312e8a2f485a3$export$be21c283b097d175);

var $37Ewn = parcelRequire("37Ewn");
function $218312e8a2f485a3$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $37Ewn.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $218312e8a2f485a3$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $218312e8a2f485a3$export$be21c283b097d175 extends (0, $37Ewn.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $218312e8a2f485a3$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});




parcelRegister("eBU4b", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("kedJ1")).blockDraggingToIFrames);

var $kedJ1 = parcelRequire("kedJ1");

});
parcelRegister("kedJ1", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", () => $aae84d661d772e4c$export$6ae1d8fab001518c);

var $lMeHP = parcelRequire("lMeHP");

var $bGF1c = parcelRequire("bGF1c");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $aae84d661d772e4c$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $aae84d661d772e4c$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $aae84d661d772e4c$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($aae84d661d772e4c$var$isActive) return;
    $aae84d661d772e4c$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$aae84d661d772e4c$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $bGF1c.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $lMeHP.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $aae84d661d772e4c$var$isActive = false;
    });
}
function $aae84d661d772e4c$export$6ae1d8fab001518c({ element: element }) {
    return (0, $lMeHP.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $aae84d661d772e4c$var$tryStart();
        }
    });
}

});


parcelRegister("92EV7", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("4AiYj")).disableNativeDragPreview);

var $4AiYj = parcelRequire("4AiYj");

});
parcelRegister("4AiYj", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => $0bfe61f995bf123d$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $0bfe61f995bf123d$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $0bfe61f995bf123d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $0bfe61f995bf123d$var$tinyTransparentImage) nativeSetDragImage($0bfe61f995bf123d$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("ltpqI", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("e9xFe")).preventUnhandled);

var $e9xFe = parcelRequire("e9xFe");

});
parcelRegister("e9xFe", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => $fd5ed4da28822088$export$453c0582481cc59d);

var $4eDgu = parcelRequire("4eDgu");

var $bOMk0 = parcelRequire("bOMk0");
function $fd5ed4da28822088$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $fd5ed4da28822088$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $fd5ed4da28822088$var$start() {
    $fd5ed4da28822088$var$cleanup();
    $fd5ed4da28822088$var$unbindEvents = (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragover',
            listener: $fd5ed4da28822088$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $fd5ed4da28822088$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $fd5ed4da28822088$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $fd5ed4da28822088$var$cleanup
        },
        ...(0, $bOMk0.getBindingsForBrokenDrags)({
            onDragEnd: $fd5ed4da28822088$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $fd5ed4da28822088$var$cleanup() {
    $fd5ed4da28822088$var$unbindEvents?.();
    $fd5ed4da28822088$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $fd5ed4da28822088$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $fd5ed4da28822088$var$cleanup();
}
const $fd5ed4da28822088$export$453c0582481cc59d = {
    start: $fd5ed4da28822088$var$start,
    stop: $fd5ed4da28822088$var$stop
};

});


parcelRegister("afUiu", function(module, exports) {
$parcel$export(module.exports, "useAccountLinks", () => $826747250108c605$export$2afde6c526be23b9);

var $iY1K4 = parcelRequire("iY1K4");
const $826747250108c605$var$buildProfileLink = (baseUrl, path, applicationParam, email)=>{
    const profileUrl = `${baseUrl}${path}`;
    return email ? `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(profileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}` : profileUrl;
};
function $826747250108c605$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink }) {
    const { baseUrl: baseUrl } = (0, $iY1K4.resolveEnvironment)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileLink = $826747250108c605$var$buildProfileLink(baseUrl, '/manage-profile', applicationParam, email);
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}` : undefined
    };
}

});
parcelRegister("iY1K4", function(module, exports) {
$parcel$export(module.exports, "resolveEnvironment", () => $441050555c98a177$export$eabfcea451f48b90);
/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $441050555c98a177$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $441050555c98a177$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $441050555c98a177$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}

});


parcelRegister("efWct", function(module, exports) {
$parcel$export(module.exports, "getUrlForDomainInContext", () => $ed2459a4c5091005$export$c162de1e7fecc908);

var $2NMzR = parcelRequire("2NMzR");

var $flLpt = parcelRequire("flLpt");

var $7pw1V = parcelRequire("7pw1V");

var $kXVmJ = parcelRequire("kXVmJ");
function $ed2459a4c5091005$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $7pw1V.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $7pw1V.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $ed2459a4c5091005$var$getDomainForIsolatedCloud(subdomain, (0, $2NMzR.COMMERCIAL), domain);
    }
    return $ed2459a4c5091005$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}
/**
 * Gets the full Isolated Cloud domain
 * Returns undefined only if ic_domain cannot be determined from the atl-ctx cookies
 * Defaults to returning the vanity name pattern
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The Isolated Cloud perimeter to get the domain for
 * @param isolatedCloudDomain - The IC domain (ex. "company.atlassian-isolated.net")
 * @returns The full domain associated with the subdomain in a specific IC
 */ function $ed2459a4c5091005$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $kXVmJ.isolatedCloudFunctions)[perimeter];
    if ((0, $kXVmJ.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $kXVmJ.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
/**
 * Gets the full domain in an non-Isolated Cloud perimeter
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The non-isolated cloud perimeter to get the domain for
 * @param The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full domain associated with the subdomain for the given perimeter and environment
 */ function $ed2459a4c5091005$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    // First, check if the subdomain is associated with a global domain
    if ((0, $flLpt.globalDomains)[subdomain]) return (0, $flLpt.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (0, $flLpt.fullDomainOverride)[subdomain]?.[perimeter]?.[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $kXVmJ.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $ed2459a4c5091005$export$c162de1e7fecc908(subdomain, envType) {
    const domain = $ed2459a4c5091005$export$3f82b86ecb947bf0(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${globalThis.location.protocol}//${domain}`;
}

});
parcelRegister("flLpt", function(module, exports) {
$parcel$export(module.exports, "globalDomains", () => $32afec2f7eca07ba$export$cfd430a73d68f4bc);
$parcel$export(module.exports, "fullDomainOverride", () => $32afec2f7eca07ba$export$4723232b625f823e);

var $2NMzR = parcelRequire("2NMzR");
const $32afec2f7eca07ba$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};
const $32afec2f7eca07ba$export$4723232b625f823e = {
    id: {
        [(0, $2NMzR.COMMERCIAL)]: {
            [(0, $2NMzR.PRODUCTION)]: 'id.atlassian.com',
            [(0, $2NMzR.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $2NMzR.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $2NMzR.FEDRAMP_MODERATE)]: {
            [(0, $2NMzR.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $2NMzR.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};

});

parcelRegister("kXVmJ", function(module, exports) {
$parcel$export(module.exports, "ReservedNameMapping", () => $13e1ac673074bb3d$export$5860df3acd1ee020);
$parcel$export(module.exports, "AtlDomainMapping", () => $13e1ac673074bb3d$export$c6366754aee43afa);
$parcel$export(module.exports, "isolatedCloudFunctions", () => $13e1ac673074bb3d$export$ad1f7afdb45ad83);
$parcel$export(module.exports, "nonIsolatedCloudFunctions", () => $13e1ac673074bb3d$export$c3b4bc58a05128d6);

var $2NMzR = parcelRequire("2NMzR");
const $13e1ac673074bb3d$export$5860df3acd1ee020 = {
    [(0, $2NMzR.COMMERCIAL)]: [
        'home',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $13e1ac673074bb3d$export$c6366754aee43afa = {
    [(0, $2NMzR.COMMERCIAL)]: [
        'packages'
    ]
};
const $13e1ac673074bb3d$export$ad1f7afdb45ad83 = {
    [(0, $2NMzR.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $13e1ac673074bb3d$export$c3b4bc58a05128d6 = {
    [(0, $2NMzR.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $2NMzR.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $2NMzR.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $2NMzR.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $2NMzR.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $2NMzR.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $2NMzR.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};

});


parcelRegister("85wfa", function(module, exports) {
$parcel$export(module.exports, "AccountMenuIntlProvider", () => $4d65939c5b5456c5$export$6c1f1571e3dd1b34);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $lf8JT = parcelRequire("lf8JT");

var $igDjg = parcelRequire("igDjg");
const $4d65939c5b5456c5$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const messages = $4d65939c5b5456c5$var$useMessages(locale);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($igDjg?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        },
        children: children
    });
};
const $4d65939c5b5456c5$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $4d65939c5b5456c5$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $4d65939c5b5456c5$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $lf8JT.default)[`${language}_${region}`] || (0, $lf8JT.default)[language])?.())?.default;
};

});
parcelRegister("lf8JT", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ea7aff2331a9eea$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $2ea7aff2331a9eea$var$lazyMessages = {
    cs: ()=>(parcelRequire("eejNX")),
    cs_CZ: ()=>(parcelRequire("ccbKN")),
    da: ()=>(parcelRequire("fs89m")),
    da_DK: ()=>(parcelRequire("7murN")),
    de: ()=>(parcelRequire("90NoL")),
    de_DE: ()=>(parcelRequire("3aatO")),
    en_GB: ()=>(parcelRequire("7hroY")),
    en_ZZ: ()=>(parcelRequire("ctWJ3")),
    es: ()=>(parcelRequire("bwkUd")),
    fi: ()=>(parcelRequire("3YATr")),
    fi_FI: ()=>(parcelRequire("lQuYU")),
    fr: ()=>(parcelRequire("g52BT")),
    fr_FR: ()=>(parcelRequire("hY6Uz")),
    hu: ()=>(parcelRequire("ePiWI")),
    hu_HU: ()=>(parcelRequire("5w0kT")),
    it: ()=>(parcelRequire("bwBLb")),
    it_IT: ()=>(parcelRequire("lhrCF")),
    ja: ()=>(parcelRequire("twbXK")),
    ja_JP: ()=>(parcelRequire("kmzJf")),
    ko: ()=>(parcelRequire("4XohM")),
    ko_KR: ()=>(parcelRequire("2QWej")),
    nb: ()=>(parcelRequire("8VAqV")),
    nb_NO: ()=>(parcelRequire("l92Ga")),
    nl: ()=>(parcelRequire("i0l1S")),
    nl_NL: ()=>(parcelRequire("550wy")),
    pl: ()=>(parcelRequire("bX2dj")),
    pl_PL: ()=>(parcelRequire("1H9vs")),
    pt_BR: ()=>(parcelRequire("apOHw")),
    ru: ()=>(parcelRequire("jv1El")),
    ru_RU: ()=>(parcelRequire("3F8OX")),
    sv: ()=>(parcelRequire("4QnEL")),
    sv_SE: ()=>(parcelRequire("3KpxL")),
    th: ()=>(parcelRequire("6sRwl")),
    th_TH: ()=>(parcelRequire("8e3Tl")),
    tr: ()=>(parcelRequire("eShdI")),
    tr_TR: ()=>(parcelRequire("817PX")),
    uk: ()=>(parcelRequire("kuPuF")),
    uk_UA: ()=>(parcelRequire("eRvS8")),
    vi: ()=>(parcelRequire("3S78D")),
    vi_VN: ()=>(parcelRequire("6vyKl")),
    zh: ()=>(parcelRequire("7LU2d")),
    zh_CN: ()=>(parcelRequire("j1eSj")),
    zh_TW: ()=>(parcelRequire("iNUdu"))
};
var $2ea7aff2331a9eea$export$2e2bcd8739ae039 = $2ea7aff2331a9eea$var$lazyMessages;

});
parcelRegister("eejNX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hu2tA").then(()=>parcelRequire('99xnO'));

});
parcelRegister("ewTvA", function(module, exports) {
"use strict";

function $a93f1ca862af756d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("iTG8W")).resolve(id));
}
module.exports = $a93f1ca862af756d$var$load;

});
parcelRegister("iTG8W", function(module, exports) {
$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});



parcelRegister("ccbKN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1LyfS").then(()=>parcelRequire('8uYLy'));

});

parcelRegister("fs89m", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lv6Md").then(()=>parcelRequire('9AqbR'));

});

parcelRegister("7murN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1RQpE").then(()=>parcelRequire('fMeA7'));

});

parcelRegister("90NoL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3U29J").then(()=>parcelRequire('1OI2f'));

});

parcelRegister("3aatO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a1bQd").then(()=>parcelRequire('34low'));

});

parcelRegister("7hroY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4zv97").then(()=>parcelRequire('kWIk8'));

});

parcelRegister("ctWJ3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cFNh6").then(()=>parcelRequire('1opTR'));

});

parcelRegister("bwkUd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2hZlB").then(()=>parcelRequire('6Gkc6'));

});

parcelRegister("3YATr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e8nY9").then(()=>parcelRequire('l9I7G'));

});

parcelRegister("lQuYU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jKf17").then(()=>parcelRequire('N1TKZ'));

});

parcelRegister("g52BT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ad62t").then(()=>parcelRequire('5UIzc'));

});

parcelRegister("hY6Uz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f7rUV").then(()=>parcelRequire('2zQft'));

});

parcelRegister("ePiWI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("378VB").then(()=>parcelRequire('chXTl'));

});

parcelRegister("5w0kT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3G0lM").then(()=>parcelRequire('daJGb'));

});

parcelRegister("bwBLb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l8wus").then(()=>parcelRequire('5TpHi'));

});

parcelRegister("lhrCF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4M8Og").then(()=>parcelRequire('aPFD1'));

});

parcelRegister("twbXK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2JtRU").then(()=>parcelRequire('79tj9'));

});

parcelRegister("kmzJf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kpRuP").then(()=>parcelRequire('8ragj'));

});

parcelRegister("4XohM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8T9Il").then(()=>parcelRequire('1GO0Q'));

});

parcelRegister("2QWej", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jsxWn").then(()=>parcelRequire('c265f'));

});

parcelRegister("8VAqV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4CW7s").then(()=>parcelRequire('bVs9G'));

});

parcelRegister("l92Ga", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9t0qc").then(()=>parcelRequire('3ndEe'));

});

parcelRegister("i0l1S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eHa2y").then(()=>parcelRequire('fblbh'));

});

parcelRegister("550wy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1JJNK").then(()=>parcelRequire('dbol2'));

});

parcelRegister("bX2dj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gWuAm").then(()=>parcelRequire('6fgzU'));

});

parcelRegister("1H9vs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kdgSW").then(()=>parcelRequire('8fJ1g'));

});

parcelRegister("apOHw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bHrk6").then(()=>parcelRequire('dVNj1'));

});

parcelRegister("jv1El", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCTzj").then(()=>parcelRequire('kfn9p'));

});

parcelRegister("3F8OX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h3oGY").then(()=>parcelRequire('1dCwS'));

});

parcelRegister("4QnEL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7juzI").then(()=>parcelRequire('esTj4'));

});

parcelRegister("3KpxL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fl3hD").then(()=>parcelRequire('1nmnc'));

});

parcelRegister("6sRwl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9QKO7").then(()=>parcelRequire('9cRHW'));

});

parcelRegister("8e3Tl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bSLko").then(()=>parcelRequire('f920Z'));

});

parcelRegister("eShdI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aeVRN").then(()=>parcelRequire('3MoTL'));

});

parcelRegister("817PX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SIB2").then(()=>parcelRequire('cVaB9'));

});

parcelRegister("kuPuF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fCfXS").then(()=>parcelRequire('8YBUu'));

});

parcelRegister("eRvS8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8iEol").then(()=>parcelRequire('bvWvJ'));

});

parcelRegister("3S78D", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hQNuQ").then(()=>parcelRequire('ijzNz'));

});

parcelRegister("6vyKl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aLcFc").then(()=>parcelRequire('79afE'));

});

parcelRegister("7LU2d", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCBzK").then(()=>parcelRequire('cC2Jo'));

});

parcelRegister("j1eSj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ux6f").then(()=>parcelRequire('7JZ4r'));

});

parcelRegister("iNUdu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dvuJ4").then(()=>parcelRequire('6P26b'));

});



parcelRegister("lf67V", function(module, exports) {
$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $2d1f530a4dd24792$export$5e6158d2118ae4aa);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $47jVa = parcelRequire("47jVa");

var $dWEml = parcelRequire("dWEml");

var $6qSYw = parcelRequire("6qSYw");

var $gAaxd = parcelRequire("gAaxd");

var $fp7V3 = parcelRequire("fp7V3");
const $2d1f530a4dd24792$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $47jVa.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $gAaxd.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $fp7V3.logInTooltip),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dWEml))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6qSYw)))
        })
    });

});
parcelRegister("gAaxd", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $2fb4bc52a55e0182$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $2fb4bc52a55e0182$export$3cbe56a0cabcff38);
const $2fb4bc52a55e0182$export$515664faa1398f37 = 'navigation';
const $2fb4bc52a55e0182$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("fp7V3", function(module, exports) {
$parcel$export(module.exports, "logInTooltip", () => $bbdc78fa5376af78$export$b495e6c63a3a03c1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $bbdc78fa5376af78$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("ku9IZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee9e27142a8353bf$export$2e2bcd8739ae039);
function $ee9e27142a8353bf$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $ee9e27142a8353bf$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $ee9e27142a8353bf$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $ee9e27142a8353bf$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $ee9e27142a8353bf$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $ee9e27142a8353bf$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $ee9e27142a8353bf$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $ee9e27142a8353bf$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $ee9e27142a8353bf$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $ee9e27142a8353bf$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $ee9e27142a8353bf$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $ee9e27142a8353bf$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $ee9e27142a8353bf$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $ee9e27142a8353bf$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $ee9e27142a8353bf$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $ee9e27142a8353bf$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $ee9e27142a8353bf$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $ee9e27142a8353bf$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $ee9e27142a8353bf$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $ee9e27142a8353bf$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $ee9e27142a8353bf$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $ee9e27142a8353bf$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $ee9e27142a8353bf$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $ee9e27142a8353bf$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $ee9e27142a8353bf$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $ee9e27142a8353bf$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $ee9e27142a8353bf$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $ee9e27142a8353bf$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $ee9e27142a8353bf$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $ee9e27142a8353bf$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $ee9e27142a8353bf$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $ee9e27142a8353bf$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $ee9e27142a8353bf$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $ee9e27142a8353bf$var$fromHex_1 = $ee9e27142a8353bf$var$fromHex, $ee9e27142a8353bf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $ee9e27142a8353bf$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $ee9e27142a8353bf$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $ee9e27142a8353bf$var$fromRgb_1 = $ee9e27142a8353bf$var$fromRgb, $ee9e27142a8353bf$var$fromCssRgb_1 = $ee9e27142a8353bf$var$fromCssRgb, $ee9e27142a8353bf$var$fromHsl_1 = $ee9e27142a8353bf$var$fromHsl, $ee9e27142a8353bf$var$fromCssHsl_1 = $ee9e27142a8353bf$var$fromCssHsl, $ee9e27142a8353bf$var$fromHsv_1 = $ee9e27142a8353bf$var$fromHsv, $ee9e27142a8353bf$var$fromCmyk_1 = $ee9e27142a8353bf$var$fromCmyk, $ee9e27142a8353bf$var$fromYiq_1 = $ee9e27142a8353bf$var$fromYiq, $ee9e27142a8353bf$var$fromXYZ_1 = $ee9e27142a8353bf$var$fromXYZ, $ee9e27142a8353bf$var$fromxyY_1 = $ee9e27142a8353bf$var$fromxyY, $ee9e27142a8353bf$var$fromLms_1 = $ee9e27142a8353bf$var$fromLms, $ee9e27142a8353bf$var$fromCieLab_1 = $ee9e27142a8353bf$var$fromCieLab, $ee9e27142a8353bf$var$fromCieLuv_1 = $ee9e27142a8353bf$var$fromCieLuv, $ee9e27142a8353bf$var$fromCieLch_1 = $ee9e27142a8353bf$var$fromCieLch, $ee9e27142a8353bf$var$fromHsluv = $ee9e27142a8353bf$var$fromCieLch$1, $ee9e27142a8353bf$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $ee9e27142a8353bf$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $ee9e27142a8353bf$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $ee9e27142a8353bf$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $ee9e27142a8353bf$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $ee9e27142a8353bf$var$fromHsluv
    }
}, $ee9e27142a8353bf$var$adapt_1 = $ee9e27142a8353bf$var$adapt, $ee9e27142a8353bf$var$adjacent_1 = $ee9e27142a8353bf$var$adjacent, $ee9e27142a8353bf$var$brightness_1 = $ee9e27142a8353bf$var$brightness, $ee9e27142a8353bf$var$complementary_1 = $ee9e27142a8353bf$var$complementary, $ee9e27142a8353bf$var$contrast_1 = $ee9e27142a8353bf$var$contrast, $ee9e27142a8353bf$var$contrastRatio_1 = $ee9e27142a8353bf$var$contrastRatio, $ee9e27142a8353bf$var$convert_1 = $ee9e27142a8353bf$var$convert, $ee9e27142a8353bf$var$difference_1 = $ee9e27142a8353bf$var$difference, $ee9e27142a8353bf$var$fade_1 = $ee9e27142a8353bf$var$fade, $ee9e27142a8353bf$var$greyscale_1 = $ee9e27142a8353bf$var$greyscale, $ee9e27142a8353bf$var$hue_1 = $ee9e27142a8353bf$var$hue, $ee9e27142a8353bf$var$invert_1 = $ee9e27142a8353bf$var$invert, $ee9e27142a8353bf$var$invertLightness_1 = $ee9e27142a8353bf$var$invertLightness, $ee9e27142a8353bf$var$mid_1 = $ee9e27142a8353bf$var$mid, $ee9e27142a8353bf$var$multiply_1 = $ee9e27142a8353bf$var$multiply, $ee9e27142a8353bf$var$saturation_1 = $ee9e27142a8353bf$var$saturation, $ee9e27142a8353bf$var$sepia_1 = $ee9e27142a8353bf$var$sepia, $ee9e27142a8353bf$var$shade_1 = $ee9e27142a8353bf$var$shade, $ee9e27142a8353bf$var$temperature_1 = $ee9e27142a8353bf$var$temperature, $ee9e27142a8353bf$var$tetrad_1 = $ee9e27142a8353bf$var$tetrad, $ee9e27142a8353bf$var$triad_1 = $ee9e27142a8353bf$var$triad, $ee9e27142a8353bf$var$index$2 = {
    adapt: $ee9e27142a8353bf$var$adapt_1,
    adjacent: $ee9e27142a8353bf$var$adjacent_1,
    brightness: $ee9e27142a8353bf$var$brightness_1,
    complementary: $ee9e27142a8353bf$var$complementary_1,
    contrast: $ee9e27142a8353bf$var$contrast_1,
    contrastRatio: $ee9e27142a8353bf$var$contrastRatio_1,
    convert: $ee9e27142a8353bf$var$convert_1,
    difference: $ee9e27142a8353bf$var$difference_1,
    fade: $ee9e27142a8353bf$var$fade_1,
    greyscale: $ee9e27142a8353bf$var$greyscale_1,
    hue: $ee9e27142a8353bf$var$hue_1,
    invert: $ee9e27142a8353bf$var$invert_1,
    invertLightness: $ee9e27142a8353bf$var$invertLightness_1,
    mid: $ee9e27142a8353bf$var$mid_1,
    multiply: $ee9e27142a8353bf$var$multiply_1,
    saturation: $ee9e27142a8353bf$var$saturation_1,
    sepia: $ee9e27142a8353bf$var$sepia_1,
    shade: $ee9e27142a8353bf$var$shade_1,
    temperature: $ee9e27142a8353bf$var$temperature_1,
    tetrad: $ee9e27142a8353bf$var$tetrad_1,
    triad: $ee9e27142a8353bf$var$triad_1
}, $ee9e27142a8353bf$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $ee9e27142a8353bf$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $ee9e27142a8353bf$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($ee9e27142a8353bf$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $ee9e27142a8353bf$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($ee9e27142a8353bf$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $ee9e27142a8353bf$var$api_1 = $ee9e27142a8353bf$var$api, $ee9e27142a8353bf$var$helpers = {
    getIlluminant: function(r) {
        return $ee9e27142a8353bf$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $ee9e27142a8353bf$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $ee9e27142a8353bf$var$index)if ($ee9e27142a8353bf$var$index.hasOwnProperty(e) && $ee9e27142a8353bf$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $ee9e27142a8353bf$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $ee9e27142a8353bf$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $ee9e27142a8353bf$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $ee9e27142a8353bf$var$constants, s));
            default:
                return null;
        }
    }
}, $ee9e27142a8353bf$var$helpers_1 = $ee9e27142a8353bf$var$helpers, $ee9e27142a8353bf$var$dependencies = {
    conversions: $ee9e27142a8353bf$var$index,
    operations: $ee9e27142a8353bf$var$index$2,
    helpers: $ee9e27142a8353bf$var$helpers_1
}, $ee9e27142a8353bf$var$entry = $ee9e27142a8353bf$var$api_1($ee9e27142a8353bf$var$dependencies, $ee9e27142a8353bf$var$constants);
var $ee9e27142a8353bf$export$2e2bcd8739ae039 = $ee9e27142a8353bf$var$entry;

});

parcelRegister("hgZ04", function(module, exports) {
$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $a20db7ceaedcae4e$export$89d857133932d6aa);
/* nav3.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $47jVa = parcelRequire("47jVa");

var $dvMQP = parcelRequire("dvMQP");

var $8sy14 = parcelRequire("8sy14");

var $euhop = parcelRequire("euhop");
const $a20db7ceaedcae4e$var$imgStyles = null;
const $a20db7ceaedcae4e$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $lRq8t.default)();
    const state = (0, $8sy14.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $euhop.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $47jVa.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: picture,
            alt: tooltip,
            className: (0, $hcewu.default)([
                "_2rko1rr0 _1bsb1ejb _4t3i1ejb"
            ])
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dvMQP))), {
            color: "currentColor",
            label: tooltip,
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
});

});
parcelRegister("8sy14", function(module, exports) {
$parcel$export(module.exports, "useImageState", () => $3eb358dfece35317$export$2c1df3428fc3264c);

var $eJOHy = parcelRequire("eJOHy");
const $3eb358dfece35317$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $eJOHy.useState)('pending');
    const imgRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("euhop", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1c223c4e5ff550a6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1c223c4e5ff550a6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});


parcelRegister("4CEkC", function(module, exports) {

var $auNny = parcelRequire("auNny");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $35d9ff07041638b1$var$kebabCase = $auNny(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $35d9ff07041638b1$var$kebabCase;

});

parcelRegister("joSn0", function(module, exports) {
"use strict";
var $e1fa6eff9b7fbc13$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $e1fa6eff9b7fbc13$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e1fa6eff9b7fbc13$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");
var $e1fa6eff9b7fbc13$var$ALL_INITIALIZERS = [];
var $e1fa6eff9b7fbc13$var$READY_INITIALIZERS = [];
function $e1fa6eff9b7fbc13$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $e1fa6eff9b7fbc13$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $e1fa6eff9b7fbc13$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $e1fa6eff9b7fbc13$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $e1fa6eff9b7fbc13$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $e1fa6eff9b7fbc13$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $e1fa6eff9b7fbc13$var$render(loaded, props) {
    return $eJOHy.createElement($e1fa6eff9b7fbc13$var$resolve(loaded), props);
}
function $e1fa6eff9b7fbc13$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $e1fa6eff9b7fbc13$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $e1fa6eff9b7fbc13$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $e1fa6eff9b7fbc13$var$READY_INITIALIZERS.push(function() {
        if ($e1fa6eff9b7fbc13$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $e1fa6eff9b7fbc13$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $e1fa6eff9b7fbc13$var$_classCallCheck(this, LoadableComponent);
            var _this = $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $eJOHy.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($eJOHy.Component), _class.contextTypes = {
        loadable: $cT3Ey.shape({
            report: $cT3Ey.func.isRequired
        })
    }, _temp;
}
function $e1fa6eff9b7fbc13$var$Loadable(opts) {
    return $e1fa6eff9b7fbc13$var$createLoadableComponent($e1fa6eff9b7fbc13$var$load, opts);
}
function $e1fa6eff9b7fbc13$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $e1fa6eff9b7fbc13$var$createLoadableComponent($e1fa6eff9b7fbc13$var$loadMap, opts);
}
$e1fa6eff9b7fbc13$var$Loadable.Map = $e1fa6eff9b7fbc13$var$LoadableMap;
var $e1fa6eff9b7fbc13$var$Capture = function(_React$Component2) {
    $e1fa6eff9b7fbc13$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $e1fa6eff9b7fbc13$var$_classCallCheck(this, Capture);
        return $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $eJOHy.Children.only(this.props.children);
    };
    return Capture;
}($eJOHy.Component);
$e1fa6eff9b7fbc13$var$Capture.propTypes = {
    report: $cT3Ey.func.isRequired
};
$e1fa6eff9b7fbc13$var$Capture.childContextTypes = {
    loadable: $cT3Ey.shape({
        report: $cT3Ey.func.isRequired
    }).isRequired
};
$e1fa6eff9b7fbc13$var$Loadable.Capture = $e1fa6eff9b7fbc13$var$Capture;
function $e1fa6eff9b7fbc13$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $e1fa6eff9b7fbc13$var$flushInitializers(initializers);
    });
}
$e1fa6eff9b7fbc13$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $e1fa6eff9b7fbc13$var$flushInitializers($e1fa6eff9b7fbc13$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$e1fa6eff9b7fbc13$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $e1fa6eff9b7fbc13$var$flushInitializers($e1fa6eff9b7fbc13$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $e1fa6eff9b7fbc13$var$Loadable;

});

parcelRegister("1kTCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f92cd302f823e70$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $0f92cd302f823e70$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $eJOHy.useRef)(null);
    var maxWaitArgs = (0, $eJOHy.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $eJOHy.useRef)(false);
    var functionTimeoutHandler = (0, $eJOHy.useRef)(null);
    var isComponentUnmounted = (0, $eJOHy.useRef)(false);
    var debouncedFunction = (0, $eJOHy.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $eJOHy.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $eJOHy.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $eJOHy.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $eJOHy.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("aWILV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f820cf60b1f66bf$export$2e2bcd8739ae039);

var $fpB9r = parcelRequire("fpB9r");

var $eJOHy = parcelRequire("eJOHy");

var $6YrP7 = parcelRequire("6YrP7");

var $1NIU8 = parcelRequire("1NIU8");

var $nGpUg = parcelRequire("nGpUg");

var $2xvzl = parcelRequire("2xvzl");

var $27Ipq = parcelRequire("27Ipq");
var $7f820cf60b1f66bf$var$testOmitPropsOnStringTag = (0, $6YrP7.default);
var $7f820cf60b1f66bf$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $7f820cf60b1f66bf$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $7f820cf60b1f66bf$var$testOmitPropsOnStringTag : $7f820cf60b1f66bf$var$testOmitPropsOnComponent;
};
var $7f820cf60b1f66bf$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $7f820cf60b1f66bf$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $7f820cf60b1f66bf$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $nGpUg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $27Ipq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $nGpUg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $7f820cf60b1f66bf$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $7f820cf60b1f66bf$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $7f820cf60b1f66bf$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $1NIU8.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $eJOHy.useContext)((0, $1NIU8.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $nGpUg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2xvzl.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $7f820cf60b1f66bf$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $eJOHy.createElement)($7f820cf60b1f66bf$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $eJOHy.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $fpB9r.default)({}, options, nextOptions, {
                shouldForwardProp: $7f820cf60b1f66bf$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $7f820cf60b1f66bf$export$2e2bcd8739ae039 = $7f820cf60b1f66bf$var$createStyled;

});
parcelRegister("6YrP7", function(module, exports) {
$parcel$export(module.exports, "default", () => $513deddd0bc11af4$export$2e2bcd8739ae039);

var $032KB = parcelRequire("032KB");
var $513deddd0bc11af4$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $513deddd0bc11af4$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $032KB.default)(function(prop) {
    return $513deddd0bc11af4$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("032KB", function(module, exports) {
$parcel$export(module.exports, "default", () => $00926a2a60d1c2ff$export$2e2bcd8739ae039);
function $00926a2a60d1c2ff$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("nGpUg", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $04730d32f372c2f1$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $04730d32f372c2f1$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $04730d32f372c2f1$export$6f077d94b33a01aa);
var $04730d32f372c2f1$var$isBrowser = true;
function $04730d32f372c2f1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $04730d32f372c2f1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $04730d32f372c2f1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $04730d32f372c2f1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $04730d32f372c2f1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});


parcelRegister("jhs3c", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("bpkMB", function(module, exports) {
$parcel$export(module.exports, "setInteractionError", () => $c49daae202026332$export$5b689ca7b019e89f);

var $2QO3b = parcelRequire("2QO3b");
function $c49daae202026332$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $2QO3b.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $2QO3b.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("h6i8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcb5285bd59bee2f$export$2e2bcd8739ae039);

var $ebgtt = parcelRequire("ebgtt");
function $fcb5285bd59bee2f$var$traceUFOPress(name, timestamp) {
    return (0, $ebgtt.default)(name, 'press', timestamp);
}
var $fcb5285bd59bee2f$export$2e2bcd8739ae039 = $fcb5285bd59bee2f$var$traceUFOPress;

});
parcelRegister("ebgtt", function(module, exports) {
$parcel$export(module.exports, "default", () => $20d2499e937c044d$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");

var $2oAAJ = parcelRequire("2oAAJ");

var $jcIvM = parcelRequire("jcIvM");

var $fiPhB = parcelRequire("fiPhB");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $kTRgU = parcelRequire("kTRgU");
function $20d2499e937c044d$var$traceUFOInteraction(name, interactionType, startTime) {
    const rate = (0, $jcIvM.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $jcIvM.getDoNotAbortActivePressInteraction)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $jcIvM.getMinorInteractions)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $2QO3b.getActiveInteraction)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $2QO3b.abortAll)('new_interaction', name);
    if ((0, $2oAAJ.default)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $aXKmr.v4)();
        (0, $kVpZx.DefaultInteractionID).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $fiPhB.setInteractionActiveTrace)(newId, interactionType);
        (0, $2QO3b.addNewInteraction)(newId, name, interactionType === 'hover' ? 'press' : interactionType, startTimestamp, rate, [], (0, $kTRgU.default).current, (0, $fiPhB.getActiveTrace)());
    }
}
var $20d2499e937c044d$export$2e2bcd8739ae039 = $20d2499e937c044d$var$traceUFOInteraction;

});


parcelRegister("jZ41J", function(module, exports) {
$parcel$export(module.exports, "useCurrentPreviewPanel", () => $73379831355d1e33$export$5351114e92b31bc6);

var $2N9Mf = parcelRequire("2N9Mf");
const $73379831355d1e33$export$5351114e92b31bc6 = ()=>{
    const context = (0, $2N9Mf.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};

});
parcelRegister("2N9Mf", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelsProvider", () => $95a74a8e8fe4b2d2$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsContext", () => $95a74a8e8fe4b2d2$export$609db4be92d0fad8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6WmCi = parcelRequire("6WmCi");

var $kUvkq = parcelRequire("kUvkq");
const $95a74a8e8fe4b2d2$var$noop = (props)=>{};
const $95a74a8e8fe4b2d2$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $95a74a8e8fe4b2d2$var$noop,
    onClose: $95a74a8e8fe4b2d2$var$noop
};
const $95a74a8e8fe4b2d2$export$f473d225913e225d = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
const $95a74a8e8fe4b2d2$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $95a74a8e8fe4b2d2$var$noop,
                onClose: $95a74a8e8fe4b2d2$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $kUvkq.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $95a74a8e8fe4b2d2$var$initialState.onOpen,
                onClose: params.onClose || $95a74a8e8fe4b2d2$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $95a74a8e8fe4b2d2$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $6WmCi.usePanelWidth)();
    const [state, dispatch] = (0, $eJOHy.useReducer)($95a74a8e8fe4b2d2$var$previewPanelsReducer, {
        ...$95a74a8e8fe4b2d2$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $eJOHy.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $eJOHy.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $eJOHy.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $eJOHy.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($95a74a8e8fe4b2d2$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $95a74a8e8fe4b2d2$export$609db4be92d0fad8 = ()=>{
    return (0, $eJOHy.useContext)($95a74a8e8fe4b2d2$export$f473d225913e225d);
};

});
parcelRegister("6WmCi", function(module, exports) {
$parcel$export(module.exports, "usePanelWidth", () => $0ea62586f26aeef5$export$82b270f291af5a5);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3s8bj = parcelRequire("3s8bj");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $bQtfb = parcelRequire("bQtfb");
const $0ea62586f26aeef5$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $eJOHy.useState)((0, $bQtfb.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $eJOHy.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $eJOHy.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $eJOHy.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        if ((0, $eGOwo.fg)('platform_global_preview_panels_resize_analytics')) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $eJOHy.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $eJOHy.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $eJOHy.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $bQtfb.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unbind = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};

});
parcelRegister("bQtfb", function(module, exports) {
$parcel$export(module.exports, "getDefaultPanelWidth", () => $3ee737ef9a06f6a7$export$29ceecbfeef33bfc);

var $59rsN = parcelRequire("59rsN");
const $3ee737ef9a06f6a7$var$getExperimentValue = (0, $59rsN.default).getExperimentValue;
const $3ee737ef9a06f6a7$var$EXPERIMENT = 'platform_global_preview_panels_default_width';
const $3ee737ef9a06f6a7$export$c82b124a4ae0f274 = 'isEnabled';
const $3ee737ef9a06f6a7$export$56368731b0f4a091 = 'minimumWidth';
const $3ee737ef9a06f6a7$export$97a0618f336c05be = 'ratio';
const $3ee737ef9a06f6a7$var$PANEL_DEFAULT_WIDTH = 400;
const $3ee737ef9a06f6a7$var$PANEL_MAX_WIDTH = 1000;
const $3ee737ef9a06f6a7$var$FALLBACK_RATIO = 0.25;
const $3ee737ef9a06f6a7$export$29ceecbfeef33bfc = ()=>{
    if (!$3ee737ef9a06f6a7$var$getExperimentValue($3ee737ef9a06f6a7$var$EXPERIMENT, $3ee737ef9a06f6a7$export$c82b124a4ae0f274, false)) return $3ee737ef9a06f6a7$var$PANEL_DEFAULT_WIDTH;
    const windowWidth = window.innerWidth;
    const minWidthForWiderPanel = $3ee737ef9a06f6a7$var$getExperimentValue($3ee737ef9a06f6a7$var$EXPERIMENT, $3ee737ef9a06f6a7$export$56368731b0f4a091, Number.MAX_VALUE);
    let width = $3ee737ef9a06f6a7$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth > minWidthForWiderPanel) {
        const panelWidthToWindowWidthRatio = $3ee737ef9a06f6a7$var$getExperimentValue($3ee737ef9a06f6a7$var$EXPERIMENT, $3ee737ef9a06f6a7$export$97a0618f336c05be, $3ee737ef9a06f6a7$var$FALLBACK_RATIO);
        const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);
        width = proposedPanelWidth < $3ee737ef9a06f6a7$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $3ee737ef9a06f6a7$var$PANEL_MAX_WIDTH;
    }
    return width;
};

});


parcelRegister("kUvkq", function(module, exports) {
$parcel$export(module.exports, "doPreviewPanelTypesMatch", () => $dd196a9b7ae5269d$export$eb89e687f2b278d7);

var $gtr2v = parcelRequire("gtr2v");
const $dd196a9b7ae5269d$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $gtr2v.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $gtr2v.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};

});



parcelRegister("fcue4", function(module, exports) {
$parcel$export(module.exports, "usePreviewPanelsActions", () => $5623bca84b546fda$export$5f5debba1692bf40);

var $2N9Mf = parcelRequire("2N9Mf");
const $5623bca84b546fda$var$noop = (props)=>{};
const $5623bca84b546fda$export$5f5debba1692bf40 = ()=>{
    const context = (0, $2N9Mf.usePreviewPanelsContext)();
    if (!context) return {
        open: $5623bca84b546fda$var$noop,
        close: $5623bca84b546fda$var$noop,
        setPanelWidth: $5623bca84b546fda$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};

});

parcelRegister("5spib", function(module, exports) {

var $ez1ap = parcelRequire("ez1ap");

var $c3u3c = parcelRequire("c3u3c");

var $8etTE = parcelRequire("8etTE");

var $4sprp = parcelRequire("4sprp");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $3f932fc664b35c8f$var$forEach(collection, iteratee) {
    var func = $4sprp(collection) ? $ez1ap : $c3u3c;
    return func(collection, $8etTE(iteratee));
}
module.exports = $3f932fc664b35c8f$var$forEach;

});
parcelRegister("8etTE", function(module, exports) {

var $d7YnM = parcelRequire("d7YnM");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $5fe6d2623666b1a0$var$castFunction(value) {
    return typeof value == 'function' ? value : $d7YnM;
}
module.exports = $5fe6d2623666b1a0$var$castFunction;

});


parcelRegister("asupr", function(module, exports) {

var $9h7YF = parcelRequire("9h7YF");
var $79d41b91627fa81b$var$Global = $9h7YF.Global;
module.exports = {
    name: 'sessionStorage',
    read: $79d41b91627fa81b$var$read,
    write: $79d41b91627fa81b$var$write,
    each: $79d41b91627fa81b$var$each,
    remove: $79d41b91627fa81b$var$remove,
    clearAll: $79d41b91627fa81b$var$clearAll
};
function $79d41b91627fa81b$var$sessionStorage() {
    return $79d41b91627fa81b$var$Global.sessionStorage;
}
function $79d41b91627fa81b$var$read(key) {
    return $79d41b91627fa81b$var$sessionStorage().getItem(key);
}
function $79d41b91627fa81b$var$write(key, data) {
    return $79d41b91627fa81b$var$sessionStorage().setItem(key, data);
}
function $79d41b91627fa81b$var$each(fn) {
    for(var i = $79d41b91627fa81b$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $79d41b91627fa81b$var$sessionStorage().key(i);
        fn($79d41b91627fa81b$var$read(key), key);
    }
}
function $79d41b91627fa81b$var$remove(key) {
    return $79d41b91627fa81b$var$sessionStorage().removeItem(key);
}
function $79d41b91627fa81b$var$clearAll() {
    return $79d41b91627fa81b$var$sessionStorage().clear();
}

});

parcelRegister("5tQVZ", function(module, exports) {
$parcel$export(module.exports, "getTrialDaysLeft", () => $68b4dedd8b237ad0$export$954628993bf3188e);
$parcel$export(module.exports, "getTrialDaysLeftFromTrialEndTime", () => $68b4dedd8b237ad0$export$165abb069513be0e);
$parcel$export(module.exports, "useMemoizedTrialDaysLeftFromTrialEndTime", () => $68b4dedd8b237ad0$export$bc3e0c760835aa1e);

var $eJOHy = parcelRequire("eJOHy");

function $68b4dedd8b237ad0$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $b511b1e804207833$export$98a7370239de6730));
}
function $68b4dedd8b237ad0$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $68b4dedd8b237ad0$export$954628993bf3188e(trialEndTime - Date.now());
}
function $68b4dedd8b237ad0$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $eJOHy.useMemo)(()=>$68b4dedd8b237ad0$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $68b4dedd8b237ad0$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $68b4dedd8b237ad0$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $68b4dedd8b237ad0$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $eJOHy.useMemo)(()=>$68b4dedd8b237ad0$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}

});
const $b511b1e804207833$export$98a7370239de6730 = 86400000;


parcelRegister("h1104", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $39bc68ae20de168c$export$291d012eb0744b34);
const $39bc68ae20de168c$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $39bc68ae20de168c$export$291d012eb0744b34 = (product)=>{
    return $39bc68ae20de168c$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("6qssf", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $c4ad04b70658641a$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $c4ad04b70658641a$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $c4ad04b70658641a$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $c4ad04b70658641a$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $3VCQy = parcelRequire("3VCQy");

var $5EMLi = parcelRequire("5EMLi");
var $ftN6c = parcelRequire("ftN6c");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");
const $c4ad04b70658641a$export$85183a312807388d = (0, $3VCQy.FabricChannel).growth;
const $c4ad04b70658641a$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $c4ad04b70658641a$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $c4ad04b70658641a$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $aLED4.useEditionAwareness)();
    const experimentContext = (0, $a0oOn.useExperimentContext)();
    const sendAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: editionAwarenessContext.invoiceableStatus === 'INVOICEABLE' ? true : editionAwarenessContext.invoiceableStatus === 'NOT_INVOICEABLE' ? false : null,
            hasPaymentDetailsEntered: editionAwarenessContext.hasPaymentDetailsEntered,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            lastKnownTrial: editionAwarenessContext?.lastKnownTrial,
            offeringKey: editionAwarenessContext?.offeringKey,
            // Upgrade properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: editionAwarenessContext.directBuyChangeOfferingToStandardExperienceUrl,
            // Entitlement properties
            isInCollection: editionAwarenessContext.isInCollection,
            collectionType: editionAwarenessContext.collectionType,
            // User permissions properties
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            billingSourceSystem: editionAwarenessContext.billingSourceSystem,
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            isEnterpriseCustomer: editionAwarenessContext.isEnterpriseCustomer,
            // Site traits
            automationUsage: editionAwarenessContext.automationUsage,
            lastAutomationFreeLimitBreachDate: editionAwarenessContext.lastAutomationFreeLimitBreachDate,
            automationFreeLimitStatus: editionAwarenessContext.automationFreeLimitStatus,
            // Capabilities
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen,
            // User Preferences
            endUserRequestUpgradeLatestDate: editionAwarenessContext.endUserRequestUpgradeLatestDate
        };
        if (payload instanceof (0, $5EMLi.default)) {
            const contextAttributes = $c4ad04b70658641a$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$c4ad04b70658641a$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            }).fire($c4ad04b70658641a$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$c4ad04b70658641a$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            });
            const contextAttributes = $c4ad04b70658641a$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($c4ad04b70658641a$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentContext
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $c4ad04b70658641a$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $c4ad04b70658641a$export$e955abb82869dc84();
    const hasSent = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}

});
parcelRegister("aLED4", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessContext", () => $7dea7aedb51a64cb$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $7dea7aedb51a64cb$export$5a5baedfe8151ce);

var $eJOHy = parcelRequire("eJOHy");
const $7dea7aedb51a64cb$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $7dea7aedb51a64cb$export$5a5baedfe8151ce() {
    const context = (0, $eJOHy.useContext)($7dea7aedb51a64cb$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("a0oOn", function(module, exports) {
$parcel$export(module.exports, "ExperimentContextClass", () => $36000c0ac495dc57$export$cab0526cd5428d4e);
$parcel$export(module.exports, "ExperimentContext", () => $36000c0ac495dc57$export$fcdf652c4fd8e4c7);
$parcel$export(module.exports, "useExperimentContext", () => $36000c0ac495dc57$export$471c3c65727643de);
$parcel$export(module.exports, "booleanCohortTransformFn", () => $36000c0ac495dc57$export$259da07bf82c42c7);
$parcel$export(module.exports, "treatmentCohortTransformFn", () => $36000c0ac495dc57$export$f2497ad79c72045c);
$parcel$export(module.exports, "useGetExperimentValue", () => $36000c0ac495dc57$export$59dd27b2c85d98d8);

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $04skO = parcelRequire("04skO");
class $36000c0ac495dc57$export$cab0526cd5428d4e {
    constructor(context){
        this.experimentDictionary = {};
        this.experimentDictionary = context ?? {};
    }
    experimentExposed(experimentName, experimentVariant, extraAttributes) {
        // If the experiment is already in the dictionary (i.e. been exposed before),
        // we don't want to overwrite the timestamp of first exposure.
        if (Object.keys(this.experimentDictionary).includes(experimentName)) return;
        this.experimentDictionary[experimentName] = {
            cohort: experimentVariant,
            timestamp: Date.now(),
            ...extraAttributes
        };
    }
    experiments() {
        return this.experimentDictionary;
    }
}
const $36000c0ac495dc57$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
function $36000c0ac495dc57$export$471c3c65727643de() {
    const context = (0, $eJOHy.useContext)($36000c0ac495dc57$export$fcdf652c4fd8e4c7);
    if (!context) throw new Error('Missing context, please ensure this is used within ExperimentContext');
    return context;
}
const $36000c0ac495dc57$export$259da07bf82c42c7 = (parameterValue)=>parameterValue ? 'variation' : 'control';
const $36000c0ac495dc57$export$f2497ad79c72045c = (cohort)=>{
    if (cohort === 'treatment') return 'variation';
    else if (cohort === 'control') return 'control';
    else return 'not-enrolled';
};
const $36000c0ac495dc57$export$59dd27b2c85d98d8 = ()=>{
    const experimentContext = $36000c0ac495dc57$export$471c3c65727643de();
    const fireExperimentExposureEvent = (0, $04skO.useFeatureExposedAnalytics)();
    const getExperimentValue = (0, $eJOHy.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $59rsN.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $59rsN.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, cohort, experimentContextAttributes);
            if (trackEventParameters) fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    /**
	 * @deprecated Use getExperimentValue instead with the correct experiment cohort values.
	 * We are moving towards consistent cohort values of 'control', 'variation' and 'not-enrolled'.
	 */ const getExperimentValueWithTransform = (0, $eJOHy.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, transformCohortFunc: transformCohortFunc, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $59rsN.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $59rsN.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, transformCohortFunc(cohort), experimentContextAttributes);
            if (trackEventParameters && typeof cohort === 'string') fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    return {
        getExperimentValue: getExperimentValue,
        getExperimentValueWithTransform: getExperimentValueWithTransform
    };
};

});
parcelRegister("04skO", function(module, exports) {
$parcel$export(module.exports, "FeatureExposedAnalytics", () => $cf4221145ca8f40a$export$b12ce465f015026c);
$parcel$export(module.exports, "useFeatureExposedAnalytics", () => $cf4221145ca8f40a$export$5218ddb3d9c658c0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qssf = parcelRequire("6qssf");
function $cf4221145ca8f40a$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const hasSent = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
}
const $cf4221145ca8f40a$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const sentFlagKeys = (0, $eJOHy.useRef)([]);
    const fireExperimentExposureEvent = (0, $eJOHy.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};

});



parcelRegister("86jVJ", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $e7065f3ae4dddd35$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $e7065f3ae4dddd35$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).PREMIUM_EDITION
};

});
parcelRegister("dl00O", function(module, exports) {
$parcel$export(module.exports, "GrowthPillar", () => $9a246c0aa98a2202$export$9874ba4d5a9c06c8);
$parcel$export(module.exports, "Edition", () => $9a246c0aa98a2202$export$6f4a0f769e61929);
var $9a246c0aa98a2202$export$9874ba4d5a9c06c8 = /*#__PURE__*/ function(GrowthPillar) {
    GrowthPillar["FIND"] = "FIND";
    GrowthPillar["BUY"] = "BUY";
    GrowthPillar["USE"] = "USE";
    GrowthPillar["PLATFORM"] = "PLATFORM";
    return GrowthPillar;
}({});
var $9a246c0aa98a2202$export$6f4a0f769e61929 = /*#__PURE__*/ function(Edition) {
    Edition["FREE_EDITION"] = "free";
    Edition["STANDARD_EDITION"] = "standard";
    Edition["PREMIUM_EDITION"] = "premium";
    Edition["SELECTION"] = "selection";
    return Edition;
}({});

});


parcelRegister("2IPZ1", function(module, exports) {
$parcel$export(module.exports, "EditionAwareness", () => $e852f9961103ed96$export$a55b02efe3d62583);

var $gt9Am = parcelRequire("gt9Am");

var $jFOoT = parcelRequire("jFOoT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $6FOAB = parcelRequire("6FOAB");

var $5tQVZ = parcelRequire("5tQVZ");

var $hSmMC = parcelRequire("hSmMC");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $ghs9K = parcelRequire("ghs9K");

var $3S2RH = parcelRequire("3S2RH");

var $jZZcf = parcelRequire("jZZcf");

var $2UnLC = parcelRequire("2UnLC");

var $l9sJA = parcelRequire("l9sJA");

var $jb8fm = parcelRequire("jb8fm");

var $4t0UC = parcelRequire("4t0UC");

var $c8yMY = parcelRequire("c8yMY");

var $7i5PX = parcelRequire("7i5PX");

var $cY4TY = parcelRequire("cY4TY");

var $apOA4 = parcelRequire("apOA4");
function $e852f9961103ed96$var$getBillingSourceSystem(typename) {
    switch(typename){
        case 'CcpEntitlement':
            return 'CCP';
        case 'HamsEntitlement':
            return 'HAMS';
    }
}
/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $e852f9961103ed96$var$EditionAwarenessImpl(props) {
    const { cloudId: cloudId, product: product, edition: edition, accountId: accountId, userRoles: userRolesFromProduct, environment: environment, siteTraits: siteTraits = [], canRender: canRender, isInReverseTrial: isInReverseTrialFromProduct, onOpenOnboardingMenu: onOpenOnboardingMenu, premiumFeatureHighlightToggle: premiumFeatureHighlightToggle, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, PremiumWrapper: PremiumWrapper, getAction: getAction, showFlag: showFlag, hideFlag: hideFlag } = props;
    const queryConfig = (0, $jZZcf.getQueryConfig)(product, edition, cloudId, accountId);
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $jFOoT.default), queryConfig);
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const entitlementId = entitlementInfo?.entitlementId;
    const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
    const isConfigurePaymentAvailable = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.isAvailableToUser === true;
    const addPaymentDetailsExperienceUrl = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.experienceUrl;
    const canAddPaymentDetails = Boolean(isConfigurePaymentAvailable && addPaymentDetailsExperienceUrl);
    const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
    const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
    const trialDaysLeft = (0, $5tQVZ.getTrialDaysLeft)(trialTimeLeft);
    const trialStartTimestamp = entitlement?.subscription?.trial?.startTimestamp;
    const trialStartDate = (0, $eJOHy.useMemo)(()=>trialStartTimestamp ? new Date(trialStartTimestamp) : undefined, [
        trialStartTimestamp
    ]);
    const trialEndTimestamp = entitlement?.subscription?.trial?.endTimestamp;
    const trialEndDate = (0, $eJOHy.useMemo)(()=>trialEndTimestamp ? new Date(trialEndTimestamp) : undefined, [
        trialEndTimestamp
    ]);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && invoiceableStatus === 'NOT_INVOICEABLE';
    const isInReverseTrial = (isInTrial || isInPredunning) && (isInReverseTrialFromProduct !== undefined ? isInReverseTrialFromProduct : false);
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const isDirectBuyChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.isAvailableToUser;
    const directBuyChangeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.experienceUrl;
    const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
    const canDirectBuyUpgrade = Boolean(isDirectBuyChangeOfferingAvailable && directBuyChangeOfferingToStandardExperienceUrl);
    const billingSourceSystem = $e852f9961103ed96$var$getBillingSourceSystem(entitlement?.__typename);
    const transactionAccountId = entitlement?.transactionAccount?.key;
    const { isInCollection: isInCollection, collectionEntitlementId: collectionEntitlementId } = (0, $eJOHy.useMemo)(()=>{
        const collectionEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION');
        return {
            isInCollection: !!collectionEntitlement?.entitlementId,
            collectionEntitlementId: collectionEntitlement?.entitlementId
        };
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const isEnterpriseCustomer = (0, $eJOHy.useMemo)(()=>{
        const enterpriseEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'ENTERPRISE');
        return !!enterpriseEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const productCollection = (0, $3S2RH.getProductCollection)(product);
    const collectionType = isInCollection && productCollection?.isEnabled && productCollection?.collectionType || null;
    const userRoles = (0, $eJOHy.useMemo)(()=>{
        const roles = [
            ...userRolesFromProduct || []
        ];
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    const userEmail = data?.user?.email;
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const storageUsageInGB = (0, $eJOHy.useMemo)(()=>{
        if (data.jira?.attachmentStorageUsed && (0, $jb8fm.isProductOneOf)(product, [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ])) return (0, $hSmMC.bytesToGigabytes)(data.jira.attachmentStorageUsed);
        if (data.confluence_storage?.bytesUsed && product === 'confluence') return (0, $hSmMC.bytesToGigabytes)(data.confluence_storage.bytesUsed);
        return undefined;
    }, [
        data.jira?.attachmentStorageUsed,
        data.confluence_storage?.bytesUsed,
        product
    ]);
    const storageLimitInGB = (0, $eJOHy.useMemo)(()=>{
        if (data.jira?.attachmentStorageAllowed) return (0, $hSmMC.bytesToGigabytes)(data.jira.attachmentStorageAllowed);
        return undefined;
    }, [
        data.jira?.attachmentStorageAllowed
    ]);
    const storageIsUnlimited = (0, $eJOHy.useMemo)(()=>{
        if (data.jira?.attachmentStorageIsUnlimited) return data.jira.attachmentStorageIsUnlimited;
        return undefined;
    }, [
        data.jira?.attachmentStorageIsUnlimited
    ]);
    const siteTraitsForContext = (0, $eJOHy.useMemo)(()=>(0, $2UnLC.getSiteTraitValues)(siteTraits, product), [
        siteTraits,
        product
    ]);
    const offeringKey = entitlement?.offering?.key;
    const automationFreeLimitStatus = (0, $eJOHy.useMemo)(()=>(0, $eGOwo.fg)('growth_automation_limits_kill_switch') ? (0, $ghs9K.getAutomationFreeLimitStatus)({
            product: product,
            edition: edition,
            isInTrial: isInTrial,
            ...siteTraitsForContext
        }) : null, [
        product,
        edition,
        isInTrial,
        siteTraitsForContext
    ]);
    const lastKnownTrial = (0, $eJOHy.useMemo)(()=>{
        // We purposely don't discard the results of the trial if the customer is not on a trial, the reason for this
        // is to enable experiences where the customer has just started a trial, but that change is not yet reflected
        // on the page that has loaded for them.
        const trialEndTimeStamp = entitlement?.entitlementProfile?.lastKnownTrial?.trialEndTimeStamp;
        if (!trialEndTimeStamp || trialEndTimeStamp <= Date.now()) // Discard the result as it's in the past and we should assume outdated
        return undefined;
        return {
            trialEndTimeStamp: entitlement?.entitlementProfile?.lastKnownTrial?.trialEndTimeStamp,
            trialType: entitlement?.entitlementProfile?.lastKnownTrial?.trialType,
            trialTrigger: entitlement?.entitlementProfile?.lastKnownTrial?.trialTrigger,
            createdAt: entitlement?.entitlementProfile?.lastKnownTrial?.createdAt,
            offeringId: entitlement?.entitlementProfile?.lastKnownTrial?.offeringId
        };
    }, [
        entitlement?.entitlementProfile?.lastKnownTrial
    ]);
    const isEnrolledInUpgradeFreePoolTargetExperiment = (0, $eJOHy.useMemo)(()=>{
        if (product !== 'confluence' || edition !== 'standard' || // technically a tenant is enrolled if they are on 'free', but once they upgrade to standard we want to continue showing them the experience as there is a 'post-upgrade' UX
        isInTrial === false || invoiceableStatus !== 'INVOICEABLE' || !userRoles?.includes('SITE_ADMIN') || lastKnownTrial?.trialType !== 'MANUAL_TRIAL') return false;
        return (0, $l9sJA.isEnrolledInConfluenceUpgradeFreePoolTargetExperiment)();
    }, [
        product,
        edition,
        isInTrial,
        invoiceableStatus,
        lastKnownTrial,
        userRoles
    ]);
    const { startCheckingForAttemptToUpgrade: startCheckingForAttemptToUpgrade } = (0, $c8yMY.useOnAttemptToUpgrade)({
        product: product,
        edition: edition,
        showFlag: showFlag,
        // Fallback should never happen as we shouldn't call startCheckingForAttemptToUpgrade
        // when there is no entitlement
        entitlementId: entitlement?.id ?? 'entitlement-id',
        lastKnownTrial: lastKnownTrial,
        isInCollection: isInCollection
    });
    const hasDialogAutoOpened = (0, $eJOHy.useCallback)((dialogId)=>{
        if (dialogId === 'feature-onboarding-modal') {
            const state = data?.userPreferences?.onboardingState?.find((s)=>s.key === (0, $4t0UC.dialogIdToKey)(dialogId, product, edition));
            if (state?.value === 'true') return true;
            return localStorage.getItem((0, $4t0UC.dialogIdToKey)(dialogId, product, edition)) === 'true';
        }
        return true;
    }, [
        data,
        product,
        edition
    ]);
    const endUserRequestUpgradeLatestDate = (0, $eJOHy.useMemo)(()=>{
        const userPreference = data?.userPreferences?.onboardingState?.find((s)=>s.key === 'end-user-request-to-upgrade-latest-timestamp');
        return typeof Number(userPreference?.value) === 'number' ? new Date(Number(userPreference?.value)) : null;
    }, [
        data
    ]);
    const context = (0, $eJOHy.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            entitlementId: entitlementId,
            invoiceableStatus: invoiceableStatus,
            canAddPaymentDetails: canAddPaymentDetails,
            hasPaymentDetailsEntered: hasPaymentDetailsEntered,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            offeringKey: offeringKey,
            trialDaysLeft: trialDaysLeft,
            trialLengthDays: trialLengthDays,
            trialStartDate: trialStartDate,
            trialEndDate: trialEndDate,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            canDirectBuyUpgrade: canDirectBuyUpgrade,
            changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: directBuyChangeOfferingToStandardExperienceUrl,
            transactionAccountId: transactionAccountId,
            isInCollection: isInCollection,
            isEnterpriseCustomer: isEnterpriseCustomer,
            collectionEntitlementId: collectionEntitlementId,
            collectionType: collectionType,
            userRoles: userRoles,
            userEmail: userEmail,
            billingSourceSystem: billingSourceSystem,
            environment: environment,
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB,
            storageLimitInGB: storageLimitInGB,
            storageIsUnlimited: storageIsUnlimited,
            ...siteTraitsForContext,
            automationFreeLimitStatus: automationFreeLimitStatus,
            onOpenOnboardingMenu: onOpenOnboardingMenu,
            premiumFeatureHighlightToggle: premiumFeatureHighlightToggle,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen,
            PremiumWrapper: PremiumWrapper,
            startCheckingForAttemptToUpgrade: startCheckingForAttemptToUpgrade,
            lastKnownTrial: lastKnownTrial,
            getAction: getAction,
            showFlag: showFlag,
            hideFlag: hideFlag,
            hasDialogAutoOpened: hasDialogAutoOpened,
            endUserRequestUpgradeLatestDate: endUserRequestUpgradeLatestDate,
            isEnrolledInUpgradeFreePoolTargetExperiment: isEnrolledInUpgradeFreePoolTargetExperiment
        };
    }, [
        cloudId,
        product,
        edition,
        entitlementId,
        invoiceableStatus,
        canAddPaymentDetails,
        hasPaymentDetailsEntered,
        addPaymentDetailsExperienceUrl,
        offeringKey,
        trialDaysLeft,
        trialLengthDays,
        trialStartDate,
        trialEndDate,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        canDirectBuyUpgrade,
        changeOfferingToStandardExperienceUrl,
        directBuyChangeOfferingToStandardExperienceUrl,
        transactionAccountId,
        isInCollection,
        isEnterpriseCustomer,
        collectionEntitlementId,
        collectionType,
        userRoles,
        userEmail,
        billingSourceSystem,
        environment,
        licensedUsers,
        storageUsageInGB,
        storageLimitInGB,
        storageIsUnlimited,
        siteTraitsForContext,
        automationFreeLimitStatus,
        onOpenOnboardingMenu,
        premiumFeatureHighlightToggle,
        shouldAutoOpen,
        onAutoOpen,
        PremiumWrapper,
        startCheckingForAttemptToUpgrade,
        lastKnownTrial,
        getAction,
        showFlag,
        hideFlag,
        hasDialogAutoOpened,
        endUserRequestUpgradeLatestDate,
        isEnrolledInUpgradeFreePoolTargetExperiment
    ]);
    const experimentContextValue = (0, $eJOHy.useMemo)(()=>new (0, $a0oOn.ExperimentContextClass)(), []);
    if (!canRender) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
        name: "edition-awareness-waiting-on-product"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a0oOn.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLED4.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cY4TY.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "audience-and-timing",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $apOA4.Spotlights), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7i5PX.AudienceAndTiming), {})
                })
            })
        })
    });
}
function $e852f9961103ed96$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cY4TY.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($e852f9961103ed96$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}

});
parcelRegister("jFOoT", function(module, exports) {
$parcel$export(module.exports, "default", () => $8db3b7988af59fd1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b94a251b07845499cc3b77553f0e055>>
 * @relayHash 37a44d5b8e97081692a3e5c73d3fb0ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3254b6c21effaedb25d2102473440bf4c6bc0e6db3ad6aa4ac1814f531ea91d9
const $8db3b7988af59fd1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "onboardingStateKeys"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckBillingAdmin"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForDirectBuyChangeOffering"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForPaymentDetails"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageLimit"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageConfluence"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForUserEmail"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckUserPreferences"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeProfile"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v19 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "applicationKey"
        },
        v19 /*: any*/ 
    ], v21 = {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldCheckForStorageLimit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v20 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageAllowed"
                            },
                            {
                                "args": v20 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageIsUnlimited"
                            }
                        ]
                    },
                    {
                        "args": v20 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    }
                ]
            }
        ]
    }, v22 = {
        "condition": "shouldCheckForStorageUsageConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v19 /*: any*/ 
                ],
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    }
                ]
            }
        ]
    }, v23 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v24 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v26 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v27 = {
        "kind": "ScalarField",
        "name": "id"
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v29 = {
        "kind": "Literal",
        "name": "offeringName",
        "value": "Standard"
    }, v30 = [
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v32 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v33 = [
        v31 /*: any*/ ,
        v32 /*: any*/ 
    ], v34 = {
        "condition": "shouldCheckForDirectBuyChangeOffering",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "changeOfferingV2WithSkipTrial",
                        "args": [
                            v29 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "skipTrial",
                                "value": true
                            }
                        ],
                        "concreteType": "CcpChangeOfferingExperienceCapability",
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": v33 /*: any*/ ,
                        "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
                    }
                ],
                "type": "CcpEntitlementExperienceCapabilities"
            }
        ]
    }, v35 = {
        "condition": "shouldCheckForChargeQuantities",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "chargeElement",
                        "variableName": "chargeElement"
                    }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "status"
    }, v37 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v38 = {
        "kind": "ScalarField",
        "name": "startTimestamp"
    }, v39 = {
        "kind": "ScalarField",
        "name": "endTimestamp"
    }, v40 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v41 = {
        "kind": "ScalarField",
        "name": "lengthDays"
    }, v42 = {
        "kind": "ScalarField",
        "name": "key"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            v42 /*: any*/ 
        ],
        "type": "CcpOffering"
    }, v44 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v45 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v46 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v47 = {
        "condition": "shouldIncludeProfile",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
                "kind": "LinkedField",
                "name": "entitlementProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
                        "kind": "LinkedField",
                        "name": "lastKnownTrial",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "trialType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "trialTrigger"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "trialEndTimeStamp"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "createdAt"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "offeringId"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v48 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v49 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "email"
            }
        ],
        "type": "AtlassianAccountUser"
    }, v50 = {
        "condition": "shouldCheckUserPreferences",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "UserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "key",
                                "variableName": "onboardingStateKeys"
                            }
                        ],
                        "concreteType": "UserOnboardingState",
                        "kind": "LinkedField",
                        "name": "onboardingState",
                        "plural": true,
                        "selections": [
                            v42 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v51 = [
        v27 /*: any*/ 
    ], v52 = {
        "kind": "InlineFragment",
        "selections": v51 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        {
                                            "args": v26 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v30 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": v33 /*: any*/ ,
                                                            "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v32 /*: any*/ ,
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v41 /*: any*/ 
                                                                    ]
                                                                },
                                                                v43 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v44 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForPaymentDetails",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v45 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v46 /*: any*/ ,
                                                        v25 /*: any*/ 
                                                    ]
                                                },
                                                v47 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v48 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v49 /*: any*/ 
                            ]
                        }
                    ]
                },
                v50 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v14 /*: any*/ ,
                v18 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v12 /*: any*/ ,
                v0 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v17 /*: any*/ ,
                v16 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "args": v26 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        {
                                                            "args": v30 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v32 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                },
                                                v35 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ ,
                                                                                v40 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v51 /*: any*/ ,
                                                                                    "type": "CcpInvoiceGroup"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v51 /*: any*/ ,
                                                                    "type": "CcpSubscription"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v41 /*: any*/ 
                                                                    ]
                                                                },
                                                                v43 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForPaymentDetails",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v25 /*: any*/ 
                                                    ]
                                                },
                                                v47 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v48 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                v49 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                v50 /*: any*/ 
            ]
        },
        "params": {
            "id": "3254b6c21effaedb25d2102473440bf4c6bc0e6db3ad6aa4ac1814f531ea91d9",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8db3b7988af59fd1$var$node.hash = "654265ee458b901e3e512dd4709aae5b";
var $8db3b7988af59fd1$export$2e2bcd8739ae039 = $8db3b7988af59fd1$var$node;

});

parcelRegister("hSmMC", function(module, exports) {
$parcel$export(module.exports, "bytesToGigabytes", () => $e5b4288066af37f9$export$6f25243957146989);
/**
 * Most storage measurements are in gigabytes
 */ function $e5b4288066af37f9$export$6f25243957146989(bytes) {
    return bytes / 1000000000;
}

});

parcelRegister("ghs9K", function(module, exports) {
$parcel$export(module.exports, "AUTOMATION_USAGE_FREE_LIMIT", () => $d280f08c342c3120$export$7296becdbc8d7810);
$parcel$export(module.exports, "AUTOMATION_USAGE_STANDARD_LIMIT", () => $d280f08c342c3120$export$5a0f9f37fb711f37);
$parcel$export(module.exports, "getAutomationFreeLimitStatus", () => $d280f08c342c3120$export$5f347675b43b787f);
$parcel$export(module.exports, "getProjectedAutomationUsage", () => $d280f08c342c3120$export$5c4f4d557a0ee678);

var $eS5ln = parcelRequire("eS5ln");

var $bDAx9 = parcelRequire("bDAx9");
const $d280f08c342c3120$export$7296becdbc8d7810 = 100;
const $d280f08c342c3120$export$5a0f9f37fb711f37 = 1700;
const $d280f08c342c3120$export$b3d11e30afa46646 = 0.8 * $d280f08c342c3120$export$7296becdbc8d7810;
const $d280f08c342c3120$export$5f347675b43b787f = ({ edition: edition, product: product, isInTrial: isInTrial, automationUsage: automationUsage, lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate = null })=>{
    if ((edition === 'free' || edition === 'standard' && isInTrial) && product === 'jira') {
        if ($d280f08c342c3120$export$5ff23a30e22aeec2(automationUsage, lastAutomationFreeLimitBreachDate)) return 'BREACHED';
        if ($d280f08c342c3120$var$isAutomationProjectedToBreach(automationUsage, edition)) return 'PROJECTED_TO_BREACH';
        if ($d280f08c342c3120$var$hasBreachedAutomationUsagePreviousMonth(lastAutomationFreeLimitBreachDate)) return 'BREACHED_PREVIOUS_MONTH';
    }
    return null;
};
const $d280f08c342c3120$export$5c4f4d557a0ee678 = (automationUsage)=>{
    const today = new Date();
    const dayOfMonth = today.getDate();
    return automationUsage / dayOfMonth * (0, $eS5ln.default)(today);
};
const $d280f08c342c3120$var$isAutomationProjectedToBreach = (automationUsage, edition)=>{
    // Already breached the limit, no need to project
    if (automationUsage >= $d280f08c342c3120$export$7296becdbc8d7810) return false;
    const projectedUsage = $d280f08c342c3120$export$5c4f4d557a0ee678(automationUsage);
    if (edition === 'free') return projectedUsage >= $d280f08c342c3120$export$7296becdbc8d7810 && automationUsage >= $d280f08c342c3120$export$b3d11e30afa46646;
    return projectedUsage >= $d280f08c342c3120$export$7296becdbc8d7810;
};
const $d280f08c342c3120$export$5ff23a30e22aeec2 = (automationUsage, lastAutomationFreeLimitBreachDate)=>{
    return lastAutomationFreeLimitBreachDate && automationUsage >= $d280f08c342c3120$export$7296becdbc8d7810 && (0, $bDAx9.default)(new Date(), lastAutomationFreeLimitBreachDate);
};
const $d280f08c342c3120$var$hasBreachedAutomationUsagePreviousMonth = (lastAutomationFreeLimitBreachDate)=>{
    if (!lastAutomationFreeLimitBreachDate) return false;
    const now = new Date();
    // Date constructor handles overflow on the last month correctly
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return (0, $bDAx9.default)(lastAutomationFreeLimitBreachDate, lastMonth);
};

});

parcelRegister("3S2RH", function(module, exports) {
$parcel$export(module.exports, "getProductCollection", () => $9eb7b00fc71e33b1$export$6cf5f13af3dcd5bf);

var $eGOwo = parcelRequire("eGOwo");
const $9eb7b00fc71e33b1$export$6cf5f13af3dcd5bf = (product)=>{
    switch(product){
        case 'jira-service-management':
            return {
                collectionType: 'Service Collection',
                isEnabled: (0, $eGOwo.fg)('servco-xflow-ga')
            };
        case 'jira':
        case 'confluence':
            return {
                collectionType: 'Teamwork Collection',
                isEnabled: true
            };
        default:
            return undefined;
    }
};

});

parcelRegister("jZZcf", function(module, exports) {
$parcel$export(module.exports, "getQueryConfig", () => $3cdb5500fc33207e$export$bac5bb66ae1b635d);

var $eGOwo = parcelRequire("eGOwo");

var $kaE00 = parcelRequire("kaE00");

var $9evzz = parcelRequire("9evzz");

var $h1104 = parcelRequire("h1104");

var $4t0UC = parcelRequire("4t0UC");
function $3cdb5500fc33207e$export$bac5bb66ae1b635d(product, edition, cloudId, accountId) {
    const isStandardTrialsUserAndStorageLimitBreakersEnabledJira = product === 'jira' && edition === 'standard' && (0, $eGOwo.fg)('jira_edition_awareness_standard_trials_gate');
    const isStandardTrialsUserAndStorageLimitBreakersEnabledConnie = product === 'confluence' && edition === 'standard' && (0, $eGOwo.fg)('connie_edition_awareness_standard_trials_gate');
    const isStorageHardLimitEnabled = product === 'jira' && edition === 'free' && !!(0, $eGOwo.fg)('jira-storage-hard-limit-gate'); // Workaround to ensure fg is not undefined to avoid errors in unit tests - https://hello.atlassian.net/wiki/x/Uy4HSgE
    const isSpecialOfferSixtyEnabled = product === 'jira' && edition === 'free' && !!(0, $eGOwo.fg)('special_offer_60_days_jira_standard_kill_switch');
    const isStandardTrialsUserAndStorageLimitBreakersEnabled = isStandardTrialsUserAndStorageLimitBreakersEnabledJira || isStandardTrialsUserAndStorageLimitBreakersEnabledConnie;
    const isBillingAdminEnabled = product === 'jira' || product === 'confluence';
    const shouldCheckForPaymentDetails = edition === 'free' && (product === 'jira-service-management' || product === 'jira-product-discovery') && (0, $eGOwo.fg)('jsm_jpd_free_to_standard_ea_update_gate') || edition === 'free' && product === 'confluence' && ((0, $eGOwo.fg)('connie_end_user_request_ea_vc90_check') || (0, $eGOwo.fg)('connie_end_user_request_kill_switch'));
    const shouldIncludeProfile = product === 'confluence' && (0, $eGOwo.fg)('ea_gups_confluence');
    const shouldCheckUserPreferences = product === 'confluence';
    const onboardingStateKeys = product === 'confluence' ? [
        (0, $4t0UC.dialogIdToKey)('feature-onboarding-modal', product, edition),
        'end-user-request-to-upgrade-latest-date'
    ] : [
        (0, $4t0UC.dialogIdToKey)('feature-onboarding-modal', product, edition)
    ];
    return {
        shouldSkip: product === 'jira-product-discovery' && (0, $eGOwo.fg)('jpd_disable_edition_awareness') === true,
        shouldCheckForDirectBuyChangeOffering: isStorageHardLimitEnabled || isSpecialOfferSixtyEnabled,
        shouldCheckForTrial: edition === 'premium' || edition === 'standard',
        cloudId: cloudId,
        productKey: (0, $h1104.getHamsKey)(product),
        shouldCheckForChargeQuantities: edition === 'free' || isStandardTrialsUserAndStorageLimitBreakersEnabled,
        // The entitlement filter ensures that we apply the `inTrialOrPreDunning` only when an entitlement is
        // on a non free edition. The filter is based on the trial end timestamp inside of TCS, this means that
        // if a customer downgrades their product to free while on a trial, then they will only show up
        // if inTrialOrPreDunning is set to true as the filter assumes they are still on trial.
        entitlementFilter: edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null,
        chargeElement: (0, $kaE00.getChargeElementKey)(product),
        shouldCheckBillingAdmin: isBillingAdminEnabled,
        shouldCheckForStorageUsageJira: isStandardTrialsUserAndStorageLimitBreakersEnabledJira || isStorageHardLimitEnabled,
        applicationKey: (0, $9evzz.getJiraApplicationKey)(product) ?? 'JIRA_SOFTWARE',
        shouldCheckForStorageUsageConfluence: isStandardTrialsUserAndStorageLimitBreakersEnabledConnie,
        // AccountID is a required value, but the condition will ensure it is not used if undefined/null
        accountId: accountId ?? '',
        shouldCheckForUserEmail: !!accountId && product === 'jira' && edition === 'standard',
        shouldCheckForStorageLimit: isStorageHardLimitEnabled,
        shouldCheckForPaymentDetails: shouldCheckForPaymentDetails,
        shouldIncludeProfile: shouldIncludeProfile,
        shouldCheckUserPreferences: shouldCheckUserPreferences,
        onboardingStateKeys: onboardingStateKeys
    };
}

});
parcelRegister("kaE00", function(module, exports) {
$parcel$export(module.exports, "getChargeElementKey", () => $55c0980c4e36acb0$export$58e4e89574623b4);
const $55c0980c4e36acb0$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent'
};
const $55c0980c4e36acb0$export$58e4e89574623b4 = (product)=>{
    return $55c0980c4e36acb0$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};

});

parcelRegister("9evzz", function(module, exports) {
$parcel$export(module.exports, "getJiraApplicationKey", () => $915f07fcc82990aa$export$2fd6994252e4887f);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $915f07fcc82990aa$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK'
};
const $915f07fcc82990aa$export$2fd6994252e4887f = (product)=>{
    return $915f07fcc82990aa$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};

});

parcelRegister("4t0UC", function(module, exports) {
$parcel$export(module.exports, "dialogIdToKey", () => $a8d4c55f6351ddba$export$423571b0238e9b3e);
$parcel$export(module.exports, "useMarkDialogAsSeen", () => $a8d4c55f6351ddba$export$64bdfecd0a02bd78);

var $31fSo = parcelRequire("31fSo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
function $a8d4c55f6351ddba$export$423571b0238e9b3e(dialogId, product, edition) {
    return `edition-awareness:${dialogId}:${product}:${edition}:has-auto-opened`;
}
function $a8d4c55f6351ddba$export$64bdfecd0a02bd78() {
    const [commit] = (0, $j4oe4.useMutation)((0, $31fSo.default));
    return (0, $eJOHy.useCallback)((dialogId, product, edition)=>{
        commit({
            variables: {
                key: $a8d4c55f6351ddba$export$423571b0238e9b3e(dialogId, product, edition),
                value: 'true'
            }
        });
        localStorage.setItem($a8d4c55f6351ddba$export$423571b0238e9b3e(dialogId, product, edition), 'true');
    }, [
        commit
    ]);
}

});
parcelRegister("31fSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $28abbdb45f5228be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e6c2ddb4cdab642478fec1a9416c6ef>>
 * @relayHash f6314aa271413378cc6a907956a8f3c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d89be6ac69ec20e87d353edcd9c7b4d2e8e5fc3a46a9555ba2d5ceb8bf352a12
const $28abbdb45f5228be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "value"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "key",
                                    "variableName": "key"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "value",
                                    "variableName": "value"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "states.0"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMarkDialogAsSeenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMarkDialogAsSeenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d89be6ac69ec20e87d353edcd9c7b4d2e8e5fc3a46a9555ba2d5ceb8bf352a12",
            "metadata": {},
            "name": "useMarkDialogAsSeenMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$28abbdb45f5228be$var$node.hash = "3dadf7831715f454e511403477edc50d";
var $28abbdb45f5228be$export$2e2bcd8739ae039 = $28abbdb45f5228be$var$node;

});



parcelRegister("2UnLC", function(module, exports) {
$parcel$export(module.exports, "getSiteTraitValues", () => $5e5869e59765f59d$export$2a16c85f3c5d2302);
const $5e5869e59765f59d$var$AUTO_UPGRADE_PRODUCT_TRAIT = {
    jira: 'jsw_ccp_auto_upgraded_trialing_and_predunning_sites',
    'jira-service-management': 'jsm_ccp_auto_upgraded_trialing_and_predunning_sites',
    'jira-product-discovery': 'jpd_ccp_auto_upgraded_trialing_and_predunning_sites',
    confluence: 'confluence_ccp_auto_upgraded_trialing_and_predunning_sites'
};
const $5e5869e59765f59d$export$2a16c85f3c5d2302 = (traits, product)=>{
    if (traits.length === 0) return {
        automationUsage: 0,
        lastAutomationFreeLimitBreachDate: null,
        isAutoUpgraded: false
    };
    const automationUsageTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_current_usage');
    const lastAutomationFreeLimitBreachDateTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_usage_latest_breach_date');
    const isAutoUpgradedTrait = traits.find((trait)=>trait.name === $5e5869e59765f59d$var$AUTO_UPGRADE_PRODUCT_TRAIT[product]);
    const automationUsage = automationUsageTrait && automationUsageTrait.value !== undefined && !isNaN(Number(automationUsageTrait.value)) ? Number(automationUsageTrait.value) : 0;
    const lastAutomationFreeLimitBreachDate = lastAutomationFreeLimitBreachDateTrait && typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' && !isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value)) ? new Date(lastAutomationFreeLimitBreachDateTrait.value) : null;
    const isAutoUpgraded = Boolean(isAutoUpgradedTrait && typeof isAutoUpgradedTrait.value === 'boolean' && isAutoUpgradedTrait.value);
    return {
        automationUsage: automationUsage,
        lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate,
        isAutoUpgraded: isAutoUpgraded
    };
};

});

parcelRegister("l9sJA", function(module, exports) {
$parcel$export(module.exports, "isEnrolledInConfluenceUpgradeFreePoolTargetExperiment", () => $b71373bf2943c17d$export$f31114036914eca1);

var $eGOwo = parcelRequire("eGOwo");
function $b71373bf2943c17d$var$hasConfluenceUpgradeFreePoolTargetExperimentCohort() {
    // We don't have the AAID of the user, so we need to look through all the local storage keys
    // An example key would be: `localStorage/atlassian.762020:646a2652-9f79-4152-9368-d6e5g1dbf8a3.frontend.atl-UPFTConfluenceStandardOfferCohort`
    for(let i = 0; i < localStorage.length; i++){
        const key = localStorage.key(i);
        if (key && key.startsWith('localStorage/atlassian.') && key.endsWith('.atl-UPFTConfluenceStandardOfferCohort') && localStorage.getItem(key) !== 'not-enrolled') return true;
    }
    return false;
}
function $b71373bf2943c17d$export$f31114036914eca1() {
    if (!(0, $eGOwo.fg)('twcg-206_confluence_upgrade_permanent_free_fg')) return false;
    return $b71373bf2943c17d$var$hasConfluenceUpgradeFreePoolTargetExperimentCohort();
}

});

parcelRegister("jb8fm", function(module, exports) {
$parcel$export(module.exports, "isProductOneOf", () => $3035ace049a06dcd$export$fda637a5d76f2dc6);
function $3035ace049a06dcd$export$fda637a5d76f2dc6(product, possibleMatches) {
    return possibleMatches.includes(product);
}

});

parcelRegister("c8yMY", function(module, exports) {
$parcel$export(module.exports, "useOnAttemptToUpgrade", () => $d39f8599db745614$export$6ce8b9d5e852c5a9);

var $fr8SS = parcelRequire("fr8SS");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $j4oe4 = parcelRequire("j4oe4");

var $59rsN = parcelRequire("59rsN");

var $kOgfc = parcelRequire("kOgfc");

var $hOOq9 = parcelRequire("hOOq9");

var $9THm6 = parcelRequire("9THm6");

var $jb8fm = parcelRequire("jb8fm");

var $h1104 = parcelRequire("h1104");
const $d39f8599db745614$export$da9ab7b2fd5998e8 = 48;
const $d39f8599db745614$var$TIME_BETWEEN_ATTEMPTS_MS = 5000; // 5 seconds
async function $d39f8599db745614$var$getHasJiraUpgraded(product) {
    // TODO: Add the query for GUPs to find out if the customer is on a manual trial
    const response = await fetch('/rest/internal/latest/meta/edition');
    if (!response.ok) throw new Error(`Fetching upgrade status failed with ${response.status}`);
    const data = await response.json();
    const key = (0, $h1104.getHamsKey)(product);
    const productHasUpgraded = data[key] === 'standard' || data[key] === 'premium';
    return {
        productHasUpgraded: productHasUpgraded,
        customerHasUpgraded: false
    };
}
const $d39f8599db745614$var$editionMap = {
    STANDARD: 'standard',
    PREMIUM: 'premium'
};
const $d39f8599db745614$var$offeringKeyToEditionMap = {
    '7547cfd6-a804-4e42-8bed-e656d49ea09e': 'free',
    '2eda1119-fab4-4699-ab37-ff8f12052cde': 'standard',
    '06ef245c-5fa3-473b-8822-5e6fe072ae4b': 'premium'
};
async function $d39f8599db745614$var$getConfluenceTrialAndEditionInformation(environment, entitlementId) {
    const response = await (0, $j4oe4.fetchQuery)(environment, (0, $fr8SS.default), {
        entitlementId: entitlementId
    }).toPromise();
    return {
        confluenceEdition: response?.confluence_tenantContext?.editions?.confluence,
        lastKnownTrial: response?.growthUnifiedProfile_getEntitlementProfile?.lastKnownTrial
    };
}
async function $d39f8599db745614$var$getHasConfluenceUpgraded({ environment: environment, entitlementId: entitlementId }) {
    const { confluenceEdition: confluenceEdition, lastKnownTrial: lastKnownTrial } = await $d39f8599db745614$var$getConfluenceTrialAndEditionInformation(environment, entitlementId);
    const upgradedEdition = confluenceEdition ? $d39f8599db745614$var$editionMap?.[confluenceEdition] : undefined;
    const gupsEdition = lastKnownTrial?.offeringId ? $d39f8599db745614$var$offeringKeyToEditionMap[lastKnownTrial?.offeringId] : undefined;
    const customerHasUpgraded = $d39f8599db745614$var$hasTrialManuallyStarted(lastKnownTrial);
    // Ten minutes ago in milliseconds since epoch
    const tenMinutesAgo = Date.now() - 600000;
    // if GUPS entitlement profile is older than 10 minutes, then return false as we cannot infer that they have upgraded
    if (!lastKnownTrial?.createdAt || lastKnownTrial?.createdAt < tenMinutesAgo) return {
        productHasUpgraded: false,
        customerHasUpgraded: customerHasUpgraded,
        upgradedEdition: upgradedEdition
    };
    return {
        productHasUpgraded: Boolean(upgradedEdition && gupsEdition && upgradedEdition === gupsEdition),
        customerHasUpgraded: customerHasUpgraded,
        upgradedEdition: upgradedEdition
    };
}
function $d39f8599db745614$var$hasTrialManuallyStarted(lastTrialInfo) {
    const trialEndTimeStamp = lastTrialInfo?.trialEndTimeStamp;
    const trialType = lastTrialInfo?.trialType;
    return Boolean(trialEndTimeStamp && trialEndTimeStamp >= Date.now() && trialType === 'MANUAL_TRIAL');
}
async function $d39f8599db745614$var$getHasProductUpgraded({ product: product, environment: environment, entitlementId: entitlementId }) {
    if (product === 'confluence') return $d39f8599db745614$var$getHasConfluenceUpgraded({
        environment: environment,
        entitlementId: entitlementId
    });
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'jira-product-discovery',
        'jira-service-management'
    ])) return $d39f8599db745614$var$getHasJiraUpgraded(product);
    throw new Error(`Unsupported product ${product}`);
}
async function $d39f8599db745614$var$linearRetry(fn, sendOperationalEvent) {
    const sendAnalytics = (action, additionalAttributes = {})=>{
        sendOperationalEvent({
            action: action,
            actionSubject: 'pollForUpgrade',
            actionSubjectId: 'editionAwareness',
            attributes: {
                ...additionalAttributes
            }
        });
    };
    const waitForInterval = ()=>new Promise((resolve)=>setTimeout(resolve, $d39f8599db745614$var$TIME_BETWEEN_ATTEMPTS_MS));
    sendAnalytics('started');
    for(let attempts = 0; attempts < $d39f8599db745614$export$da9ab7b2fd5998e8; attempts++)try {
        const result = await fn();
        if (result) {
            sendAnalytics('success', {
                attempt: attempts + 1
            });
            return true;
        }
        if (attempts < $d39f8599db745614$export$da9ab7b2fd5998e8 - 1) await waitForInterval();
    } catch (error) {
        sendAnalytics('error', {
            attempt: attempts + 1,
            error: error instanceof Error ? error.message : 'Unknown error'
        });
        if (attempts < $d39f8599db745614$export$da9ab7b2fd5998e8 - 1) await waitForInterval();
    }
    sendAnalytics('timeout', {
        attempts: $d39f8599db745614$export$da9ab7b2fd5998e8
    });
    return false;
}
function $d39f8599db745614$export$6ce8b9d5e852c5a9({ product: product, edition: edition, isInCollection: isInCollection, showFlag: showFlag, hideFlag: hideFlag, entitlementId: entitlementId, lastKnownTrial: lastKnownTrial }) {
    const sendOperationalEvent = (0, $kOgfc.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    const sendUIEvent = (0, $hOOq9.useUIAnalytics)({
        product: product,
        edition: edition
    });
    const intl = (0, $lRq8t.default)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const showUpgradeInProgressFlag = (0, $eJOHy.useCallback)(function() {
        if (product !== 'confluence' || isInCollection) // Currently we're only targeting confluence upgrades
        return;
        const cohort = (0, $59rsN.default).getExperimentValue('manual_trial_w_pde_onboarding', 'cohort', 'not-enrolled');
        sendUIEvent({
            action: 'show',
            actionSubject: 'editionAwarenessUpgradePolling',
            actionSubjectId: 'upgradeInProgressFlag',
            attributes: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (cohort === 'variation') showFlag?.({
            id: '@atlassian/edition-awareness.upgrade-in-progress-flag',
            title: intl.formatMessage({
                id: '@atlassian/edition-awareness.upgrade-in-progress-flag.title',
                defaultMessage: 'Upgrading your plan',
                description: 'Flag title for informing the customer they are being upgraded'
            }),
            description: intl.formatMessage({
                id: '@atlassian/edition-awareness.upgrade-in-progress-flag.description',
                defaultMessage: "This may take a couple of minutes. We\u2019ll let you know when it\u2019s finished.",
                description: 'Upgrade in progress message'
            })
        });
    }, [
        product,
        sendUIEvent,
        showFlag,
        intl,
        isInCollection
    ]);
    const showUpgradedFlag = (0, $eJOHy.useCallback)(function(edition) {
        if (product !== 'confluence' || isInCollection) // Currently we're only targeting confluence upgrades
        return;
        const cohort = (0, $59rsN.default).getExperimentValue('manual_trial_w_pde_onboarding', 'cohort', 'not-enrolled');
        sendUIEvent({
            action: 'show',
            actionSubject: 'editionAwarenessUpgradePolling',
            actionSubjectId: 'upgradeCompleteFlag',
            attributes: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (cohort === 'variation') {
            hideFlag?.('@atlassian/edition-awareness.upgrade-in-progress-flag');
            showFlag?.({
                id: '@atlassian/edition-awareness.upgrade-complete-flag',
                title: intl.formatMessage({
                    id: '@atlassian/edition-awareness.upgrade-complete-flag.title',
                    defaultMessage: 'Refresh to start using new features',
                    description: 'Flag title for informing the customer they need to refresh the page to be on the new edition'
                }),
                description: intl.formatMessage({
                    id: '@atlassian/edition-awareness.upgrade-complete-flag.description2',
                    defaultMessage: 'Your upgrade to {product, select, confluence {Confluence} jira {Jira} jpd {Jira Product Discovery} jsm {Jira Service Management} other {}} {edition, select, standard {Standard} premium {Premium} other {}} is complete.',
                    description: 'Upgrade complete message'
                }, {
                    edition: edition,
                    product: (0, $9THm6.getProductForTranslation)(product)
                }),
                actions: [
                    {
                        onClick: ()=>{
                            window.location.reload();
                        },
                        content: intl.formatMessage({
                            id: '@atlassian/edition-awareness.upgrade-complete-flag.action',
                            defaultMessage: 'Refresh',
                            description: 'Call to action to refresh the page'
                        })
                    }
                ]
            });
        }
    }, [
        product,
        sendUIEvent,
        showFlag,
        hideFlag,
        intl,
        isInCollection
    ]);
    const hasRunOnPageLoad = (0, $eJOHy.useRef)(false);
    // Five minutes ago in milliseconds since epoch
    const fiveMinutesAgo = Date.now() - 300000;
    const lastKnowTrialCreatedAt = lastKnownTrial?.createdAt || 0;
    const gupsEdition = lastKnownTrial?.offeringId ? $d39f8599db745614$var$offeringKeyToEditionMap[lastKnownTrial?.offeringId] : undefined;
    // check if the FG is on and the edition is different from the edition in GUPS profile and
    // that the GUPS profile was created less than 5 minutes ago and it says that the trial has manually started
    // then we need to poll for the latest edition from TCS
    const shouldCheckOnPageLoad = !isInCollection && gupsEdition && edition !== gupsEdition && lastKnowTrialCreatedAt > fiveMinutesAgo && $d39f8599db745614$var$hasTrialManuallyStarted(lastKnownTrial);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldCheckOnPageLoad) // check that GUPS is updated
        $d39f8599db745614$var$linearRetry(async ()=>{
            const { productHasUpgraded: productHasUpgraded, upgradedEdition: upgradedEdition } = await $d39f8599db745614$var$getHasProductUpgraded({
                product: product,
                environment: environment,
                entitlementId: entitlementId
            });
            if (productHasUpgraded) showUpgradedFlag(upgradedEdition);
            return productHasUpgraded;
        }, sendOperationalEvent);
        hasRunOnPageLoad.current = true;
    }, [
        hasRunOnPageLoad,
        shouldCheckOnPageLoad,
        entitlementId,
        environment,
        product,
        sendOperationalEvent,
        showUpgradedFlag
    ]);
    const startCheckingForAttemptToUpgrade = (0, $eJOHy.useCallback)(async ()=>{
        let hasSeenInProgressFlag = false;
        return $d39f8599db745614$var$linearRetry(async ()=>{
            const { productHasUpgraded: productHasUpgraded, customerHasUpgraded: customerHasUpgraded, upgradedEdition: upgradedEdition } = await $d39f8599db745614$var$getHasProductUpgraded({
                product: product,
                environment: environment,
                entitlementId: entitlementId
            });
            if (!productHasUpgraded && customerHasUpgraded && !hasSeenInProgressFlag) {
                // Customer has upgraded, but product does not reflect the change
                hasSeenInProgressFlag = true;
                showUpgradeInProgressFlag();
                return false;
            }
            if (productHasUpgraded) showUpgradedFlag(upgradedEdition);
            return productHasUpgraded;
        }, sendOperationalEvent);
    }, [
        environment,
        product,
        sendOperationalEvent,
        entitlementId,
        showUpgradedFlag,
        showUpgradeInProgressFlag
    ]);
    // At a later stage there will be a useEffect which checks if the customer has started a manual trial but is not on
    // a trial yet (aka in product doesn't reflect the action they performed). This polling will show a flag too
    return {
        startCheckingForAttemptToUpgrade: startCheckingForAttemptToUpgrade
    };
}

});
parcelRegister("fr8SS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2111511553e29597$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b75b92ce536fd9e7fcd698c92577a59d>>
 * @relayHash f3e4eb6cbc15671c025448a6b8f3386a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 097d25120462db2fc5b530f09b21ab8a20b6e4505b7830695f84979384461086
const $2111511553e29597$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitlementId"
        }
    ], v1 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entitlementId",
                    "variableName": "entitlementId"
                }
            ],
            "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_getEntitlementProfile",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
                    "kind": "LinkedField",
                    "name": "lastKnownTrial",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "trialEndTimeStamp"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "offeringId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "createdAt"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useOnAttemptToUpgradeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useOnAttemptToUpgradeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "097d25120462db2fc5b530f09b21ab8a20b6e4505b7830695f84979384461086",
            "metadata": {},
            "name": "useOnAttemptToUpgradeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2111511553e29597$var$node.hash = "534e6ffeac5ad7e96470d5b9f9681151";
var $2111511553e29597$export$2e2bcd8739ae039 = $2111511553e29597$var$node;

});

parcelRegister("kOgfc", function(module, exports) {
$parcel$export(module.exports, "useOperationalAnalytics", () => $7dbb33b54634ed12$export$18e9461e904f638a);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $6qssf = parcelRequire("6qssf");
function $7dbb33b54634ed12$export$18e9461e904f638a({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...(0, $6qssf.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $6qssf.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $6qssf.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}

});

parcelRegister("hOOq9", function(module, exports) {
$parcel$export(module.exports, "useUIAnalytics", () => $38ad290b0d74b387$export$b8462e385dedb052);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $6qssf = parcelRequire("6qssf");
function $38ad290b0d74b387$export$b8462e385dedb052({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'ui',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...(0, $6qssf.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $6qssf.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $6qssf.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}

});

parcelRegister("9THm6", function(module, exports) {
$parcel$export(module.exports, "getProductForTranslation", () => $eb8c6feb97bd401e$export$fd45d905638d9909);
const $eb8c6feb97bd401e$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $eb8c6feb97bd401e$export$fd45d905638d9909(product) {
    return $eb8c6feb97bd401e$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});


parcelRegister("7i5PX", function(module, exports) {
$parcel$export(module.exports, "IneligibleAnalytics", () => $ac59c0aeb29fd98e$export$132e847a0a2f0eca);
$parcel$export(module.exports, "AudienceAndTiming", () => $ac59c0aeb29fd98e$export$d288e6ad7a0cf9f8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $6qssf = parcelRequire("6qssf");

var $aLED4 = parcelRequire("aLED4");

var $1zLBK = parcelRequire("1zLBK");

var $2Vyvh = parcelRequire("2Vyvh");

var $jb8fm = parcelRequire("jb8fm");

var $ktqhG = parcelRequire("ktqhG");
/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness
 */ function $ac59c0aeb29fd98e$var$useTrackAudienceAndTiming(isEligible) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const hasSent = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible
    ]);
}
/**
 * Tracks when a user should see the edition awareness experience
 */ function $ac59c0aeb29fd98e$var$Analytics({ children: children }) {
    $ac59c0aeb29fd98e$var$useTrackAudienceAndTiming(true);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
}
function $ac59c0aeb29fd98e$export$132e847a0a2f0eca() {
    $ac59c0aeb29fd98e$var$useTrackAudienceAndTiming(false);
    return null;
}
function $ac59c0aeb29fd98e$export$d288e6ad7a0cf9f8() {
    const context = (0, $aLED4.useEditionAwareness)();
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection, isEnterpriseCustomer: isEnterpriseCustomer, canUpgrade: canUpgrade, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    const isInTrialOrPredunning = isInTrial || isInPredunning;
    const shouldSeeManualFeatureOnboarding = (0, $2Vyvh.isEligibleForManualFeatureOnboarding)(context);
    const shouldSeeButton = (0, $eJOHy.useMemo)(()=>{
        if (isEnterpriseCustomer && (0, $eGOwo.fg)('enterprise_disable_edition_awareness')) // EA should not be shown to Enterprise customers as per: https://atlassiansupport.atlassian.net/browse/CES-106245
        return false;
        /* Avoid complex logic for collection
		// Collection starts with new stream of logic to see if we should show the button
		// We should avoid products-specific complex logic for collection
		//
		// Collection uses different logic for edition awareness
		// As required by Team EU. EA is shown for Teamwork Collection when user has PDE.
		// */ if (isInCollection) {
            if ((0, $jb8fm.isProductOneOf)(product, [
                'jira',
                'confluence'
            ])) // Teamwork Collection EA is shown to all customers in collection
            // by identifying product is Jira, Confluence or Loon to identify Teamwork Collection
            // This is temporary solution to identify Teamwork Collection
            return true;
        //intentional leave this no default return to avoid block other collection handler
        }
        if (product === 'jira-product-discovery' && (0, $eGOwo.fg)('jpd_disable_edition_awareness')) return false;
        if (edition === 'free' && (canUpgrade || canDirectBuyUpgrade)) return true;
        if ((0, $eGOwo.fg)('connie_end_user_request_ea_vc90_check') || (0, $eGOwo.fg)('connie_end_user_request_kill_switch')) {
            if ((0, $1zLBK.isEligibleForConfluenceEndUserRequestExperiment)(context)) return true;
        }
        if (edition === 'standard' && isInTrialOrPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) return true;
        if (edition === 'premium' && (0, $jb8fm.isProductOneOf)(product, [
            'jira',
            'jira-service-management'
        ]) && isInTrialOrPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) return true;
        if (shouldSeeManualFeatureOnboarding) // As part of the manual trial onboarding experiment we are showing the button to customers on manual trial with payment details
        return true;
        if (product === 'confluence' && edition === 'premium' && isInTrialOrPredunning) // Confluence will always show the button for premium while a customer is in a trial or in predunning
        // If the customer can add payment, that is checked as part of rendering the dialog (as the dialog
        // will still show to the customer if they can not add payment details)
        return true;
        return false;
    }, [
        isEnterpriseCustomer,
        isInCollection,
        product,
        edition,
        canUpgrade,
        canDirectBuyUpgrade,
        isInTrialOrPredunning,
        invoiceableStatus,
        canAddPaymentDetails,
        shouldSeeManualFeatureOnboarding,
        context
    ]);
    if (!shouldSeeButton) {
        if (invoiceableStatus === 'INVOICEABLE' && isInTrial && (0, $eGOwo.fg)('ea_expand_to_trialers_with_pde_vc90')) // Like below, we're firing the analytics event, but also including a span to test the VC90 impact
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    "data-testid": "ea-expanded-audience"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($ac59c0aeb29fd98e$export$132e847a0a2f0eca, {})
            ]
        });
        if (edition === 'free' || isInTrialOrPredunning) // We're only firing the ineligible analytics when we could've shown the button, not all instances
        // this is to ensure we don't send the event on every page load
        return /*#__PURE__*/ (0, $gt9Am.jsx)($ac59c0aeb29fd98e$export$132e847a0a2f0eca, {});
        return null;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ac59c0aeb29fd98e$var$Analytics, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ktqhG.ActionsAndContent), {})
    });
}

});
parcelRegister("1zLBK", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluenceEndUserRequestExperiment", () => $71a8feaad9b2dfa9$export$948aef0b9bedfdf5);

var $eGOwo = parcelRequire("eGOwo");
function $71a8feaad9b2dfa9$export$948aef0b9bedfdf5(context) {
    const { product: product, edition: edition, hasPaymentDetailsEntered: hasPaymentDetailsEntered, isInCollection: isInCollection, canUpgrade: canUpgrade } = context;
    return Boolean(!isInCollection && product === 'confluence' && edition === 'free' && hasPaymentDetailsEntered === true && canUpgrade === false && ((0, $eGOwo.fg)('connie_end_user_request_ea_vc90_check') || (0, $eGOwo.fg)('connie_end_user_request_kill_switch')));
}

});

parcelRegister("2Vyvh", function(module, exports) {
$parcel$export(module.exports, "isEligibleForManualFeatureOnboarding", () => $87cc633cbd735367$export$e8dada0cc6b0ffe9);
function $87cc633cbd735367$export$e8dada0cc6b0ffe9(context) {
    const { edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, userRoles: userRoles, lastKnownTrial: lastKnownTrial, product: product, isEnrolledInUpgradeFreePoolTargetExperiment: isEnrolledInUpgradeFreePoolTargetExperiment } = context;
    return Boolean(product === 'confluence' && (edition === 'standard' || edition === 'premium') && isInTrial && invoiceableStatus === 'INVOICEABLE' && userRoles?.includes('SITE_ADMIN') && lastKnownTrial?.trialType === 'MANUAL_TRIAL' && !isEnrolledInUpgradeFreePoolTargetExperiment);
}

});

parcelRegister("ktqhG", function(module, exports) {
$parcel$export(module.exports, "NoAction", () => $837c947fbc47dbdb$export$e2b7efdbe9e8a76b);
$parcel$export(module.exports, "ActionsAndContent", () => $837c947fbc47dbdb$export$3bec899b1babe0fe);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $6qssf = parcelRequire("6qssf");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $i60Ls = parcelRequire("i60Ls");

var $ghidZ = parcelRequire("ghidZ");

var $1zLBK = parcelRequire("1zLBK");

var $3SOIn = parcelRequire("3SOIn");

var $2Vyvh = parcelRequire("2Vyvh");

var $bNNb4 = parcelRequire("bNNb4");

var $37AaY = parcelRequire("37AaY");

var $9K2vV = parcelRequire("9K2vV");

var $jb8fm = parcelRequire("jb8fm");

var $7i5PX = parcelRequire("7i5PX");

var $1KnnM = parcelRequire("1KnnM");

var $iijzm = parcelRequire("iijzm");

var $027Jd = parcelRequire("027Jd");

var $j32Ap = parcelRequire("j32Ap");

var $21YZG = parcelRequire("21YZG");

var $gQG4m = parcelRequire("gQG4m");

var $2qbVE = parcelRequire("2qbVE");

var $lPbzI = parcelRequire("lPbzI");

var $7iwBT = parcelRequire("7iwBT");

var $jGDgv = parcelRequire("jGDgv");

var $a2rSK = parcelRequire("a2rSK");

var $aKvI4 = parcelRequire("aKvI4");

var $81iQz = parcelRequire("81iQz");

var $k6fSn = parcelRequire("k6fSn");

var $eC5BP = parcelRequire("eC5BP");

var $9G3RQ = parcelRequire("9G3RQ");

var $lUiJU = parcelRequire("lUiJU");

var $lkomN = parcelRequire("lkomN");

var $2BQtG = parcelRequire("2BQtG");

var $2SKrs = parcelRequire("2SKrs");
function $837c947fbc47dbdb$export$e2b7efdbe9e8a76b() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const hasSent = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'actionsAndContent',
            actionSubjectId: 'editionAwareness',
            action: 'missed'
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent
    ]);
    return null;
}
function $837c947fbc47dbdb$var$FreeEdition() {
    const context = (0, $aLED4.useEditionAwareness)();
    const { product: product, isInCollection: isInCollection, userRoles: userRoles, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && isInCollection && userRoles?.includes('BILLING_ADMIN')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jGDgv.PlanSelectionPageModal), {
        type: "twc"
    });
    // block any EA to be shown if the customer is in teamwork collection
    if (isInCollection && (0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return null;
    // This new modal is expanding the audience,
    // but not all eligibility checks on the modals below verify all the criteria because they depended on audience-and-timing to filter them out.
    // Not all check that user have permissions to upgrade
    // We will put it at the top to minimize the risk of showing the incorrect modal
    // Example: Choose your Edition, meet partially meets the criteria of this modal and it would be shown if we put it below
    if ((0, $eGOwo.fg)('connie_end_user_request_ea_vc90_check')) {
        if ((0, $1zLBK.isEligibleForConfluenceEndUserRequestExperiment)(context)) // Render a dummy element to VC90 impact on EA
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "confluence-end-user-request-dummy-element"
        });
    }
    if ((0, $eGOwo.fg)('connie_end_user_request_kill_switch')) {
        if ((0, $1zLBK.isEligibleForConfluenceEndUserRequestExperiment)(context)) {
            // We are using this AA test to test exposures
            getExperimentValue({
                statsigParams: {
                    experimentName: 'connie_end_user_request_exp_aa',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            });
            // Fire exposure for the main experiment
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'connie_end_user_request_exp',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'transmuters'
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j32Ap.EndUserRequestModal), {});
            // End users shouldn't see anything in control, I don-t let it fallthrough as the other, because other modals partially meet the criteria and may be shown incorrectly
            return null;
        }
    }
    if ((0, $eGOwo.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            // These two statuses change the button content, and we need to fire exposure
            const fireExperimentExposure = automationFreeLimitStatus === 'BREACHED' || automationFreeLimitStatus === 'PROJECTED_TO_BREACH';
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'growth_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: fireExperimentExposure
                    }
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'tako'
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1KnnM.AutomationFreeLimitModal), {});
        }
    }
    if ((0, $eGOwo.fg)('jira-storage-hard-limit-gate')) {
        if ((0, $9K2vV.isEligibleForStorageHardLimit)(context)) {
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'jira-storage-hard-limit',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'tako'
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lUiJU.StorageHardLimitModal), {});
        }
    }
    if ((0, $eGOwo.fg)('special_offer_60_days_jira_standard_kill_switch')) {
        if ((0, $bNNb4.isEligibleForSpecialOfferSixty)(context)) {
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'special_offer_60_days_jira_standard',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: false
                    }
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6fSn.SpecialOfferSixtyModal), {});
        }
    }
    if ((0, $3SOIn.isEligibleForFreeToStandardUpgrade)(context)) {
        const pdeExperimentEnabled = getExperimentValue({
            statsigParams: {
                experimentName: 'jsm_jpd_free_to_standard_ea_update',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: {
                    // We only want to fire the exposure when they view the modal.
                    // The control experience is still inside of the product.
                    fireExperimentExposure: false
                }
            }
        }) === 'variation';
        const noPdeExperimentEnabled = getExperimentValue({
            statsigParams: {
                experimentName: 'jsm_jpd_free_to_standard_ea_update_no_pde',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: {
                    // We only want to fire the exposure when they view the modal.
                    // The control experience is still inside of the product.
                    fireExperimentExposure: false
                }
            }
        }) === 'variation';
        if ((product === 'jira-service-management' || product === 'jira-product-discovery') && (context.hasPaymentDetailsEntered === true && pdeExperimentEnabled || context.hasPaymentDetailsEntered === false && noPdeExperimentEnabled)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lPbzI.FreeToStandardRefreshModal), {});
    }
    if ((0, $eGOwo.fg)('confluence_free_choose_your_edition_kill_switch')) {
        if ((0, $i60Ls.isEligibleForChooseYourEdition)(context)) {
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'confluence_free_choose_your_edition_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: false
                    }
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gQG4m.FreeChooseYourEditionModal), {});
        }
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qbVE.FreeToStandardModal), {});
}
function $837c947fbc47dbdb$var$StandardEdition() {
    const context = (0, $aLED4.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue, getExperimentValueWithTransform: getExperimentValueWithTransform } = (0, $a0oOn.useGetExperimentValue)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection, userRoles: userRoles, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, automationFreeLimitStatus: automationFreeLimitStatus, userEmail: userEmail } = context;
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && isInCollection && userRoles?.includes('BILLING_ADMIN')) {
        if (isInTrial) {
            if (invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) // Teamwork Collection with no PDE in trial
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jGDgv.PlanSelectionPageModal), {
                type: "twc"
            });
            if ((0, $eGOwo.fg)('teamwork_collection_ea_update_fg')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $027Jd.CollectionChangePlanPopup), {});
        }
        if (isInPredunning && (0, $eGOwo.fg)('teamwork_collection_ea_update_fg')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iijzm.CollectionAddPaymentDetailsPopup), {});
    }
    // block any EA to be shown if the customer is in teamwork collection
    if (isInCollection && (0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return null;
    if ((0, $eGOwo.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'growth_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: false
                    }
                }
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1KnnM.AutomationFreeLimitModal), {});
        }
    }
    if ((0, $2Vyvh.isEligibleForManualFeatureOnboarding)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'manual_trial_w_pde_onboarding',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $21YZG.FeatureOnboardingModal), {});
    if ((isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) {
        if ((0, $eGOwo.fg)('ea_to_osb_kill_switch')) {
            if ((0, $jb8fm.isProductOneOf)(product, [
                'jira',
                'confluence'
            ]) && addPaymentDetailsExperienceUrl) {
                const osbEACohort = getExperimentValue({
                    statsigParams: {
                        experimentName: 'ea_to_osb_experiment',
                        parameterName: 'cohort',
                        defaultValue: 'not-enrolled',
                        options: {
                            fireExperimentExposure: false
                        }
                    }
                });
                if (osbEACohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2SKrs.PaymentFlowLink), {
                    href: addPaymentDetailsExperienceUrl
                });
            }
        }
        if (// Only eligible for Confluence and Jira
        (0, $37AaY.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context, getExperimentValue)) {
            const abExperimentKey = product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials';
            const abCohort = getExperimentValueWithTransform({
                statsigParams: {
                    experimentName: abExperimentKey,
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                transformCohortFunc: (0, $a0oOn.treatmentCohortTransformFn),
                trackEventParameters: {
                    trackEventGrowthInitiative: 'luna'
                }
            });
            if (abCohort === 'treatment') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9G3RQ.StandardTrialLimitBreakersModal), {});
        }
        if (isInTrial && (product === 'jira-service-management' || product === 'jira-product-discovery')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eC5BP.StandardAddPaymentModal), {});
        // Jira Standard - Site admins get routed to JSTO, others to payment popup
        if (product === 'jira' && isInTrial && userRoles?.includes('SITE_ADMIN') && userEmail) return !(0, $eGOwo.fg)('ea_to_jsto_kill_switch') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2BQtG.JiraStandardTrialOverviewLink), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7iwBT.PaymentDetailsPopup), {});
        // If the site admin doesn't have an email then we fallback to the non site admin experience
        if (product === 'jira' && isInTrial && (!userRoles?.includes('SITE_ADMIN') || !userEmail)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7iwBT.PaymentDetailsPopup), {});
        if (product === 'confluence') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eC5BP.StandardAddPaymentModal), {});
        if (addPaymentDetailsExperienceUrl && isInPredunning && (0, $jb8fm.isProductOneOf)(product, [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ])) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkomN.AddPaymentLink), {
            href: addPaymentDetailsExperienceUrl
        });
    }
    if ((0, $2Vyvh.isEligibleForManualFeatureOnboarding)(context)) // Customers that are eligible (have payment details) would not see any other standard button
    // We're returning early with the ineligible analytics here to not fire the no action event which
    // is used for monitoring
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7i5PX.IneligibleAnalytics), {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)($837c947fbc47dbdb$export$e2b7efdbe9e8a76b, {});
}
function $837c947fbc47dbdb$var$PremiumEdition() {
    const context = (0, $aLED4.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, isInCollection: isInCollection, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, userRoles: userRoles } = context;
    // make sure twc is always shown first before jira reverse trial
    // otherwise, jira reverse trial will be shown with collection
    // addition check on invoiceableStatus and canAddPaymentDetails
    // to block any EA to be shown if the customer is in a collection
    // * confluence premium is showing EA regardless which needs to be blocked from collection
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && isInCollection && userRoles?.includes('BILLING_ADMIN')) {
        if (isInTrial) {
            if (invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) // Teamwork Collection with no PDE in trial
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jGDgv.PlanSelectionPageModal), {
                type: "twc"
            });
            if ((0, $eGOwo.fg)('teamwork_collection_ea_update_fg')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $027Jd.CollectionChangePlanPopup), {});
        }
        if (isInPredunning && (0, $eGOwo.fg)('teamwork_collection_ea_update_fg')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iijzm.CollectionAddPaymentDetailsPopup), {});
    }
    // block any EA to be shown if the customer is in a TWC collection
    if (isInCollection && (0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return null;
    if ((0, $2Vyvh.isEligibleForManualFeatureOnboarding)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'manual_trial_w_pde_onboarding',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $21YZG.FeatureOnboardingModal), {});
    if (product === 'jira' && (isInTrial || isInPredunning) && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $eGOwo.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        const rtCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (rtCohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jGDgv.PlanSelectionPageModal), {
            type: "reverse-trial"
        });
    }
    if (product === 'jira' && isInTrial && isInReverseTrial && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $81iQz.ReverseTrialPopupDialog), {});
    if (product === 'jira' && isInTrial && !isInReverseTrial && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7iwBT.PaymentDetailsPopup), {});
    if (isInPredunning && (0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'jira-service-management'
    ]) && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkomN.AddPaymentLink), {
        href: addPaymentDetailsExperienceUrl
    });
    if ((0, $ghidZ.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $eGOwo.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'actions-and-content'
                }
            }
        });
        if (abCohort === 'variation') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jGDgv.PlanSelectionPageModal), {
            type: "reverse-trial"
        });
    }
    if (product === 'confluence' && (isInTrial || isInPredunning)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKvI4.PremiumPopup), {});
    if (isInTrial && product === 'jira-service-management') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a2rSK.PremiumAddPaymentModal), {});
    if ((0, $2Vyvh.isEligibleForManualFeatureOnboarding)(context)) // Customers that are eligible (have payment details) would not see any other standard button
    // We're returning early with the ineligible analytics here to not fire the no action event which
    // is used for monitoring
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7i5PX.IneligibleAnalytics), {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)($837c947fbc47dbdb$export$e2b7efdbe9e8a76b, {});
}
function $837c947fbc47dbdb$export$3bec899b1babe0fe() {
    const { edition: edition } = (0, $aLED4.useEditionAwareness)();
    if (edition === 'free') return /*#__PURE__*/ (0, $gt9Am.jsx)($837c947fbc47dbdb$var$FreeEdition, {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $gt9Am.jsx)($837c947fbc47dbdb$var$StandardEdition, {});
    if (edition === 'premium') return /*#__PURE__*/ (0, $gt9Am.jsx)($837c947fbc47dbdb$var$PremiumEdition, {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)($837c947fbc47dbdb$export$e2b7efdbe9e8a76b, {});
}

});
parcelRegister("i60Ls", function(module, exports) {
$parcel$export(module.exports, "isEligibleForChooseYourEdition", () => $45833c8e332c8fe3$export$94a1af7d4eee9d3f);

var $eGOwo = parcelRequire("eGOwo");
function $45833c8e332c8fe3$export$94a1af7d4eee9d3f(context) {
    const { product: product, edition: edition, billingSourceSystem: billingSourceSystem, isInCollection: isInCollection, isInTrial: isInTrial } = context;
    return !isInCollection && product === 'confluence' && edition === 'free' && !isInTrial && billingSourceSystem === 'CCP' && (0, $eGOwo.fg)('confluence_free_choose_your_edition_kill_switch');
}

});

parcelRegister("ghidZ", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluenceBuyReverseTrialExperiment", () => $775ae7896d398e59$export$d8e323470f628b52);
function $775ae7896d398e59$export$d8e323470f628b52(context) {
    const { product: product, edition: edition, invoiceableStatus: invoiceableStatus, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection, billingSourceSystem: billingSourceSystem } = context;
    return Boolean(!isInCollection && product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && invoiceableStatus === 'NOT_INVOICEABLE' && billingSourceSystem === 'CCP');
}

});

parcelRegister("3SOIn", function(module, exports) {
$parcel$export(module.exports, "isEligibleForFreeToStandardUpgrade", () => $496b14b216bd2850$export$9a83331889d71f60);

var $jb8fm = parcelRequire("jb8fm");
const $496b14b216bd2850$export$9a83331889d71f60 = (context)=>{
    return context.edition === 'free' && (0, $jb8fm.isProductOneOf)(context.product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ]);
};

});

parcelRegister("bNNb4", function(module, exports) {
$parcel$export(module.exports, "isEligibleForSpecialOfferSixty", () => $77e2e9db65806da8$export$fb0151ca07bf2312);

var $eGOwo = parcelRequire("eGOwo");
function $77e2e9db65806da8$export$fb0151ca07bf2312(context) {
    const { isInCollection: isInCollection, product: product, billingSourceSystem: billingSourceSystem, entitlementId: entitlementId, transactionAccountId: transactionAccountId, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    return product === 'jira' && !isInCollection && billingSourceSystem === 'CCP' && Boolean(entitlementId) && Boolean(transactionAccountId) && Boolean(canDirectBuyUpgrade) && (0, $eGOwo.fg)('special_offer_60_days_jira_standard_kill_switch');
}

});

parcelRegister("37AaY", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardTrialsUserAndStorageLimitBreakers", () => $4a032893e82c0d73$export$4ade6028e006f174);

var $eGOwo = parcelRequire("eGOwo");
function $4a032893e82c0d73$export$4ade6028e006f174(context, getExperimentValue) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, licensedUsers: licensedUsers, canAddPaymentDetails: canAddPaymentDetails, trialDaysLeft: trialDaysLeft, storageUsageInGB: storageUsageInGB, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
    const isOverUserLimit = licensedUsers > 10;
    const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);
    if ((0, $eGOwo.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            const cohort = getExperimentValue({
                statsigParams: {
                    experimentName: 'growth_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled',
                    options: {
                        fireExperimentExposure: false
                    }
                }
            });
            if (cohort !== 'not-enrolled') return false;
        }
    }
    if (product === 'confluence' && edition === 'standard' && (0, $eGOwo.fg)('connie_edition_awareness_standard_trials_gate')) return !!((isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    if (product === 'jira' && edition === 'standard' && (0, $eGOwo.fg)('jira_edition_awareness_standard_trials_gate')) return !!(isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    return false;
}

});

parcelRegister("9K2vV", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStorageHardLimit", () => $d8633450fc4735ba$export$8057dcbab6360925);
function $d8633450fc4735ba$export$8057dcbab6360925(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, billingSourceSystem: billingSourceSystem, isInCollection: isInCollection } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return !isInCollection && product === 'jira' && edition === 'free' && billingSourceSystem === 'CCP' && !storageIsUnlimited && storageUsageInGB >= storageLimitInGB;
}

});

parcelRegister("1KnnM", function(module, exports) {
$parcel$export(module.exports, "AutomationFreeLimitModal", () => $b57d8efcdc4bd398$export$b124b7369c64df7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $fYq8K = parcelRequire("fYq8K");

var $cc6jK = parcelRequire("cc6jK");

var $foP5E = parcelRequire("foP5E");
function $b57d8efcdc4bd398$export$b124b7369c64df7c() {
    const { edition: edition } = (0, $aLED4.useEditionAwareness)();
    const DIALOG_CONFIG = (0, $eJOHy.useMemo)(()=>{
        if (edition === 'free') return 0, $cc6jK.FREE_DIALOG_CONFIG;
        else if (edition === 'standard') return 0, $cc6jK.STANDARD_DIALOG_CONFIG;
        throw new Error(`Unsupported edition: ${edition}`);
    }, [
        edition
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $foP5E.default),
        dialogConfig: DIALOG_CONFIG
    });
}

});
parcelRegister("fYq8K", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPoint", () => $d866ac9437aef171$export$50a5ec7edfae079b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $bskNA = parcelRequire("bskNA");

var $asoyU = parcelRequire("asoyU");

var $4fW61 = parcelRequire("4fW61");

var $e9ksW = parcelRequire("e9ksW");

var $3UQ55 = parcelRequire("3UQ55");

var $eAOjM = parcelRequire("eAOjM");

var $1S9Gd = parcelRequire("1S9Gd");
function $d866ac9437aef171$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fW61.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($d866ac9437aef171$var$ModalEntryPointInner, {
                ...rest
            })
        })
    });
}
function $d866ac9437aef171$var$ModalEntryPointInner(props) {
    const { shouldAutoOpen: shouldAutoOpen, entryPointProps: entryPointProps, onError: onError, ...rest } = props;
    const onEntrypointError = (0, $e9ksW.useEntrypointErrorAnalytics)();
    const onErrorCallback = (0, $eJOHy.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        onEntrypointError({
            error: error,
            errorInfo: errorInfo
        });
        onError?.({
            error: error,
            errorInfo: errorInfo
        });
    }, [
        onEntrypointError,
        onError
    ]);
    const onCloseDialog = (0, $3UQ55.useOnCloseDialog)();
    const onClose = (0, $eJOHy.useCallback)((extraInformation)=>{
        let attributes;
        if (extraInformation && typeof extraInformation === 'object' && 'triggeredBy' in extraInformation) attributes = {
            triggeredBy: extraInformation.triggeredBy
        };
        onCloseDialog(attributes);
        entryPointProps?.onClose?.();
    }, [
        entryPointProps,
        onCloseDialog
    ]);
    const finalEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            ...entryPointProps,
            onClose: onClose
        }), [
        entryPointProps,
        onClose
    ]);
    // If we're auto opening, we can handle this setting here
    const Trigger = shouldAutoOpen ? (0, $1S9Gd.AutoOpenModalTrigger) : (0, $asoyU.ModalTrigger);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bskNA.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Trigger, {
            ...rest,
            entryPointProps: finalEntryPointProps,
            onError: onErrorCallback,
            shouldAutoOpen: shouldAutoOpen,
            preloadOnFocus: true,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAOjM.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}

});
parcelRegister("4fW61", function(module, exports) {
$parcel$export(module.exports, "DialogContext", () => $c655f12693a46026$export$8b93a07348a7730c);
$parcel$export(module.exports, "useDialogContext", () => $c655f12693a46026$export$898e461c0669e62d);

var $eJOHy = parcelRequire("eJOHy");
const $c655f12693a46026$export$8b93a07348a7730c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $c655f12693a46026$export$898e461c0669e62d() {
    return (0, $eJOHy.useContext)($c655f12693a46026$export$8b93a07348a7730c);
}

});

parcelRegister("e9ksW", function(module, exports) {
$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $8b1bee41e49cb42f$export$f2e26e89f653216c);

var $eJOHy = parcelRequire("eJOHy");

var $6qssf = parcelRequire("6qssf");
function $8b1bee41e49cb42f$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const handleOnError = (0, $eJOHy.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("3UQ55", function(module, exports) {
$parcel$export(module.exports, "useOnCloseDialog", () => $e82ca1bb577f5638$export$bdf52d4393ceb609);

var $eJOHy = parcelRequire("eJOHy");

var $1kTCl = parcelRequire("1kTCl");

var $6qssf = parcelRequire("6qssf");
const $e82ca1bb577f5638$export$bdf52d4393ceb609 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const onClose = (0, $eJOHy.useCallback)((attributes)=>{
        sendAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessDialog',
            attributes: attributes
        });
    }, [
        sendAnalyticsEvent
    ]);
    const [onCloseDebounced] = (0, $1kTCl.default)(onClose, 300, {
        leading: true,
        trailing: false
    });
    return onCloseDebounced;
};

});

parcelRegister("eAOjM", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessButton", () => $f362e55c3788bd44$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $f362e55c3788bd44$export$1bf8122badfd728c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4fzUT = parcelRequire("4fzUT");

var $1aFA1 = parcelRequire("1aFA1");

var $d8UFE = parcelRequire("d8UFE");

var $6kf2c = parcelRequire("6kf2c");

var $1CltT = parcelRequire("1CltT");

var $guChT = parcelRequire("guChT");

var $eGOwo = parcelRequire("eGOwo");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $eHCv2 = parcelRequire("eHCv2");

var $6qssf = parcelRequire("6qssf");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $45U1E = parcelRequire("45U1E");

var $jPfsL = parcelRequire("jPfsL");

var $2I2is = parcelRequire("2I2is");
const $f362e55c3788bd44$export$c36573823bda97dd = 'edition-awareness';
const $f362e55c3788bd44$var$buttonStyles = (0, $1DXK0.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.small',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $f362e55c3788bd44$var$defaultStyles = (0, $1DXK0.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    ':hover': {
        backgroundColor: 'color.background.accent.purple.subtlest.hovered',
        color: 'color.text.discovery'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        color: 'color.text.discovery'
    }
});
const $f362e55c3788bd44$var$warningStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border.warning'
});
const $f362e55c3788bd44$var$dangerStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border.danger'
});
const $f362e55c3788bd44$var$dismissibleStyles = (0, $1DXK0.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    ':hover': {
        color: 'color.text.discovery',
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        textDecoration: 'none'
    }
});
const $f362e55c3788bd44$var$iconStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
function $f362e55c3788bd44$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E06C00)";
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
            label: "",
            color: color ?? defaultColor,
            size: "small"
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1aFA1))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)",
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4fzUT))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
}
const $f362e55c3788bd44$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $jPfsL.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $1CltT.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const context = (0, $aLED4.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        // Fire exposure for ea_to_osb_experiment control tenants
        if ((0, $45U1E.isEligibleForEAtoOSBExperiment)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes,
        getExperimentValue,
        context
    ]);
    const handleOnMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $eGOwo.fg)('ea_hover_analytics_event_gate')) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
        name: $f362e55c3788bd44$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6kf2c.Button), {
            ...rest,
            ref: ref,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            iconBefore: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($f362e55c3788bd44$var$Icon, {
                    appearance: appearance,
                    icon: icon,
                    color: "currentColor"
                }),
            children: [
                text,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eHCv2.UiViewedEvent), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
        name: $f362e55c3788bd44$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bQP4O.default), {
            ...rest,
            ref: ref,
            xcss: [
                $f362e55c3788bd44$var$buttonStyles,
                appearance === 'default' && $f362e55c3788bd44$var$defaultStyles,
                appearance === 'warning' && $f362e55c3788bd44$var$warningStyles,
                appearance === 'danger' && $f362e55c3788bd44$var$dangerStyles,
                isDismissible && $f362e55c3788bd44$var$dismissibleStyles
            ],
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: $f362e55c3788bd44$var$iconStyles,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($f362e55c3788bd44$var$Icon, {
                        appearance: appearance,
                        icon: icon
                    })
                }),
                text,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eHCv2.UiViewedEvent), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        })
    });
});
const $f362e55c3788bd44$export$1bf8122badfd728c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $jPfsL.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $1CltT.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $2I2is.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const handleOnMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $eGOwo.fg)('ea_hover_analytics_event_gate')) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
        name: $f362e55c3788bd44$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6kf2c.LinkButton), {
            ...rest,
            href: tracedUrl,
            ref: ref,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            iconBefore: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($f362e55c3788bd44$var$Icon, {
                    appearance: appearance,
                    icon: icon,
                    color: "currentColor"
                }),
            children: [
                text,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eHCv2.UiViewedEvent), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
        name: $f362e55c3788bd44$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lL4G9.default), {
            ...rest,
            href: tracedUrl,
            ref: ref,
            xcss: [
                $f362e55c3788bd44$var$buttonStyles,
                appearance === 'default' && $f362e55c3788bd44$var$defaultStyles,
                appearance === 'warning' && $f362e55c3788bd44$var$warningStyles,
                appearance === 'danger' && $f362e55c3788bd44$var$dangerStyles
            ],
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: $f362e55c3788bd44$var$iconStyles,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($f362e55c3788bd44$var$Icon, {
                        appearance: appearance,
                        icon: icon
                    })
                }),
                text,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eHCv2.UiViewedEvent), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        })
    });
});

});
parcelRegister("eHCv2", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $0dc52179526f461d$export$d0a9edec5c713764);

var $eJOHy = parcelRequire("eJOHy");

var $6qssf = parcelRequire("6qssf");
function $0dc52179526f461d$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    const hasSent = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});

parcelRegister("45U1E", function(module, exports) {
$parcel$export(module.exports, "isEligibleForEAtoOSBExperiment", () => $a209555cf53a89c9$export$30e224db82597c29);

var $eGOwo = parcelRequire("eGOwo");

var $jb8fm = parcelRequire("jb8fm");
function $a209555cf53a89c9$export$30e224db82597c29(context) {
    const { isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, product: product, edition: edition } = context;
    return Boolean((isInTrial || isInPredunning) && edition === 'standard' && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && (0, $eGOwo.fg)('ea_to_osb_kill_switch'));
}

});

parcelRegister("jPfsL", function(module, exports) {
$parcel$export(module.exports, "useButtonContent", () => $558d49d6ac3e0911$export$c810aba6284fa97d);

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $9THm6 = parcelRequire("9THm6");

var $9K2vV = parcelRequire("9K2vV");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $ghidZ = parcelRequire("ghidZ");

var $2Vyvh = parcelRequire("2Vyvh");

var $kPD5C = parcelRequire("kPD5C");

var $37AaY = parcelRequire("37AaY");

var $jb8fm = parcelRequire("jb8fm");
// TODO: `licensedUserLimit` should be fetched from the server
const $558d49d6ac3e0911$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $558d49d6ac3e0911$var$getFreeContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue }) {
    const { licensedUsers: licensedUsers, product: product, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const limits = $558d49d6ac3e0911$var$PRODUCT_LIMITS_MAP[product];
    // Is eligible for automation limits
    if ((0, $eGOwo.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            if (automationFreeLimitStatus === 'BREACHED' && getExperimentValue({
                statsigParams: {
                    experimentName: 'growth_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            }) === 'variation') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.automation-limits-breached',
                    defaultMessage: 'Limit reached',
                    description: 'Informs the user that they have breached their automation limits'
                }),
                appearance: 'danger',
                icon: 'warning'
            };
            if (automationFreeLimitStatus === 'PROJECTED_TO_BREACH' && getExperimentValue({
                statsigParams: {
                    experimentName: 'growth_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            }) === 'variation') // If the automation usage is projected to breach, we show a warning
            return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.automation-near-limit',
                    defaultMessage: 'Near limit',
                    description: 'Informs the user that they are about to breach their automation limits'
                }),
                appearance: 'warning',
                icon: 'warning'
            };
        }
    }
    if ((0, $eGOwo.fg)('jira-storage-hard-limit-gate')) {
        if ((0, $9K2vV.isEligibleForStorageHardLimit)(context) && getExperimentValue({
            statsigParams: {
                experimentName: 'jira-storage-hard-limit',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.storage-hard-limit',
                defaultMessage: 'Storage full'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira-product-discovery',
        'jira-service-management'
    ])) {
        if (licensedUsers >= limits.licensedUserLimit && getExperimentValue({
            statsigParams: {
                experimentName: 'jsm_jpd_ea_free_content_adjustment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.no-users-left-content-adjustment',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $9THm6.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
        if (limits.licensedUserLimit - licensedUsers === 1 && getExperimentValue({
            statsigParams: {
                experimentName: 'jsm_jpd_ea_free_content_adjustment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.limited-users-left-content-adjustment',
                defaultMessage: '1 {product, select, jpd {creator} jsm {agent} other {user}} left',
                description: 'Informs the user that there is 1 licensed user left before they need to upgrade their product'
            }, {
                product: (0, $9THm6.getProductForTranslation)(product)
            }),
            appearance: 'default',
            icon: 'gem'
        };
    }
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.no-users-left',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $9THm6.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.limited-users-left',
                defaultMessage: 'Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their product'
            }, {
                product: (0, $9THm6.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    let text = formatMessage({
        id: '@atlassian/edition-awareness.button.upgrade',
        defaultMessage: 'Upgrade',
        description: 'Informs the user that they can upgrade their product'
    });
    if (product === 'confluence' && licensedUsers >= limits.warningUserLimit) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: text,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: text,
        appearance: 'default',
        icon: 'gem'
    };
}
function $558d49d6ac3e0911$var$getTrialContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue, getExperimentValueWithTransform: getExperimentValueWithTransform }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: '@atlassian/edition-awareness.button.daysLeft',
        defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
        description: 'Informs the user how many days they have left in trial'
    }, {
        trialDaysLeft: trialDaysLeft
    });
    const isInFirstHalfOfTrial = Boolean(trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
    // Jira Limit Breakers currently does not show 'Standard trial' in the first half of trial
    // This should be fixed in productionisation for completeness
    if (product === 'jira' && (0, $37AaY.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context, getExperimentValue) && getExperimentValueWithTransform({
        statsigParams: {
            experimentName: 'jira_edition_awareness_standard_trials',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        },
        transformCohortFunc: (0, $a0oOn.treatmentCohortTransformFn)
    }) === 'treatment') return {
        text: daysLeftText,
        appearance: trialDaysLeft && trialDaysLeft <= 3 ? 'danger' : 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && (0, $37AaY.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context, getExperimentValue) && getExperimentValueWithTransform({
        statsigParams: {
            experimentName: 'connie_edition_awareness_standard_trials',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        },
        transformCohortFunc: (0, $a0oOn.treatmentCohortTransformFn)
    }) === 'treatment') return {
        text: daysLeftText,
        appearance: 'warning',
        icon: 'warning'
    };
    if (edition === 'premium' && product === 'jira' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $eGOwo.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (isInFirstHalfOfTrial) return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans',
                    defaultMessage: 'See plans',
                    description: 'Informs the user that they are able to see plans'
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: daysLeftText,
                appearance: appearance,
                icon: icon
            };
        }
    }
    if ((0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        // If trial is still in its first half, show trial message instead of trial days left
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.premium-trial',
                    defaultMessage: 'Premium trial',
                    description: 'Informs the user that they are on a premium trial'
                }),
                appearance: appearance,
                icon: icon
            };
            if (edition === 'standard') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.standard-trial',
                    defaultMessage: 'Standard trial',
                    description: 'Informs the user that they are on a standard trial'
                }),
                appearance: appearance,
                icon: icon
            };
        }
        // If trial has 3 days or less remaining, swap the button to the warning state
        if (trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if ((0, $2Vyvh.isEligibleForManualFeatureOnboarding)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'manual_trial_w_pde_onboarding',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) === 'variation') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.explore-edition',
            defaultMessage: 'Explore {edition, select, premium {Premium} standard {Standard} other {Trial}}',
            description: 'CTA for the user to explore the features of their trial'
        }, {
            edition: edition
        }),
        appearance: 'default',
        icon: 'gem'
    };
    if ((0, $ghidZ.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $eGOwo.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'use-button-content getTrialContent'
                }
            }
        });
        if (abCohort === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (trialDaysLeft && trialDaysLeft > 15) return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt',
                    defaultMessage: 'See plans',
                    description: 'Informs the user that they are able to see plans'
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt.final',
                    defaultMessage: '{trialDaysLeft, plural, =1 {# day} other {# days}} left',
                    description: 'Indicates to the user how many days they have left in trial'
                }, {
                    trialDaysLeft: trialDaysLeft
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $558d49d6ac3e0911$var$getPredunningContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue, getExperimentValueWithTransform: getExperimentValueWithTransform }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $37AaY.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context, getExperimentValue) && getExperimentValueWithTransform({
        statsigParams: {
            experimentName: product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        },
        transformCohortFunc: (0, $a0oOn.treatmentCohortTransformFn)
    }) === 'treatment') {
        appearance = 'warning';
        icon = 'warning';
    }
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $eGOwo.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.choose-plans',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $ghidZ.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $eGOwo.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'use-button-content getPredunningContent'
                }
            }
        });
        if (abCohort === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans.final',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.addPaymentDetails',
            defaultMessage: 'Add payment details',
            description: 'Informs the user how many days they have left in trial'
        }),
        appearance: appearance,
        icon: icon
    };
}
function $558d49d6ac3e0911$var$getCollectionContent({ context: context, formatMessage: formatMessage }) {
    /* ==============================
	// Collection
	// Collection handles its own logic for the button content
	// This is to avoid the button content from being overridden by other products' logic
	// ============================== */ const { isInTrial: isInTrial, trialDaysLeft: trialDaysLeft, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    if (isInTrial) {
        let appearance = 'default';
        let icon = 'gem';
        const daysLeftText = formatMessage({
            id: '@atlassian/edition-awareness.button.collection.daysLeft',
            defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
            description: 'Informs the user how many days they have left in trial'
        }, {
            trialDaysLeft: trialDaysLeft
        });
        if (trialDaysLeft && trialDaysLeft <= 3 && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if (isInPredunning) {
        if (canAddPaymentDetails && invoiceableStatus === 'NOT_INVOICEABLE') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.collection.addPaymentDetails',
                defaultMessage: 'Add payment details'
            }),
            appearance: 'default',
            icon: 'gem'
        };
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.collection.upgrade',
            defaultMessage: 'Upgrade'
        }),
        appearance: 'default',
        icon: 'gem'
    };
}
function $558d49d6ac3e0911$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $aLED4.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue, getExperimentValueWithTransform: getExperimentValueWithTransform } = (0, $a0oOn.useGetExperimentValue)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial, isInCollection: isInCollection, product: product } = context;
    /*
	 * Keep this before the other checks to avoid showing the collection content in the other cases
	 */ if (isInCollection && (0, $jb8fm.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return $558d49d6ac3e0911$var$getCollectionContent({
        context: context,
        formatMessage: formatMessage
    });
    if (edition === 'free') return $558d49d6ac3e0911$var$getFreeContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue
    });
    if (isInTrial) return $558d49d6ac3e0911$var$getTrialContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue,
        getExperimentValueWithTransform: getExperimentValueWithTransform
    });
    if (isInPredunning) return $558d49d6ac3e0911$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue,
        getExperimentValueWithTransform: getExperimentValueWithTransform
    });
    if ((0, $kPD5C.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade.standard-to-premium',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("kPD5C", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $f8c95ebb68f11731$export$d58c0da339bf36d9);

var $eGOwo = parcelRequire("eGOwo");
function $f8c95ebb68f11731$export$d58c0da339bf36d9({ product: product, edition: edition, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    if (edition === 'standard' && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium') {
        if (product === 'jira' && (0, $eGOwo.fg)('edition_awareness_upsell_jira_fg')) return true;
        if (product === 'jira-service-management' && (0, $eGOwo.fg)('edition_awareness_upsell_jsm_fg')) return true;
        if (product === 'confluence' && (0, $eGOwo.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return true;
        if (product === 'jira-product-discovery' && (0, $eGOwo.fg)('upsell_edition_awareness_jpd_fg')) return true;
    }
    return false;
}

});


parcelRegister("2I2is", function(module, exports) {
$parcel$export(module.exports, "useTracedUrl", () => $83a5991054d2f295$export$5eea7bde9861e87b);

var $eJOHy = parcelRequire("eJOHy");

var $1kFb3 = parcelRequire("1kFb3");

var $aLED4 = parcelRequire("aLED4");
const $83a5991054d2f295$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $83a5991054d2f295$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $aLED4.useEditionAwareness)();
    const origin = (0, $eJOHy.useMemo)(()=>new (0, $1kFb3.default)({
            product: $83a5991054d2f295$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $eJOHy.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});


parcelRegister("1S9Gd", function(module, exports) {
$parcel$export(module.exports, "AutoOpenModalTrigger", () => $3495e952a5066f68$export$beb58c00994cbd66);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lBwnZ = parcelRequire("lBwnZ");

var $2bMVP = parcelRequire("2bMVP");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $78OnL = parcelRequire("78OnL");

var $iUOpD = parcelRequire("iUOpD");

var $6UHe9 = parcelRequire("6UHe9");

var $dy5PQ = parcelRequire("dy5PQ");

var $lBsyH = parcelRequire("lBsyH");

var $4Gyvo = parcelRequire("4Gyvo");
const $3495e952a5066f68$var$emptyEntryPointParams = {};
const $3495e952a5066f68$var$emptyEntryPointProps = {};
function $3495e952a5066f68$export$beb58c00994cbd66({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, shouldAutoOpen: shouldAutoOpen, preloadOnFocus: preloadOnFocus = false }) {
    const { openModal: openModal } = (0, $eJOHy.useContext)((0, $6UHe9.ModalContext));
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $iUOpD.useEntryPointConfig)();
    const metricName = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $3495e952a5066f68$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                        hasCloseButton: true,
                        children: title ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {}),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {}),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kseeK.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $gt9Am.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $gt9Am.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $3495e952a5066f68$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $dy5PQ.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $lBwnZ.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    const hasRun = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasRun.current && shouldAutoOpen) {
            hasRun.current = true;
            const reference = load();
            onLoad({
                reference: reference,
                dispose: reference.dispose
            });
        }
    }, [
        shouldAutoOpen,
        load,
        onLoad
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    return children({
        ref: mergedRef
    });
}

});


parcelRegister("cc6jK", function(module, exports) {
$parcel$export(module.exports, "FREE_DIALOG_CONFIG", () => $8c3388494f61405c$export$212eac90358facd0);
$parcel$export(module.exports, "STANDARD_DIALOG_CONFIG", () => $8c3388494f61405c$export$e42f11d536a45036);

var $dl00O = parcelRequire("dl00O");
const $8c3388494f61405c$export$212eac90358facd0 = {
    touchpointIntent: 'startTrial',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};
const $8c3388494f61405c$export$e42f11d536a45036 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("foP5E", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef391abf171625b3$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ef391abf171625b3$var$AutomationLimitsEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gQbq2")), {
        moduleId: "fda1ad3d",
        priority: "interaction",
        moduleId: 'edition-awareness-automation-free-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $ef391abf171625b3$export$2e2bcd8739ae039 = $ef391abf171625b3$var$AutomationLimitsEntryPoint;

});
parcelRegister("gQbq2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3Lctm")
]).then(()=>parcelRequire('6Fxr4'));

});



parcelRegister("iijzm", function(module, exports) {
$parcel$export(module.exports, "CollectionAddPaymentDetailsPopup", () => $c89faf7398aee0fd$export$7c1c66d41188536);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $664dI = parcelRequire("664dI");

var $tTYnw = parcelRequire("tTYnw");

var $8gnUg = parcelRequire("8gnUg");
const $c89faf7398aee0fd$export$7c1c66d41188536 = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $664dI.PopupEntryPoint), {
        entryPoint: (0, $8gnUg.entryPoint),
        entryPointProps: {},
        placement: 'bottom-end',
        dialogConfig: (0, $tTYnw.DETAILS_CONFIG)
    });
};

});
parcelRegister("664dI", function(module, exports) {
$parcel$export(module.exports, "PopupEntryPoint", () => $4eb253a0cbda3d27$export$e14c42e99b209c4d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $8nu6j = parcelRequire("8nu6j");

var $7ep4S = parcelRequire("7ep4S");

var $b8OI0 = parcelRequire("b8OI0");

var $4fW61 = parcelRequire("4fW61");

var $e9ksW = parcelRequire("e9ksW");

var $3UQ55 = parcelRequire("3UQ55");

var $eAOjM = parcelRequire("eAOjM");
function $4eb253a0cbda3d27$export$e14c42e99b209c4d(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fW61.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($4eb253a0cbda3d27$export$dece147acb9eddff, {
                ...rest
            })
        })
    });
}
function $4eb253a0cbda3d27$export$dece147acb9eddff(props) {
    const { onClose: onClose, ...rest } = props;
    const onError = (0, $e9ksW.useEntrypointErrorAnalytics)();
    const onCloseDialog = (0, $3UQ55.useOnCloseDialog)();
    const onClosePopup = (0, $eJOHy.useCallback)((event, currentLevel)=>{
        onClose?.(event, currentLevel);
        onCloseDialog();
    }, [
        onClose,
        onCloseDialog
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b8OI0.PopupTrigger), {
        ...rest,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAOjM.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)($4eb253a0cbda3d27$var$PopupFallback, {}),
        onError: onError,
        onClose: onClosePopup,
        preloadOnFocus: true
    });
}
const $4eb253a0cbda3d27$var$PopupFallback = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });

});
parcelRegister("b8OI0", function(module, exports) {
$parcel$export(module.exports, "PopupTrigger", () => $84962bbe368c26b9$export$95d4acdbab2fc6ef);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $e2Zbt = parcelRequire("e2Zbt");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $7ep4S = parcelRequire("7ep4S");

var $dy5PQ = parcelRequire("dy5PQ");

var $lBsyH = parcelRequire("lBsyH");

var $4Gyvo = parcelRequire("4Gyvo");

var $1yk36 = parcelRequire("1yk36");
const $84962bbe368c26b9$var$emptyEntryPointParams = {};
const $84962bbe368c26b9$var$emptyEntryPointProps = {};
const $84962bbe368c26b9$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $eJOHy.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: fallback || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
function $84962bbe368c26b9$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, preloadOnFocus: preloadOnFocus = false, ...popupProps }) {
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [content, setContent] = (0, $eJOHy.useState)(null);
    const updateRef = (0, $eJOHy.useRef)(null);
    const handleOpen = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $eJOHy.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const triggerCloseRef = (0, $1yk36.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $84962bbe368c26b9$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            (0, $eGOwo.fg)('entry_points_popup_trigger_update_callback') ? /*#__PURE__*/ (0, $gt9Am.jsx)($84962bbe368c26b9$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }) : fallback || /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {}),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $84962bbe368c26b9$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $dy5PQ.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $eJOHy.useCallback)((triggerProps)=>{
        const mergedRef = (0, $e2Zbt.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $eJOHy.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}

});
parcelRegister("1yk36", function(module, exports) {
$parcel$export(module.exports, "useClickToCloseRef", () => $ac7899653e7dcdef$export$46ec6629f411921d);

var $eJOHy = parcelRequire("eJOHy");
function $ac7899653e7dcdef$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});



parcelRegister("tTYnw", function(module, exports) {
$parcel$export(module.exports, "DETAILS_CONFIG", () => $5aea24c5b98545c5$export$d6f7f679ada50a33);
const $5aea24c5b98545c5$export$d6f7f679ada50a33 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'collection-add-payment-details-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("8gnUg", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $6d1711aeab6df30f$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6d1711aeab6df30f$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bRDn2")), {
        moduleId: "732c33d7",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-add-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("bRDn2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("9tZVl")
]).then(()=>parcelRequire('2rmzr'));

});



parcelRegister("027Jd", function(module, exports) {
$parcel$export(module.exports, "CollectionChangePlanPopup", () => $e9a7e18fdbcf521b$export$a32dee959fd7bd6e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $664dI = parcelRequire("664dI");

var $5VGSZ = parcelRequire("5VGSZ");

var $6B57O = parcelRequire("6B57O");
const $e9a7e18fdbcf521b$export$a32dee959fd7bd6e = ()=>{
    const { cloudId: cloudId, collectionEntitlementId: collectionEntitlementId, product: product } = (0, $aLED4.useEditionAwareness)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`,
            hamsProductKey: (0, $h1104.getHamsKey)(product),
            shouldShowPspLink: (0, $eGOwo.fg)('twc_ea_pde_trial_psp_link')
        }), [
        cloudId,
        collectionEntitlementId,
        product
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $664dI.PopupEntryPoint), {
        entryPoint: (0, $6B57O.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $5VGSZ.DIALOG_CONFIG)
    });
};

});
parcelRegister("5VGSZ", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $5b92081f52339c46$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $5b92081f52339c46$export$3b6761b6086f6dfd = {
    touchpointIntent: 'changePlan',
    dialogId: 'collection-change-plan-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $dl00O.Edition).SELECTION
};

});

parcelRegister("6B57O", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $c94a04fe2985e56f$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $k4nRN = parcelRequire("k4nRN");

const $c94a04fe2985e56f$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gByWE")), {
        moduleId: "47830478",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-change-plan-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, collectionEntitlementId: collectionEntitlementId, hamsProductKey: hamsProductKey, shouldShowPspLink: shouldShowPspLink })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                collectionChangePlanPopupQuery: {
                    parameters: $k4nRN.default,
                    variables: {
                        cloudId: cloudId,
                        collectionEntitlementId: collectionEntitlementId,
                        hamsProductKey: hamsProductKey,
                        shouldShowPspLink: shouldShowPspLink
                    }
                }
            }
        })
});

});
parcelRegister("k4nRN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c60b23308af1d0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b973d7e66102d8223a1d4c3cae6a53e>>
 * @relayHash fcd1377a74b6e682479cd92c8be303b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e47474fbf95b94b1c4596f5f3a4968cce3a4d363b0daf94694a46d1df6d49d79

var $37Ewn = parcelRequire("37Ewn");
const $3c60b23308af1d0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionEntitlementId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldShowPspLink"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionEntitlementId"
        }
    ], v6 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpManageEntitlementExperienceCapability",
                "kind": "LinkedField",
                "name": "manageEntitlement",
                "plural": false,
                "selections": [
                    v4 /*: any*/ ,
                    v3 /*: any*/ 
                ]
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "condition": "shouldShowPspLink",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldShowPspLink",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "CcpQueryApi",
                            "kind": "LinkedField",
                            "name": "ccp",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "CcpEntitlement",
                                    "kind": "LinkedField",
                                    "name": "entitlementV2",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "condition": "shouldShowPspLink",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldShowPspLink",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "CcpQueryApi",
                            "kind": "LinkedField",
                            "name": "ccp",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "CcpEntitlement",
                                    "kind": "LinkedField",
                                    "name": "entitlementV2",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e47474fbf95b94b1c4596f5f3a4968cce3a4d363b0daf94694a46d1df6d49d79",
            "metadata": {},
            "name": "collectionChangePlanPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3c60b23308af1d0b$var$node.hash = "211b64b0f169b5ec96f63f9e5238ed73";
(0, $37Ewn.PreloadableQueryRegistry).set($3c60b23308af1d0b$var$node.params.id, $3c60b23308af1d0b$var$node);
var $3c60b23308af1d0b$export$2e2bcd8739ae039 = $3c60b23308af1d0b$var$node;

});

parcelRegister("gByWE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6XPyJ")
]).then(()=>parcelRequire('8RcDd'));

});



parcelRegister("j32Ap", function(module, exports) {
$parcel$export(module.exports, "EndUserRequestModal", () => $48e653e0bf746545$export$c9535e299db3229b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fYq8K = parcelRequire("fYq8K");

var $gOJcg = parcelRequire("gOJcg");

var $5DMms = parcelRequire("5DMms");
function $48e653e0bf746545$export$c9535e299db3229b() {
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $5DMms.entryPoint),
        modalProps: modalProps,
        dialogConfig: (0, $gOJcg.DIALOG_CONFIG)
    });
}

});
parcelRegister("gOJcg", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $0b2650128ae80121$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $0b2650128ae80121$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'end-user-request-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("5DMms", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $731814c62ba00e50$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $731814c62ba00e50$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("idg3q")), {
        moduleId: "6fc056c1",
        priority: "interaction",
        moduleId: 'edition-awareness-end-user-request-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $731814c62ba00e50$export$2e2bcd8739ae039 = $731814c62ba00e50$export$6333901e831d7af0;

});
parcelRegister("idg3q", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Hnwjz").then(()=>parcelRequire('4pgQY'));

});



parcelRegister("21YZG", function(module, exports) {
$parcel$export(module.exports, "FeatureOnboardingModal", () => $769b2db404862454$export$14fd36acdc725af0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $4t0UC = parcelRequire("4t0UC");

var $fYq8K = parcelRequire("fYq8K");

var $b1dQD = parcelRequire("b1dQD");

var $eMBz0 = parcelRequire("eMBz0");
function $769b2db404862454$export$14fd36acdc725af0() {
    const { cloudId: cloudId, hasDialogAutoOpened: hasDialogAutoOpened, product: product, edition: edition } = (0, $aLED4.useEditionAwareness)();
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 968,
            height: 568
        }), []);
    const shouldAutoOpen = (0, $eJOHy.useMemo)(()=>!hasDialogAutoOpened('feature-onboarding-modal'), [
        hasDialogAutoOpened
    ]);
    const markDialogAsSeen = (0, $4t0UC.useMarkDialogAsSeen)();
    const hasMarked = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (hasMarked.current || !shouldAutoOpen) return;
        markDialogAsSeen('feature-onboarding-modal', product, edition);
        hasMarked.current = true;
    }, [
        shouldAutoOpen,
        markDialogAsSeen,
        product,
        edition
    ]);
    const [isAutoOpened, setIsAutoOpened] = (0, $eJOHy.useState)(shouldAutoOpen);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            isAutoOpened: isAutoOpened,
            onClose () {
                setIsAutoOpened(false);
            }
        }), [
        isAutoOpened
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            isAutoOpened: isAutoOpened
        }), [
        isAutoOpened
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: analyticsAttributes,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
            entryPoint: (0, $eMBz0.entryPoint),
            modalProps: modalProps,
            dialogConfig: (0, $b1dQD.DIALOG_CONFIG),
            entryPointProps: entryPointProps,
            shouldAutoOpen: shouldAutoOpen,
            entryPointParams: entryPointParams
        })
    });
}

});
parcelRegister("b1dQD", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $4cd7799b11740ded$export$3b6761b6086f6dfd);
const $4cd7799b11740ded$export$3b6761b6086f6dfd = {
    touchpointIntent: 'onboarding',
    dialogId: 'feature-onboarding-modal',
    dialogType: 'modal'
};

});

parcelRegister("eMBz0", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $4ea98022827eec39$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $1HgzZ = parcelRequire("1HgzZ");

const $4ea98022827eec39$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3cSN6")), {
        moduleId: "88239b19",
        priority: "interaction",
        moduleId: 'edition-awareness-feature-onboarding-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                featureOnboardingModalQuery: {
                    parameters: $1HgzZ.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("1HgzZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $09db64e8f6c47673$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c28e295db48e2ed4c48d24dc8af5bab>>
 * @relayHash fd4cb6f3571e14ffe0aaedf31344d774
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04b83b613cdd7f5c82d98e9c5ef18e4d689581650254e9b0a7e39ba1cc846859
const $09db64e8f6c47673$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "04b83b613cdd7f5c82d98e9c5ef18e4d689581650254e9b0a7e39ba1cc846859",
        "metadata": {},
        "name": "featureOnboardingModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $09db64e8f6c47673$export$2e2bcd8739ae039 = $09db64e8f6c47673$var$node;

});

parcelRegister("3cSN6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lKsfw")
]).then(()=>parcelRequire('8Dd1e'));

});



parcelRegister("gQG4m", function(module, exports) {
$parcel$export(module.exports, "FreeChooseYourEditionModal", () => $e77297b3577a3c60$export$e7aac02eddd1c992);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $fYq8K = parcelRequire("fYq8K");

var $7gvZ0 = parcelRequire("7gvZ0");

var $4RlIZ = parcelRequire("4RlIZ");
function $e77297b3577a3c60$export$e7aac02eddd1c992() {
    const { product: product, cloudId: cloudId, showFlag: showFlag } = (0, $aLED4.useEditionAwareness)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            shouldScrollInViewport: true,
            width: 'x-large'
        }), []);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        showFlag?.({
            id: '@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag',
            title: formatMessage({
                id: '@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag.title',
                defaultMessage: "We weren't able to get your plan details.",
                description: 'Title for the error flag shown when Edition Awareness entrypoint cannot be loaded.'
            }),
            description: '',
            appearance: 'error',
            actions: [
                {
                    content: formatMessage({
                        id: '@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag.action',
                        defaultMessage: 'Refresh',
                        description: 'Action for the error flag shown when Edition Awareness entrypoint cannot be loaded.'
                    }),
                    onClick: ()=>{
                        window.location.reload();
                    }
                }
            ]
        });
    }, [
        showFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $4RlIZ.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $7gvZ0.DIALOG_CONFIG),
        onError: handleOnError
    });
}

});
parcelRegister("7gvZ0", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $a1d66a93975e779f$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $a1d66a93975e779f$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-choose-your-edition-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).SELECTION
};

});

parcelRegister("4RlIZ", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $6ca641babf29da54$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $93UOi = parcelRequire("93UOi");

const $6ca641babf29da54$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7Ryl1")), {
        moduleId: "951dde01",
        priority: "interaction",
        moduleId: 'edition-awareness-free-choose-your-edition-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeChooseYourEditionModalQuery: {
                    parameters: $93UOi.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("93UOi", function(module, exports) {
$parcel$export(module.exports, "default", () => $63009899a8f0a5e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eae0caf60d501468f00c97677c325117>>
 * @relayHash dce043bf215d0738fb2f0c558281922b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f75688f1ae1ca933842d545c9d503ba5b6f3c6d424bd556ae0e143e549031217

var $37Ewn = parcelRequire("37Ewn");
const $63009899a8f0a5e7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = [
        v4 /*: any*/ 
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "compareOfferingsStandardHighlighted",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "input",
                        "value": {
                            "highlightedOffering": {
                                "offeringName": "Standard"
                            }
                        }
                    }
                ],
                "concreteType": "CcpCompareOfferingsExperienceCapability",
                "kind": "LinkedField",
                "name": "compareOfferings",
                "plural": false,
                "selections": v5 /*: any*/ ,
                "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Standard\"}})"
            },
            {
                "alias": "compareOfferingsPremiumHighlighted",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "input",
                        "value": {
                            "highlightedOffering": {
                                "offeringName": "Premium"
                            }
                        }
                    }
                ],
                "concreteType": "CcpCompareOfferingsExperienceCapability",
                "kind": "LinkedField",
                "name": "compareOfferings",
                "plural": false,
                "selections": v5 /*: any*/ ,
                "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Premium\"}})"
            }
        ],
        "type": "CcpEntitlementExperienceCapabilities"
    }, v7 = {
        "concreteType": "ConfluenceStorage",
        "kind": "LinkedField",
        "name": "confluence_storage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isUnlimited"
            },
            {
                "kind": "ScalarField",
                "name": "bytesUsed"
            },
            {
                "kind": "ScalarField",
                "name": "bytesLimit"
            }
        ]
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "GrowthUnifiedProfileResult",
        "kind": "LinkedField",
        "name": "growthUnifiedProfile_getUnifiedProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfileSiteDetails",
                "kind": "LinkedField",
                "name": "sites",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileProductDetails",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "productName"
                            },
                            {
                                "concreteType": "GrowthUnifiedProfileProductNBE",
                                "kind": "LinkedField",
                                "name": "nbeRecommendation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "edition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "recommendationDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "freeChooseYourEditionModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "changeOfferingPremium",
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ ,
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "freeChooseYourEditionModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": "changeOfferingPremium",
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ]
        },
        "params": {
            "id": "f75688f1ae1ca933842d545c9d503ba5b6f3c6d424bd556ae0e143e549031217",
            "metadata": {},
            "name": "freeChooseYourEditionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$63009899a8f0a5e7$var$node.hash = "240c219ea71360a60cbbdf77a06dbd96";
(0, $37Ewn.PreloadableQueryRegistry).set($63009899a8f0a5e7$var$node.params.id, $63009899a8f0a5e7$var$node);
var $63009899a8f0a5e7$export$2e2bcd8739ae039 = $63009899a8f0a5e7$var$node;

});

parcelRegister("7Ryl1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hFmwG").then(()=>parcelRequire('1Sa6x'));

});



parcelRegister("2qbVE", function(module, exports) {
$parcel$export(module.exports, "FreeToStandardModal", () => $99b4b6eebbad4f1e$export$61689b501c3b79e6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $9evzz = parcelRequire("9evzz");

var $3Wwdw = parcelRequire("3Wwdw");

var $h1104 = parcelRequire("h1104");

var $fYq8K = parcelRequire("fYq8K");

var $2iKJM = parcelRequire("2iKJM");

var $78QJo = parcelRequire("78QJo");
function $99b4b6eebbad4f1e$var$shouldIncludeGUPS(product, cyeaExperimentCohort) {
    if (product !== 'confluence') return false;
    return cyeaExperimentCohort === 'control' || cyeaExperimentCohort === 'variation';
}
function $99b4b6eebbad4f1e$export$61689b501c3b79e6() {
    const { product: product, cloudId: cloudId } = (0, $aLED4.useEditionAwareness)();
    const jiraApplicationKey = (0, $9evzz.getJiraApplicationKey)(product);
    const projectType = (0, $3Wwdw.getJiraProjectTypeKey)(product);
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    const cyeaExperimentCohort = getExperimentValue({
        statsigParams: {
            experimentName: 'confluence_free_choose_your_edition_experiment',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled',
            options: {
                fireExperimentExposure: false
            }
        }
    });
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence',
            shouldIncludeGUPS: $99b4b6eebbad4f1e$var$shouldIncludeGUPS(product, cyeaExperimentCohort)
        }), [
        cyeaExperimentCohort,
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $78QJo.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $2iKJM.DIALOG_CONFIG)
    });
}

});
parcelRegister("3Wwdw", function(module, exports) {
$parcel$export(module.exports, "getJiraProjectTypeKey", () => $9b75fbe3fa35de01$export$600268f282087736);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $9b75fbe3fa35de01$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $9b75fbe3fa35de01$export$600268f282087736 = (product)=>{
    return $9b75fbe3fa35de01$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};

});

parcelRegister("2iKJM", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $2d38a3129aa8200e$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $2d38a3129aa8200e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("78QJo", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $6dede9aaa19d78c4$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $5jTld = parcelRequire("5jTld");

const $6dede9aaa19d78c4$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hRvKi")), {
        moduleId: "afc4323d",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence, shouldIncludeGUPS: shouldIncludeGUPS })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardModalQuery: {
                    parameters: $5jTld.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence,
                        shouldIncludeGUPS: shouldIncludeGUPS
                    }
                }
            }
        })
});

});
parcelRegister("5jTld", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9add94e279d4ff8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79d7b0f2d178f6b15d3a0ab0751bed52>>
 * @relayHash f414c8c351fff5fe86a702b3d5940cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b914287c9466ffe442e8832ba3cbc0ec27ded02133bd16d689996ab511d83209

var $37Ewn = parcelRequire("37Ewn");
const $b9add94e279d4ff8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeGUPS"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v6 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v7 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v9 = {
        "condition": "shouldIncludeGUPS",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getUnifiedProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileSiteDetails",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "GrowthUnifiedProfileProductDetails",
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "productName"
                                    },
                                    {
                                        "concreteType": "GrowthUnifiedProfileProductNBE",
                                        "kind": "LinkedField",
                                        "name": "nbeRecommendation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "edition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "recommendationDate"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v10 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v6 /*: any*/ 
    ], v11 = {
        "args": v10 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v12 = {
        "args": v10 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v13 = {
        "args": v10 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v14 = [
        v6 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v15 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "freeToStandardModalQuery",
            "selections": [
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v15 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "freeToStandardModalQuery",
            "selections": [
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v15 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v7 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b914287c9466ffe442e8832ba3cbc0ec27ded02133bd16d689996ab511d83209",
            "metadata": {},
            "name": "freeToStandardModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b9add94e279d4ff8$var$node.hash = "c472eaeb7d557347cdcd839b736b6cda";
(0, $37Ewn.PreloadableQueryRegistry).set($b9add94e279d4ff8$var$node.params.id, $b9add94e279d4ff8$var$node);
var $b9add94e279d4ff8$export$2e2bcd8739ae039 = $b9add94e279d4ff8$var$node;

});

parcelRegister("hRvKi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ezP1Z")
]).then(()=>parcelRequire('fOl4O'));

});



parcelRegister("lPbzI", function(module, exports) {
$parcel$export(module.exports, "FreeToStandardRefreshModal", () => $b8e437f359baa4fd$export$bb3f0c07c7eb1cc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $3Wwdw = parcelRequire("3Wwdw");

var $fYq8K = parcelRequire("fYq8K");

var $hV7hJ = parcelRequire("hV7hJ");

var $5awx7 = parcelRequire("5awx7");
function $b8e437f359baa4fd$export$bb3f0c07c7eb1cc() {
    const { product: product, cloudId: cloudId } = (0, $aLED4.useEditionAwareness)();
    const projectType = (0, $3Wwdw.getJiraProjectTypeKey)(product);
    if (!projectType) throw new Error('Tried to render free to standard refresh dialog for unsupported product');
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectType: projectType
        }), [
        cloudId,
        projectType
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 932,
            height: 500
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $5awx7.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $hV7hJ.DIALOG_CONFIG)
    });
}

});
parcelRegister("hV7hJ", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $55f940c11d6bb790$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $55f940c11d6bb790$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-refresh-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("5awx7", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $942b72f6d4405c10$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $4COsV = parcelRequire("4COsV");

const $942b72f6d4405c10$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bhZBC")), {
        moduleId: "b8007f47",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-refresh-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardRefreshModalQuery: {
                    parameters: $4COsV.default,
                    variables: {
                        cloudId: cloudId,
                        projectType: projectType
                    }
                }
            }
        })
});

});
parcelRegister("4COsV", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe08f0109be4d22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcad1347ec5d911979066311575d1def>>
 * @relayHash 076bb6c4d9d049c1aa218840c9dfadc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e787304b75e454ca0c1651c155b7a855b7719b06c5e57941f7042940c5d3694

var $37Ewn = parcelRequire("37Ewn");
const $ebe08f0109be4d22$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "freeToStandardRefreshModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "freeToStandardRefreshModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2e787304b75e454ca0c1651c155b7a855b7719b06c5e57941f7042940c5d3694",
            "metadata": {},
            "name": "freeToStandardRefreshModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ebe08f0109be4d22$var$node.hash = "add28ab8fceeba3e37a636585af2dd9f";
(0, $37Ewn.PreloadableQueryRegistry).set($ebe08f0109be4d22$var$node.params.id, $ebe08f0109be4d22$var$node);
var $ebe08f0109be4d22$export$2e2bcd8739ae039 = $ebe08f0109be4d22$var$node;

});

parcelRegister("bhZBC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gBafa")
]).then(()=>parcelRequire('3cTdW'));

});



parcelRegister("7iwBT", function(module, exports) {
$parcel$export(module.exports, "PaymentDetailsPopup", () => $a426fb544528e942$export$7d88b723086482e8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $664dI = parcelRequire("664dI");

var $5qHtZ = parcelRequire("5qHtZ");

var $5FpjR = parcelRequire("5FpjR");
function $a426fb544528e942$export$7d88b723086482e8() {
    const { edition: edition } = (0, $aLED4.useEditionAwareness)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $664dI.PopupEntryPoint), {
        entryPoint: (0, $5FpjR.entryPoint),
        placement: 'bottom-start',
        dialogConfig: edition === 'standard' ? (0, $5qHtZ.STANDARD_DIALOG_CONFIG) : (0, $5qHtZ.PREMIUM_DIALOG_CONFIG)
    });
}

});
parcelRegister("5qHtZ", function(module, exports) {
$parcel$export(module.exports, "PREMIUM_DIALOG_CONFIG", () => $c1805f03a6dd9a91$export$1a0ae553b5d69abc);
$parcel$export(module.exports, "STANDARD_DIALOG_CONFIG", () => $c1805f03a6dd9a91$export$e42f11d536a45036);

var $dl00O = parcelRequire("dl00O");
const $c1805f03a6dd9a91$export$1a0ae553b5d69abc = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $dl00O.Edition).PREMIUM_EDITION
};
const $c1805f03a6dd9a91$export$e42f11d536a45036 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("5FpjR", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $a95ed6b4ceabd975$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a95ed6b4ceabd975$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fsYkQ")), {
        moduleId: "43cb1037",
        priority: "interaction",
        moduleId: 'edition-awareness-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("fsYkQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("18DLz")
]).then(()=>parcelRequire('b5hCG'));

});



parcelRegister("jGDgv", function(module, exports) {
$parcel$export(module.exports, "PlanSelectionPageModal", () => $d8722ea79b3e82a3$export$d906ffa5ff65562d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $fYq8K = parcelRequire("fYq8K");

var $dJ7e2 = parcelRequire("dJ7e2");

var $iynol = parcelRequire("iynol");
const $d8722ea79b3e82a3$var$MODAL_CONFIGS = {
    twc: {
        width: '968px',
        height: '808px'
    },
    'reverse-trial': {
        width: '990px',
        height: '771px'
    }
};
function $d8722ea79b3e82a3$export$d906ffa5ff65562d({ type: type }) {
    const { cloudId: cloudId, product: product } = (0, $aLED4.useEditionAwareness)();
    const { width: width, height: height } = $d8722ea79b3e82a3$var$MODAL_CONFIGS[type];
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            type: type
        }), [
        type
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: width,
            height: height,
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true
        }), [
        width,
        height
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $iynol.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $dJ7e2.DIALOG_CONFIG)
    });
}

});
parcelRegister("dJ7e2", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $c1d63960738c1570$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $c1d63960738c1570$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).SELECTION
};

});

parcelRegister("iynol", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $0b0dcee3bd9375f4$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $aqnSy = parcelRequire("aqnSy");

const $0b0dcee3bd9375f4$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("aCBrh")), {
        moduleId: "d069ac51",
        priority: "interaction",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                planSelectionPageModalQuery: {
                    parameters: $aqnSy.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("aqnSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $99b044bf640ebba8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a2c299c3370e776909144f2aeddf21a>>
 * @relayHash f8efbc82dcbdf8e7ea9e842b687fdc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45

var $37Ewn = parcelRequire("37Ewn");
const $99b044bf640ebba8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45",
            "metadata": {},
            "name": "planSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$99b044bf640ebba8$var$node.hash = "5856634e7757286e019aec8f127ddc46";
(0, $37Ewn.PreloadableQueryRegistry).set($99b044bf640ebba8$var$node.params.id, $99b044bf640ebba8$var$node);
var $99b044bf640ebba8$export$2e2bcd8739ae039 = $99b044bf640ebba8$var$node;

});

parcelRegister("aCBrh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5ncEu").then(()=>parcelRequire('bC3h9'));

});



parcelRegister("a2rSK", function(module, exports) {
$parcel$export(module.exports, "PremiumAddPaymentModal", () => $a8633aa50719c39e$export$45cd24e1ba5c2588);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fYq8K = parcelRequire("fYq8K");

var $iAvWX = parcelRequire("iAvWX");

var $cDPAb = parcelRequire("cDPAb");
function $a8633aa50719c39e$export$45cd24e1ba5c2588() {
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 968,
            height: 576
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $cDPAb.entryPoint),
        modalProps: modalProps,
        dialogConfig: (0, $iAvWX.DIALOG_CONFIG)
    });
}

});
parcelRegister("iAvWX", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $98e8dfffd2965cd5$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $98e8dfffd2965cd5$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).PREMIUM_EDITION
};

});

parcelRegister("cDPAb", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $d8b6541ce57c3b5c$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d8b6541ce57c3b5c$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("01skH")), {
        moduleId: "f32031a2",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("01skH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("ejM5d")
]).then(()=>parcelRequire('3nYjj'));

});



parcelRegister("aKvI4", function(module, exports) {
$parcel$export(module.exports, "PremiumPopup", () => $f86ed2949da739e3$export$831a974b36144ba6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $664dI = parcelRequire("664dI");

var $dznWl = parcelRequire("dznWl");

var $c8s85 = parcelRequire("c8s85");

var $iPWxB = parcelRequire("iPWxB");
const $f86ed2949da739e3$export$831a974b36144ba6 = ()=>{
    const { cloudId: cloudId, product: product, PremiumWrapper: PremiumWrapper, trialDaysLeft: trialDaysLeft, userRoles: userRoles, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial } = (0, $aLED4.useEditionAwareness)();
    const [isPremiumModalOpen, setIsPremiumModalOpen] = (0, $eJOHy.useState)(false);
    const handleClosePremiumModal = (0, $eJOHy.useCallback)(()=>setIsPremiumModalOpen(false), []);
    const handleOpenPremiumModal = (0, $eJOHy.useCallback)(()=>setIsPremiumModalOpen(true), []);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product)
        }), [
        product,
        cloudId
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            handleOpenPremiumModal: handleOpenPremiumModal,
            onClose: handleClosePremiumModal
        }), [
        handleOpenPremiumModal,
        handleClosePremiumModal
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        // This will reset the auto open state from product
        onAutoOpen?.();
    }, [
        onAutoOpen
    ]);
    if (!PremiumWrapper) // Shouldn't happen, but if it does then we can at least still show the customer a dialog
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: shouldAutoOpen ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dznWl.AutoOpenPopupTrigger), {
            entryPoint: (0, $iPWxB.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $c8s85.DIALOG_CONFIG)
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $664dI.PopupEntryPoint), {
            entryPoint: (0, $iPWxB.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $c8s85.DIALOG_CONFIG)
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(PremiumWrapper, {
            isInTrial: Boolean(isInTrial),
            isInReverseTrial: Boolean(isInReverseTrial),
            trialDaysLeft: trialDaysLeft,
            isSiteAdmin: !!userRoles?.includes('SITE_ADMIN'),
            isPremiumModalOpen: isPremiumModalOpen,
            onClosePremiumModal: handleClosePremiumModal,
            children: shouldAutoOpen ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dznWl.AutoOpenPopupTrigger), {
                entryPoint: (0, $iPWxB.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $c8s85.DIALOG_CONFIG)
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $664dI.PopupEntryPoint), {
                entryPoint: (0, $iPWxB.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $c8s85.DIALOG_CONFIG)
            })
        })
    });
};

});
parcelRegister("dznWl", function(module, exports) {
$parcel$export(module.exports, "AutoOpenPopupTrigger", () => $a6d6073f382c1920$export$6189e5bf9171fa04);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $e2B2h = parcelRequire("e2B2h");

var $kJsb4 = parcelRequire("kJsb4");

var $8nu6j = parcelRequire("8nu6j");

var $7ep4S = parcelRequire("7ep4S");

var $lBsyH = parcelRequire("lBsyH");

var $4Gyvo = parcelRequire("4Gyvo");

var $e9ksW = parcelRequire("e9ksW");

var $3UQ55 = parcelRequire("3UQ55");

var $eAOjM = parcelRequire("eAOjM");
const $a6d6073f382c1920$var$emptyEntryPointParams = {};
const $a6d6073f382c1920$var$emptyEntryPointProps = {};
function $a6d6073f382c1920$export$6189e5bf9171fa04(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($a6d6073f382c1920$var$AutoOpenPopupTriggerInner, {
            ...rest
        })
    });
}
/**
 * THIS IS A TEMPORARY IMPLEMENTATION, WILL BE REMOVED IN THE FUTURE
 * NOT RECOMMENDED FOR USE ANYWHERE ELSE
 * Supports the auto-open functionality for the Confluence Premium Popup
 */ function $a6d6073f382c1920$var$AutoOpenPopupTriggerInner({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $4Gyvo.useRelayEnvironmentProvider)();
    const onError = (0, $e9ksW.useEntrypointErrorAnalytics)();
    const onDismiss = (0, $3UQ55.useOnCloseDialog)();
    const id = (0, $eJOHy.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [content, setContent] = (0, $eJOHy.useState)(null);
    const handleOpen = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $eJOHy.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
        onDismiss();
    }, [
        onClose,
        onDismiss
    ]);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $a6d6073f382c1920$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBsyH.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)($a6d6073f382c1920$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $a6d6073f382c1920$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $eJOHy.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAOjM.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $eJOHy.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $eJOHy.useRef)(false);
    // Auto-open on load
    (0, $eJOHy.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
const $a6d6073f382c1920$var$PopupFallback = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });

});

parcelRegister("c8s85", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $3198890805327875$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $3198890805327875$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $dl00O.Edition).PREMIUM_EDITION
};

});

parcelRegister("iPWxB", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $195ed07c9294e469$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $agXGO = parcelRequire("agXGO");

const $195ed07c9294e469$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jZavV")), {
        moduleId: "d68a8af6",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                confluencePremiumPopupQuery: {
                    parameters: $agXGO.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("agXGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $a21c69e8784acf98$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5821fe529cfc22897c2985ff0ad736c4>>
 * @relayHash f5958739e09e5411147f112f6550ea59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7

var $37Ewn = parcelRequire("37Ewn");
const $a21c69e8784acf98$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7",
            "metadata": {},
            "name": "confluencePremiumPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a21c69e8784acf98$var$node.hash = "42c226cd7fc904c05729c90bcaaed23e";
(0, $37Ewn.PreloadableQueryRegistry).set($a21c69e8784acf98$var$node.params.id, $a21c69e8784acf98$var$node);
var $a21c69e8784acf98$export$2e2bcd8739ae039 = $a21c69e8784acf98$var$node;

});

parcelRegister("jZavV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("68cVV")
]).then(()=>parcelRequire('4Accx'));

});



parcelRegister("81iQz", function(module, exports) {
$parcel$export(module.exports, "ReverseTrialPopupDialog", () => $c51a5313158b9035$export$436172fa0e71e289);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $664dI = parcelRequire("664dI");

var $1m7bZ = parcelRequire("1m7bZ");

var $8DaJf = parcelRequire("8DaJf");
function $c51a5313158b9035$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId } = (0, $aLED4.useEditionAwareness)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $664dI.PopupEntryPoint), {
        entryPoint: (0, $8DaJf.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $1m7bZ.DIALOG_CONFIG)
    });
}

});
parcelRegister("1m7bZ", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $7b86730c2da3b984$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $7b86730c2da3b984$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $dl00O.Edition).PREMIUM_EDITION
};

});

parcelRegister("8DaJf", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $925ae797e03ff3fd$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $ltHjG = parcelRequire("ltHjG");

const $925ae797e03ff3fd$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("avLIy")), {
        moduleId: "38aee5f9",
        priority: "interaction",
        moduleId: 'edition-awareness-reverse-trial-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                reverseTrialPopupQuery: {
                    parameters: $ltHjG.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("ltHjG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4d2b0e561ceee06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e7ab9d82c11f650f2bdc01edf024c90>>
 * @relayHash fb387ee4c17d62b6ce4867baf6061884
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b

var $37Ewn = parcelRequire("37Ewn");
const $e4d2b0e561ceee06$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b",
            "metadata": {},
            "name": "reverseTrialPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e4d2b0e561ceee06$var$node.hash = "7149df0cbb7841476e95591ab561c360";
(0, $37Ewn.PreloadableQueryRegistry).set($e4d2b0e561ceee06$var$node.params.id, $e4d2b0e561ceee06$var$node);
var $e4d2b0e561ceee06$export$2e2bcd8739ae039 = $e4d2b0e561ceee06$var$node;

});

parcelRegister("avLIy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("hQOH3")
]).then(()=>parcelRequire('6MJKj'));

});



parcelRegister("k6fSn", function(module, exports) {
$parcel$export(module.exports, "SpecialOfferSixtyModal", () => $f685ad2006b4dd8d$export$28e8832f80c55136);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $3Wwdw = parcelRequire("3Wwdw");

var $fYq8K = parcelRequire("fYq8K");

var $b1ZrA = parcelRequire("b1ZrA");

var $lydwt = parcelRequire("lydwt");
function $f685ad2006b4dd8d$export$28e8832f80c55136() {
    const { cloudId: cloudId, product: product } = (0, $aLED4.useEditionAwareness)();
    const projectType = (0, $3Wwdw.getJiraProjectTypeKey)(product);
    if (!projectType) throw new Error('Tried to render special offer sixty modal for unsupported product. Product: ' + product);
    const entryPointParams = {
        cloudId: cloudId,
        projectType: projectType
    };
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 968,
            height: 568
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $lydwt.entryPoint),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $b1ZrA.DIALOG_CONFIG)
    });
}

});
parcelRegister("b1ZrA", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $9ff84e84d7a62848$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $9ff84e84d7a62848$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'special-offer-sixty-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("lydwt", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $bf97c6006cc6c6e9$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $43AwN = parcelRequire("43AwN");

const $bf97c6006cc6c6e9$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9aWvh")), {
        moduleId: "652ea50a",
        priority: "interaction",
        moduleId: 'edition-awareness-special-offer-sixty-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                specialOfferSixtyModalQuery: {
                    parameters: $43AwN.default,
                    variables: {
                        cloudId: cloudId,
                        projectType: projectType
                    }
                }
            }
        })
});

});
parcelRegister("43AwN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff3b193d429d6810$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e13bd47da081d26d9973b8612665a27f>>
 * @relayHash 18a19388990ad5495499cf916821c41f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54b26d57473f480c736b713e1e344d4254fcb367d0d9cf5696dca539e63b93c1

var $37Ewn = parcelRequire("37Ewn");
const $ff3b193d429d6810$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "specialOfferSixtyModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "specialOfferSixtyModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "54b26d57473f480c736b713e1e344d4254fcb367d0d9cf5696dca539e63b93c1",
            "metadata": {},
            "name": "specialOfferSixtyModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff3b193d429d6810$var$node.hash = "8897785224a240053607a72b915d6145";
(0, $37Ewn.PreloadableQueryRegistry).set($ff3b193d429d6810$var$node.params.id, $ff3b193d429d6810$var$node);
var $ff3b193d429d6810$export$2e2bcd8739ae039 = $ff3b193d429d6810$var$node;

});

parcelRegister("9aWvh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("h8XpL")
]).then(()=>parcelRequire('8SLN8'));

});



parcelRegister("eC5BP", function(module, exports) {
$parcel$export(module.exports, "StandardAddPaymentModal", () => $fb2c7f7c931afff9$export$e7d982549be9547c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $kaE00 = parcelRequire("kaE00");

var $9evzz = parcelRequire("9evzz");

var $3Wwdw = parcelRequire("3Wwdw");

var $h1104 = parcelRequire("h1104");

var $fYq8K = parcelRequire("fYq8K");

var $5QG0T = parcelRequire("5QG0T");

var $gKXiL = parcelRequire("gKXiL");
function $fb2c7f7c931afff9$export$e7d982549be9547c() {
    const { product: product, cloudId: cloudId } = (0, $aLED4.useEditionAwareness)();
    const projectType = (0, $3Wwdw.getJiraProjectTypeKey)(product);
    const jiraApplicationKey = (0, $9evzz.getJiraApplicationKey)(product);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product),
            chargeElement: (0, $kaE00.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600
        };
        return {
            width: 968,
            height: 576
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $gKXiL.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $5QG0T.DIALOG_CONFIG)
    });
}

});
parcelRegister("5QG0T", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $74c7a324cd635140$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $74c7a324cd635140$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("gKXiL", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $73958534184559e2$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $9nSAp = parcelRequire("9nSAp");

const $73958534184559e2$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("9GINJ")), {
        moduleId: "8a2449b3",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardAddPaymentModalQuery: {
                    parameters: $9nSAp.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("9nSAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1a883ed8f0980ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5568e86e767c1f7e601e3156c2ec0fd2>>
 * @relayHash 081ae02dbc9e7d3009e7fbdca4492722
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9

var $37Ewn = parcelRequire("37Ewn");
const $b1a883ed8f0980ca$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v10 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v10 /*: any*/ 
    ], v14 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v15 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v16 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v17 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9",
            "metadata": {},
            "name": "standardAddPaymentModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b1a883ed8f0980ca$var$node.hash = "1a2deb9f2ae9b251077ad9a1cce4e589";
(0, $37Ewn.PreloadableQueryRegistry).set($b1a883ed8f0980ca$var$node.params.id, $b1a883ed8f0980ca$var$node);
var $b1a883ed8f0980ca$export$2e2bcd8739ae039 = $b1a883ed8f0980ca$var$node;

});

parcelRegister("9GINJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("35m47")
]).then(()=>parcelRequire('6KxRp'));

});



parcelRegister("9G3RQ", function(module, exports) {
$parcel$export(module.exports, "StandardTrialLimitBreakersModal", () => $3dc5093844a0b5e2$export$5c6029d6bd848fe3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $9evzz = parcelRequire("9evzz");

var $3Wwdw = parcelRequire("3Wwdw");

var $fYq8K = parcelRequire("fYq8K");

var $5mABA = parcelRequire("5mABA");

var $7RzGr = parcelRequire("7RzGr");
function $3dc5093844a0b5e2$export$5c6029d6bd848fe3() {
    const { product: product, cloudId: cloudId } = (0, $aLED4.useEditionAwareness)();
    const jiraApplicationKey = (0, $9evzz.getJiraApplicationKey)(product);
    const projectType = (0, $3Wwdw.getJiraProjectTypeKey)(product);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            projectType: projectType ?? 'SOFTWARE',
            shouldIncludeIfProductIsConfluence: product === 'confluence',
            shouldIncludeIfProductIsJiraSoftware: product === 'jira'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        entryPoint: (0, $7RzGr.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $5mABA.DIALOG_CONFIG)
    });
}

});
parcelRegister("5mABA", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $71251f43e4874a86$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $71251f43e4874a86$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-trial-limit-breakers-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("7RzGr", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $a20021a9745e0d1f$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $5BKns = parcelRequire("5BKns");

const $a20021a9745e0d1f$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fXR5Z")), {
        moduleId: "bd9500f5",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-trial-limit-breakers-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, jiraApplicationKey: jiraApplicationKey, projectType: projectType, shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence, shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardTrialLimitBreakersModalQuery: {
                    parameters: $5BKns.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence,
                        shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware
                    }
                }
            }
        })
});

});
parcelRegister("5BKns", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ddf299f780d7590$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d4f4fa10cb1ef6f4f57d93e7954fb46>>
 * @relayHash a947bab4dac1ef6718fb3c84adf315bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67e2eacd3acce089b612cf033c703816a8e2ed3928c75edf7e54fd8611fc3b09

var $37Ewn = parcelRequire("37Ewn");
const $8ddf299f780d7590$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraApplicationKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeIfProductIsConfluence"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeIfProductIsJiraSoftware"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v1 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardTrialLimitBreakersModalQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "jiraApplicationKey",
                            "variableName": "jiraApplicationKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectType",
                            "variableName": "projectType"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsConfluence",
                            "variableName": "shouldIncludeIfProductIsConfluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsJiraSoftware",
                            "variableName": "shouldIncludeIfProductIsJiraSoftware"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "limitBreakersModal_AtlassianEditionAwareness"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardTrialLimitBreakersModalQuery",
            "selections": [
                {
                    "condition": "shouldIncludeIfProductIsConfluence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceStorage",
                            "kind": "LinkedField",
                            "name": "confluence_storage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isUnlimited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "bytesLimit"
                                }
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "cql",
                                    "value": "type=user"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "excludeServiceAppUsers",
                                    "value": true
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 200
                                }
                            ],
                            "concreteType": "ConfluenceSearchConnection",
                            "kind": "LinkedField",
                            "name": "confluence_searchUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluencePerson",
                                            "kind": "LinkedField",
                                            "name": "confluencePerson",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "concreteType": "Icon",
                                                    "kind": "LinkedField",
                                                    "name": "profilePicture",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "path"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldIncludeIfProductIsJiraSoftware",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageAllowed"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageIsUnlimited"
                                },
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "fields": [
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "types.0",
                                                            "variableName": "projectType"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "types"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 20
                                                                }
                                                            ],
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:20)"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67e2eacd3acce089b612cf033c703816a8e2ed3928c75edf7e54fd8611fc3b09",
            "metadata": {},
            "name": "standardTrialLimitBreakersModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8ddf299f780d7590$var$node.hash = "70fbc764ea31e18b35433affd71b9531";
(0, $37Ewn.PreloadableQueryRegistry).set($8ddf299f780d7590$var$node.params.id, $8ddf299f780d7590$var$node);
var $8ddf299f780d7590$export$2e2bcd8739ae039 = $8ddf299f780d7590$var$node;

});

parcelRegister("fXR5Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("42uNc")
]).then(()=>parcelRequire('afYJJ'));

});



parcelRegister("lUiJU", function(module, exports) {
$parcel$export(module.exports, "StorageHardLimitModal", () => $8f5eb47b094af5d4$export$d58ea28307440812);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fYq8K = parcelRequire("fYq8K");

var $gm1KA = parcelRequire("gm1KA");

var $MCmlk = parcelRequire("MCmlk");
function $8f5eb47b094af5d4$export$d58ea28307440812() {
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $MCmlk.default),
        dialogConfig: (0, $gm1KA.DIALOG_CONFIG)
    });
}

});
parcelRegister("gm1KA", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $b56453285c96854f$export$3b6761b6086f6dfd);

var $dl00O = parcelRequire("dl00O");
const $b56453285c96854f$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'storage-hard-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $dl00O.Edition).STANDARD_EDITION
};

});

parcelRegister("MCmlk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce8bf962f4e441c0$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ce8bf962f4e441c0$var$ModalNameEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bmgaC")), {
        moduleId: "c613c169",
        priority: "interaction",
        moduleId: 'edition-awareness-storage-hard-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $ce8bf962f4e441c0$export$2e2bcd8739ae039 = $ce8bf962f4e441c0$var$ModalNameEntryPoint;

});
parcelRegister("bmgaC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("qyXGs")
]).then(()=>parcelRequire('3lzEQ'));

});



parcelRegister("lkomN", function(module, exports) {
$parcel$export(module.exports, "AddPaymentLink", () => $b6773bf51e7626fc$export$c3039f8cc491a849);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $k71qx = parcelRequire("k71qx");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $45U1E = parcelRequire("45U1E");

var $eAOjM = parcelRequire("eAOjM");
const $b6773bf51e7626fc$export$c3039f8cc491a849 = ({ href: href })=>{
    const context = (0, $aLED4.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    const handleAddPaymentClick = (0, $eJOHy.useCallback)(()=>{
        // Fire exposure for ea_to_osb_experiment control tenants
        if ((0, $45U1E.isEligibleForEAtoOSBExperiment)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        getExperimentValue,
        context
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "@atlassian/edition-awareness.link.add-payment-tooltip",
            defaultMessage: "Add payment details to keep your subscription",
            description: "Tooltip for add payment details button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAOjM.EditionAwarenessLink), {
            href: href,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "predunning",
            onClick: handleAddPaymentClick
        })
    });
};

});

parcelRegister("2BQtG", function(module, exports) {
$parcel$export(module.exports, "JiraStandardTrialOverviewLink", () => $a1114e0c4541ac9b$export$7e52df418278fb7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $k71qx = parcelRequire("k71qx");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $45ust = parcelRequire("45ust");

var $45U1E = parcelRequire("45U1E");

var $5KKaK = parcelRequire("5KKaK");

var $ktqhG = parcelRequire("ktqhG");

var $eAOjM = parcelRequire("eAOjM");
const $a1114e0c4541ac9b$export$7e52df418278fb7 = ()=>{
    const context = (0, $aLED4.useEditionAwareness)();
    const { cloudId: cloudId, environment: environment, billingSourceSystem: billingSourceSystem, userEmail: userEmail, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    const handleJstoClick = (0, $eJOHy.useCallback)(()=>{
        if (automationFreeLimitStatus) getExperimentValue({
            statsigParams: {
                experimentName: 'growth_automation_limits_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
        // Fire exposure for ea_to_osb_experiment control tenants
        if ((0, $45U1E.isEligibleForEAtoOSBExperiment)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        automationFreeLimitStatus,
        getExperimentValue,
        context
    ]);
    // This information should always be available, given the prior checks to get here
    if (!environment || !billingSourceSystem || !userEmail) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ktqhG.NoAction), {});
    const rawJstoUrl = `${(0, $5KKaK.WAC_URL)[environment]}/software/jira?ref=edition_awareness_standard_trial_` + `${billingSourceSystem.toLowerCase()}&cloudSiteId=${cloudId}`;
    const jstoUrl = (0, $45ust.getLoggedInPage)(userEmail, rawJstoUrl);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip",
            defaultMessage: "More about your trial and how to pay",
            description: "Tooltip for trial information button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAOjM.EditionAwarenessLink), {
            href: jstoUrl,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "jsto",
            onClick: handleJstoClick
        })
    });
};

});
parcelRegister("45ust", function(module, exports) {
$parcel$export(module.exports, "getLoggedInPage", () => $01c20f7c9daf92b0$export$30ac0f723bd6cc08);

var $8RHPx = parcelRequire("8RHPx");
function $01c20f7c9daf92b0$export$30ac0f723bd6cc08(userEmail, pageUrl) {
    const encodedPageUrl = encodeURIComponent(pageUrl);
    const encodedUserEmail = encodeURIComponent(userEmail);
    // This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
    return `https://${(0, $8RHPx.getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}

});

parcelRegister("5KKaK", function(module, exports) {
$parcel$export(module.exports, "WAC_URL", () => $020b1a9c48b64111$export$5e8c8041aa206ba5);
const $020b1a9c48b64111$export$5e8c8041aa206ba5 = {
    prod: 'https://www.atlassian.com',
    staging: 'https://wac.stg.internal.atlassian.com',
    dev: 'https://wac.stg.internal.atlassian.com',
    local: 'https://wac.stg.internal.atlassian.com'
};

});


parcelRegister("2SKrs", function(module, exports) {
$parcel$export(module.exports, "PaymentFlowLink", () => $4a93072ed02359a2$export$aa8ff608e1ef425);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $k71qx = parcelRequire("k71qx");

var $a0oOn = parcelRequire("a0oOn");

var $eAOjM = parcelRequire("eAOjM");
const $4a93072ed02359a2$export$aa8ff608e1ef425 = ({ href: href })=>{
    const { getExperimentValue: getExperimentValue } = (0, $a0oOn.useGetExperimentValue)();
    const handlePaymentFlowClick = (0, $eJOHy.useCallback)(()=>{
        // Fire exposure for ea_to_osb_experiment variant tenants
        getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        getExperimentValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            id: "@atlassian/edition-awareness.link.payment-flow-tooltip",
            defaultMessage: "Add payment details to keep your subscription",
            description: "Tooltip for add payment details button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAOjM.EditionAwarenessLink), {
            href: href,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "payment-flow",
            onClick: handlePaymentFlowClick
        })
    });
};

});



parcelRegister("cY4TY", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $560242cd73765e1c$export$e926676385687eaf);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7aoMz = parcelRequire("7aoMz");

var $2QO3b = parcelRequire("2QO3b");

var $8ex9s = parcelRequire("8ex9s");
const $560242cd73765e1c$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $8ex9s.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const onError = (0, $eJOHy.useCallback)((error)=>{
        const interaction = (0, $2QO3b.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $2QO3b.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $2QO3b.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {}),
        children: children
    });
};

});
parcelRegister("8ex9s", function(module, exports) {
$parcel$export(module.exports, "useErrorAnalytics", () => $ce1f926d8f8d3afc$export$e2d4523bbccd2343);

var $eJOHy = parcelRequire("eJOHy");

var $kOgfc = parcelRequire("kOgfc");
/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $ce1f926d8f8d3afc$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const sendOperationalEvent = (0, $kOgfc.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    return (0, $eJOHy.useCallback)((attributes)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: attributes
        });
    }, [
        sendOperationalEvent
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $ce1f926d8f8d3afc$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $ce1f926d8f8d3afc$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$ce1f926d8f8d3afc$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $ce1f926d8f8d3afc$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $ce1f926d8f8d3afc$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $eJOHy.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $ce1f926d8f8d3afc$var$isSLOError(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $ce1f926d8f8d3afc$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $ce1f926d8f8d3afc$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $eJOHy.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}

});


parcelRegister("apOA4", function(module, exports) {
$parcel$export(module.exports, "useSpotlight", () => $5e86cf3e5b354d71$export$cc7026713a353975);
$parcel$export(module.exports, "Spotlights", () => $5e86cf3e5b354d71$export$c7b90ff96148d0e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bdRit = parcelRequire("bdRit");
var $d2s5v = parcelRequire("d2s5v");

var $aLED4 = parcelRequire("aLED4");
const $5e86cf3e5b354d71$var$SpotlightContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $5e86cf3e5b354d71$export$cc7026713a353975() {
    const setActiveSpotlight = (0, $eJOHy.useContext)($5e86cf3e5b354d71$var$SpotlightContext);
    if (!setActiveSpotlight) return {
        setActiveSpotlight: ()=>{}
    };
    return {
        setActiveSpotlight: setActiveSpotlight
    };
}
function $5e86cf3e5b354d71$var$GotIt() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        id: "@atlassian/edition-awareness.spotlights.got-it",
        defaultMessage: "Got it",
        description: "Spotlight button text which is used to dismiss the spotlight"
    });
}
function $5e86cf3e5b354d71$var$ActiveSpotlight({ id: id, onDismiss: onDismiss }) {
    const { product: product } = (0, $aLED4.useEditionAwareness)();
    if (id === 'standard-to-premium') {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2s5v.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
                actions: [
                    {
                        onClick: onDismiss,
                        text: /*#__PURE__*/ (0, $gt9Am.jsx)($5e86cf3e5b354d71$var$GotIt, {})
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready.",
                    description: "Message to show in the spotlight on the profile menu icon when the user dismisses the EA pill and is eligible for standard to premium upsell"
                })
            })
        });
    }
    return null;
}
function $5e86cf3e5b354d71$export$c7b90ff96148d0e3({ children: children }) {
    const [activeSpotlight, setActiveSpotlight] = (0, $eJOHy.useState)(null);
    const handleOnDismiss = (0, $eJOHy.useCallback)(()=>setActiveSpotlight(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($5e86cf3e5b354d71$var$SpotlightContext.Provider, {
                value: setActiveSpotlight,
                children: children
            }),
            activeSpotlight && /*#__PURE__*/ (0, $gt9Am.jsx)($5e86cf3e5b354d71$var$ActiveSpotlight, {
                id: activeSpotlight,
                onDismiss: handleOnDismiss
            })
        ]
    });
}

});


parcelRegister("D3BHJ", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessUpsell", () => $3cc52274348a0426$export$148b30c5d238daaa);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $6FOAB = parcelRequire("6FOAB");

var $4Gyvo = parcelRequire("4Gyvo");

var $04skO = parcelRequire("04skO");

var $aLED4 = parcelRequire("aLED4");

var $a0oOn = parcelRequire("a0oOn");

var $dUMxA = parcelRequire("dUMxA");

var $kPD5C = parcelRequire("kPD5C");

var $eYTNZ = parcelRequire("eYTNZ");

var $cY4TY = parcelRequire("cY4TY");

var $apOA4 = parcelRequire("apOA4");
/**
 * This is a required action in context, just not used in the upsell modal
 */ function $3cc52274348a0426$var$startCheckingForAttemptToUpgrade() {
    return new Promise((resolve)=>resolve(false));
}
/**
 * Edition awareness upsell is an experimental EA implementtiona that has to be exported as its own component to avoid making ccp calls which are alerting VC90 mertics
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $3cc52274348a0426$var$EditionAwarenessUpsellImpl({ edition: edition, product: product, cloudId: cloudId, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, navVersion: navVersion }) {
    const trialOfferingName = (0, $dUMxA.getTrialOfferingName)(product, edition);
    const context = (0, $eJOHy.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            trialOfferingName: trialOfferingName,
            // This is not used in this flow, but a required type in context
            licensedUsers: 1,
            // This is displayed to sites that are on not trial not predunning
            invoiceableStatus: 'INVOICEABLE',
            startCheckingForAttemptToUpgrade: $3cc52274348a0426$var$startCheckingForAttemptToUpgrade,
            hasDialogAutoOpened () {
                // Require for context, not used in the modal
                return true;
            }
        };
    }, [
        cloudId,
        product,
        edition,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        trialOfferingName
    ]);
    const experimentContextValue = (0, $eJOHy.useMemo)(()=>new (0, $a0oOn.ExperimentContextClass)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a0oOn.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLED4.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
                data: {
                    navVersion: navVersion,
                    hasDismissedButton: hasDismissedButton
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $apOA4.Spotlights), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($3cc52274348a0426$var$StandardEdition, {})
                })
            })
        })
    });
}
function $3cc52274348a0426$export$148b30c5d238daaa(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gyvo.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
            name: "edition-awareness-upsell",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cY4TY.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "edition-awareness-upsell",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($3cc52274348a0426$var$EditionAwarenessUpsellImpl, {
                        ...props
                    })
                })
            })
        })
    });
}
function $3cc52274348a0426$var$StandardEdition() {
    const context = (0, $aLED4.useEditionAwareness)();
    const { product: product, hasDismissedButton: hasDismissedButton } = context;
    const { getExperimentValueWithTransform: getExperimentValueWithTransform } = (0, $a0oOn.useGetExperimentValue)();
    if ((0, $kPD5C.isEligibleForStandardToPremium)(context) && !hasDismissedButton) {
        let experimentKey;
        if (product === 'confluence') experimentKey = 'edition_awareness_standard_upsell_confluence_ab';
        else if (product === 'jira-product-discovery') experimentKey = 'edition_awareness_upsell_jpd';
        else experimentKey = 'edition_awareness_upsell_jira_ab';
        const cohort = getExperimentValueWithTransform({
            statsigParams: {
                experimentName: experimentKey,
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            transformCohortFunc: (0, $a0oOn.treatmentCohortTransformFn)
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                cohort === 'control' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04skO.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort
                }),
                cohort === 'treatment' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04skO.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eYTNZ.StandardToPremiumModal), {})
                })
            ]
        });
    }
    return null;
}

});
parcelRegister("dUMxA", function(module, exports) {
$parcel$export(module.exports, "getTrialOfferingName", () => $9969da095a62c8fb$export$38ffae8c634274ba);

var $eGOwo = parcelRequire("eGOwo");
const $9969da095a62c8fb$export$38ffae8c634274ba = (product, edition)=>{
    if (edition === 'standard') {
        if (product === 'jira' && (0, $eGOwo.fg)('edition_awareness_upsell_jira_fg')) return 'premium';
        if (product === 'jira-service-management' && (0, $eGOwo.fg)('edition_awareness_upsell_jsm_fg')) return 'premium';
        if (product === 'confluence' && (0, $eGOwo.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return 'premium';
        if (product === 'jira-product-discovery' && (0, $eGOwo.fg)('upsell_edition_awareness_jpd_fg')) return 'premium';
    }
    return 'standard';
};

});

parcelRegister("eYTNZ", function(module, exports) {
$parcel$export(module.exports, "StandardToPremiumModal", () => $b2365b18d59057fd$export$a74acc125b20e3e5);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aLED4 = parcelRequire("aLED4");

var $h1104 = parcelRequire("h1104");

var $5GKEZ = parcelRequire("5GKEZ");

var $86jVJ = parcelRequire("86jVJ");

var $3NnY3 = parcelRequire("3NnY3");
function $b2365b18d59057fd$export$a74acc125b20e3e5() {
    const { product: product, cloudId: cloudId } = (0, $aLED4.useEditionAwareness)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $h1104.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5GKEZ.DismissibleModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $3NnY3.entryPoint),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $86jVJ.DIALOG_CONFIG)
    });
}

});
parcelRegister("5GKEZ", function(module, exports) {
$parcel$export(module.exports, "DismissibleModalEntryPoint", () => $5ecc555fcd447bc5$export$3362d3660491ee6d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");

var $cyC2p = parcelRequire("cyC2p");

var $fYq8K = parcelRequire("fYq8K");
function $5ecc555fcd447bc5$export$3362d3660491ee6d(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fYq8K.ModalEntryPoint), {
                ...props
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cyC2p.DismissMenu), {})
        ]
    });
}

});
parcelRegister("cyC2p", function(module, exports) {
$parcel$export(module.exports, "DismissMenu", () => $d44e033fd634ff84$export$6c8332cc6beadf8a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $NByNW = parcelRequire("NByNW");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $c5wvT = parcelRequire("c5wvT");
var $bnpBF = parcelRequire("bnpBF");
var $jLzeC = parcelRequire("jLzeC");
var $ckdeJ = parcelRequire("ckdeJ");

var $k8GKb = parcelRequire("k8GKb");

var $aLED4 = parcelRequire("aLED4");

var $dUMxA = parcelRequire("dUMxA");

var $apOA4 = parcelRequire("apOA4");
const $d44e033fd634ff84$var$dismissMenuStyles = (0, $1DXK0.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.small',
    paddingInline: 'space.100',
    paddingBlock: '0',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    borderColor: 'color.border.discovery',
    borderLeftWidth: '0',
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    ':hover': {
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed'
    }
});
const $d44e033fd634ff84$var$reasonsUlStyles = (0, $1DXK0.xcss)({
    marginTop: '0',
    marginLeft: 'space.200',
    paddingLeft: 'space.100'
});
const $d44e033fd634ff84$var$capitalizeName = (name)=>name.split(' ').map((word)=>{
        return word[0].toUpperCase() + word.substring(1);
    }).join(' ');
function $d44e033fd634ff84$export$6c8332cc6beadf8a() {
    const fireDismissMenuEvent = (0, $k8GKb.useOnClickDismissMenu)();
    const { product: product, edition: edition, onDismissButton: onDismissButton } = (0, $aLED4.useEditionAwareness)();
    const { setActiveSpotlight: setActiveSpotlight } = (0, $apOA4.useSpotlight)();
    const trialOfferingName = (0, $dUMxA.getTrialOfferingName)(product, edition);
    const handleOnEvents = (0, $eJOHy.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
            setActiveSpotlight('standard-to-premium');
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        setActiveSpotlight,
        fireDismissMenuEvent
    ]);
    const getAdControlsTrigger = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            ...props,
            ref: triggerRef,
            xcss: [
                $d44e033fd634ff84$var$dismissMenuStyles
            ],
            "aria-label": "More",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            })
        }), []);
    const offering = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
        weight: "bold",
        children: [
            $d44e033fd634ff84$var$capitalizeName(product.replace(/-/g, ' ')),
            " ",
            $d44e033fd634ff84$var$capitalizeName(trialOfferingName)
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bnpBF.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c5wvT.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jLzeC.default), {
                            ...props,
                            children: "Dismiss"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ckdeJ.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this",
                                                defaultMessage: "We think {offering} will improve your team's productivity. This recommendation is only shown to billing admins and is based on:",
                                                description: "A message that informs the user why they are seeing the current plan recommendation for their current product",
                                                values: {
                                                    offering: offering
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                                            as: "ul",
                                            xcss: $d44e033fd634ff84$var$reasonsUlStyles,
                                            children: [
                                                /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1",
                                                        defaultMessage: "the size of your team",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2",
                                                        defaultMessage: "your existing Atlassian products",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian",
                                                    description: "Link to Atlassian data privacy page"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}

});
parcelRegister("c5wvT", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3c78808f629ff09$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");
var $aLJ1L = parcelRequire("aLJ1L");

var $eGOwo = parcelRequire("eGOwo");


var $lGX9r = parcelRequire("lGX9r");

var $72GTx = parcelRequire("72GTx");
const $d3c78808f629ff09$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $d3c78808f629ff09$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $lGX9r.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $72GTx.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $558362b42dfda4e2$export$17ff257e1f6e39f5) : (0, $558362b42dfda4e2$export$7fc09cf740f33ed4), createInteractedUIEvent($d3c78808f629ff09$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: (0, $eGOwo.fg)('should-render-to-parent-should-be-true-growth-trai'),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $d3c78808f629ff09$export$2e2bcd8739ae039 = $d3c78808f629ff09$var$AdControlDropdownMenu;

});
// ACT Event types
// AdControlDropdownMenu
const $558362b42dfda4e2$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $558362b42dfda4e2$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $558362b42dfda4e2$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $558362b42dfda4e2$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $558362b42dfda4e2$export$6d3088110036f124 = 'DISMISS_FAILED';
const $558362b42dfda4e2$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $558362b42dfda4e2$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $558362b42dfda4e2$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $558362b42dfda4e2$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("lGX9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $00ace945eb24b88c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $ftN6c = parcelRequire("ftN6c");
function $00ace945eb24b88c$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$f1d537d508d2945a),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';


parcelRegister("72GTx", function(module, exports) {
$parcel$export(module.exports, "useAdControlProvider", () => $760fc4dfa5402c1c$export$450072b04d50916);

var $eJOHy = parcelRequire("eJOHy");


var $kEJFu = parcelRequire("kEJFu");

var $hpCBZ = parcelRequire("hpCBZ");
function $760fc4dfa5402c1c$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $hpCBZ.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $558362b42dfda4e2$export$5c5fc6956b7600ea:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((itemId)=>{
        return new (0, $kEJFu.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}

});
parcelRegister("kEJFu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8132baad72e61aa$export$2e2bcd8739ae039);
class $c8132baad72e61aa$export$2e2bcd8739ae039 {
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
}

});

parcelRegister("hpCBZ", function(module, exports) {
$parcel$export(module.exports, "useAdControlContext", () => $ea897342074f7ba1$export$4e82dc865a56141b);

var $eJOHy = parcelRequire("eJOHy");

var $1ltyv = parcelRequire("1ltyv");
function $ea897342074f7ba1$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $1ltyv.AdControlContext));
}

});
parcelRegister("1ltyv", function(module, exports) {
$parcel$export(module.exports, "AdControlContext", () => $c495556f816afdf7$export$554b2f9bd0a293df);

var $eJOHy = parcelRequire("eJOHy");

var $3aWr8 = parcelRequire("3aWr8");
const $c495556f816afdf7$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    state: {
        ...(0, $3aWr8.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});

});
parcelRegister("3aWr8", function(module, exports) {
$parcel$export(module.exports, "initialAdControlProviderState", () => $5930eba792f32ca2$export$22776e7a42f7089d);
$parcel$export(module.exports, "adControlProviderReducer", () => $5930eba792f32ca2$export$5f3557676ca801eb);
const $5930eba792f32ca2$export$22776e7a42f7089d = {
    flags: new Map()
};
const $5930eba792f32ca2$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};

});





parcelRegister("bnpBF", function(module, exports) {
$parcel$export(module.exports, "default", () => $be0fd45bb55bb66e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $1ltyv = parcelRequire("1ltyv");

var $3aWr8 = parcelRequire("3aWr8");

var $6YjhV = parcelRequire("6YjhV");

var $cQxD4 = parcelRequire("cQxD4");

var $dUq27 = parcelRequire("dUq27");
const $be0fd45bb55bb66e$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useReducer((0, $3aWr8.adControlProviderReducer), (0, $3aWr8.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YjhV.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1ltyv.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dUq27.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                (0, $eGOwo.fg)('jfp-magma-hydration-fix-ad-control') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQxD4.default), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {}),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQxD4.default), {})
                })
            ]
        })
    });
};
var $be0fd45bb55bb66e$export$2e2bcd8739ae039 = $be0fd45bb55bb66e$var$AdControlProvider;

});
parcelRegister("6YjhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $08fccba15000c465$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $fwhbL = parcelRequire("fwhbL");

var $fS9aS = parcelRequire("fS9aS");
const $08fccba15000c465$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $fS9aS.default),
        loaderFn: (0, $fwhbL.fetchMessagesForLocale),
        children: children
    });
};
var $08fccba15000c465$export$2e2bcd8739ae039 = $08fccba15000c465$var$ActIntlProvider;

});
parcelRegister("fwhbL", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $6686de85bf6db266$export$2b153a2030b0feb2);

var $32CQN = parcelRequire("32CQN");

var $fS9aS = parcelRequire("fS9aS");
const $6686de85bf6db266$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $6686de85bf6db266$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($6686de85bf6db266$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $32CQN.locales)) {
            const messages = await (0, $32CQN.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $32CQN.locales)) {
            const messages = await (0, $32CQN.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $fS9aS.default;
};

});
parcelRegister("32CQN", function(module, exports) {
$parcel$export(module.exports, "locales", () => $8020f94b2bf2a54f$export$df1c34db1371eeed);


























const $8020f94b2bf2a54f$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("aaWQO")),
    da: ()=>(parcelRequire("90Jzq")),
    de: ()=>(parcelRequire("8GkRN")),
    en_GB: ()=>(parcelRequire("8oPdZ")),
    en_ZZ: ()=>(parcelRequire("7gW6g")),
    en: ()=>Promise.resolve((parcelRequire("fS9aS"))),
    es: ()=>(parcelRequire("VOgTv")),
    fi: ()=>(parcelRequire("3HVnL")),
    fr: ()=>(parcelRequire("2hDVT")),
    hu: ()=>(parcelRequire("458tJ")),
    it: ()=>(parcelRequire("bxg3f")),
    ja: ()=>(parcelRequire("68ZlK")),
    ko: ()=>(parcelRequire("4UYba")),
    nb: ()=>(parcelRequire("2kdtY")),
    nl: ()=>(parcelRequire("cqJnu")),
    pl: ()=>(parcelRequire("f2sHD")),
    pt_BR: ()=>(parcelRequire("cPPo8")),
    ru: ()=>(parcelRequire("e6FOd")),
    sv: ()=>(parcelRequire("dCnJq")),
    th: ()=>(parcelRequire("6brdP")),
    tr: ()=>(parcelRequire("919bC")),
    uk: ()=>(parcelRequire("fPamz")),
    vi: ()=>(parcelRequire("ed18I")),
    zh_TW: ()=>(parcelRequire("aaxbf")),
    zh: ()=>(parcelRequire("gntZE"))
};

});
parcelRegister("aaWQO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gaMCD").then(()=>parcelRequire('7QgOZ'));

});

parcelRegister("90Jzq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eoJuN").then(()=>parcelRequire('4rPC8'));

});

parcelRegister("8GkRN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gwPQU").then(()=>parcelRequire('l5aFg'));

});

parcelRegister("8oPdZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ksuHZ").then(()=>parcelRequire('i6eF3'));

});

parcelRegister("7gW6g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1imaz").then(()=>parcelRequire('90tnF'));

});

parcelRegister("VOgTv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("leALi").then(()=>parcelRequire('7r0z6'));

});

parcelRegister("3HVnL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7RECz").then(()=>parcelRequire('h08YX'));

});

parcelRegister("2hDVT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hz3TQ").then(()=>parcelRequire('9OZDh'));

});

parcelRegister("458tJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eJn7C").then(()=>parcelRequire('6CDte'));

});

parcelRegister("bxg3f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4GRhR").then(()=>parcelRequire('4ynVq'));

});

parcelRegister("68ZlK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7zlvy").then(()=>parcelRequire('6bpop'));

});

parcelRegister("4UYba", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eCpgx").then(()=>parcelRequire('nYcpU'));

});

parcelRegister("2kdtY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3HBL8").then(()=>parcelRequire('fOA0V'));

});

parcelRegister("cqJnu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3ffo3").then(()=>parcelRequire('eV4RC'));

});

parcelRegister("f2sHD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jVok0").then(()=>parcelRequire('d3cjG'));

});

parcelRegister("cPPo8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h1VUN").then(()=>parcelRequire('eVXmI'));

});

parcelRegister("e6FOd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dP03a").then(()=>parcelRequire('kcBMK'));

});

parcelRegister("dCnJq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dhRfv").then(()=>parcelRequire('1LBPs'));

});

parcelRegister("6brdP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5ZRDI").then(()=>parcelRequire('goWpo'));

});

parcelRegister("919bC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("18CZ5").then(()=>parcelRequire('bTpte'));

});

parcelRegister("fPamz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1ZoZ6").then(()=>parcelRequire('1We21'));

});

parcelRegister("ed18I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hYjNa").then(()=>parcelRequire('ebauY'));

});

parcelRegister("aaxbf", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3I5VS").then(()=>parcelRequire('f3r1O'));

});

parcelRegister("gntZE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6af4M").then(()=>parcelRequire('bniYD'));

});




parcelRegister("cQxD4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f35542f06ce09c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1jLQ3 = parcelRequire("1jLQ3");
var $gPCVG = parcelRequire("gPCVG");

var $4b867 = parcelRequire("4b867");

var $8IeH1 = parcelRequire("8IeH1");



var $lGX9r = parcelRequire("lGX9r");

var $72GTx = parcelRequire("72GTx");

var $9o7AZ = parcelRequire("9o7AZ");

var $3w1Xq = parcelRequire("3w1Xq");
const $b9f35542f06ce09c$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $b9f35542f06ce09c$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $b9f35542f06ce09c$var$DismissalFlagGroup = ()=>{
    (0, $3w1Xq.overridePortalIndex)($b9f35542f06ce09c$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $72GTx.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $lGX9r.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $558362b42dfda4e2$export$5c5fc6956b7600ea), createInteractedUIEvent($b9f35542f06ce09c$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPCVG.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                id: $b9f35542f06ce09c$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1jLQ3.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4b867))), {
                        label: "Success",
                        spacing: "spacious",
                        color: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`
                    }),
                    title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $9o7AZ.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $9o7AZ.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $b9f35542f06ce09c$export$2e2bcd8739ae039 = $b9f35542f06ce09c$var$DismissalFlagGroup;

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("9o7AZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3f92a1e6762a1b18$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3f92a1e6762a1b18$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    notInterested: {
        id: 'act.action.notInterested.button.text',
        defaultMessage: 'Not interested',
        description: 'The text of a button to indicate the users can dismiss the current component'
    },
    notInterestedFlag: {
        id: 'act.action.notInterestedFlag.flag.text',
        defaultMessage: 'Got it, thanks for letting us know',
        description: 'A message that informs the users the dismissal action is taken'
    },
    showReasons: {
        id: 'act.action.showReasons.common.text',
        defaultMessage: 'Why am I seeing this?',
        description: "The text of a button to indicate the users can click and see the reasons for a component's appearance"
    },
    dismissalMessage: {
        id: 'act.action.dismissalMessage.common.text',
        defaultMessage: "You won\u2019t see this here as often.",
        description: 'A message that informs the users the dismissal action is taken'
    },
    reasonsModalOkButton: {
        id: 'act.action.reasonsModalOkButton.common.text',
        defaultMessage: 'OK',
        description: 'The text of a button to indicate the users can dismiss the current modal'
    }
});

});

parcelRegister("3w1Xq", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PORTAL_OVERRIDE_INDEX", () => $e165eabdbb1d4ea3$export$335243096683aa37);
$parcel$export(module.exports, "overridePortalIndex", () => $e165eabdbb1d4ea3$export$61df98316049b30);
const $e165eabdbb1d4ea3$export$335243096683aa37 = 900;
function $e165eabdbb1d4ea3$export$61df98316049b30(elementId, index = $e165eabdbb1d4ea3$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $e165eabdbb1d4ea3$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $e165eabdbb1d4ea3$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $e165eabdbb1d4ea3$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$e165eabdbb1d4ea3$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}

});


parcelRegister("dUq27", function(module, exports) {
$parcel$export(module.exports, "default", () => $e52fbaa400ba4b53$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $8IeH1 = parcelRequire("8IeH1");


var $lGX9r = parcelRequire("lGX9r");

var $72GTx = parcelRequire("72GTx");

var $9o7AZ = parcelRequire("9o7AZ");

var $3w1Xq = parcelRequire("3w1Xq");
const $e52fbaa400ba4b53$var$adControlScreenName = 'adControlsReasonsModal';
const $e52fbaa400ba4b53$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $e52fbaa400ba4b53$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $3w1Xq.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $72GTx.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $lGX9r.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const eventDispatcherRef = (0, $eJOHy.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $eJOHy.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $558362b42dfda4e2$export$ff50ad60f08a4bc0), createScreenUIEvent($e52fbaa400ba4b53$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $558362b42dfda4e2$export$6bd2d8eacca15ce1), createScreenUIEvent($e52fbaa400ba4b53$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $3w1Xq.overridePortalIndex)($e52fbaa400ba4b53$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gHHv2.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                id: $e52fbaa400ba4b53$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                        hasCloseButton: hasCloseButton,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                            children: title ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $9o7AZ.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kseeK.default), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $9o7AZ.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $e52fbaa400ba4b53$export$2e2bcd8739ae039 = $e52fbaa400ba4b53$var$ReasonsModal;

});


parcelRegister("jLzeC", function(module, exports) {
$parcel$export(module.exports, "default", () => $690a922f8bbf39fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");


var $lGX9r = parcelRequire("lGX9r");

var $72GTx = parcelRequire("72GTx");

var $9o7AZ = parcelRequire("9o7AZ");
const $690a922f8bbf39fa$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $690a922f8bbf39fa$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $72GTx.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $lGX9r.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $558362b42dfda4e2$export$e33200507ac1d20a), createInteractedUIEvent($690a922f8bbf39fa$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $558362b42dfda4e2$export$103f41d1f3bf374e));
        } catch (e) {
            eventDispatcher.dispatchError((0, $558362b42dfda4e2$export$6d3088110036f124), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $9o7AZ.messages).notInterested
        })
    });
};
var $690a922f8bbf39fa$export$2e2bcd8739ae039 = $690a922f8bbf39fa$var$DismissalButton;

});

parcelRegister("ckdeJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $550db46867c1215d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");


var $lGX9r = parcelRequire("lGX9r");

var $72GTx = parcelRequire("72GTx");

var $9o7AZ = parcelRequire("9o7AZ");
const $550db46867c1215d$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $550db46867c1215d$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $72GTx.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $lGX9r.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $558362b42dfda4e2$export$5595c6967e83d351), createInteractedUIEvent($550db46867c1215d$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $9o7AZ.messages).showReasons
        })
    });
};
var $550db46867c1215d$export$2e2bcd8739ae039 = $550db46867c1215d$var$ReasonsButton;

});

parcelRegister("k8GKb", function(module, exports) {
$parcel$export(module.exports, "useOnClickDismissMenu", () => $ee0f09693f9e156b$export$d840cf3018e72a62);

var $eJOHy = parcelRequire("eJOHy");

var $6qssf = parcelRequire("6qssf");
const $ee0f09693f9e156b$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $6qssf.useAnalytics)();
    return (0, $eJOHy.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});



parcelRegister("3NnY3", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $8bc5f362dcd5db02$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $7jR5e = parcelRequire("7jR5e");

const $8bc5f362dcd5db02$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lYkXZ")), {
        moduleId: "9dc17d8c",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-to-premium-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardToPremiumModalQuery: {
                    parameters: $7jR5e.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("7jR5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $046effe4ac9d03ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67206532cf6e6f51082ec69fc9e97638>>
 * @relayHash de6e2bac8a58a1f311e29bca101d04f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e

var $37Ewn = parcelRequire("37Ewn");
const $046effe4ac9d03ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e",
            "metadata": {},
            "name": "standardToPremiumModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$046effe4ac9d03ab$var$node.hash = "2c7841c5e5f86c438cbec88e2db2ae41";
(0, $37Ewn.PreloadableQueryRegistry).set($046effe4ac9d03ab$var$node.params.id, $046effe4ac9d03ab$var$node);
var $046effe4ac9d03ab$export$2e2bcd8739ae039 = $046effe4ac9d03ab$var$node;

});

parcelRegister("lYkXZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1eMUV")
]).then(()=>parcelRequire('7Da0J'));

});




parcelRegister("igfaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef2bfc9a908341d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $OU5kE = parcelRequire("OU5kE");

var $3XKVc = parcelRequire("3XKVc");

var $gdqa5 = parcelRequire("gdqa5");
var $eUaD0 = parcelRequire("eUaD0");
var $4J0ad = parcelRequire("4J0ad");

var $ctVTi = parcelRequire("ctVTi");
const $7ef2bfc9a908341d$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $7ef2bfc9a908341d$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $7ef2bfc9a908341d$var$TRIGGER_CONTEXT = {
    componentName: (0, $gdqa5.TRIGGER_COMPONENT),
    ...(0, $ctVTi.default)
};
class $7ef2bfc9a908341d$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                actionSubject: (0, $gdqa5.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $gdqa5.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(()=>{
            (0, $OU5kE.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $7ef2bfc9a908341d$var$THROTTLE_EXPIRES, $7ef2bfc9a908341d$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $3XKVc.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $3XKVc.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $7ef2bfc9a908341d$var$PrefetchTriggerWithEvents = (0, $4J0ad.default)()($7ef2bfc9a908341d$var$PrefetchTrigger);
var $7ef2bfc9a908341d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.NavigationAnalyticsContext), {
        data: $7ef2bfc9a908341d$var$TRIGGER_CONTEXT,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($7ef2bfc9a908341d$var$PrefetchTriggerWithEvents, {
            ...props
        })
    });

});
parcelRegister("OU5kE", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $8147e111c2082666$export$aba5d6cf034db22e);

var $bbBWr = parcelRequire("bbBWr");

var $b2VOh = parcelRequire("b2VOh");

var $dhcaA = parcelRequire("dhcaA");

var $kPVAb = parcelRequire("kPVAb");

var $aBlvu = parcelRequire("aBlvu");
const $8147e111c2082666$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $dhcaA.default)(product);
    (0, $kPVAb.prefetchFlightDeck)({});
    (0, $bbBWr.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $aBlvu.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $b2VOh.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("bbBWr", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $deaf12a10cd3b3d6$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $deaf12a10cd3b3d6$export$1c5684a3ba697d80);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kkNZZ = parcelRequire("kkNZZ");
const { fetchMethod: $deaf12a10cd3b3d6$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $deaf12a10cd3b3d6$var$DefaultBffDataProviderComponent } = (0, $kkNZZ.createAppSwitcherBffAvailableProductsProvider)();
const $deaf12a10cd3b3d6$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($deaf12a10cd3b3d6$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product,
        children: children
    });
const $deaf12a10cd3b3d6$export$1c5684a3ba697d80 = $deaf12a10cd3b3d6$var$fetchAppSwitcherBffAvailableProducts;
const $deaf12a10cd3b3d6$export$cd9fc41c59711bdd = ()=>$deaf12a10cd3b3d6$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("kkNZZ", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $333ec0216042e1e2$export$7fd9c7ae7afb494c);

var $a2G6W = parcelRequire("a2G6W");

var $hmtdE = parcelRequire("hmtdE");

var $gZSfe = parcelRequire("gZSfe");
const $333ec0216042e1e2$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $333ec0216042e1e2$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $hmtdE.fetchJsonWithNetworkRetries)(`${$333ec0216042e1e2$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $333ec0216042e1e2$export$7fd9c7ae7afb494c = ()=>{
    return (0, $a2G6W.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $gZSfe.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $333ec0216042e1e2$export$1096efb00c5f8afc);
};

});
parcelRegister("a2G6W", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $ad086b8e60a98762$export$310e48be95687c2f);

var $3ZEcX = parcelRequire("3ZEcX");

var $hmtdE = parcelRequire("hmtdE");

var $jBwZ2 = parcelRequire("jBwZ2");
const $ad086b8e60a98762$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $jBwZ2.withCached)((param)=>(0, $hmtdE.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $3ZEcX.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $ad086b8e60a98762$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $jBwZ2.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $3ZEcX.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});
parcelRegister("3ZEcX", function(module, exports) {
$parcel$export(module.exports, "Status", () => $860a69f0005a2ce3$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $860a69f0005a2ce3$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $860a69f0005a2ce3$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $860a69f0005a2ce3$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $860a69f0005a2ce3$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $860a69f0005a2ce3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gdqa5 = parcelRequire("gdqa5");

var $4J0ad = parcelRequire("4J0ad");

var $ll8p3 = parcelRequire("ll8p3");

var $iHrhr = parcelRequire("iHrhr");

var $1taFi = parcelRequire("1taFi");
const $860a69f0005a2ce3$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $860a69f0005a2ce3$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $860a69f0005a2ce3$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $860a69f0005a2ce3$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $860a69f0005a2ce3$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $860a69f0005a2ce3$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $860a69f0005a2ce3$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $860a69f0005a2ce3$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $iHrhr.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $ll8p3.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$860a69f0005a2ce3$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $ll8p3.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                    actionSubject: $860a69f0005a2ce3$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $gdqa5.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $4J0ad.default)()((0, $1taFi.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("gdqa5", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $d21a4958c492cfbf$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $d21a4958c492cfbf$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $d21a4958c492cfbf$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $d21a4958c492cfbf$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $d21a4958c492cfbf$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $d21a4958c492cfbf$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $d21a4958c492cfbf$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $d21a4958c492cfbf$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $d21a4958c492cfbf$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $d21a4958c492cfbf$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $d21a4958c492cfbf$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $d21a4958c492cfbf$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $d21a4958c492cfbf$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $d21a4958c492cfbf$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $d21a4958c492cfbf$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $d21a4958c492cfbf$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $d21a4958c492cfbf$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $d21a4958c492cfbf$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $d21a4958c492cfbf$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $d21a4958c492cfbf$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $d21a4958c492cfbf$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getJoinableSitesRenderTracker", () => $d21a4958c492cfbf$export$e823e937102b322b);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $d21a4958c492cfbf$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $d21a4958c492cfbf$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("4J0ad")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("eUaD0")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $d6f34b7bd34f6138$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $d6f34b7bd34f6138$export$a1562d08625f5d7e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $5fWw9 = parcelRequire("5fWw9");
var $4J0ad = parcelRequire("4J0ad");


var $3ZEcX = parcelRequire("3ZEcX");

var $4Az9V = parcelRequire("4Az9V");

var $hp1OS = parcelRequire("hp1OS");
const $d21a4958c492cfbf$export$515664faa1398f37 = 'navigation';
const $d21a4958c492cfbf$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $d21a4958c492cfbf$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $d21a4958c492cfbf$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $d21a4958c492cfbf$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $d21a4958c492cfbf$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $d21a4958c492cfbf$export$2b570fc112cbca = 'atlassianSwitcher';
const $d21a4958c492cfbf$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $d21a4958c492cfbf$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $d21a4958c492cfbf$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $d21a4958c492cfbf$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $d21a4958c492cfbf$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $d21a4958c492cfbf$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $d21a4958c492cfbf$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $d21a4958c492cfbf$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $d21a4958c492cfbf$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $d21a4958c492cfbf$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $d21a4958c492cfbf$var$RENDERED_ACTION = 'rendered';
const $d21a4958c492cfbf$var$NOT_RENDERED_ACTION = 'not_rendered';
const $d21a4958c492cfbf$var$VIEWED_ACTION = 'viewed';
const $d21a4958c492cfbf$export$884b1a4c7ac9dd14 = (0, $5fWw9.default)($d21a4958c492cfbf$export$515664faa1398f37);
const $d21a4958c492cfbf$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $d21a4958c492cfbf$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $d21a4958c492cfbf$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $d21a4958c492cfbf$export$e09ad93c2b74b853 = (0, $4J0ad.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            action: $d21a4958c492cfbf$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$d21a4958c492cfbf$var$isValidDuration(duration) && {
                    bucket: (0, $hp1OS.getMetricBucket)(duration, (0, $hp1OS.RenderTrackerBuckets))
                }
            }
        }).fire($d21a4958c492cfbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $d21a4958c492cfbf$export$95b1f1a72cad0dcb = (0, $4J0ad.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
            action: $d21a4958c492cfbf$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($d21a4958c492cfbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $d21a4958c492cfbf$export$b3fd6624b6a6d057 = (0, $4J0ad.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            action: $d21a4958c492cfbf$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($d21a4958c492cfbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $d21a4958c492cfbf$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $d21a4958c492cfbf$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d21a4958c492cfbf$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $d21a4958c492cfbf$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $3ZEcX.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $d21a4958c492cfbf$var$renderTracker({
        subject: $d21a4958c492cfbf$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $d21a4958c492cfbf$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $3ZEcX.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $4Az9V.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $d21a4958c492cfbf$var$renderTrackerWithReason({
        subject: $d21a4958c492cfbf$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $d21a4958c492cfbf$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$d21a4958c492cfbf$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("4Az9V", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $e31798a0cb2ba326$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $e31798a0cb2ba326$export$c460344055e97b1);
var $e31798a0cb2ba326$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $e31798a0cb2ba326$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("hp1OS", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $a9b6af5a83f41588$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $a9b6af5a83f41588$export$b59492d26971ae92);
const $a9b6af5a83f41588$var$INFINITY = '+Inf';
const $a9b6af5a83f41588$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $a9b6af5a83f41588$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $a9b6af5a83f41588$var$INFINITY) : null;
};

});


parcelRegister("ll8p3", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $3cdee95c99b74c5f$export$a3e288208721751b);
function $3cdee95c99b74c5f$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("iHrhr", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $4e5d3940dbbde5e0$export$1d94629c94e7a17f);
const $4e5d3940dbbde5e0$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $4e5d3940dbbde5e0$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $4e5d3940dbbde5e0$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("1taFi", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $193679940d67a515$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $193679940d67a515$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $193679940d67a515$export$f88dde183f4d31cb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $193679940d67a515$var$noop = ()=>{};
const $193679940d67a515$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    start: $193679940d67a515$var$noop,
    success: $193679940d67a515$var$noop,
    failure: $193679940d67a515$var$noop,
    failureAll: $193679940d67a515$var$noop,
    abort: $193679940d67a515$var$noop,
    abortAll: $193679940d67a515$var$noop,
    markStart: $193679940d67a515$var$noop,
    markEnd: $193679940d67a515$var$noop
});
const $193679940d67a515$export$cdefb2a8b53f879f = ()=>(0, $eJOHy.useContext)($193679940d67a515$export$3f3eebb4b8116461);
const $193679940d67a515$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $193679940d67a515$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("hmtdE", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $53da4d33c11314f3$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $53da4d33c11314f3$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $53da4d33c11314f3$export$c776284ef4b1209a);

var $anSqX = parcelRequire("anSqX");

var $iHrhr = parcelRequire("iHrhr");

var $ctVTi = parcelRequire("ctVTi");
const $53da4d33c11314f3$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $anSqX.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $53da4d33c11314f3$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $ctVTi.default).packageVersion,
            ...init?.headers
        }
    }).then(!emptyResponse ? $53da4d33c11314f3$var$extraJsonFromResponse : ()=>{});
const $53da4d33c11314f3$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $iHrhr.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $ctVTi.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($53da4d33c11314f3$var$extraJsonFromResponse);
};
const $53da4d33c11314f3$export$c776284ef4b1209a = (url, data, emptyResponse)=>$53da4d33c11314f3$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("anSqX", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $1aa79f27e103a4bc$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $1aa79f27e103a4bc$export$26e841bcf1aeb894);
const $1aa79f27e103a4bc$export$83179404a61b001a = 'FetchError';
class $1aa79f27e103a4bc$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $1aa79f27e103a4bc$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $1aa79f27e103a4bc$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("ctVTi", function(module, exports) {
$parcel$export(module.exports, "default", () => $685df905709f614e$export$2e2bcd8739ae039);
const $685df905709f614e$var$packageName = "platform-pkg";
const $685df905709f614e$var$packageVersion = "0.0.0-use.local";
var $685df905709f614e$export$2e2bcd8739ae039 = {
    packageName: $685df905709f614e$var$packageName,
    packageVersion: $685df905709f614e$var$packageVersion
};

});


parcelRegister("jBwZ2", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $6cb891c7613f7e6b$export$7f51828d6b6af163);
const $6cb891c7613f7e6b$export$d4d4b402ab64e2f4 = 5000;
const $6cb891c7613f7e6b$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $6cb891c7613f7e6b$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($6cb891c7613f7e6b$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $6cb891c7613f7e6b$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("gZSfe", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $aba7ab916f143273$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $aba7ab916f143273$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $aba7ab916f143273$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $aba7ab916f143273$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $aba7ab916f143273$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $aba7ab916f143273$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $aba7ab916f143273$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $aba7ab916f143273$export$86919b84f9a64054);

var $2lxLk = parcelRequire("2lxLk");

var $1LsJB = parcelRequire("1LsJB");
var $aba7ab916f143273$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $aba7ab916f143273$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $aba7ab916f143273$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $aba7ab916f143273$var$allNonTestExperienceMarks = Object.values($aba7ab916f143273$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $aba7ab916f143273$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $aba7ab916f143273$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $aba7ab916f143273$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $aba7ab916f143273$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $aba7ab916f143273$var$allNonTestExperienceMarks
};
const $aba7ab916f143273$export$805ed806e0769ee4 = (0, $1LsJB.invertRecordOfArrays)($aba7ab916f143273$export$755e75afbd377bc4);
var $aba7ab916f143273$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $aba7ab916f143273$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $aba7ab916f143273$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("1LsJB", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $e34d120f6bad399e$export$c371a74fe5222b3);
function $e34d120f6bad399e$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});




parcelRegister("b2VOh", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $fdfe50c68805a429$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $fdfe50c68805a429$export$2aed3ef1595b4d9);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2RHso = parcelRequire("2RHso");
const { fetchMethod: $fdfe50c68805a429$var$fetchJoinableSites, ProviderComponent: $fdfe50c68805a429$var$DefaultDataProviderComponent } = (0, $2RHso.createJoinableSitesProvider)();
const $fdfe50c68805a429$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $fdfe50c68805a429$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(DataProviderComponent, {
        cloudId: cloudId,
        children: children
    });
};
const $fdfe50c68805a429$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $fdfe50c68805a429$var$fetchJoinableSites({});
};
const $fdfe50c68805a429$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $fdfe50c68805a429$var$fetchJoinableSites.reset();
};

});
parcelRegister("2RHso", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $4a681075d47b7908$export$c3b6af53f1ca17d8);

var $a2G6W = parcelRequire("a2G6W");

var $gZSfe = parcelRequire("gZSfe");
const $4a681075d47b7908$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $4a681075d47b7908$export$c3b6af53f1ca17d8 = (fetchData = $4a681075d47b7908$export$62986affcccd56a5, retryConfig)=>{
    return (0, $a2G6W.createProviderWithCustomFetchData)('joinableSites', (0, $gZSfe.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});


parcelRegister("dhcaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b492ea623827e8d0$export$2e2bcd8739ae039);

var $PwmAc = parcelRequire("PwmAc");
var $b492ea623827e8d0$export$2e2bcd8739ae039 = (product)=>{
    (0, $PwmAc.loadAtlassianSwitcher)();
    if (product === 'jira') return (0, $PwmAc.loadJiraSwitcher)();
    if (product === 'confluence') return (0, $PwmAc.loadConfluenceSwitcher)();
    return (0, $PwmAc.loadGenericSwitcher)();
};

});
parcelRegister("PwmAc", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $1c2b93db5dd7c628$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadJiraSwitcher", () => $1c2b93db5dd7c628$export$52c59c5b477673fb);
$parcel$export(module.exports, "loadConfluenceSwitcher", () => $1c2b93db5dd7c628$export$2d2945898d9ee55f);
$parcel$export(module.exports, "loadGenericSwitcher", () => $1c2b93db5dd7c628$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $1c2b93db5dd7c628$export$25f16f9fee84a840);
$parcel$export(module.exports, "JiraSwitcherLoader", () => $1c2b93db5dd7c628$export$10767845f9f42bd);
$parcel$export(module.exports, "ConfluenceSwitcherLoader", () => $1c2b93db5dd7c628$export$71f961c620294b68);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $1c2b93db5dd7c628$export$8c21d1a0c59fc17e);

var $gt9Am = parcelRequire("gt9Am");

var $joSn0 = parcelRequire("joSn0");
parcelRequire("eJOHy");

var $cy9FC = parcelRequire("cy9FC");

const $1c2b93db5dd7c628$export$6c6894dd831bfacb = ()=>(parcelRequire("k1Lhj")).then((module)=>module.default);

const $1c2b93db5dd7c628$export$52c59c5b477673fb = ()=>(parcelRequire("1qlQM")).then((module)=>module.default);

const $1c2b93db5dd7c628$export$2d2945898d9ee55f = ()=>(parcelRequire("5JZkk")).then((module)=>module.default);

const $1c2b93db5dd7c628$export$64191a36345a6b2b = ()=>(parcelRequire("gveua")).then((module)=>module.default);
const $1c2b93db5dd7c628$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: $1c2b93db5dd7c628$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $cy9FC.default), {})
});
const $1c2b93db5dd7c628$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: $1c2b93db5dd7c628$export$52c59c5b477673fb,
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $cy9FC.default), {})
});
const $1c2b93db5dd7c628$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: $1c2b93db5dd7c628$export$2d2945898d9ee55f,
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $cy9FC.default), {})
});
const $1c2b93db5dd7c628$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: $1c2b93db5dd7c628$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $cy9FC.default), {})
});

});
parcelRegister("cy9FC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e641ec313a41eb45$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $gZSfe = parcelRequire("gZSfe");
var $kI28I = parcelRequire("kI28I");

var $lRq8t = parcelRequire("lRq8t");

var $agwRm = parcelRequire("agwRm");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $e641ec313a41eb45$var$iconSkeleton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $e641ec313a41eb45$var$lineSkeleton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $e641ec313a41eb45$export$2e2bcd8739ae039 = ()=>{
    (0, $kI28I.useExperienceRenderAndMountMark)((0, $gZSfe.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const items = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        },
        children: [
            $e641ec313a41eb45$var$iconSkeleton,
            $e641ec313a41eb45$var$lineSkeleton
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $agwRm.default).skeletonLoaderAriaLabel),
        testId: "skeleton",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                "aria-hidden": "true",
                style: {
                    paddingInline: "var(--ds-space-200, 16px)",
                    paddingTop: "var(--ds-space-300, 24px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                },
                children: $e641ec313a41eb45$var$lineSkeleton
            }),
            items,
            items,
            items
        ]
    });
};

});
parcelRegister("kI28I", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $a5f69cfd6a6b9807$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $a5f69cfd6a6b9807$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $1taFi = parcelRequire("1taFi");

var $eJOHy = parcelRequire("eJOHy");

var $313yD = parcelRequire("313yD");
function $a5f69cfd6a6b9807$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $1taFi.useExperienceTracker)();
    (0, $313yD.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $a5f69cfd6a6b9807$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $1taFi.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $a5f69cfd6a6b9807$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $1taFi.useExperienceTracker)();
    (0, $313yD.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("313yD", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $45e85f7dae640bb9$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $45e85f7dae640bb9$export$ad4f8d0eee7a0e24);

var $eJOHy = parcelRequire("eJOHy");
function $45e85f7dae640bb9$export$abf4268d2dd55708(builder) {
    const ref = (0, $eJOHy.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $45e85f7dae640bb9$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $eJOHy.useRef)(false);
    const result = (0, $eJOHy.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});


parcelRegister("agwRm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4e2ce04eb2286b7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e4e2ce04eb2286b7$var$messages = (0, $7qGN1.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    }
});
var $e4e2ce04eb2286b7$export$2e2bcd8739ae039 = $e4e2ce04eb2286b7$var$messages;

});


parcelRegister("k1Lhj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("38N5I").then(()=>parcelRequire('9wtJH'));

});

parcelRegister("1qlQM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4cmQH").then(()=>parcelRequire('6GlkH'));

});

parcelRegister("5JZkk", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7T7KD").then(()=>parcelRequire('kePQf'));

});

parcelRegister("gveua", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Smxy").then(()=>parcelRequire('3SkEw'));

});



parcelRegister("kPVAb", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $dcef3636f915327f$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $dcef3636f915327f$export$7d2a567d3e50224);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9nfpX = parcelRequire("9nfpX");

var $a2G6W = parcelRequire("a2G6W");

var $gZSfe = parcelRequire("gZSfe");

var $7VM1L = parcelRequire("7VM1L");

var $lopBx = parcelRequire("lopBx");


var $8fMPj = parcelRequire("8fMPj");
const $dcef3636f915327f$var$client = new (0, $9nfpX.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $dcef3636f915327f$var$fetchFlightDeck, ProviderComponent: $dcef3636f915327f$var$DefaultFlightDeckProviderComponent } = (0, $a2G6W.createProviderWithCustomFetchData)('flightDeck', (0, $gZSfe.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $dcef3636f915327f$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $lopBx.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $dcef3636f915327f$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $dcef3636f915327f$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $7VM1L.formatLabel)(displayName),
            rebrandedLabel: rebrandedDisplayName && (0, $7VM1L.formatLabel)(rebrandedDisplayName),
            description: (0, $7VM1L.formatDescription)(subtitle),
            iconKey: iconKey,
            rebrandedIconKey: rebrandedIconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $ee74964486343666$export$45e63649edff1e2a))) artifactMap.set((0, $ee74964486343666$export$45e63649edff1e2a), {
            key: (0, $ee74964486343666$export$45e63649edff1e2a),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            label: (0, $7VM1L.formatLabel)((0, $8fMPj.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $7VM1L.formatLabel)(link.displayName),
                    description: (0, $7VM1L.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $dcef3636f915327f$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($dcef3636f915327f$var$DefaultFlightDeckProviderComponent, {
        children: children
    });
const $dcef3636f915327f$export$7d2a567d3e50224 = $dcef3636f915327f$var$fetchFlightDeck;

});
parcelRegister("9nfpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d3238b1152377d9$export$2e2bcd8739ae039);

var $7M3Wu = parcelRequire("7M3Wu");

var $eWi0F = parcelRequire("eWi0F");

var $aOPCi = parcelRequire("aOPCi");

var $8WFY9 = parcelRequire("8WFY9");
var $cRo5G = parcelRequire("cRo5G");

var $4rQ9F = parcelRequire("4rQ9F");

var $92KTQ = parcelRequire("92KTQ");

var $kELoB = parcelRequire("kELoB");
function $6d3238b1152377d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d3238b1152377d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d3238b1152377d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d3238b1152377d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6d3238b1152377d9$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $6d3238b1152377d9$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $6d3238b1152377d9$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $7M3Wu.default)(this, "fallbackArtifactMap", new Map());
        (0, $7M3Wu.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $aOPCi.default)($6d3238b1152377d9$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $92KTQ.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $eWi0F.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $8WFY9.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $4rQ9F.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$6d3238b1152377d9$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $kELoB.flightDeckClientExperience)() : new (0, $cRo5G.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $6d3238b1152377d9$var$_objectSpread($6d3238b1152377d9$var$_objectSpread({}, artifact), {}, {
                key: (0, $92KTQ.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $kELoB.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("eWi0F", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $97f0044d7f33ce6a$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("4xBPy")).default);

var $1VPlT = parcelRequire("1VPlT");

var $eVPR5 = parcelRequire("eVPR5");

var $4xBPy = parcelRequire("4xBPy");
const $97f0044d7f33ce6a$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $97f0044d7f33ce6a$var$NO_CALLS_ERROR = 'No calls made';
const $97f0044d7f33ce6a$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $eVPR5.NO_RETRIES), retryOn: retryOn = [
    (0, $4xBPy.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($97f0044d7f33ce6a$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $97f0044d7f33ce6a$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $97f0044d7f33ce6a$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $1VPlT.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("1VPlT", function(module, exports) {
$parcel$export(module.exports, "default", () => $abb51aa98ed04e2d$export$2e2bcd8739ae039);
const $abb51aa98ed04e2d$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $abb51aa98ed04e2d$export$2e2bcd8739ae039 = $abb51aa98ed04e2d$var$convertToError;

});

parcelRegister("eVPR5", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $092f9c95300a876a$export$a0a1c8f90becc136);
const $092f9c95300a876a$export$a0a1c8f90becc136 = [];
const $092f9c95300a876a$export$972171517b12aa4 = [
    0,
    0
];
const $092f9c95300a876a$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $092f9c95300a876a$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("4xBPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a90f962beee276ab$export$2e2bcd8739ae039);
class $a90f962beee276ab$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("aOPCi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a3b382dbba31ebf$export$2e2bcd8739ae039);

var $7TAQ1 = parcelRequire("7TAQ1");
const $3a3b382dbba31ebf$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $3a3b382dbba31ebf$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $3a3b382dbba31ebf$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $7TAQ1.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("7TAQ1", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $7ee843aa68630f54$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $7ee843aa68630f54$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $7ee843aa68630f54$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$7ee843aa68630f54$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});


parcelRegister("8WFY9", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $68344bb5c60b45af$export$6026918e023c9101);

var $1n5fh = parcelRequire("1n5fh");

var $kPyXb = parcelRequire("kPyXb");

var $idLNY = parcelRequire("idLNY");

var $3ZW4v = parcelRequire("3ZW4v");

var $cfxYZ = parcelRequire("cfxYZ");

var $cRo5G = parcelRequire("cRo5G");

var $bCNf6 = parcelRequire("bCNf6");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $68344bb5c60b45af$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $68344bb5c60b45af$var$defaultPerimeter = "commercial";
async function $68344bb5c60b45af$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $68344bb5c60b45af$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $68344bb5c60b45af$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $68344bb5c60b45af$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $1n5fh.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $68344bb5c60b45af$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $68344bb5c60b45af$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $68344bb5c60b45af$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $68344bb5c60b45af$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $68344bb5c60b45af$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $68344bb5c60b45af$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $cRo5G.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $cRo5G.getVersionMetadataFetchExperience)();
    return new (0, $cfxYZ.ConfigClient)(new (0, $idLNY.BifrostDataSource)(new (0, $3ZW4v.BifrostHttpClientImpl)(env, perimeter), (0, $kPyXb.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $68344bb5c60b45af$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("1n5fh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5156c883e561616$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $a5156c883e561616$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $a5156c883e561616$export$2e2bcd8739ae039 = $a5156c883e561616$export$852ff24d0930c62f;

});

parcelRegister("kPyXb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $41DaG = parcelRequire("41DaG");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $41DaG.Either;
    }
});

var $7DE2w = parcelRequire("7DE2w");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $7DE2w.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $7DE2w.tryGetArtifactData;
    }
});

var $j4V29 = parcelRequire("j4V29");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $j4V29.parseArtifactManifest;
    }
});

var $lQIPi = parcelRequire("lQIPi");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $lQIPi.parseVersionMetadata;
    }
});

var $4Xgo7 = parcelRequire("4Xgo7");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $4Xgo7.checkManifest;
    }
});

var $8kfyr = parcelRequire("8kfyr");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $8kfyr.ConfigRegistryDataSource;
    }
});

var $1XX2B = parcelRequire("1XX2B");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $1XX2B.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $1XX2B.Versions;
    }
});

});
parcelRegister("41DaG", function(module, exports) {
"use strict";
var $2ee5a4067e9aae10$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $2ee5a4067e9aae10$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $2ee5a4067e9aae10$var$Right(value);
    };
    Either.left = function(error) {
        return new $2ee5a4067e9aae10$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $2ee5a4067e9aae10$var$Either;
var $2ee5a4067e9aae10$var$Right = /** @class */ function(_super) {
    $2ee5a4067e9aae10$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $2ee5a4067e9aae10$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $2ee5a4067e9aae10$var$Either.right(this.right);
    };
    return Right;
}($2ee5a4067e9aae10$var$Either);
var $2ee5a4067e9aae10$var$Left = /** @class */ function(_super) {
    $2ee5a4067e9aae10$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $2ee5a4067e9aae10$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $2ee5a4067e9aae10$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $2ee5a4067e9aae10$var$Either.left(f(this.left));
    };
    return Left;
}($2ee5a4067e9aae10$var$Either);

});

parcelRegister("7DE2w", function(module, exports) {
"use strict";
var $58fb3bf8c5aae677$var$__assign = module.exports && module.exports.__assign || function() {
    $58fb3bf8c5aae677$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $58fb3bf8c5aae677$var$__assign.apply(this, arguments);
};
var $58fb3bf8c5aae677$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $58fb3bf8c5aae677$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $58fb3bf8c5aae677$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $58fb3bf8c5aae677$var$tryGetArtifactData;

var $bnWU7 = parcelRequire("bnWU7");

var $kPyXb = parcelRequire("kPyXb");

var $6y2ly = parcelRequire("6y2ly");

var $8OySu = parcelRequire("8OySu");

var $7SeVk = parcelRequire("7SeVk");
function $58fb3bf8c5aae677$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $58fb3bf8c5aae677$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $58fb3bf8c5aae677$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $kPyXb.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $6y2ly.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $58fb3bf8c5aae677$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $8OySu.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $58fb3bf8c5aae677$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $58fb3bf8c5aae677$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $bnWU7.interpolateTagScheme)(manifest.tagScheme, $58fb3bf8c5aae677$var$__assign($58fb3bf8c5aae677$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $58fb3bf8c5aae677$var$__awaiter(_this, void 0, void 0, function() {
                                return $58fb3bf8c5aae677$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $58fb3bf8c5aae677$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $7SeVk.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $7SeVk.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $8OySu.assertUnreachable)(artifact);
    }
}

});
parcelRegister("bnWU7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $849f88d7c1122c02$var$interpolateTagScheme;
module.exports.generateTagScheme = $849f88d7c1122c02$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $849f88d7c1122c02$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $849f88d7c1122c02$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $849f88d7c1122c02$var$getVersionMetadataTag;
const $849f88d7c1122c02$var$TAG_SCHEME_VERSION = 2;
function $849f88d7c1122c02$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($849f88d7c1122c02$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $849f88d7c1122c02$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $849f88d7c1122c02$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $849f88d7c1122c02$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $849f88d7c1122c02$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $849f88d7c1122c02$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $849f88d7c1122c02$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $849f88d7c1122c02$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("6y2ly", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $4c47bd0a8230f9fc$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $4c47bd0a8230f9fc$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("8OySu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $66ae0c412e7ccf70$var$assertUnreachable;
function $66ae0c412e7ccf70$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("7SeVk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $5bb92719109ab370$var$toJson;
module.exports.toPrettyJson = $5bb92719109ab370$var$toPrettyJson;
function $5bb92719109ab370$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $5bb92719109ab370$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("j4V29", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $de3aa1b8e712c3e3$var$parseArtifactManifest;

var $2LwBS = parcelRequire("2LwBS");
function $de3aa1b8e712c3e3$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $2LwBS.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $2LwBS.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $de3aa1b8e712c3e3$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $2LwBS.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $de3aa1b8e712c3e3$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $de3aa1b8e712c3e3$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $2LwBS.parseUnknownObject)(dimensions);
    var supported = (0, $2LwBS.parseArray)(unparsedDimensions.supported).map($2LwBS.parseString);
    var fallback = (0, $2LwBS.parseUndefinedOr)($2LwBS.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $de3aa1b8e712c3e3$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $2LwBS.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $de3aa1b8e712c3e3$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $de3aa1b8e712c3e3$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $2LwBS.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $2LwBS.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $2LwBS.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $2LwBS.parseUndefinedOr)($2LwBS.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $de3aa1b8e712c3e3$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $de3aa1b8e712c3e3$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("2LwBS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $2039443a032c83e2$var$parseString;
module.exports.parseArray = $2039443a032c83e2$var$parseArray;
module.exports.parseBoolean = $2039443a032c83e2$var$parseBoolean;
module.exports.parseUnknownObject = $2039443a032c83e2$var$parseUnknownObject;
module.exports.parseUndefinedOr = $2039443a032c83e2$var$parseUndefinedOr;
function $2039443a032c83e2$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $2039443a032c83e2$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $2039443a032c83e2$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $2039443a032c83e2$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $2039443a032c83e2$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("lQIPi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $fe8139e1b9056a03$var$parseVersionMetadata;

var $2LwBS = parcelRequire("2LwBS");
function $fe8139e1b9056a03$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $2LwBS.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $2LwBS.parseString)(unknownObject.version);
    var publishTime = new Date((0, $2LwBS.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $2LwBS.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("4Xgo7", function(module, exports) {
"use strict";
var $39b9626b06f94152$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $39b9626b06f94152$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $39b9626b06f94152$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $39b9626b06f94152$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("8kfyr", function(module, exports) {
"use strict";
var $60fc41c83b0b42ce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $60fc41c83b0b42ce$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $bnWU7 = parcelRequire("bnWU7");

var $41DaG = parcelRequire("41DaG");

var $j4V29 = parcelRequire("j4V29");

var $lQIPi = parcelRequire("lQIPi");
var $60fc41c83b0b42ce$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $60fc41c83b0b42ce$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $60fc41c83b0b42ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $bnWU7.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($j4V29.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $41DaG.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $60fc41c83b0b42ce$var$__awaiter(this, void 0, void 0, function() {
            return $60fc41c83b0b42ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $60fc41c83b0b42ce$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $60fc41c83b0b42ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $bnWU7.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $lQIPi.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $60fc41c83b0b42ce$var$ConfigRegistryDataSource;

});

parcelRegister("1XX2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $16e9197195a917cd$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $16e9197195a917cd$var$BaseUrls;
var $16e9197195a917cd$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $16e9197195a917cd$var$Versions;

});


parcelRegister("idLNY", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $d43e85f334e6fa20$export$2cb8d79200775058);

var $kPyXb = parcelRequire("kPyXb");

var $bnWU7 = parcelRequire("bnWU7");
class $d43e85f334e6fa20$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $bnWU7.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $kPyXb.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $kPyXb.parseVersionMetadata)(response);
                return (0, $kPyXb.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $kPyXb.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $bnWU7.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $kPyXb.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $kPyXb.parseArtifactManifest)(response);
                return (0, $kPyXb.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $kPyXb.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("3ZW4v", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $2e941d6dd444fd76$export$45c6d12ca9c14f83);

var $kPyXb = parcelRequire("kPyXb");
function $2e941d6dd444fd76$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $2e941d6dd444fd76$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $2e941d6dd444fd76$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $kPyXb.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $kPyXb.Either).right(json)));
            }).catch((error)=>resolve((0, $kPyXb.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("cfxYZ", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $8eb13f04a9160464$export$8489e2f039bfcc4c);

var $7M3Wu = parcelRequire("7M3Wu");

var $kPyXb = parcelRequire("kPyXb");

var $5hz9f = parcelRequire("5hz9f");
function $8eb13f04a9160464$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8eb13f04a9160464$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8eb13f04a9160464$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8eb13f04a9160464$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $8eb13f04a9160464$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $5hz9f.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $8eb13f04a9160464$var$_objectSpread($8eb13f04a9160464$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $kPyXb.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $kPyXb.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("5hz9f", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $3d89cdfd84a360c3$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $3d89cdfd84a360c3$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("cRo5G", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $95cd1f2f3025b40a$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $95cd1f2f3025b40a$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $95cd1f2f3025b40a$export$c3ac7702bfd47c1b);
const $95cd1f2f3025b40a$var$SAMPLING_RATE = 10;
class $95cd1f2f3025b40a$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $95cd1f2f3025b40a$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $95cd1f2f3025b40a$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $95cd1f2f3025b40a$var$SAMPLING_RATE) return new $95cd1f2f3025b40a$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("7NT0L"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $95cd1f2f3025b40a$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $95cd1f2f3025b40a$export$5e7536cf7bc56fee();
    }
}
const $95cd1f2f3025b40a$export$a3006f8f221c0a3b = ()=>$95cd1f2f3025b40a$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $95cd1f2f3025b40a$export$c3ac7702bfd47c1b = ()=>$95cd1f2f3025b40a$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("7NT0L", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("712kb").then(()=>parcelRequire('bsSEQ'));

});


parcelRegister("bCNf6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $4Yw32 = parcelRequire("4Yw32");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $4Yw32.parseConfigWithTargeting;
    }
});

var $2sgKn = parcelRequire("2sgKn");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $2sgKn.TargetedConfig;
    }
});

});
parcelRegister("4Yw32", function(module, exports) {
"use strict";
var $39f5a012e18f7c8d$var$__assign = module.exports && module.exports.__assign || function() {
    $39f5a012e18f7c8d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39f5a012e18f7c8d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $39f5a012e18f7c8d$var$parseConfigWithTargeting;

var $2sgKn = parcelRequire("2sgKn");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $39f5a012e18f7c8d$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $39f5a012e18f7c8d$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $2sgKn.TargetedConfig({
                defaultConfig: $39f5a012e18f7c8d$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $39f5a012e18f7c8d$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $2sgKn.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $39f5a012e18f7c8d$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $39f5a012e18f7c8d$var$__assign($39f5a012e18f7c8d$var$__assign({}, accObject), (_a = {}, _a[key] = $39f5a012e18f7c8d$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $39f5a012e18f7c8d$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $39f5a012e18f7c8d$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $39f5a012e18f7c8d$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $39f5a012e18f7c8d$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $39f5a012e18f7c8d$var$parseIdentifierList(target.orgIds),
            siteIds: $39f5a012e18f7c8d$var$parseIdentifierList(target.siteIds),
            userIds: $39f5a012e18f7c8d$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $39f5a012e18f7c8d$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("2sgKn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $1c9b2fe11eb42b78$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $1c9b2fe11eb42b78$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $1c9b2fe11eb42b78$var$TargetedConfig;
function $1c9b2fe11eb42b78$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("4rQ9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $33d223f074a7d29d$export$2e2bcd8739ae039);
class $33d223f074a7d29d$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $33d223f074a7d29d$export$1d76d155060824c9 = (e)=>e instanceof $33d223f074a7d29d$export$2e2bcd8739ae039;

});

parcelRegister("92KTQ", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $6958ae44f34d3a1a$export$e3553dc63541d477);
const $6958ae44f34d3a1a$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("kELoB", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $f09c4ee659b1cd8d$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $f09c4ee659b1cd8d$export$f33622abb5224195);

var $7M3Wu = parcelRequire("7M3Wu");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
function $f09c4ee659b1cd8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f09c4ee659b1cd8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f09c4ee659b1cd8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7M3Wu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f09c4ee659b1cd8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f09c4ee659b1cd8d$export$1e3a41a51f6457c5 = ()=>new (0, $f39LL.UFOExperience)("retrieve-artifact", {
        type: (0, $2lxLk.ExperienceTypes).Operation,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $f09c4ee659b1cd8d$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $f09c4ee659b1cd8d$var$_objectSpread($f09c4ee659b1cd8d$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("7VM1L", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $c861dcefe57819b1$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $c861dcefe57819b1$export$f731e929548061dc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $c861dcefe57819b1$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...label
    });
};
const $c861dcefe57819b1$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...description
    }) : null;
};

});

const $ee74964486343666$export$45e63649edff1e2a = 'ASSETS';
const $ee74964486343666$export$eb7589a4ee50c678 = 'tenantless';

parcelRegister("8fMPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bfd928c42df4aec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0bfd928c42df4aec$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} More',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    }
});
var $0bfd928c42df4aec$export$2e2bcd8739ae039 = $0bfd928c42df4aec$var$messages;

});


parcelRegister("aBlvu", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $6d7ddc28540fd7d9$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $6d7ddc28540fd7d9$export$ba83558707df5bbe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3ks7v = parcelRequire("3ks7v");
const { fetchMethod: $6d7ddc28540fd7d9$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $6d7ddc28540fd7d9$var$DefaultBffThirdPartyProductsDataProvider } = (0, $3ks7v.createAppSwitcherBffThirdPartyProductsProvider)();
const $6d7ddc28540fd7d9$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, $gt9Am.jsx)($6d7ddc28540fd7d9$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product,
        children: children
    });
const $6d7ddc28540fd7d9$export$ba83558707df5bbe = $6d7ddc28540fd7d9$var$fetchAppSwitcherBffThirdPartyProducts;
const $6d7ddc28540fd7d9$export$fdb5fe543e39bc7a = ()=>$6d7ddc28540fd7d9$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("3ks7v", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $71c395b9475f5b16$export$1a41882ddb3a9c38);

var $a2G6W = parcelRequire("a2G6W");

var $hmtdE = parcelRequire("hmtdE");

var $gZSfe = parcelRequire("gZSfe");
const $71c395b9475f5b16$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $71c395b9475f5b16$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $hmtdE.fetchJsonWithNetworkRetries)(`${$71c395b9475f5b16$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $71c395b9475f5b16$export$1a41882ddb3a9c38 = ()=>{
    return (0, $a2G6W.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $gZSfe.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $71c395b9475f5b16$export$c39ca0fbc2221bcc);
};

});



parcelRegister("3XKVc", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $b596a958a5d90add$export$fb4230f160368c88);
const $b596a958a5d90add$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});


parcelRegister("4uNLM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a27d5cbcea41441$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $cy9FC = parcelRequire("cy9FC");


var $gdqa5 = parcelRequire("gdqa5");

var $ftN6c = parcelRequire("ftN6c");






























function $4a27d5cbcea41441$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("g5nrH"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("jLGJW"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("2dCpV"));
        case 'en-GB':
            return (parcelRequire("46DDc"));
        case 'en-ZZ':
            return (parcelRequire("53Gk6"));
        case 'en-US':
        case 'en':
            return (parcelRequire("2LLyh"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("ffH5b"));
        case 'et':
            return (parcelRequire("fzMsB"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("eiedX"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("gc3Gd"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("7mkpH"));
        case 'is':
            return (parcelRequire("4Ilzc"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("4dexL"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("fBfhv"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("8Vxdi"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("epvYv"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("eeIwW"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("bjvjs"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("c64K6"));
        case 'pt-PT':
            return (parcelRequire("eA3jN"));
        case 'ro':
            return (parcelRequire("hlTIe"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("5xQZW"));
        case 'sk':
            return (parcelRequire("80bl2"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("5HztL"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("crgtq"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("l056c"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("b9IWN"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("iermv"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("aWdBu"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("gwxjI"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $4a27d5cbcea41441$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [messages, setMessages] = (0, $eJOHy.useState)({});
    (0, $eJOHy.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $4a27d5cbcea41441$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch (e) {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $gdqa5.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cy9FC.default), {});
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        children: children
    }, locale);
};
var $4a27d5cbcea41441$export$2e2bcd8739ae039 = $4a27d5cbcea41441$var$SwitcherIntlProvider;

});
parcelRegister("g5nrH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dbGVv").then(()=>parcelRequire('bwYWn'));

});

parcelRegister("jLGJW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1eEkR").then(()=>parcelRequire('fpuot'));

});

parcelRegister("2dCpV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8NZXA").then(()=>parcelRequire('3u7xR'));

});

parcelRegister("46DDc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fX3JH").then(()=>parcelRequire('jBI3h'));

});

parcelRegister("53Gk6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3ky86").then(()=>parcelRequire('kTbfK'));

});

parcelRegister("2LLyh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8lFsj").then(()=>parcelRequire('1vlnd'));

});

parcelRegister("ffH5b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fXqh3").then(()=>parcelRequire('eQ5x7'));

});

parcelRegister("fzMsB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gd5li").then(()=>parcelRequire('hPTxc'));

});

parcelRegister("eiedX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1fEC8").then(()=>parcelRequire('l9FKp'));

});

parcelRegister("gc3Gd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ewJlC").then(()=>parcelRequire('2kWm6'));

});

parcelRegister("7mkpH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hfJvO").then(()=>parcelRequire('gvs5F'));

});

parcelRegister("4Ilzc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8aF6Y").then(()=>parcelRequire('k2vLq'));

});

parcelRegister("4dexL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2cfNn").then(()=>parcelRequire('13EZY'));

});

parcelRegister("fBfhv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iCAVc").then(()=>parcelRequire('lbmdH'));

});

parcelRegister("8Vxdi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("42qE5").then(()=>parcelRequire('4leZi'));

});

parcelRegister("epvYv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fru0c").then(()=>parcelRequire('eFD7t'));

});

parcelRegister("eeIwW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4bt3q").then(()=>parcelRequire('7jeSP'));

});

parcelRegister("bjvjs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYEAu").then(()=>parcelRequire('dej0b'));

});

parcelRegister("c64K6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lTiX1").then(()=>parcelRequire('3LIgV'));

});

parcelRegister("eA3jN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dYKS0").then(()=>parcelRequire('9u7hm'));

});

parcelRegister("hlTIe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j8LyV").then(()=>parcelRequire('5LTxU'));

});

parcelRegister("5xQZW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cFtyz").then(()=>parcelRequire('l8BRw'));

});

parcelRegister("80bl2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fRxDU").then(()=>parcelRequire('1qbF0'));

});

parcelRegister("5HztL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ckqbP").then(()=>parcelRequire('bhz32'));

});

parcelRegister("crgtq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("doHJv").then(()=>parcelRequire('bNJtO'));

});

parcelRegister("l056c", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hRhkr").then(()=>parcelRequire('89m2r'));

});

parcelRegister("b9IWN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bvu0i").then(()=>parcelRequire('fzQQz'));

});

parcelRegister("iermv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gt5IT").then(()=>parcelRequire('gwfIx'));

});

parcelRegister("aWdBu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jhykh").then(()=>parcelRequire('5FrU9'));

});

parcelRegister("gwxjI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("150WG").then(()=>parcelRequire('4U2eK'));

});


parcelRegister("ehuUo", function(module, exports) {
$parcel$export(module.exports, "experienceTimingsOf", () => $68fe0225a5cb96d7$export$3ac4e94b194cd647);
$parcel$export(module.exports, "generateUFOMarkName", () => $68fe0225a5cb96d7$export$504463c8409cf4d7);
$parcel$export(module.exports, "setSwitcherRenderStartMark", () => $68fe0225a5cb96d7$export$16539b434cec5cfb);
$parcel$export(module.exports, "getSwitcherRenderStartMark", () => $68fe0225a5cb96d7$export$436b7aeb93937572);

var $gZSfe = parcelRequire("gZSfe");
function $68fe0225a5cb96d7$export$3ac4e94b194cd647(experience) {
    return (0, $gZSfe.EXPERIENCES_TO_MARKS)[experience].map($68fe0225a5cb96d7$var$generateUFOTiming);
}
function $68fe0225a5cb96d7$var$generateUFOTiming(mark) {
    return {
        key: mark,
        startMark: $68fe0225a5cb96d7$export$504463c8409cf4d7(mark, (0, $gZSfe.ExperienceMarkPhase).START),
        endMark: $68fe0225a5cb96d7$export$504463c8409cf4d7(mark, (0, $gZSfe.ExperienceMarkPhase).END)
    };
}
const $68fe0225a5cb96d7$export$504463c8409cf4d7 = (mark, phase)=>`${mark}_${phase}`;
const $68fe0225a5cb96d7$export$16539b434cec5cfb = ()=>{
    performance.mark((0, $gZSfe.SWITCHER_RENDER_START_PERFORMANCE_MARK));
};
const $68fe0225a5cb96d7$export$436b7aeb93937572 = ()=>{
    const renderStartPerformanceMarks = performance.getEntriesByName ? performance.getEntriesByName((0, $gZSfe.SWITCHER_RENDER_START_PERFORMANCE_MARK)) : [];
    return renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]?.startTime;
};

});

parcelRegister("lK21m", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5c51a656e7f0274$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e5c51a656e7f0274$var$messages = (0, $7qGN1.defineMessages)({
    switchSitesOrAppsTooltip: {
        id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
        defaultMessage: 'Switch sites or apps',
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    tenantlessTopOrgSwitcherText: {
        id: 'fabric.atlassianSwitcher.tenantlessTopOrgSwitcherText',
        defaultMessage: 'Select organisation',
        description: 'The text of the organisation switcher item when no organisation is selected'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    joinStatusText: {
        id: 'fabric.atlassianSwitcher.joinStatusText',
        defaultMessage: 'Join',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    instantAccessStatusText: {
        id: 'fabric.atlassianSwitcher.instantAccessStatusText',
        defaultMessage: 'Instant access',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    joinTeamStatusText: {
        id: 'fabric.atlassianSwitcher.joinTeamStatusText',
        defaultMessage: 'Join team',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    jpdDescriptionText: {
        id: 'fabric.atlassianSwitcher.jpdDescriptionText',
        defaultMessage: 'Prioritize and plan new ideas',
        description: 'The description displayed for Jira Product Discovery.'
    },
    confluenceDescriptionText: {
        id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
        defaultMessage: 'Document and collaborate',
        description: 'The description displayed for Confluence.'
    },
    jiraDescriptionText: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    jsmDescriptionText: {
        id: 'fabric.atlassianSwitcher.jsmDescriptionText',
        defaultMessage: 'Automate and deliver IT support',
        description: 'The description displayed for Jira Service Management.'
    },
    requestSentStatusText: {
        id: 'fabric.atlassianSwitcher.requestSentStatusText',
        defaultMessage: 'Request sent',
        description: 'The text displayed alongside a product to indicate the user has requested access to the product.'
    },
    requestAccessPendingRequestFlagTitle: {
        id: 'fabric.atlassianSwitcher.successFlag.title',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to a product but the request is pending.'
    },
    requestAccessPendingRequestFlagDescription: {
        id: 'fabric.atlassianSwitcher.successFlag.description',
        defaultMessage: "You'll get an email once it's approved",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: 'fabric.atlassianSwitcher.errorFlag.title',
        defaultMessage: `We couldn't add you to {product}`,
        description: 'Title shown when user has requested access to a product but the request has failed.'
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: 'fabric.atlassianSwitcher.errorFlag.description',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    reorderItemErrorFlagTitle: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagTitle',
        defaultMessage: 'Something went wrong',
        description: 'The title of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagDescription: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagDescription',
        defaultMessage: 'Please refresh the page or try again later.',
        description: 'The description of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagAction: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagAction',
        defaultMessage: 'Got it',
        description: 'The action of the error flag for reordering items in the switcher'
    },
    jwmInactiveSwitcherWithJSWItemDescriptionGalaxia: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription-galaxia',
        defaultMessage: 'Manage business spaces, free with Jira ',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated and they have a Jira Software License'
    },
    jwmInactiveSwitcherWithDefaultItemDescriptionGalaxia: {
        id: 'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription-galaxia',
        defaultMessage: 'Manage spaces for business teams',
        description: 'Description when a user has never used Jira Work Management but Jira Work Management has been activated'
    },
    jiraDescriptionTextGalaxia: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText-galaxia',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    }
});
var $e5c51a656e7f0274$export$2e2bcd8739ae039 = $e5c51a656e7f0274$var$messages;

});

parcelRegister("aPN1a", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7c520702d5b0920$export$2e2bcd8739ae039);

var $3pZc2 = parcelRequire("3pZc2");

var $2wz6j = parcelRequire("2wz6j");
class $c7c520702d5b0920$export$2e2bcd8739ae039 {
    constructor(configOrCloudId, stargateUrl){
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    async start(messageId, variationId) {
        if (!(0, $2wz6j.isMessagingEnabled)()) return false;
        return (0, $3pZc2.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $2wz6j.isMessagingEnabled)()) return false;
        return (0, $3pZc2.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
}

});

parcelRegister("axnxR", function(module, exports) {
$parcel$export(module.exports, "SwitchToTooltipText", () => $1bfee3be9faf324e$export$c5ef4d14b7e18cbd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4uNLM = parcelRequire("4uNLM");

var $lK21m = parcelRequire("lK21m");
const $1bfee3be9faf324e$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4uNLM.default), {
    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $lK21m.default).switchSitesOrAppsTooltip
    })
});

});

parcelRegister("lT9x0", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $9a2fdd3f16de4971$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $d2s5v = parcelRequire("d2s5v");

var $4QR3m = parcelRequire("4QR3m");

var $9vPaT = parcelRequire("9vPaT");

var $5nYbP = parcelRequire("5nYbP");

var $3lFeO = parcelRequire("3lFeO");
const $9a2fdd3f16de4971$var$SpotlightWithVariables = (0, $4QR3m.default)((0, $3lFeO.default));
const $9a2fdd3f16de4971$export$f57123e11f24bec9 = (0, $9vPaT.default)($9a2fdd3f16de4971$var$SpotlightWithVariables);
const $9a2fdd3f16de4971$var$SpotlightWithMessage = (0, $5nYbP.default)($9a2fdd3f16de4971$export$f57123e11f24bec9, 'spotlight');
function $9a2fdd3f16de4971$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2s5v.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($9a2fdd3f16de4971$var$SpotlightWithMessage, {
            ...props
        })
    });
}

});
parcelRegister("4QR3m", function(module, exports) {
$parcel$export(module.exports, "default", () => $f68a7d49b4eb1be3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qEWz = parcelRequire("6qEWz");
function $f68a7d49b4eb1be3$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $eJOHy.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $f68a7d49b4eb1be3$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(TargetComponent, {
                ...props
            });
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $f68a7d49b4eb1be3$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $6qEWz.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $6qEWz.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $6qEWz.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("6qEWz", function(module, exports) {
$parcel$export(module.exports, "rebuildButtonAction", () => $4f5202f5615d7dcb$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $4f5202f5615d7dcb$export$d808999430a3f186);

var $bDjYx = parcelRequire("bDjYx");
function $4f5202f5615d7dcb$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $4f5202f5615d7dcb$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $bDjYx.runTemplateForUrl)(input, variables) : (0, $bDjYx.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $4a4792e17d2d5187$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $4a4792e17d2d5187$export$e26f00bd90899835 = 'success';
const $4a4792e17d2d5187$export$edb46161045fece7 = 'error';

parcelRegister("bDjYx", function(module, exports) {
$parcel$export(module.exports, "runTemplateForUrl", () => $6ffe838aa9e1fae0$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $6ffe838aa9e1fae0$export$5681b97796b74884);

var $5QL6E = parcelRequire("5QL6E");

var $bQvGh = parcelRequire("bQvGh");


var $b6hcz = parcelRequire("b6hcz");
function $6ffe838aa9e1fae0$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $5QL6E.default)(template);
    return (0, $b6hcz.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $6ffe838aa9e1fae0$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $5QL6E.default)(template);
    return (0, $bQvGh.replaceForUrl)(epTemplate, variables);
}
function $6ffe838aa9e1fae0$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $5QL6E.default)(template);
    return (0, $bQvGh.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("5QL6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcb6de4a7a4965b0$export$2e2bcd8739ae039);

var $gMVeb = parcelRequire("gMVeb");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $fcb6de4a7a4965b0$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $fcb6de4a7a4965b0$var$UNESCAPED_MATCH = 1;
const $fcb6de4a7a4965b0$var$UNESCAPED_GROUP_CONTENTS = 2;
const $fcb6de4a7a4965b0$var$ESCAPED_GROUP_CONTENTS = 5;
function $fcb6de4a7a4965b0$export$2e2bcd8739ae039(template) {
    const parts = (0, $gMVeb.regexpParts)(template, $fcb6de4a7a4965b0$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$fcb6de4a7a4965b0$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$fcb6de4a7a4965b0$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$fcb6de4a7a4965b0$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("gMVeb", function(module, exports) {
$parcel$export(module.exports, "regexpParts", () => $1d195b8fbfc9ce29$export$b16d411b3b6d6dff);
function $1d195b8fbfc9ce29$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $1d195b8fbfc9ce29$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $1d195b8fbfc9ce29$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $1d195b8fbfc9ce29$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $1d195b8fbfc9ce29$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("bQvGh", function(module, exports) {
$parcel$export(module.exports, "replaceForUrl", () => $709e5f94b263ded4$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $709e5f94b263ded4$export$ca536300dbd6350);

var $b6hcz = parcelRequire("b6hcz");

var $gLy9V = parcelRequire("gLy9V");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $709e5f94b263ded4$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $b6hcz.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $709e5f94b263ded4$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $709e5f94b263ded4$var$rawReplaceVariablesForUrl(template, variables) {
    return $709e5f94b263ded4$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $709e5f94b263ded4$var$rawReplaceVariablesForHtml(template, variables) {
    return $709e5f94b263ded4$var$rawReplaceVariables(template, variables, (0, $gLy9V.default));
}
function $709e5f94b263ded4$export$d10ae881b12b8ef2(template, variables) {
    return $709e5f94b263ded4$var$withVariableValidation(template, variables, $709e5f94b263ded4$var$rawReplaceVariablesForUrl);
}
function $709e5f94b263ded4$export$ca536300dbd6350(template, variables) {
    return $709e5f94b263ded4$var$withVariableValidation(template, variables, $709e5f94b263ded4$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("b6hcz", function(module, exports) {
$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $41d5b32b695f5967$export$4a33186abb06007b);

var $6Slcz = parcelRequire("6Slcz");
function $41d5b32b695f5967$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $41d5b32b695f5967$export$4a33186abb06007b(template) {
    const variableParts = $41d5b32b695f5967$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $6Slcz.uniqStrings)(variableNames);
}

});
parcelRegister("6Slcz", function(module, exports) {
$parcel$export(module.exports, "uniqStrings", () => $c8a83bb61490b6a3$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $c8a83bb61490b6a3$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("gLy9V", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffd70d72a7df40bf$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $ffd70d72a7df40bf$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("3lFeO", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb1669614e19fe03$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $bdRit = parcelRequire("bdRit");

var $9BCGk = parcelRequire("9BCGk");

var $bK1H5 = parcelRequire("bK1H5");
class $cb1669614e19fe03$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $9BCGk.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bK1H5.default), {
                html: body
            })
        });
    }
}

});


parcelRegister("79KhM", function(module, exports) {
$parcel$export(module.exports, "useNudgeController", () => $9e23bc82a736243d$export$9a533735412babca);
$parcel$export(module.exports, "useRegisterNudgeTarget", () => $9e23bc82a736243d$export$eb8a96124d659f2d);

var $eJOHy = parcelRequire("eJOHy");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 *  See some of the history here https://hello.atlassian.net/wiki/spaces/~620663553/pages/2896059847/Shipit+57+-+Out+of+Tree+Nudges
 */ class $9e23bc82a736243d$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $9e23bc82a736243d$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
const $9e23bc82a736243d$export$9a533735412babca = ()=>$9e23bc82a736243d$var$NudgeController.instance;
const $9e23bc82a736243d$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $9e23bc82a736243d$export$9a533735412babca();
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};

});

parcelRegister("1qr3l", function(module, exports) {
$parcel$export(module.exports, "ChatOpenerSubscriber", () => $a49dfe8f4c7dc709$export$6fa95a645837361b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3VR5d = parcelRequire("3VR5d");
var $fveN7 = parcelRequire("fveN7");
var $leNtV = parcelRequire("leNtV");

var $9tFw2 = parcelRequire("9tFw2");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $a49dfe8f4c7dc709$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);
const $a49dfe8f4c7dc709$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $a49dfe8f4c7dc709$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9tFw2.useAnalytics)();
    const [triggerOpen, setTriggerOpen] = (0, $eJOHy.useState)(!!(0, $3VR5d.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $eJOHy.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $leNtV.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $a49dfe8f4c7dc709$var$ignoredEvents.has(type);
        if (!$a49dfe8f4c7dc709$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        // Extract conversation ID from chat-open events
        const conversationId = type === 'chat-open' && 'data' in payload ? payload.data.channelId : undefined;
        onTriggerOpeningChat(conversationId);
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fveN7.RovoPostMessagePubsubListener), {})
    });
};

});
parcelRegister("3VR5d", function(module, exports) {
$parcel$export(module.exports, "getRovoParams", () => $12e9918cc7b08ea4$export$6405071f390601f7);
$parcel$export(module.exports, "updatePageRovoParams", () => $12e9918cc7b08ea4$export$4a302fc7d977f7b3);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $12e9918cc7b08ea4$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $12e9918cc7b08ea4$export$eddc20a009406015);

var $2UhnR = parcelRequire("2UhnR");
const $12e9918cc7b08ea4$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $12e9918cc7b08ea4$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $12e9918cc7b08ea4$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $12e9918cc7b08ea4$export$9748efee331ec573 = (param)=>`${0, $2UhnR.ROVO_PARAM_PREFIX}${$12e9918cc7b08ea4$export$fda91e425d265029(param)}`;
const $12e9918cc7b08ea4$export$f2888183a34644d4 = (param)=>{
    return $12e9918cc7b08ea4$export$858653b7ee3cbb17(param.replace((0, $2UhnR.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $12e9918cc7b08ea4$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $12e9918cc7b08ea4$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $2UhnR.ROVO_PARAM_PREFIX))) return;
        const paramKey = $12e9918cc7b08ea4$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $12e9918cc7b08ea4$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $12e9918cc7b08ea4$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $12e9918cc7b08ea4$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $12e9918cc7b08ea4$export$ef04687636c850fe(window.location.pathname, params));
};
const $12e9918cc7b08ea4$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $12e9918cc7b08ea4$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $12e9918cc7b08ea4$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $12e9918cc7b08ea4$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$12e9918cc7b08ea4$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$12e9918cc7b08ea4$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $12e9918cc7b08ea4$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $12e9918cc7b08ea4$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $2UhnR.ROVO_VALID_PARAMS).map((param)=>`${$12e9918cc7b08ea4$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("2UhnR", function(module, exports) {
$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $44ee4f94616d6887$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $44ee4f94616d6887$export$3cd6b610e7ede579);
const $44ee4f94616d6887$export$5a550907ffbc9119 = 'rovoChat';
const $44ee4f94616d6887$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt'
];

});


parcelRegister("9tFw2", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $7d35ad749e7bb18c$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $5EMLi = parcelRequire("5EMLi");
var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $b1fSH = parcelRequire("b1fSH");

var $brEuN = parcelRequire("brEuN");

var $7flwf = parcelRequire("7flwf");

var $QsQau = parcelRequire("QsQau");

var $iEF5w = parcelRequire("iEF5w");
const $7d35ad749e7bb18c$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $7d35ad749e7bb18c$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $7d35ad749e7bb18c$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $brEuN.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $eJOHy.useCallback)((inputPayload)=>{
        const payload = (0, $5EMLi.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $7d35ad749e7bb18c$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$7d35ad749e7bb18c$var$DEFAULT_TAGS
    ];
    if ($7d35ad749e7bb18c$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $b1fSH.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $iEF5w.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $QsQau.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $eJOHy.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, mode: mode } = propertiesRef.current;
        return {
            [(0, $7flwf.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $7flwf.AI_MATE_ATTRIBUTES).mode]: mode
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $eJOHy.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$7d35ad749e7bb18c$var$DEFAULT_TAGS
        ];
        if ($7d35ad749e7bb18c$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, invokedPlugins: invokedPlugins, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        // Core AI MAU payload
        let eventPayload = {
            eventType: 'track',
            tags: tags,
            source: source,
            actionSubjectId: subjectId,
            attributes: attributes
        };
        const migrationEnabled = (0, $eGOwo.fg)('rovo_ai_events_tracking_migration');
        if (migrationEnabled) {
            let libAttributes = {
                ...attributes,
                aiFeatureName: 'aiChat',
                proactiveGeneratedAI: proactive ? 1 : 0,
                userGeneratedAI: userGenerated ? 1 : 0
            };
            switch(payload.type){
                case 'initiated':
                    trackAIInteractionInit({
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'viewed':
                    trackAIResultView({
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'error':
                    trackAIResultError({
                        aiErrorMessage: payload.errorMessage
                    }, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'dismissed':
                    trackAIInteractionDismiss({
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'actioned':
                    trackAIResultAction(payload.actionResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                case 'feedback':
                    trackAIFeedbackSubmit(payload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
            }
        } else {
            switch(payload.type){
                case 'initiated':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiInteraction',
                        action: 'initiated'
                    };
                    break;
                case 'viewed':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'viewed'
                    };
                    break;
                case 'error':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'error'
                    };
                    break;
                case 'dismissed':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiInteraction',
                        action: 'dismissed'
                    };
                    break;
                case 'actioned':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiResult',
                        action: 'actioned',
                        attributes: {
                            ...eventPayload.attributes,
                            aiResultAction: payload.actionResult
                        }
                    };
                    break;
                case 'feedback':
                    eventPayload = {
                        ...eventPayload,
                        actionSubject: 'aiFeedback',
                        action: 'submitted',
                        attributes: {
                            ...eventPayload.attributes,
                            aiFeedbackResult: payload.feedbackResult
                        }
                    };
                    break;
            }
            // Build event and apply context attributes
            const event = createAnalyticsEvent(eventPayload);
            const aiMateContextAttributes = (0, $iEF5w.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $QsQau.ANALYTICS_CHANNEL));
        }
    // Handle specific AI MAU events
    }, [
        createAnalyticsEvent,
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $eJOHy.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $7d35ad749e7bb18c$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if ((0, $5EMLi.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $iEF5w.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $QsQau.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $iEF5w.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $QsQau.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};

});
parcelRegister("b1fSH", function(module, exports) {
$parcel$export(module.exports, "useAIEventsInstrumentation", () => $48c758f1d390e21e$export$ddf49ad062368ad2);

var $eJOHy = parcelRequire("eJOHy");

var $fCkfV = parcelRequire("fCkfV");

var $3VCQy = parcelRequire("3VCQy");

var $ftN6c = parcelRequire("ftN6c");

var $9Sbhc = parcelRequire("9Sbhc");

var $4ydDU = parcelRequire("4ydDU");

var $gSINT = parcelRequire("gSINT");

var $jh4uf = parcelRequire("jh4uf");

var $lmKRx = parcelRequire("lmKRx");
const $48c758f1d390e21e$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $eJOHy.useContext)((0, $9Sbhc.AIEventsInstrumentationContext));
    if (customConfig) context = {
        config: {
            ...(0, $4ydDU.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $lmKRx.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $eJOHy.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $fCkfV.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $jh4uf.AISessionState).unset,
            nextState: (0, $fCkfV.P).union((0, $jh4uf.AISessionState).viewed, (0, $jh4uf.AISessionState).error, (0, $jh4uf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $jh4uf.AISessionState).initiated,
            nextState: (0, $fCkfV.P).union((0, $jh4uf.AISessionState).submitted, (0, $jh4uf.AISessionState).actioned, (0, $jh4uf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $eJOHy.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3VCQy.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $eJOHy.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes
            }
        };
        return (0, $fCkfV.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $gSINT.getTagsWithPlatfromTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $fCkfV.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $fCkfV.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        aiExperienceName,
        aiFeatureName,
        product,
        proactiveGeneratedAI,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        userGeneratedAI,
        isAIFeature,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents
    ]);
    const trackAIInteractionInit = (0, $eJOHy.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $eJOHy.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $eJOHy.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $eJOHy.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $eJOHy.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $eJOHy.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $eJOHy.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $jh4uf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    return {
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};

});
parcelRegister("fCkfV", function(module, exports) {
$parcel$export(module.exports, "P", () => $b5ea1e03c9b70b8e$export$56c0d5a1e737357d);
$parcel$export(module.exports, "match", () => $b5ea1e03c9b70b8e$export$4659b591c19bdf3d);
const $b5ea1e03c9b70b8e$var$t = Symbol.for("@ts-pattern/matcher"), $b5ea1e03c9b70b8e$var$e = Symbol.for("@ts-pattern/isVariadic"), $b5ea1e03c9b70b8e$var$n = "@ts-pattern/anonymous-select-key", $b5ea1e03c9b70b8e$var$r = (t)=>Boolean(t && "object" == typeof t), $b5ea1e03c9b70b8e$var$i = (e)=>e && !!e[$b5ea1e03c9b70b8e$var$t], $b5ea1e03c9b70b8e$var$o = (n, s, c)=>{
    if ($b5ea1e03c9b70b8e$var$i(n)) {
        const e = n[$b5ea1e03c9b70b8e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($b5ea1e03c9b70b8e$var$r(n)) {
        if (!$b5ea1e03c9b70b8e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $b5ea1e03c9b70b8e$var$i(s) && s[$b5ea1e03c9b70b8e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$b5ea1e03c9b70b8e$var$o(t, e[n], c)) && r.every((t, e)=>$b5ea1e03c9b70b8e$var$o(t, n[e], c)) && (0 === a.length || $b5ea1e03c9b70b8e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$b5ea1e03c9b70b8e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $b5ea1e03c9b70b8e$var$i(a = r) && "optional" === a[$b5ea1e03c9b70b8e$var$t]().matcherType) && $b5ea1e03c9b70b8e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $b5ea1e03c9b70b8e$var$s = (e)=>{
    var n, o, a;
    return $b5ea1e03c9b70b8e$var$r(e) ? $b5ea1e03c9b70b8e$var$i(e) ? null != (n = null == (o = (a = e[$b5ea1e03c9b70b8e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $b5ea1e03c9b70b8e$var$c(e, $b5ea1e03c9b70b8e$var$s) : $b5ea1e03c9b70b8e$var$c(Object.values(e), $b5ea1e03c9b70b8e$var$s) : [];
}, $b5ea1e03c9b70b8e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $b5ea1e03c9b70b8e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$b5ea1e03c9b70b8e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $b5ea1e03c9b70b8e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $b5ea1e03c9b70b8e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$b5ea1e03c9b70b8e$var$l(t),
        and: (e)=>$b5ea1e03c9b70b8e$var$m(t, e),
        or: (e)=>$b5ea1e03c9b70b8e$var$d(t, e),
        select: (e)=>void 0 === e ? $b5ea1e03c9b70b8e$var$y(t) : $b5ea1e03c9b70b8e$var$y(e, t)
    });
}
function $b5ea1e03c9b70b8e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$b5ea1e03c9b70b8e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$b5ea1e03c9b70b8e$var$h($b5ea1e03c9b70b8e$var$l(t)),
        select: (e)=>$b5ea1e03c9b70b8e$var$h(void 0 === e ? $b5ea1e03c9b70b8e$var$y(t) : $b5ea1e03c9b70b8e$var$y(e, t))
    });
}
function $b5ea1e03c9b70b8e$var$l(e) {
    return $b5ea1e03c9b70b8e$var$u({
        [$b5ea1e03c9b70b8e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($b5ea1e03c9b70b8e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $b5ea1e03c9b70b8e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$b5ea1e03c9b70b8e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $b5ea1e03c9b70b8e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $b5ea1e03c9b70b8e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $b5ea1e03c9b70b8e$var$m(...e) {
    return $b5ea1e03c9b70b8e$var$u({
        [$b5ea1e03c9b70b8e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$b5ea1e03c9b70b8e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$b5ea1e03c9b70b8e$var$c(e, $b5ea1e03c9b70b8e$var$s),
                matcherType: "and"
            })
    });
}
function $b5ea1e03c9b70b8e$var$d(...e) {
    return $b5ea1e03c9b70b8e$var$u({
        [$b5ea1e03c9b70b8e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $b5ea1e03c9b70b8e$var$c(e, $b5ea1e03c9b70b8e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$b5ea1e03c9b70b8e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$b5ea1e03c9b70b8e$var$c(e, $b5ea1e03c9b70b8e$var$s),
                matcherType: "or"
            })
    });
}
function $b5ea1e03c9b70b8e$var$p(e) {
    return {
        [$b5ea1e03c9b70b8e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $b5ea1e03c9b70b8e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $b5ea1e03c9b70b8e$var$u({
        [$b5ea1e03c9b70b8e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $b5ea1e03c9b70b8e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $b5ea1e03c9b70b8e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $b5ea1e03c9b70b8e$var$n
                    ].concat(void 0 === i ? [] : $b5ea1e03c9b70b8e$var$s(i))
            })
    });
}
function $b5ea1e03c9b70b8e$var$v(t) {
    return "number" == typeof t;
}
function $b5ea1e03c9b70b8e$var$b(t) {
    return "string" == typeof t;
}
function $b5ea1e03c9b70b8e$var$w(t) {
    return "bigint" == typeof t;
}
const $b5ea1e03c9b70b8e$var$S = $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p(function(t) {
    return !0;
})), $b5ea1e03c9b70b8e$var$O = $b5ea1e03c9b70b8e$var$S, $b5ea1e03c9b70b8e$var$j = (t)=>Object.assign($b5ea1e03c9b70b8e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, (n = e, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, (n = e, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, (n = e, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$m(t, (n = e, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $b5ea1e03c9b70b8e$var$K = $b5ea1e03c9b70b8e$var$j($b5ea1e03c9b70b8e$var$p($b5ea1e03c9b70b8e$var$b)), $b5ea1e03c9b70b8e$var$x = (t)=>Object.assign($b5ea1e03c9b70b8e$var$u(t), {
        between: (e, n)=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, ((t, e)=>$b5ea1e03c9b70b8e$var$p((n)=>$b5ea1e03c9b70b8e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$v(e) && e < t))(e))),
        gt: (e)=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$v(e) && e > t))(e))),
        lte: (e)=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$v(e) && e <= t))(e))),
        gte: (e)=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$v(e) && e >= t))(e))),
        int: ()=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$v(t) && t > 0))),
        negative: ()=>$b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$m(t, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$v(t) && t < 0)))
    }), $b5ea1e03c9b70b8e$var$E = $b5ea1e03c9b70b8e$var$x($b5ea1e03c9b70b8e$var$p($b5ea1e03c9b70b8e$var$v)), $b5ea1e03c9b70b8e$var$A = (t)=>Object.assign($b5ea1e03c9b70b8e$var$u(t), {
        between: (e, n)=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, ((t, e)=>$b5ea1e03c9b70b8e$var$p((n)=>$b5ea1e03c9b70b8e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$w(e) && e < t))(e))),
        gt: (e)=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$w(e) && e > t))(e))),
        lte: (e)=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$w(e) && e <= t))(e))),
        gte: (e)=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, ((t)=>$b5ea1e03c9b70b8e$var$p((e)=>$b5ea1e03c9b70b8e$var$w(e) && e >= t))(e))),
        positive: ()=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$w(t) && t > 0))),
        negative: ()=>$b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$m(t, $b5ea1e03c9b70b8e$var$p((t)=>$b5ea1e03c9b70b8e$var$w(t) && t < 0)))
    }), $b5ea1e03c9b70b8e$var$P = $b5ea1e03c9b70b8e$var$A($b5ea1e03c9b70b8e$var$p($b5ea1e03c9b70b8e$var$w)), $b5ea1e03c9b70b8e$var$T = $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p(function(t) {
    return "boolean" == typeof t;
})), $b5ea1e03c9b70b8e$var$B = $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p(function(t) {
    return "symbol" == typeof t;
})), $b5ea1e03c9b70b8e$var$_ = $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p(function(t) {
    return null == t;
})), $b5ea1e03c9b70b8e$var$k = $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p(function(t) {
    return null != t;
}));
var $b5ea1e03c9b70b8e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $b5ea1e03c9b70b8e$var$t,
    optional: $b5ea1e03c9b70b8e$var$l,
    array: function(...e) {
        return $b5ea1e03c9b70b8e$var$h({
            [$b5ea1e03c9b70b8e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $b5ea1e03c9b70b8e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$b5ea1e03c9b70b8e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $b5ea1e03c9b70b8e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $b5ea1e03c9b70b8e$var$u({
            [$b5ea1e03c9b70b8e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $b5ea1e03c9b70b8e$var$f(t, (t)=>$b5ea1e03c9b70b8e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $b5ea1e03c9b70b8e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $b5ea1e03c9b70b8e$var$u({
            [$b5ea1e03c9b70b8e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $b5ea1e03c9b70b8e$var$g(t, (t, e)=>{
                                const n = $b5ea1e03c9b70b8e$var$o(s, e, r), i = $b5ea1e03c9b70b8e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$b5ea1e03c9b70b8e$var$s(e[0]),
                            ...$b5ea1e03c9b70b8e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $b5ea1e03c9b70b8e$var$m,
    union: $b5ea1e03c9b70b8e$var$d,
    not: function(e) {
        return $b5ea1e03c9b70b8e$var$u({
            [$b5ea1e03c9b70b8e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$b5ea1e03c9b70b8e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $b5ea1e03c9b70b8e$var$p,
    select: $b5ea1e03c9b70b8e$var$y,
    any: $b5ea1e03c9b70b8e$var$S,
    _: $b5ea1e03c9b70b8e$var$O,
    string: $b5ea1e03c9b70b8e$var$K,
    number: $b5ea1e03c9b70b8e$var$E,
    bigint: $b5ea1e03c9b70b8e$var$P,
    boolean: $b5ea1e03c9b70b8e$var$T,
    symbol: $b5ea1e03c9b70b8e$var$B,
    nullish: $b5ea1e03c9b70b8e$var$_,
    nonNullable: $b5ea1e03c9b70b8e$var$k,
    instanceOf: function(t) {
        return $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $b5ea1e03c9b70b8e$var$u($b5ea1e03c9b70b8e$var$p($b5ea1e03c9b70b8e$export$ce1e7a33533a73d9(t)));
    }
};
class $b5ea1e03c9b70b8e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $b5ea1e03c9b70b8e$var$$ = {
    matched: !1,
    value: void 0
};
function $b5ea1e03c9b70b8e$export$4659b591c19bdf3d(t) {
    return new $b5ea1e03c9b70b8e$var$I(t, $b5ea1e03c9b70b8e$var$$);
}
class $b5ea1e03c9b70b8e$var$I {
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$b5ea1e03c9b70b8e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $b5ea1e03c9b70b8e$var$$ : {
            matched: !0,
            value: e(s ? $b5ea1e03c9b70b8e$var$n in c ? c[$b5ea1e03c9b70b8e$var$n] : c : this.input, this.input)
        };
        return new $b5ea1e03c9b70b8e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $b5ea1e03c9b70b8e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $b5ea1e03c9b70b8e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $b5ea1e03c9b70b8e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
}
function $b5ea1e03c9b70b8e$var$L(t) {
    throw new $b5ea1e03c9b70b8e$export$6c1467edb54d3773(t);
}

});

parcelRegister("9Sbhc", function(module, exports) {
$parcel$export(module.exports, "AIEventsInstrumentationContext", () => $13ee5484ae7bbd20$export$4f059feb37b5835e);

var $eJOHy = parcelRequire("eJOHy");
const $13ee5484ae7bbd20$export$4f059feb37b5835e = (0, $eJOHy.createContext)(null);

});

parcelRegister("4ydDU", function(module, exports) {
$parcel$export(module.exports, "defaultAIEventsInstrumentationConfigValues", () => $f53fb9affddca3d1$export$5013b36eeed4ec19);

var $jh4uf = parcelRequire("jh4uf");
const $f53fb9affddca3d1$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $jh4uf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};

});
parcelRegister("jh4uf", function(module, exports) {
$parcel$export(module.exports, "AISessionState", () => $2fd96f98a6943799$export$af92e0e920a45719);
$parcel$export(module.exports, "EventDispatcherSources", () => $2fd96f98a6943799$export$7052d5b66e36f60f);
var $2fd96f98a6943799$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $2fd96f98a6943799$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});

});


parcelRegister("gSINT", function(module, exports) {
$parcel$export(module.exports, "getTagsWithPlatfromTag", () => $a55f5445ec41ef46$export$8dd34cb3211cf994);
const $a55f5445ec41ef46$export$8dd34cb3211cf994 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};

});

parcelRegister("lmKRx", function(module, exports) {
$parcel$export(module.exports, "useAIInstrumentationSetup", () => $87031042cd476074$export$259576f4e7ac6488);

var $eJOHy = parcelRequire("eJOHy");

var $cyYLA = parcelRequire("cyYLA");

var $2LmyS = parcelRequire("2LmyS");

var $jh4uf = parcelRequire("jh4uf");
const $87031042cd476074$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $eJOHy.useRef)(undefined);
    const aiSessionStateRef = (0, $eJOHy.useRef)((0, $jh4uf.AISessionState).unset);
    const setAISessionState = (0, $eJOHy.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $eJOHy.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $eJOHy.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $cyYLA.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $2LmyS.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $eJOHy.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $2LmyS.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};

});
parcelRegister("cyYLA", function(module, exports) {
$parcel$export(module.exports, "getNewSingleInstrumentationID", () => $800c6e6d3292001f$export$cee2a1482be61648);

var $fCkfV = parcelRequire("fCkfV");

var $8KLBw = parcelRequire("8KLBw");
function $800c6e6d3292001f$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $fCkfV.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $fCkfV.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $fCkfV.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
}

});

parcelRegister("2LmyS", function(module, exports) {
$parcel$export(module.exports, "setSingleInstrumentationIDCookie", () => $e9071ee3332e4c46$export$9a4eaf99327c19fe);
$parcel$export(module.exports, "readSingleInstrumentationIDCookie", () => $e9071ee3332e4c46$export$d6fb1caea334c7c7);

var $2p0jb = parcelRequire("2p0jb");
var $dXMgi = parcelRequire("dXMgi");
const $e9071ee3332e4c46$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $e9071ee3332e4c46$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $e9071ee3332e4c46$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $dXMgi.setCookie)($e9071ee3332e4c46$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $e9071ee3332e4c46$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $2p0jb.getCookie)($e9071ee3332e4c46$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $e9071ee3332e4c46$export$72d8c154d3f75075;

});
parcelRegister("dXMgi", function(module, exports) {
$parcel$export(module.exports, "setCookie", () => $4744641bab47031a$export$110700823644f4a6);

var $5H4WP = parcelRequire("5H4WP");

var $eGOwo = parcelRequire("eGOwo");

var $9SIye = parcelRequire("9SIye");
var $lgusX = parcelRequire("lgusX");

var $15Ffx = parcelRequire("15Ffx");

var $60vYG = parcelRequire("60vYG");

var $6T1aH = parcelRequire("6T1aH");
const $4744641bab47031a$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $eGOwo.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $6T1aH.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $9SIye.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $15Ffx.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $6T1aH.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $lgusX.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $6T1aH.Status).SUCCESS;
        } else return (0, $6T1aH.Status).BLOCKED;
    } catch (e) {
        (0, $60vYG.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $6T1aH.Status).BLOCKED;
    }
};

});




parcelRegister("brEuN", function(module, exports) {
$parcel$export(module.exports, "SharedFeaturesInstrumentationIdContext", () => $943f6a262ac32c09$export$5ae3634fdb64882c);
$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $943f6a262ac32c09$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $943f6a262ac32c09$export$ab8aa3dfd687f012);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");
const $943f6a262ac32c09$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $943f6a262ac32c09$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    propertiesRef: {
        current: {
            ...$943f6a262ac32c09$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $943f6a262ac32c09$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $943f6a262ac32c09$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $eJOHy.useRef)({
        ...$943f6a262ac32c09$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $eJOHy.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($943f6a262ac32c09$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $943f6a262ac32c09$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $eJOHy.useContext)($943f6a262ac32c09$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $eJOHy.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($943f6a262ac32c09$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($943f6a262ac32c09$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $943f6a262ac32c09$export$ab8aa3dfd687f012 = ()=>{
    return (0, $eJOHy.useContext)($943f6a262ac32c09$var$AnalyticsPropertiesContext);
};

});

parcelRegister("7flwf", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $a794628e0bab621d$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $a794628e0bab621d$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId'
};

});

parcelRegister("QsQau", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $ebed0bdebb8aa096$export$85183a312807388d);
$parcel$export(module.exports, "AUTOSUGGEST_SOURCE", () => $ebed0bdebb8aa096$export$406073150b1a408);

var $3VCQy = parcelRequire("3VCQy");
const $ebed0bdebb8aa096$export$85183a312807388d = (0, $3VCQy.FabricChannel).aiMate;
var $ebed0bdebb8aa096$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});

});

parcelRegister("iEF5w", function(module, exports) {
$parcel$export(module.exports, "getAttributesFromContexts", () => $8e4f830937979ffb$export$d97c97ed77ff09e8);

var $eUaD0 = parcelRequire("eUaD0");

var $gJTFC = parcelRequire("gJTFC");
const $8e4f830937979ffb$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $gJTFC.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $8e4f830937979ffb$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$8e4f830937979ffb$var$isSourceAndAttributes(x) || x[0, $eUaD0.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $eUaD0.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};

});
parcelRegister("gJTFC", function(module, exports) {
$parcel$export(module.exports, "ALLOWED_AI_MATE_SOURCES", () => $33feae389904d8bd$export$e31e24b63b7085fd);
const $33feae389904d8bd$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];

});




parcelRegister("lsErf", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantUIModes", () => $b7dd385dfd5ba7b9$export$bc36ebf73899a71d);
const $b7dd385dfd5ba7b9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};

});

parcelRegister("jfIWt", function(module, exports) {
$parcel$export(module.exports, "useRovoEntitlement", () => $ba3d93da72a2bb35$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $ba3d93da72a2bb35$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $ba3d93da72a2bb35$export$d03a05ad8547472c);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $ba3d93da72a2bb35$var$rovoEntitlementStore = (0, $GtRbT.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $ba3d93da72a2bb35$var$useStateHook = (0, $iJq0l.createStateHook)($ba3d93da72a2bb35$var$rovoEntitlementStore);
const $ba3d93da72a2bb35$export$66d5dd4be64dea43 = ()=>{
    const result = $ba3d93da72a2bb35$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $ba3d93da72a2bb35$export$8004893135276275 = (0, $iJq0l.createActionsHook)($ba3d93da72a2bb35$var$rovoEntitlementStore);
const $ba3d93da72a2bb35$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $ba3d93da72a2bb35$export$8004893135276275();
    (0, $eJOHy.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};

});

parcelRegister("ldCDT", function(module, exports) {
$parcel$export(module.exports, "ChatContextSubscriber", () => $967e02e7a7724a3e$export$29ff0802eb3bb217);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $leNtV = parcelRequire("leNtV");

var $bhiKB = parcelRequire("bhiKB");
const $967e02e7a7724a3e$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext, setDashboardContext: setDashboardContext, setAIFeatureContext: setAIFeatureContext } = (0, $bhiKB.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $leNtV.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    case 'dashboard-insights-actions':
                        (0, $eGOwo.fg)('platform_avp_enable_dashboard_context_event_pubsub') && setDashboardContext(payload.data);
                        break;
                    case 'set-message-context':
                        setAIFeatureContext(payload.data);
                        break;
                    default:
                }
            } catch (error) {}
        }
    });
};

});
parcelRegister("bhiKB", function(module, exports) {
$parcel$export(module.exports, "useChatContextStoreActions", () => $34589850022e88a1$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $34589850022e88a1$export$9465f65715425f1b);
$parcel$export(module.exports, "useChatContextBrowserContext", () => $34589850022e88a1$export$376b2a7bf70dad8);
$parcel$export(module.exports, "useChatContextProvider", () => $34589850022e88a1$export$904052abb7b98535);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $eGOwo = parcelRequire("eGOwo");
const $34589850022e88a1$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        contentTargets: {},
        currentTargetId: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentAIFeatureContextState = getState().aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        getTarget: (contentContext)=>({ getState: getState })=>getState().contentTargets[contentContext],
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                const entry = entries.find(([, value])=>value.id === contentId);
                return entry?.[0];
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                setState({
                    contentTargets: {
                        ...getState().contentTargets,
                        [toAdd]: target
                    }
                });
            },
        clearTarget: (toRemove)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k === toRemove) continue;
                    nextState[k] = currentState[k];
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $34589850022e88a1$export$53bf948a400e8426 = (0, $iJq0l.createActionsHook)($34589850022e88a1$export$6f57813fe9f31bf9);
const $34589850022e88a1$export$9465f65715425f1b = (0, $iJq0l.createHook)($34589850022e88a1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $34589850022e88a1$export$eea520981851a092 = (0, $iJq0l.createHook)($34589850022e88a1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $34589850022e88a1$export$376b2a7bf70dad8 = (0, $iJq0l.createHook)($34589850022e88a1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $34589850022e88a1$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $34589850022e88a1$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $eJOHy.useCallback)(async (type, contentContext)=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext);
        if (!contentTarget) return undefined;
        const contentBody = await getContentBody(type, type === 'page' && (0, $eGOwo.fg)('platform_editor_aifc_multiple_editor_streaming') ? currentTargetId || contentTarget.id : contentTarget.id);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    isViewMode: contentBody.isViewMode,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $eJOHy.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
        const isAifcEnabled = (0, $eGOwo.fg)('aifc_create_enabled');
        const shouldProvideContext = $34589850022e88a1$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $eJOHy.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
        const isAifcEnabled = (0, $eGOwo.fg)('aifc_create_enabled');
        const shouldProvideContext = $34589850022e88a1$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('whiteboard', contentContext) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $eJOHy.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference })=>{
        const isAifcEnabled = (0, $eGOwo.fg)('aifc_create_enabled');
        const shouldProvideContext = $34589850022e88a1$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('database', contentContext) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $eJOHy.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $eGOwo.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $eJOHy.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $eJOHy.useCallback)((addCurrentPageAsContextUserPreference)=>{
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $eJOHy.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $eJOHy.useCallback)(async ()=>{
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $34589850022e88a1$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, or if the prompt is not the first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}

});


parcelRegister("hmxq3", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantButtonNav4", () => $68d07e7ccf1a3bf3$export$25e85d244cbf7845);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");
var $7UDun = parcelRequire("7UDun");

var $lRq8t = parcelRequire("lRq8t");

var $gRw8I = parcelRequire("gRw8I");

var $e2Zbt = parcelRequire("e2Zbt");

var $7GbGs = parcelRequire("7GbGs");

var $59rsN = parcelRequire("59rsN");

var $lgMTT = parcelRequire("lgMTT");

var $6kf2c = parcelRequire("6kf2c");

var $54CI2 = parcelRequire("54CI2");
var $fBe2p = parcelRequire("fBe2p");
var $guChT = parcelRequire("guChT");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $9tFw2 = parcelRequire("9tFw2");

var $gxwEg = parcelRequire("gxwEg");
var $kp0xK = parcelRequire("kp0xK");
var $kgTnp = parcelRequire("kgTnp");
var $18T1s = parcelRequire("18T1s");

var $3ocqN = parcelRequire("3ocqN");

var $7Hc0H = parcelRequire("7Hc0H");
const $68d07e7ccf1a3bf3$var$defaultButtonStyles = {
    paddingInline: "var(--ds-space-100, 8px)"
};
const $68d07e7ccf1a3bf3$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #0515240F)"
};
const $68d07e7ccf1a3bf3$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #17171708)",
    color: "var(--ds-text-disabled, #080F214A)"
};
const $68d07e7ccf1a3bf3$var$getConversationAssistantButton = (Button = (0, $7GbGs.PrimaryButton))=>/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, tooltipContent: tooltipContent, siteId: siteId, productKey: productKey }, ref)=>{
        (0, $gRw8I.di)((0, $7UDun.useCoordination), (0, $kgTnp.useCoordinationClient), (0, $59rsN.default));
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        const { start: start } = (0, $kp0xK.useConversationAssistantSpotlightActions)();
        const [shouldShowMessage, setShouldShowMessage] = (0, $eJOHy.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9tFw2.useAnalytics)();
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $eJOHy.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const getChildren = ()=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Button, {
                onMouseEnter: ()=>{
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                    children: formatMessage((0, $7Hc0H.messages).rovoChatButtonLabel)
                }),
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$68d07e7ccf1a3bf3$var$defaultButtonStyles,
                    ...!isActive && $68d07e7ccf1a3bf3$var$inactiveButtonStyles,
                    ...isDisabled && $68d07e7ccf1a3bf3$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.RovoIcon), {
                    size: "xxsmall"
                }),
                interactionName: interactionName,
                ref: ref,
                children: formatMessage((0, $7Hc0H.messages).rovoChatButtonLabel)
            });
        };
        return shouldUseCoordination ? /*#__PURE__*/ (0, $gt9Am.jsx)($68d07e7ccf1a3bf3$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: openRovoChat
        }) : getChildren();
    });
const $68d07e7ccf1a3bf3$var$Nav4Button = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ tooltip: tooltip, ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltip,
        // This button's visible text matches the tooltip
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: tooltipRef, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kf2c.Button), {
                interactionName: props?.interactionName,
                ref: (0, $e2Zbt.mergeRefs)([
                    forwardedRef,
                    tooltipRef
                ]),
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $68d07e7ccf1a3bf3$export$7c328c0993982813 = $68d07e7ccf1a3bf3$var$getConversationAssistantButton((0, $7GbGs.PrimaryButton));
const $68d07e7ccf1a3bf3$export$25e85d244cbf7845 = $68d07e7ccf1a3bf3$var$getConversationAssistantButton($68d07e7ccf1a3bf3$var$Nav4Button);
const $68d07e7ccf1a3bf3$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
    const { activeSpotlight: activeSpotlight } = (0, $kp0xK.useConversationAssistantSpotlightState)();
    const coordinationClient = (0, $kgTnp.useCoordinationClient)(siteId);
    const [onboardingStarted, stopOnboarding] = (0, $18T1s.usePostOfficeCoordination)(coordinationClient, messageId, (0, $eGOwo.fg)('rovo-chat-agents-spotlight-post-office-migration'));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9tFw2.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $eJOHy.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3ocqN.ConditionalWrapper), {
        condition: shouldShowMessage,
        wrapper: (children)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $54CI2.default), {
                blanketIsTinted: true,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
                    name: (0, $4e2f42f70e4cc16a$export$12496216771c6bdd),
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fBe2p.Pulse), {
                        radius: 3,
                        pulse: activeSpotlight === null,
                        children: [
                            children,
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxwEg.ConversationAssistantOnboardingSpotlight), {
                                onDismiss: onDismissMessage,
                                openRovoChat: openRovoChat
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lT9x0.EngagementSpotlight), {
                                engagementId: (0, $4e2f42f70e4cc16a$export$12496216771c6bdd)
                            })
                        ]
                    })
                })
            }),
        children: children
    });
};

});
parcelRegister("7UDun", function(module, exports) {
$parcel$export(module.exports, "useCoordination", () => $ceb56b35c8ab4910$export$3c29cca421979b0e);

var $eJOHy = parcelRequire("eJOHy");
const $ceb56b35c8ab4910$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $eJOHy.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};

});

parcelRegister("gxwEg", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $41294f100a801444$export$e4abc8af2fc5e2ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gRw8I = parcelRequire("gRw8I");

var $bdRit = parcelRequire("bdRit");

var $9tFw2 = parcelRequire("9tFw2");

var $kp0xK = parcelRequire("kp0xK");


var $hj2T7 = parcelRequire("hj2T7");
const $41294f100a801444$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, openAgentSelectorMenu: openAgentSelectorMenu, onDismiss: onDismiss })=>{
    (0, $gRw8I.di)((0, $kp0xK.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { end: end } = (0, $kp0xK.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $kp0xK.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9tFw2.useAnalytics)();
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdRit.default), {
                actions: [
                    {
                        onClick: (event, analyticsEvent)=>{
                            if (openRovoChat) openRovoChat(event, analyticsEvent);
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                // this is more of 'chatButtonClicked'
                                action: 'dismissed',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $hj2T7.default).tryChat)
                    },
                    {
                        onClick: ()=>{
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'dismissButtonClicked',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $hj2T7.default).dismissOnboarding),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $hj2T7.default).onboardingHeading),
                target: (0, $4e2f42f70e4cc16a$export$12496216771c6bdd),
                targetRadius: 3,
                children: formatMessage((0, $hj2T7.default).onboardingDescription)
            }, (0, $4e2f42f70e4cc16a$export$12496216771c6bdd))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: renderActiveSpotlight()
    });
};

});
parcelRegister("kp0xK", function(module, exports) {
$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $54ddce9f3f9b5f28$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $54ddce9f3f9b5f28$export$258c2a6b93cdef4a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $54ddce9f3f9b5f28$var$initialState = {
    activeSpotlight: null
};
const $54ddce9f3f9b5f28$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $54ddce9f3f9b5f28$var$ConversationAssistantSpotlightStore = (0, $GtRbT.createStore)({
    initialState: $54ddce9f3f9b5f28$var$initialState,
    actions: $54ddce9f3f9b5f28$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $54ddce9f3f9b5f28$export$283f4929c8863814 = (0, $iJq0l.createActionsHook)($54ddce9f3f9b5f28$var$ConversationAssistantSpotlightStore);
const $54ddce9f3f9b5f28$export$258c2a6b93cdef4a = (0, $iJq0l.createStateHook)($54ddce9f3f9b5f28$var$ConversationAssistantSpotlightStore);

});

const $4e2f42f70e4cc16a$export$12496216771c6bdd = 'rovo-chat-button';

parcelRegister("hj2T7", function(module, exports) {
$parcel$export(module.exports, "default", () => $d16f788f595c9b00$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d16f788f595c9b00$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Chat now',
        description: 'Action button for rovo onboarding spotlight'
    },
    dismissOnboarding: {
        id: 'rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for rovo onboarding spotlight'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Chat with AI',
        description: 'Onboarding step heading'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'With Rovo Chat, use AI to explore company knowledge, create new things, and collaborate on your work.',
        description: 'Onboarding step description'
    }
});

});


parcelRegister("kgTnp", function(module, exports) {
$parcel$export(module.exports, "useCoordinationClient", () => $57718823747f47a2$export$ddc368dc94a41e62);

var $eJOHy = parcelRequire("eJOHy");

var $aPN1a = parcelRequire("aPN1a");
const $57718823747f47a2$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
    return (0, $eJOHy.useMemo)(()=>new (0, $aPN1a.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            workspaceId: workspaceId,
            orgId: orgId,
            coordinationOptions: {
                /**
					 * This will prevent conflicting spotlights in products from displaying at the same time
					 */ enableChoreographer: true
            }
        }), [
        cloudId,
        workspaceId,
        orgId
    ]);
};

});

parcelRegister("18T1s", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeCoordination", () => $c50abea6ca0dbf01$export$a890021247f253fb);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $5V25X = parcelRequire("5V25X");
const $c50abea6ca0dbf01$export$a890021247f253fb = (coordinationClient, messageId, poMessageRolloutEnabled)=>{
    const [epMessageStarted, epMessageStop] = (0, $7UDun.useCoordination)(coordinationClient, messageId);
    const { isActive: poIsActive } = (0, $5V25X.useTrigger)(`${messageId}-started`);
    const { fireTrigger: poRequestMessageStart } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: poFireDismissClick } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-dismiss`
    });
    (0, $eJOHy.useEffect)(()=>{
        if (poMessageRolloutEnabled) poRequestMessageStart({
            isActive: true
        });
    }, [
        messageId,
        poMessageRolloutEnabled,
        poRequestMessageStart
    ]);
    const started = poMessageRolloutEnabled ? poIsActive : epMessageStarted;
    const stop = (force)=>{
        if (poMessageRolloutEnabled) poFireDismissClick({
            isActive: true
        });
        else epMessageStop(force);
    };
    return [
        started,
        stop
    ];
};

});
parcelRegister("5V25X", function(module, exports) {
$parcel$export(module.exports, "TriggerContextProvider", () => $6825a94eb84405ab$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $6825a94eb84405ab$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $6825a94eb84405ab$export$83b33e5fe4cce64);
$parcel$export(module.exports, "usePostOfficeExernalMessageProxy", () => $6825a94eb84405ab$export$e45375ff75169f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $6825a94eb84405ab$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6825a94eb84405ab$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6825a94eb84405ab$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($6825a94eb84405ab$var$initialActiveTriggerState);
const $6825a94eb84405ab$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($6825a94eb84405ab$var$initialTriggerDispatchState);
const $6825a94eb84405ab$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $eJOHy.useState)($6825a94eb84405ab$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $eJOHy.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $eJOHy.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $eJOHy.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($6825a94eb84405ab$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($6825a94eb84405ab$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $6825a94eb84405ab$export$454c1d7c35958f5e = ()=>(0, $eJOHy.useContext)($6825a94eb84405ab$var$TriggerContext);
const $6825a94eb84405ab$export$23cbf084e08bdb93 = ()=>(0, $eJOHy.useContext)($6825a94eb84405ab$var$TriggerDispatchContext);
const $6825a94eb84405ab$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6825a94eb84405ab$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6825a94eb84405ab$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6825a94eb84405ab$export$23cbf084e08bdb93();
    const fireTrigger = (0, $eJOHy.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6825a94eb84405ab$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6825a94eb84405ab$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6825a94eb84405ab$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6825a94eb84405ab$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6825a94eb84405ab$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $eJOHy.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $eJOHy.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $eJOHy.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};

});


parcelRegister("3ocqN", function(module, exports) {
$parcel$export(module.exports, "ConditionalWrapper", () => $350ddf8ed20c71bd$export$39aecc95f0365819);
const $350ddf8ed20c71bd$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;

});

parcelRegister("7Hc0H", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a2d2620e674d2d33$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a2d2620e674d2d33$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rovoChatButtonLabel: {
        id: 'conversation-assistant-button.ask-rovo-label',
        defaultMessage: 'Ask Rovo',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("isfIV", function(module, exports) {
$parcel$export(module.exports, "useRovoExperienceAPIStore", () => $383d0918d5cb9afd$export$37440b51449f7ac6);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $8xtZV = parcelRequire("8xtZV");
const $383d0918d5cb9afd$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true
};
const $383d0918d5cb9afd$var$store = (0, $GtRbT.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $383d0918d5cb9afd$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($383d0918d5cb9afd$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $8xtZV.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $8xtZV.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $8xtZV.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $8xtZV.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $8xtZV.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $8xtZV.ConversationAssistantUIModes).MINI_MODAL
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $383d0918d5cb9afd$var$useStore = (0, $iJq0l.createHook)($383d0918d5cb9afd$var$store);
const $383d0918d5cb9afd$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable }, { reset: reset, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $383d0918d5cb9afd$var$useStore();
    return {
        mode: mode,
        reset: reset,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $383d0918d5cb9afd$export$66cf76b7e04da11f = (0, $iJq0l.createActionsHook)($383d0918d5cb9afd$var$store);

});
parcelRegister("8xtZV", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantUIModes", () => $a4949fd59ab4cb94$export$bc36ebf73899a71d);
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $a4949fd59ab4cb94$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};

});


parcelRegister("8lMZg", function(module, exports) {
$parcel$export(module.exports, "ARTICLE_TYPE", () => $4f5ae834a49be933$export$a72bfd9b1e5592c8);
var $4f5ae834a49be933$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("343k9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bc82bc2cdf9a7ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
class $9bc82bc2cdf9a7ee$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            fallback: null
        };
    }
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $eJOHy.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});

parcelRegister("eGEpA", function(module, exports) {
$parcel$export(module.exports, "QuickFindSkeleton", () => $25ac3de2aefc6e40$export$8f0d616c2469c6b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gl2vi = parcelRequire("gl2vi");

var $iMyql = parcelRequire("iMyql");
var $k5Dg1 = parcelRequire("k5Dg1");

var $bkEVB = parcelRequire("bkEVB");

var $hUFyN = parcelRequire("hUFyN");

var $11f1U = parcelRequire("11f1U");
if (!window.inputSkeletonState) (0, $iMyql.resetInputSkeletonState)();
const $25ac3de2aefc6e40$export$8f0d616c2469c6b6 = ({ onEnter: onEnter, isNav4Enabled: isNav4Enabled, injectValue: injectValue })=>{
    const dialogId = (0, $gl2vi.useId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const initialSearchQuery = (0, $hUFyN.getInitialQuery)();
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)((0, $iMyql.getInputSkeletonFocus));
    const [value, setValue] = (0, $eJOHy.useState)(()=>injectValue ?? initialSearchQuery);
    const onFocus = (e)=>{
        setIsExpanded(true);
        (0, $iMyql.setInputSkeletonIsFocus)(true);
        const target = e.currentTarget;
        (0, $iMyql.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $iMyql.setInputSkeletonIsFocus)(false);
        (0, $iMyql.setInputSkeletonSelection)(0, 0, 'none');
    };
    const onKeyDown = (e)=>{
        const target = e.currentTarget;
        if (e.key === 'Escape') {
            target.blur();
            onBlur();
        }
    };
    const onChange = (e)=>{
        const newValue = e.currentTarget.value;
        setValue(newValue);
        (0, $iMyql.setInputSkeletonQuery)(newValue);
        const target = e.currentTarget;
        (0, $iMyql.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
        (0, $k5Dg1.setSessionItem)((0, $k5Dg1.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = (e)=>{
        const target = e.currentTarget;
        (0, $iMyql.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bkEVB.Textfield), {
        value: value,
        placeholder: formatMessage((0, $11f1U.messages).placeholder),
        dialogId: dialogId,
        quickFindOpen: isExpanded,
        onEnter: onEnter,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: onKeyDown,
        onChange: onChange,
        isNav4Enabled: isNav4Enabled
    });
};

});
parcelRegister("iMyql", function(module, exports) {
$parcel$export(module.exports, "getInputSkeletonQuery", () => $fe6bc7b583917cfb$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $fe6bc7b583917cfb$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $fe6bc7b583917cfb$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $fe6bc7b583917cfb$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $fe6bc7b583917cfb$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $fe6bc7b583917cfb$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $fe6bc7b583917cfb$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $fe6bc7b583917cfb$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $fe6bc7b583917cfb$export$c830bcf42e072a93);
const $fe6bc7b583917cfb$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $fe6bc7b583917cfb$export$b8b6c2e7a0664212 = ()=>{
    return $fe6bc7b583917cfb$var$getWindow()?.inputSkeletonState?.query ?? '';
};
const $fe6bc7b583917cfb$export$baa1c819dd4691f3 = (newQuery)=>{
    const { inputSkeletonState: inputSkeletonState } = $fe6bc7b583917cfb$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.query = newQuery;
};
const $fe6bc7b583917cfb$export$38fcbc98be180790 = ()=>{
    return $fe6bc7b583917cfb$var$getWindow()?.inputSkeletonState?.isFocused || false;
};
const $fe6bc7b583917cfb$export$d3c6894b4e9af000 = (newIsFocused)=>{
    const { inputSkeletonState: inputSkeletonState } = $fe6bc7b583917cfb$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.isFocused = newIsFocused;
};
const $fe6bc7b583917cfb$export$a0c71b3bd9ec143c = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $fe6bc7b583917cfb$var$getWindow() ?? {};
    return {
        selectionStart: inputSkeletonState?.selectionStart ?? 0,
        selectionEnd: inputSkeletonState?.selectionEnd ?? 0,
        selectionDirection: inputSkeletonState?.selectionDirection ?? 'none'
    };
};
const $fe6bc7b583917cfb$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    const { inputSkeletonState: inputSkeletonState } = $fe6bc7b583917cfb$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.selectionStart = newSelectionStart;
        inputSkeletonState.selectionEnd = newSelectionEnd;
        inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $fe6bc7b583917cfb$export$c89dd2d5d4024c5e = ()=>{
    const safeWindow = $fe6bc7b583917cfb$var$getWindow();
    if (safeWindow) safeWindow.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $fe6bc7b583917cfb$export$166ce39761ad7743 = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $fe6bc7b583917cfb$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.listeners.forEach(([target, event, handler])=>{
            target.removeEventListener(event, handler);
        });
        inputSkeletonState.listeners = [];
    }
};
const $fe6bc7b583917cfb$export$c830bcf42e072a93 = ()=>{
    $fe6bc7b583917cfb$export$166ce39761ad7743();
    delete $fe6bc7b583917cfb$var$getWindow()?.inputSkeletonState;
};

});

parcelRegister("k5Dg1", function(module, exports) {
$parcel$export(module.exports, "SEARCH_QUERY_KEY", () => $c43d411846bd2e8d$export$240cb7dc75f6cac2);
$parcel$export(module.exports, "SEARCH_FILTERS_KEY", () => $c43d411846bd2e8d$export$978fb20afa14aaa7);
$parcel$export(module.exports, "SEARCH_SHOW_AI_DIALOG_KEY", () => $c43d411846bd2e8d$export$f4dca218ecb5824a);
$parcel$export(module.exports, "getSessionItem", () => $c43d411846bd2e8d$export$fdf7104ff19cc288);
$parcel$export(module.exports, "setSessionItem", () => $c43d411846bd2e8d$export$a5376dd4adeb0fbf);
$parcel$export(module.exports, "deleteSessionItem", () => $c43d411846bd2e8d$export$5896963da935fdc4);

var $48TwY = parcelRequire("48TwY");

var $eGOwo = parcelRequire("eGOwo");
const $c43d411846bd2e8d$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $c43d411846bd2e8d$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $c43d411846bd2e8d$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $c43d411846bd2e8d$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $c43d411846bd2e8d$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $c43d411846bd2e8d$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $c43d411846bd2e8d$var$getWindow();
    if (!windowReady) return null;
    return (0, $eGOwo.fg)('search_page_use_bsc_session_storage') ? (0, $48TwY.AtlBrowserStorageSession).getItem(key) : $c43d411846bd2e8d$var$getWindow()?.sessionStorage.getItem(key);
};
const $c43d411846bd2e8d$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $c43d411846bd2e8d$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $eGOwo.fg)('search_page_use_bsc_session_storage')) (0, $48TwY.AtlBrowserStorageSession).setItem(key, value);
        else $c43d411846bd2e8d$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $c43d411846bd2e8d$export$5896963da935fdc4 = (key)=>{
    const windowReady = $c43d411846bd2e8d$var$getWindow();
    if (!windowReady) return;
    if ((0, $eGOwo.fg)('search_page_use_bsc_session_storage')) (0, $48TwY.AtlBrowserStorageSession).removeItem(key);
    else $c43d411846bd2e8d$var$getWindow()?.sessionStorage.removeItem(key);
};

});

parcelRegister("bkEVB", function(module, exports) {
$parcel$export(module.exports, "Textfield", () => $155541afb1179f05$export$d66ddc2063fc70a7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $6J9k6 = parcelRequire("6J9k6");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $bwYoR = parcelRequire("bwYoR");

var $bmFAv = parcelRequire("bmFAv");
const $155541afb1179f05$var$textFieldBoxStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.300',
    ':focus': {
        height: 'size.400'
    },
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingRight: 'space.200',
    width: '100%'
});
const $155541afb1179f05$var$textFieldBoxFocusedStyles = (0, $1DXK0.xcss)({
    height: 'size.400',
    border: 'none',
    boxShadow: 'elevation.shadow.overlay',
    paddingRight: '0'
});
const $155541afb1179f05$var$inputStyles = null;
const $155541afb1179f05$var$inputFocusedStyles = null;
const $155541afb1179f05$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    minWidth: 'size.300',
    minHeight: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $155541afb1179f05$var$iconWrapperFocusedStyles = (0, $1DXK0.xcss)({
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.150',
    minWidth: 'size.200'
});
const $155541afb1179f05$var$clearIconStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});
// Nav3 style overrides
// Can be removed once all supported products use Nav4
const $155541afb1179f05$var$nav3StyleOverrides = {
    textFieldBoxStyles: (0, $1DXK0.xcss)({
        borderColor: 'color.border.input',
        backgroundColor: 'color.background.input',
        borderRadius: 'radius.medium',
        width: '200px'
    }),
    textFieldBoxFocusedStyles: (0, $1DXK0.xcss)({
        backgroundColor: 'elevation.surface.overlay',
        borderRadius: 'radius.large',
        width: '780px'
    }),
    iconWrapperStyles: (0, $1DXK0.xcss)({
        minWidth: '30px'
    }),
    inputStyles: null
};
const $155541afb1179f05$export$d66ddc2063fc70a7 = ({ value: value, dialogId: dialogId, quickFindOpen: quickFindOpen, isNav4Enabled: isNav4Enabled, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, onSelect: onSelect, onKeyDown: onKeyDown, onChange: onChange, onClear: onClear, inputRef: inputRef, clearIconRef: clearIconRef, placeholder: placeholder })=>{
    const intl = (0, $lRq8t.default)();
    const handleKeyDown = (e)=>{
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
        if (typeof onKeyDown === 'function') onKeyDown(e);
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        xcss: [
            $155541afb1179f05$var$textFieldBoxStyles,
            quickFindOpen && $155541afb1179f05$var$textFieldBoxFocusedStyles,
            !isNav4Enabled && $155541afb1179f05$var$nav3StyleOverrides.textFieldBoxStyles,
            !isNav4Enabled && quickFindOpen && $155541afb1179f05$var$nav3StyleOverrides.textFieldBoxFocusedStyles
        ],
        onClick: ()=>{
            inputRef?.current?.focus();
        },
        testId: "search-input-container",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $155541afb1179f05$var$iconWrapperStyles,
                    quickFindOpen && $155541afb1179f05$var$iconWrapperFocusedStyles,
                    !isNav4Enabled && $155541afb1179f05$var$nav3StyleOverrides.iconWrapperStyles
                ],
                children: isNav4Enabled || quickFindOpen ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
                    color: "currentColor",
                    label: intl.formatMessage((0, $bmFAv.messages).searchIconLabel)
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bwYoR.LegacySearchIcon), {
                    isExpanded: !!quickFindOpen
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: inputRef,
                onFocus: onFocus,
                onBlur: onBlur,
                onSelect: onSelect,
                onKeyDown: handleKeyDown,
                placeholder: placeholder || intl.formatMessage((0, $bmFAv.messages).inputPlaceholder),
                onChange: onChange,
                value: value,
                "data-testid": "search-input",
                autoComplete: "off",
                "aria-label": intl.formatMessage((0, $bmFAv.messages).inputAriaLabel),
                "aria-expanded": quickFindOpen,
                "aria-controls": quickFindOpen ? dialogId : undefined,
                "aria-haspopup": "true",
                role: "combobox",
                className: (0, $hcewu.default)([
                    "_12ji1r31 _1qu2glyw _12y31o36 _11q7glyw _11c82smr _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _syaz1rpy _1bsb1osq _1bto1l2s _o5721q9c _1idr1rpy",
                    quickFindOpen && "_syazi7uo",
                    !isNav4Enabled && "_11c82smr"
                ])
            }),
            quickFindOpen && value && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $155541afb1179f05$var$clearIconStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    ref: clearIconRef,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
                            ...iconProps,
                            color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
                            label: intl.formatMessage((0, $bmFAv.messages).clearIconLabel),
                            LEGACY_size: "small"
                        }),
                    spacing: 'compact',
                    onClick: onClear,
                    label: intl.formatMessage((0, $bmFAv.messages).clearIconLabel),
                    appearance: "subtle",
                    testId: "search-input-clear-button"
                })
            })
        ]
    }));
};

});
parcelRegister("bwYoR", function(module, exports) {
$parcel$export(module.exports, "LegacySearchIcon", () => $4b20a2e5d0f98e34$export$c3bd67ecc5ebe519);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i0iAU = parcelRequire("i0iAU");

const $4b20a2e5d0f98e34$export$c3bd67ecc5ebe519 = ({ isExpanded: isExpanded, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $7bb4c1736002a04a$export$7d61b15e0da132af})`, defaultColor: defaultColor = `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`, label: label = '' })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        label: label,
        LEGACY_primaryColor: isExpanded ? primaryColor : defaultColor,
        LEGACY_size: size,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : defaultColor
    });

});

parcelRegister("bmFAv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d1e9c29e90e0e085$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d1e9c29e90e0e085$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    searchIconLabel: {
        id: 'quick_find_dialog_aria_label',
        defaultMessage: 'Quick Find',
        description: 'Label text for search icon'
    },
    clearIconLabel: {
        id: 'input_clear_icon_label',
        defaultMessage: 'Clear',
        description: 'Label text for clear icon'
    },
    inputPlaceholder: {
        id: 'input_placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in primary search input'
    },
    inputAriaLabel: {
        id: 'input_aria_label',
        defaultMessage: 'Search, press enter to navigate to advanced search with your text query',
        description: 'Aria label for primary search input, directs users advanced search'
    }
});

});


parcelRegister("hUFyN", function(module, exports) {
$parcel$export(module.exports, "getInitialQuery", () => $f00bbd4b85c37e16$export$ed7270bd966434af);
$parcel$export(module.exports, "useInputSkeleton", () => $f00bbd4b85c37e16$export$67de3a75cbe82e14);

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");

var $iMyql = parcelRequire("iMyql");
var $k5Dg1 = parcelRequire("k5Dg1");
// The query is stored in module scope to persist across remounts
let $f00bbd4b85c37e16$var$initialQueryValue;
const $f00bbd4b85c37e16$export$ed7270bd966434af = (searchQueryParams)=>{
    const stickySearch = (0, $eGOwo.fg)('quick_find_remove_sticky_search') ? $f00bbd4b85c37e16$var$initialQueryValue : (0, $k5Dg1.getSessionItem)((0, $k5Dg1.SEARCH_QUERY_KEY));
    return (0, $59rsN.default).initializeCalled() && (0, $59rsN.default).getExperimentValue('platform_set_initial_search_query_state', 'isEnabled', false) && searchQueryParams || stickySearch || (0, $iMyql.getInputSkeletonQuery)() || '';
};
const $f00bbd4b85c37e16$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $eJOHy.useEffect)(()=>{
        const skeletonFocused = (0, $iMyql.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $iMyql.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $iMyql.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('quick_find_remove_sticky_search')) // Update the module-scoped variable to make it available for remounts
        $f00bbd4b85c37e16$var$initialQueryValue = localQuery;
        else (0, $k5Dg1.setSessionItem)((0, $k5Dg1.SEARCH_QUERY_KEY), localQuery);
    }, [
        localQuery
    ]);
};

});

parcelRegister("11f1U", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2fb8320957f6488b$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2fb8320957f6488b$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'search_dialog_aria_label',
        defaultMessage: 'Search',
        description: 'Placeholder text in primary search input'
    }
});

});


parcelRegister("gbld1", function(module, exports) {
$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $002e7ae81813b590$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $gt9Am = parcelRequire("gt9Am");

var $j0qJ4 = parcelRequire("j0qJ4");
var $khofA = parcelRequire("khofA");
parcelRequire("eJOHy");
const $002e7ae81813b590$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khofA.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j0qJ4.default), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j0qJ4.default), {
        ...rest
    });
};

});
parcelRegister("j0qJ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad7c1a454f33644c$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $khofA = parcelRequire("khofA");

var $c967W = parcelRequire("c967W");

var $jJWyy = parcelRequire("jJWyy");

var $hZXFQ = parcelRequire("hZXFQ");

var $Ay1uj = parcelRequire("Ay1uj");

var $iMyql = parcelRequire("iMyql");

var $53NRq = parcelRequire("53NRq");
const $ad7c1a454f33644c$var$MAX_INPUT_LENGTH = 500;
const $ad7c1a454f33644c$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $khofA.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel, dataSsrPlaceholder: dataSsrPlaceholder } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $iMyql.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $53NRq.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jJWyy.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        "data-ssr-placeholder": dataSsrPlaceholder,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $c967W.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZXFQ.SearchIcon), {
                                theme: theme,
                                isExpanded: false,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZXFQ.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $ad7c1a454f33644c$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $ad7c1a454f33644c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ad7c1a454f33644c$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("khofA", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $83ac01894b5542da$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $83ac01894b5542da$export$93d4e7f90805808f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $83ac01894b5542da$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
            borderColor: `var(--ds-border-input, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7090862dc3038a9f)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $83ac01894b5542da$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $83ac01894b5542da$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, $83ac01894b5542da$export$e6c62eb05a8288ed.default, searchCSS);
};
const $83ac01894b5542da$var$ctx = /*#__PURE__*/ (0, $eJOHy.createContext)($83ac01894b5542da$export$e6c62eb05a8288ed.default);
const $83ac01894b5542da$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $83ac01894b5542da$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($83ac01894b5542da$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $83ac01894b5542da$export$93d4e7f90805808f = ()=>{
    return (0, $eJOHy.useContext)($83ac01894b5542da$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $83ac01894b5542da$export$f9bb738f552c610d = $83ac01894b5542da$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $83ac01894b5542da$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("c967W", function(module, exports) {
$parcel$export(module.exports, "MobileSearchIconWrapper", () => $2b26e52cb67b3f23$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $2b26e52cb67b3f23$export$9673cb6b61244e6e);
$parcel$export(module.exports, "InputBoxOverlayRight", () => $2b26e52cb67b3f23$export$1da38d078e896a10);
$parcel$export(module.exports, "ClearIconWrapper", () => $2b26e52cb67b3f23$export$ff9b1a25d343474d);
$parcel$export(module.exports, "ArrowIconWrapper", () => $2b26e52cb67b3f23$export$54c466678ae7c638);
$parcel$export(module.exports, "SearchInputContainer", () => $2b26e52cb67b3f23$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $2b26e52cb67b3f23$export$b6261a2c5ea449d);
$parcel$export(module.exports, "HiddenTooltip", () => $2b26e52cb67b3f23$export$ca6fe3402791d08e);
$parcel$export(module.exports, "SSRsearchInputField", () => $2b26e52cb67b3f23$export$6d53dccb772ed720);
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $2b26e52cb67b3f23$export$c47d4a3e1f1297f1);
$parcel$export(module.exports, "SSRformContainer", () => $2b26e52cb67b3f23$export$58ae19ee1fc7be8a);
$parcel$export(module.exports, "SSRsearchInputContainer", () => $2b26e52cb67b3f23$export$b40f2abde293e8e4);
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $2b26e52cb67b3f23$export$eb4e9f55bbe045df);
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $2b26e52cb67b3f23$export$3f33ed4b273b43d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7AseU = parcelRequire("7AseU");

var $jNjVw = parcelRequire("jNjVw");


var $6efFi = parcelRequire("6efFi");

var $aWILV = parcelRequire("aWILV");
function $2b26e52cb67b3f23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b26e52cb67b3f23$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $2b26e52cb67b3f23$export$63e083aca343a6ae = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "eq4kchp13"
})("display:none;@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $2b26e52cb67b3f23$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $aWILV.default)('span', {
    target: "eq4kchp12"
})("width:", (0, $jNjVw.grid).multiple(2).px, ";height:", (0, $jNjVw.grid).multiple(2).px, ";position:absolute;top:", (0, $jNjVw.grid).px, ";left:", (0, $jNjVw.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $7bb4c1736002a04a$export$fbda843f0a27fe96})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$215b7063051591f1)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:none;}");
const $2b26e52cb67b3f23$export$1da38d078e896a10 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp11"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){right:24px;}");
const $2b26e52cb67b3f23$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp10"
})("width:", (0, $jNjVw.grid).multiple(2).px, ";height:", (0, $jNjVw.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`, ";}&>span>svg{vertical-align:unset;}");
const $2b26e52cb67b3f23$export$54c466678ae7c638 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp9"
})("display:none;margin:0 ", (0, $jNjVw.grid).px, ";height:", (0, $jNjVw.grid).multiple(4).px, ";padding-bottom:", (0, $jNjVw.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $2b26e52cb67b3f23$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $2b26e52cb67b3f23$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp8"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $1NIU8.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $jNjVw.dialogWidth) : (0, $jNjVw.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $2b26e52cb67b3f23$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $1NIU8.css)(styles, " @media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $jNjVw.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $2b26e52cb67b3f23$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $aWILV.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $jNjVw.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $2b26e52cb67b3f23$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $jNjVw.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $jNjVw.grid).multiple(1.5).px} ${(0, $jNjVw.grid).multiple(0.25).px};
            margin: 0 ${(0, $jNjVw.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $6efFi.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");
const $2b26e52cb67b3f23$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $aWILV.default)((0, $7AseU.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $2b26e52cb67b3f23$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $aWILV.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $jNjVw.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`}`, ";}@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:none;}");
const $2b26e52cb67b3f23$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp4"
})("position:relative;height:32px;@media screen and (min-width: 781px){min-width:", (props)=>props.shouldFillContainer ? '100%' : '200px', ";}", (props)=>props.shouldFillContainer ? 'width: 100%;' : '', ";");
const $2b26e52cb67b3f23$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $2b26e52cb67b3f23$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $jNjVw.collapsedSearchInputWidth;
}, ";");
const $2b26e52cb67b3f23$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $aWILV.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $jNjVw.grid).multiple(2).px, ";height:", (0, $jNjVw.grid).multiple(2).px, ";position:absolute;top:", (0, $jNjVw.grid).px, ";left:", (0, $jNjVw.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:none;}");
const $2b26e52cb67b3f23$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $aWILV.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $jNjVw.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){display:flex;}");

});
parcelRegister("jNjVw", function(module, exports) {
$parcel$export(module.exports, "zIndex", () => $faf0c90b210329ff$export$56446adcecbeec34);
$parcel$export(module.exports, "grid", () => $faf0c90b210329ff$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $faf0c90b210329ff$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $faf0c90b210329ff$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $faf0c90b210329ff$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $faf0c90b210329ff$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $faf0c90b210329ff$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $faf0c90b210329ff$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $faf0c90b210329ff$export$30310ee354b45eb0);
$parcel$export(module.exports, "primaryTextColour", () => $faf0c90b210329ff$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $faf0c90b210329ff$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $faf0c90b210329ff$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $faf0c90b210329ff$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $faf0c90b210329ff$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $IW7jS = parcelRequire("IW7jS");

function $faf0c90b210329ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $faf0c90b210329ff$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$faf0c90b210329ff$var$AkGrid(multiplier * num),
        half: ()=>$faf0c90b210329ff$var$AkGrid(0.5 * num),
        twice: ()=>$faf0c90b210329ff$var$AkGrid(2 * num)
    });
const $faf0c90b210329ff$export$56446adcecbeec34 = {
    searchDialog: (0, $IW7jS.layers).dialog()
};
const $faf0c90b210329ff$export$85fc379452d91af0 = $faf0c90b210329ff$var$AkGrid(1);
const $faf0c90b210329ff$export$b9930dabfa4a3a3 = '56px';
const $faf0c90b210329ff$export$f6af7620e8789c39 = '200px';
const $faf0c90b210329ff$export$64d8573e83b64ff8 = '150px';
const $faf0c90b210329ff$export$a3da89b899389ed8 = '780px';
const $faf0c90b210329ff$export$ce4512df260a325a = 780;
const $faf0c90b210329ff$export$a406031ed42c8e02 = '1130px';
const $faf0c90b210329ff$export$e00021bea368c518 = $faf0c90b210329ff$export$85fc379452d91af0.multiple(4);
const $faf0c90b210329ff$export$30310ee354b45eb0 = $faf0c90b210329ff$export$85fc379452d91af0.multiple(6);
const $faf0c90b210329ff$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`;
const $faf0c90b210329ff$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`;
const $faf0c90b210329ff$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`;
const $faf0c90b210329ff$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`;
const $faf0c90b210329ff$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});


parcelRegister("jJWyy", function(module, exports) {
$parcel$export(module.exports, "AbsoluteContainer", () => $c656951d77093b37$export$36aa0f4a98890c96);
$parcel$export(module.exports, "SearchDialogAnchor", () => $c656951d77093b37$export$f565ce1043dae7c9);
$parcel$export(module.exports, "SearchAnchorWrapper", () => $c656951d77093b37$export$dfece74a62f1398d);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $c656951d77093b37$export$5566658d36f6ca7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $jNjVw = parcelRequire("jNjVw");

var $aWILV = parcelRequire("aWILV");
const $c656951d77093b37$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "exl9bxq3"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $1NIU8.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $jNjVw.zIndex).searchDialog
    });
    return {};
});
const $c656951d77093b37$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $aWILV.default)('div', {
    target: "exl9bxq2"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $1NIU8.css)("@media screen and (max-width: ", (0, $jNjVw.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $jNjVw.zIndex).searchDialog, ";left:calc((100% - ", (0, $jNjVw.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $jNjVw.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $c656951d77093b37$export$dfece74a62f1398d = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "exl9bxq1"
})("position:relative;@media screen and (min-width: ", (0, $jNjVw.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $jNjVw.inputFieldHeight).px, ";height:", (0, $jNjVw.inputFieldHeight).px, ";");
const $c656951d77093b37$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $aWILV.default)($c656951d77093b37$export$dfece74a62f1398d, {
    target: "exl9bxq0"
})("height:", (props)=>props.isExpanded ? (0, $jNjVw.enlargedInputFieldHeight).px : (0, $jNjVw.inputFieldHeight).px, ";");

});

parcelRegister("hZXFQ", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $fcc12e7f33ff38e1$export$82eafebb825fc23f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i0iAU = parcelRequire("i0iAU");

const $fcc12e7f33ff38e1$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $7bb4c1736002a04a$export$7d61b15e0da132af})`, label: label = '' })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        label: label,
        LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
        LEGACY_size: size,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });

});

parcelRegister("53NRq", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $c967W = parcelRequire("c967W");


var $hZXFQ = parcelRequire("hZXFQ");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $c967W.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZXFQ.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZXFQ.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $8310c929e4801f64$export$bc237d627614fc48)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});
/* eslint-disable */ // @ts-ignore
const $8310c929e4801f64$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;




parcelRegister("8zLeM", function(module, exports) {
$parcel$export(module.exports, "ProductSearchInputSkeletonInteractive", () => $4621163e88a5de20$export$e3798ad624b9f761);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input.  The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 * On the first render of this component, this stored state is used as initial
 * an initial state. This behaviour allows one instance of this component
 * to be replaced by another and appear to seamlessly act as a single component.
 *
 * This component is intended to be used for client side rendering only.
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7KCjz = parcelRequire("7KCjz");
var $khofA = parcelRequire("khofA");
const $4621163e88a5de20$export$e3798ad624b9f761 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khofA.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KCjz.SearchInputSkeletonInteractive), {
            ...props
        })
    });
};

});
parcelRegister("7KCjz", function(module, exports) {
$parcel$export(module.exports, "SearchInputSkeletonInteractive", () => $3a977436144ee526$export$fca483ab36e9fec9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1NBMM = parcelRequire("1NBMM");

var $axWwK = parcelRequire("axWwK");

var $k5Dg1 = parcelRequire("k5Dg1");

var $iMyql = parcelRequire("iMyql");
const $3a977436144ee526$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
    // Initialise stored inputSkeletonState if necessary
    const checkedForInputSkeletonState = (0, $eJOHy.useRef)(false);
    if (!checkedForInputSkeletonState.current) {
        if (!window.inputSkeletonState) (0, $iMyql.resetInputSkeletonState)();
        checkedForInputSkeletonState.current = true;
    }
    const searchInputRef = (0, $eJOHy.useRef)(null);
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)((0, $iMyql.getInputSkeletonFocus)());
    const [value, setValue] = (0, $eJOHy.useState)(()=>{
        const stickySearchQuery = (0, $k5Dg1.getSessionItem)((0, $k5Dg1.SEARCH_QUERY_KEY));
        return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, $iMyql.getInputSkeletonQuery)();
    });
    // Use the stored state to focus and set selection
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $iMyql.removeInputSkeletonEventListeners)();
        const isFoucsed = (0, $iMyql.getInputSkeletonFocus)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $iMyql.getInputSkeletonSelection)();
        if (isFoucsed) {
            searchInputRef?.current?.focus();
            searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    }, []);
    const onFocus = ()=>{
        setIsExpanded(true);
        (0, $iMyql.setInputSkeletonIsFocus)(true);
        searchInputRef?.current?.focus();
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $iMyql.setInputSkeletonIsFocus)(false);
        if (!stickySearchEnabled) {
            setValue('');
            (0, $iMyql.setInputSkeletonQuery)('');
            (0, $iMyql.setInputSkeletonSelection)(0, 0, 'none');
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') {
            searchInputRef?.current?.blur();
            onBlur();
        }
    };
    const onInput = (newValue)=>{
        setValue(newValue);
        (0, $iMyql.setInputSkeletonQuery)(newValue);
        (0, $iMyql.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        if (stickySearchEnabled) (0, $k5Dg1.setSessionItem)((0, $k5Dg1.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = ()=>{
        (0, $iMyql.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
    };
    // Fixes some instances where callbacks would not be called when the search
    // input is clicked as the component is being destroyed
    (0, $eJOHy.useEffect)(()=>{
        let storedSearchInputRef = null;
        if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
        return ()=>{
            if (storedSearchInputRef) {
                (0, $iMyql.setInputSkeletonQuery)(storedSearchInputRef.value);
                (0, $iMyql.setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                (0, $iMyql.setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NBMM.SearchAnchor), {
        isExpanded: isExpanded,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axWwK.default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        })
    });
};

});
parcelRegister("1NBMM", function(module, exports) {
$parcel$export(module.exports, "SearchAnchor", () => $982e7a8ce7b647d8$export$bc951697710bb35a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jJWyy = parcelRequire("jJWyy");
const $982e7a8ce7b647d8$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jJWyy.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jJWyy.AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jJWyy.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });

});

parcelRegister("axWwK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2cc9f0ed710edf7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lqfmR = parcelRequire("lqfmR");

var $Ay1uj = parcelRequire("Ay1uj");

var $khofA = parcelRequire("khofA");

var $hZXFQ = parcelRequire("hZXFQ");

var $c967W = parcelRequire("c967W");

var $kZsI1 = parcelRequire("kZsI1");
const $d2cc9f0ed710edf7$var$MAX_INPUT_LENGTH = 500;
const $d2cc9f0ed710edf7$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer, disableBoxShadow: disableBoxShadow, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleTabEnter = (e)=>{
        if (e.key === 'Enter' && onClick) onClick();
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $c967W.HiddenTooltip);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $c967W.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        label: "Search",
                        onClick: handleClick,
                        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZXFQ.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    onKeyPress: handleTabEnter,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZXFQ.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
                        label: exitSearchLabel || 'Exit Search',
                        LEGACY_size: "large",
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.SearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $d2cc9f0ed710edf7$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...disableBoxShadow && {
                        style: {
                            boxShadow: 'none'
                        }
                    },
                    ...theme
                }),
                (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZsI1.SearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    toggleAISearchButton: toggleAISearchButton
                })
            ]
        })
    });
};
var $d2cc9f0ed710edf7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const theme = (0, $khofA.useTheme)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d2cc9f0ed710edf7$export$55d7609a8f1eccd2, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});
parcelRegister("kZsI1", function(module, exports) {
$parcel$export(module.exports, "SearchInputOverlay", () => $2754110d33ae28f4$export$bde709da22d710bb);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c967W = parcelRequire("c967W");

var $5pWSu = parcelRequire("5pWSu");
const $2754110d33ae28f4$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $c967W.InputBoxOverlayRight), {
        children: [
            showClearButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c967W.ClearIconWrapper), {
                ...theme,
                role: "button",
                onClick: onClear,
                onMouseEnter: ()=>{
                    allowChangeExpand?.(false);
                },
                onMouseLeave: ()=>{
                    allowChangeExpand?.(true);
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                    color: "currentColor",
                    label: clearSearchLabel || 'Clear search session',
                    LEGACY_size: "small"
                })
            }),
            toggleAISearchButton
        ]
    });
};

});




parcelRegister("d8CRX", function(module, exports) {
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM", () => $01d586a6c017a39a$export$71a8b319599e57dc);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD", () => $01d586a6c017a39a$export$c076c4dd9e9d1e6e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM", () => $01d586a6c017a39a$export$23877616cb34cf0c);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM", () => $01d586a6c017a39a$export$68be56e20dba0ed5);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD", () => $01d586a6c017a39a$export$f39fa5cd744578ae);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM", () => $01d586a6c017a39a$export$a36d8c2d9981ec2b);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER", () => $01d586a6c017a39a$export$fe025e19388affcf);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER", () => $01d586a6c017a39a$export$11e2cd4e8edc5e82);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER", () => $01d586a6c017a39a$export$9b30fb0a29b39382);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED", () => $01d586a6c017a39a$export$a62089c95934ccf8);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED", () => $01d586a6c017a39a$export$4e36729d15b3db9e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN", () => $01d586a6c017a39a$export$87f92c12fc8bb620);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_NAME", () => $01d586a6c017a39a$export$86bb6d2503529310);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_NAME", () => $01d586a6c017a39a$export$722a4624bef605fa);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER_NAME", () => $01d586a6c017a39a$export$1963cf4be1b2cd5e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME", () => $01d586a6c017a39a$export$a18b3b3caa760214);
$parcel$export(module.exports, "STATSIG_FULL_PAGE_SEARCH_LAYER", () => $01d586a6c017a39a$export$39bbb550e0341d58);
$parcel$export(module.exports, "STATSIG_QUICK_FIND_LAYER", () => $01d586a6c017a39a$export$b669e8e4ed2b4c67);
$parcel$export(module.exports, "STATSIG_SEARCH_PLATFORM_JIRA_LAYER", () => $01d586a6c017a39a$export$ee35a7247cdafe84);
$parcel$export(module.exports, "STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED", () => $01d586a6c017a39a$export$2d33b7f91c9f9071);
$parcel$export(module.exports, "DEFAULT_STATSIG_EXPERIMENT_CONFIG", () => $01d586a6c017a39a$export$afc3cbf9db978004);
$parcel$export(module.exports, "DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG", () => $01d586a6c017a39a$export$fca208e1e43c6fac);
const $01d586a6c017a39a$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $01d586a6c017a39a$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $01d586a6c017a39a$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $01d586a6c017a39a$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $01d586a6c017a39a$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $01d586a6c017a39a$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $01d586a6c017a39a$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $01d586a6c017a39a$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $01d586a6c017a39a$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $01d586a6c017a39a$export$a62089c95934ccf8 = 'enable_l3';
const $01d586a6c017a39a$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $01d586a6c017a39a$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $01d586a6c017a39a$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $01d586a6c017a39a$export$722a4624bef605fa = 'search_platform_layer_l2';
const $01d586a6c017a39a$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $01d586a6c017a39a$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $01d586a6c017a39a$export$39bbb550e0341d58 = 'full_page_search_layer';
const $01d586a6c017a39a$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $01d586a6c017a39a$export$ee35a7247cdafe84 = 'search_platform_jira_layer';
const $01d586a6c017a39a$export$2d33b7f91c9f9071 = 'search_platform_jira_layer_tenants_based';
const $01d586a6c017a39a$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $01d586a6c017a39a$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};

});

const $54dbbe6dc88f8bd2$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $982bab3922601ed3$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $982bab3922601ed3$export$d57b6b390e78d90f = 'jira-cosmos';
const $982bab3922601ed3$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $982bab3922601ed3$export$eed606b4351295d7 = 'login';
const $982bab3922601ed3$export$35e541d26a145a7c = 'logout';

/**
 * Character key codes which can be used in keyboard events.
 */ const $9f42f4c07a71299e$export$390330c10ff2b9a1 = 'ArrowUp';
const $9f42f4c07a71299e$export$a80636c6f41931fe = 'ArrowDown';
const $9f42f4c07a71299e$export$4af703091671bc = 'Home';
const $9f42f4c07a71299e$export$e2bc30913faa5db7 = 'End';
const $9f42f4c07a71299e$export$10f6869ed0a7d75b = 'Tab';
const $9f42f4c07a71299e$export$8152f929a25a0ff4 = 'Enter';
const $9f42f4c07a71299e$export$e51a3576c045c8d5 = 'Space';
const $9f42f4c07a71299e$export$2bb790b9008907b4 = 'Escape';

const $3d9529cd8ff26a50$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $3d9529cd8ff26a50$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $3d9529cd8ff26a50$export$13f57c02915787b3 = 'atlaskit-portal';

const $31a7f3563d375095$export$ed5835cc67e87f72 = 'akPortalMount';
const $31a7f3563d375095$export$80816bd900e5bd00 = 'akPortalUnmount';

const $3a153a61cf6b691b$export$ff39ebd4bb12b718 = 201;
const $3a153a61cf6b691b$export$3288b14b6745c572 = 204;
const $3a153a61cf6b691b$export$9de493bcd9b1d977 = 400;
const $3a153a61cf6b691b$export$67d19e9a991baa07 = 401;
const $3a153a61cf6b691b$export$a3269a3914b007e3 = 403;
const $3a153a61cf6b691b$export$8bca792d963eb0ef = 404;
const $3a153a61cf6b691b$export$4a3cb39801694eee = 407;
const $3a153a61cf6b691b$export$fa405bbf47d510e2 = 408;
const $3a153a61cf6b691b$export$c09e7ea0fc79f34f = 409;
const $3a153a61cf6b691b$export$5244030134e99 = 412;
const $3a153a61cf6b691b$export$f90ac1df0b60853d = 413;
const $3a153a61cf6b691b$export$a447d0a965e16776 = 422;
const $3a153a61cf6b691b$export$3b48aba8957000cd = 426;
const $3a153a61cf6b691b$export$6763168a631449a2 = 429;
const $3a153a61cf6b691b$export$e813cd7045fcc98d = 500;
const $3a153a61cf6b691b$export$2ce38d41a306034e = 502;
const $3a153a61cf6b691b$export$974c37534b0191b1 = 503;
const $3a153a61cf6b691b$export$5400e8dddac3fcf3 = 504;

const $3a6f6559ec260003$export$881d135f98d8d7d0 = 100;
const $3a6f6559ec260003$export$9ab5bdcb8a1d6c34 = false;
const $3a6f6559ec260003$export$f267d0e9ab3eb265 = false;
const $3a6f6559ec260003$export$12c1dc38ea1692da = 0;
const $3a6f6559ec260003$export$c6d9b82b8528dcc3 = false;

const $107c403b1827dc68$export$d2aa6c54a5925f01 = 'v3';
const $107c403b1827dc68$export$2bd315ece9f68967 = 'v4';

const $95eb6070d868c1b7$export$2ee9e5a3556c1e43 = 'sidebar';
const $95eb6070d868c1b7$export$793ed84f5e13fedc = 'top';
const $95eb6070d868c1b7$export$f1c9dd0f5207dd5e = 'tab';
const $95eb6070d868c1b7$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $002870cfa80d64f4$export$17ff3f7e02c6ac22 = 'global';
const $002870cfa80d64f4$export$33d8c916a600c5e9 = 'container';

const $bfc89d778f76f56d$export$6dd9406e478a1fe2 = 'navigationItem';
const $bfc89d778f76f56d$export$b887e88d8d0739f6 = 'button';
const $bfc89d778f76f56d$export$64fed82162bd367 = 'dropdownItem';
const $bfc89d778f76f56d$export$b0a8b257f1f878a2 = 'searchInput';

const $7e5fbaca814a6bf2$export$4261d5d429e288ec = 'is-admin';
const $7e5fbaca814a6bf2$export$2eca2b4f46ed58e6 = 'is-nav4-tenant-opt-in';
const $7e5fbaca814a6bf2$export$a4507bf14f4bb764 = 'is-nav4-tenant-opt-out';
const $7e5fbaca814a6bf2$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $7e5fbaca814a6bf2$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';

const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';
const $315aedf92e50a945$export$a310f85340477585 = 'assets';

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $8b23ddd9ac8df64b$export$a7801e29f563faad = 400;

// dimension vars
const $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $7326b3b2ac0b6dee$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $7326b3b2ac0b6dee$export$c103b605cd368aed = 'rightSidebarWidth';
const $7326b3b2ac0b6dee$export$fa34f417972d6341 = 'rightPanelWidth';
const $7326b3b2ac0b6dee$export$3a6a779d9181047c = 'topNavigationHeight';
const $7326b3b2ac0b6dee$export$bcd94a6a792e7f96 = 'bannerHeight';
const $7326b3b2ac0b6dee$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $7326b3b2ac0b6dee$export$344062f7cfc9528e = 'left-panel';
const $7326b3b2ac0b6dee$export$c7139cc2d6110b5f = 'right-panel';
const $7326b3b2ac0b6dee$export$238d30785c4bca84 = 'banner';
const $7326b3b2ac0b6dee$export$bec6dca2e63de4ae = 'top-navigation';
const $7326b3b2ac0b6dee$export$d1213e82613ff4df = 'content';
const $7326b3b2ac0b6dee$export$be83e7118304b28e = 56;
const $7326b3b2ac0b6dee$export$4a98ee0bd1ae362 = 56;
const $7326b3b2ac0b6dee$export$539e68c09584883a = 240;
const $7326b3b2ac0b6dee$export$b92df8810d2fcd01 = 280;
const $7326b3b2ac0b6dee$export$c3e41153b9288bcf = 368;
const $7326b3b2ac0b6dee$export$c4d6152f86ea28f6 = 368;
const $7326b3b2ac0b6dee$export$46acf8758e9e2636 = 20;
const $7326b3b2ac0b6dee$export$70740f5ad8360a78 = 16;
const $7326b3b2ac0b6dee$export$991d5285ad765a3d = 240;
const $7326b3b2ac0b6dee$export$6949d4f32b161684 = 200;
const $7326b3b2ac0b6dee$export$d6e7e8af042815bb = 350;
const $7326b3b2ac0b6dee$export$3749e1104328fde4 = 300;
const $7326b3b2ac0b6dee$export$1074d925b0b82be5 = 200;
const $7326b3b2ac0b6dee$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $7326b3b2ac0b6dee$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $7326b3b2ac0b6dee$export$70c702a8c5895f03 = 'data-grab-area-line';
const $7326b3b2ac0b6dee$export$48a43f91e4becf4e = 'data-grab-area';
const $7326b3b2ac0b6dee$export$dac2fb31a9f6844d = 'data-resize-button';
const $7326b3b2ac0b6dee$export$9ecd22db14e6c70e = 'data-resize-control';
const $7326b3b2ac0b6dee$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $7326b3b2ac0b6dee$export$206a08f7f8beb554 = 'Skip to:';
const $7326b3b2ac0b6dee$export$659ee746b31b360d = 'data-layout-container';
const $7326b3b2ac0b6dee$export$f963aecf2d4465bd = `var(--${$7326b3b2ac0b6dee$export$cbfb0f5b2869b17b}, 0px)`;
const $7326b3b2ac0b6dee$export$750459958906793 = `var(--${$7326b3b2ac0b6dee$export$fa34f417972d6341}, 0px)`;
const $7326b3b2ac0b6dee$export$f897e1ed9f8ed251 = `var(--${$7326b3b2ac0b6dee$export$a30f2e00489a8957}, 0px)`;
const $7326b3b2ac0b6dee$export$b44ab66843c05a69 = `var(--${$7326b3b2ac0b6dee$export$c103b605cd368aed}, 0px)`;
const $7326b3b2ac0b6dee$export$aeff86a16f13529 = `var(--${$7326b3b2ac0b6dee$export$3a6a779d9181047c}, 0px)`;
const $7326b3b2ac0b6dee$export$ed7cc0d417ee89e = `var(--${$7326b3b2ac0b6dee$export$bcd94a6a792e7f96}, 0px)`;
const $7326b3b2ac0b6dee$export$d2fa14f05b61e66 = `var(--${$7326b3b2ac0b6dee$export$b6744d31294864fd}, ${$7326b3b2ac0b6dee$export$991d5285ad765a3d}px)`;

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $e6e0b17becc5e339$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $e6e0b17becc5e339$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';

const $eeb70e8c0a60dc66$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eeb70e8c0a60dc66$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eeb70e8c0a60dc66$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eeb70e8c0a60dc66$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $eeb70e8c0a60dc66$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $eeb70e8c0a60dc66$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $eeb70e8c0a60dc66$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

const $a09d0fc1237ba534$export$d6830277b06edd6 = 'normal';

const $4a60e80b3610d78a$export$b5a308a17bc991f3 = 'projectKey';
const $4a60e80b3610d78a$export$929d50f83189406c = 'boardId';
const $4a60e80b3610d78a$export$da6f46390e1a426f = 'projectId';

const $c8eeacd6960f72dc$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

const $71feb0ebe2f021d7$export$cf090d5281b5ae06 = 10000;
const $71feb0ebe2f021d7$export$8575e30be0feb909 = 30000;

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$baf21119361ffad = 'planCreateMoreWorkItemsNudge';
const $2b839a8453de5367$export$7fac0b950c128b4b = 'planConnectRelatedWorkNudge';
const $2b839a8453de5367$export$9fac41c1d8941795 = 'planShareYourPlanWithTheWorldTeamNudge';
const $2b839a8453de5367$export$994f00a8ff485faf = 'planShareYourPlanWithTheWorldAddPeopleNudge';
const $2b839a8453de5367$export$fc1e19da8853ecdc = 'planBringInTheTeamNudge';
const $2b839a8453de5367$export$d0ece87d6f260877 = 'planConfirmScopeNudge';
const $2b839a8453de5367$export$cc93e7cb8dd884fe = 'planCheckYourSettingsNudge';
const $2b839a8453de5367$export$b579a6f09436e23e = 'asyncPlanOnboardingTourNudge';
const $2b839a8453de5367$export$c7f7837470493c6f = 'planAdjustDetailsFieldsMenuNudge';
const $2b839a8453de5367$export$8909317d0f73beab = 'planAdjustDetailsFieldCellsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

const $70024ada6ee08235$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';

const $d6576400092700bc$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4RolloutAnalytics';
const $d6576400092700bc$export$d57b6b390e78d90f = 'jira-cosmos';

const $0c5166c52045dbc3$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $0c5166c52045dbc3$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $0c5166c52045dbc3$export$9934c8d98fd9e572 = 'atlassianSwitcher';

const $10b5883439ef237e$export$3288b14b6745c572 = 204;
const $10b5883439ef237e$export$c09e7ea0fc79f34f = 409;
const $10b5883439ef237e$export$974c37534b0191b1 = 503;

// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $0b41093501185867$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $0b41093501185867$export$64aee74ba59709e5 = 439; // px
const $0b41093501185867$export$1c07393c5bb1bc27 = 439; // px
const $0b41093501185867$export$aa3478deee7adbeb = 350; // px
const $0b41093501185867$export$21e515a86cd1733b = 'Chat';
const $0b41093501185867$export$e942bf04e23ff966 = 'Rovo';

const $a630de669343b4d7$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;

const $33cafeed9becac72$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $ae356bea880b592a$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $ae356bea880b592a$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $ae356bea880b592a$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';

const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';

const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;

const $44259bc988b99eaa$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $44259bc988b99eaa$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $44259bc988b99eaa$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $44259bc988b99eaa$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $44259bc988b99eaa$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $44259bc988b99eaa$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $44259bc988b99eaa$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $44259bc988b99eaa$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $44259bc988b99eaa$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $44259bc988b99eaa$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $44259bc988b99eaa$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $44259bc988b99eaa$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $44259bc988b99eaa$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $44259bc988b99eaa$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $44259bc988b99eaa$export$f8bf435a6066832c = 'button clicked';
const $44259bc988b99eaa$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $44259bc988b99eaa$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $44259bc988b99eaa$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $44259bc988b99eaa$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $44259bc988b99eaa$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $44259bc988b99eaa$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $44259bc988b99eaa$export$5908fa8acd2c0739 = 'filterListNudge';
const $44259bc988b99eaa$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $44259bc988b99eaa$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $44259bc988b99eaa$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $44259bc988b99eaa$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $44259bc988b99eaa$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $44259bc988b99eaa$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $44259bc988b99eaa$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $44259bc988b99eaa$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $44259bc988b99eaa$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $44259bc988b99eaa$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $44259bc988b99eaa$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $44259bc988b99eaa$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $44259bc988b99eaa$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $44259bc988b99eaa$export$a1be34032ee24f78 = 'shareProjectNudge';
const $44259bc988b99eaa$export$29fe6611cc093756 = 'summaryTabNudge';
const $44259bc988b99eaa$export$f107c06c0830f09d = 'reportsTabNudge';
const $44259bc988b99eaa$export$9749a972a54ad7ba = 'boardContainerNudge';
const $44259bc988b99eaa$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $44259bc988b99eaa$export$b7fd448c62b5fb97 = 'listview';
const $44259bc988b99eaa$export$10c63dc5c09466d2 = 'boardview';
const $44259bc988b99eaa$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $44259bc988b99eaa$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $44259bc988b99eaa$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $44259bc988b99eaa$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $44259bc988b99eaa$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $44259bc988b99eaa$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $44259bc988b99eaa$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $44259bc988b99eaa$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $44259bc988b99eaa$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $44259bc988b99eaa$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $44259bc988b99eaa$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $44259bc988b99eaa$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $44259bc988b99eaa$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

const $6684ec2238b90c47$export$53f45136e435c2fd = 'help_button_ui_state';

const $f71427a7081a8d43$export$67a034c701fa7ff6 = 'uniapa';
const $f71427a7081a8d43$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $f71427a7081a8d43$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';

const $0da9307007fc60c1$export$e0226a83abddbd07 = 'check-notifications';

const $fd3ecb7812b98df6$export$14c62ba6f49b806f = 9;

const $44a1f3ad00fd7f5d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $44a1f3ad00fd7f5d$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $3e9c0e1856c1af11$export$b98e411ae80c806f = '/';


$parcel$global.rlb("l253H")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.add7a750.js.map
